(function() {
'use strict';

angular.lowercase = function (text) {
    return text.toLowerCase();
}

angular
    .module('Noscope', [
        'algoliasearch',
        'angular-bugsnag',
        'angular-loading-bar',
        'angularMoment',
        'highcharts-ng',
        'LocalStorageModule',
        'ngCsv',
        'ngSanitize',
        'offClick',
        'pasvaz.bindonce',
        'restangular',
        'satellizer',
        'sticky',
        'ui.router',
        'ui.bootstrap',
    ]);

})();

(function() {
'use strict';

angular
    .module('Noscope')
    .controller('CampaignsShowController', campaignsShowController);

/** @ngInject */
function campaignsShowController(
    $anchorScroll,
    $location,
    $scope,
    $state,
    $stateParams,
    $timeout,
    Campaign,
    ChartConfig,
    ChartHelpers,
    ENV,
    localStorageService,
    moment,
    OutageService,
    RequestTimeoutService,
    TitleService,
    Helpers
) {
    var vm = this;

    TitleService.set(Campaign.title);
    vm.pullInterval = ENV.pullInterval;
    vm.campaign = Campaign;

    vm.maxRange = {
        start: moment.utc(Campaign.range.start).local(),
        end: moment.utc(Campaign.range.end).local()
    };

    vm.range = {
        start: moment.utc(Campaign.range.start).local(),
        end: moment.utc(Campaign.range.end).local()
    };

    if(Campaign.range.start === Campaign.range.end) {
        $stateParams.day = vm.range.start.format('YYYY-MM-DD');
    }

    vm.now = moment();
    vm.daysLeft = vm.maxRange.end.diff(vm.now, 'days') + 1;
    vm.daysLeft = vm.daysLeft > 0 ? vm.daysLeft : 0;

    vm.tableSort = 'name';
    vm.onlyPlayed = true;
    vm.participantsOpen = !localStorageService.get('campaign.participants.hide');

    vm.chart = {};

    vm.chart.config = {
        options: ChartConfig.get('campaign-overview'),
        series: [],
        size: { height: 340, width: 965 },
        loading: true,
        useHighStocks: true
    };

    ChartHelpers.bootstrap(vm.chart.config);
    vm.chart.config.helpers.setPlotLine(vm.now.clone());
    vm.chart.config.helpers.setClick(function() {

        if(!vm.isDay) {
            var day = moment(this.x).format('YYYY-MM-DD');

            $state.go('app.campaign', {
                day: day
            }, {
                notify: false,
                replace: true,
            });
            $stateParams.day = day;
            init();
        }
    });

    vm.chart.metrics = [
        { column: 'total_minutes', title: 'Total Minutes Watched' },
        { column: 'channels', title: 'Channel Count' },
        { column: 'total_minutes_per_channel', title: 'Minutes Watched/Channel' },
        { column: 'stream_time', title: 'Minutes Streamed' }
    ];

    vm.chart.dayMetrics = [
        { column: 'viewers', title: 'Viewers' },
        { column: 'channels', title: 'Channel Count' }
    ];

    vm.chart.changeMetric = function(metric) {
        vm.chart.metric = metric;

        var preppedData = [];

        _.forEach(vm.days[metric.column], function(day) {
            var x = moment(day[0]).unix()*1000;
            preppedData.push([x, day[1]]);
        });

        vm.chart.config.series = [{
            name: metric.title,
            data: preppedData
        }];
    };

    vm.chart.changeDayMetric = function(metric) {
        vm.chart.dayMetric = metric;

        vm.chart.config.series = [{
            name: metric.title,
            data: vm.days[metric.column]
        }];
    };

    vm.reset = function() {
        $state.go('app.campaign', {
            day: null
        }, {
            notify: false,
            replace: true,
        });
        $stateParams.day = null;
        vm.isDay = false;

        init();
    };

    vm.changeSort = function(sort) {
        var newSort = Helpers.parseSortString(sort);
        var oldSort = Helpers.parseSortString(vm.tableSort);

        if(newSort.column === oldSort.column) {
            newSort.direction = (oldSort.direction === 'DESC') ? 'ASC' : 'DESC' ;
        }

        vm.tableSort = Helpers.encodeSortString(newSort);
    };

    vm.goToChannel = function(channel) {
        $anchorScroll.yOffset = 200;

        vm.channelMap[channel.id].highlight = true;
        $anchorScroll(channel.name);

        $timeout(function() {
            vm.channelMap[channel.id].highlight = false;
        }, 2000);
    };

    vm.toggleParticipants = function() {
        vm.participantsOpen = vm.participantsOpen ? false : true;
        localStorageService.set('campaign.participants.hide', !vm.participantsOpen);
    };

    vm.openChannel = function(channel) {
        channel.open = (channel.open) ? false : true;

        if(!channel.chart) {
            channel.chart = {};
            channel.chart.config = {
                options: ChartConfig.get('campaign-overview-channel'),
                series: [],
                size: { height: 290, width: 870 },
                loading: true,
                useHighStocks: true
            };
        }

        channel.chart.config.loading = true;
        channel.showCampaign = true;

        var preppedData = [];

        if(!vm.isDay) {
            _.forEach(vm.days['total_minutes'], function(day) {
                var x = moment(day[0]).unix()*1000;
                var point = [x, day[1]];
                preppedData.push(point);
            });
        } else {
            preppedData = vm.days['viewers'];
        }

        channel.chart.config.series = [{
            type: 'area',
            name: (vm.isDay) ? 'viewers' : 'Total Minutes Watched',
            data: preppedData
        }];

        Campaign.one('report')
            .withHttpConfig({ timeout: RequestTimeoutService.promise() })
            .get({
                day: $stateParams.day || null,
                channel: channel.id
            })
            .then(function(peeks) {

                var series = [];

                var baseSeries = angular.copy(preppedData);
                var peekMap = _.keyBy(peeks, 0);

                _.forEach(baseSeries, function(timestamp) {

                    if(!vm.isDay) {

                        var pointDate = moment.unix(timestamp[0]/1000).local().format('YYYY-MM-DD');

                        _.forEach(peekMap, function(peek, ts) {
                            var peekDate = moment.unix(ts/1000).local().add(1, 'day').format('YYYY-MM-DD');

                            if(peekDate === pointDate) {
                                timestamp[1] = peek[1];
                            } else if(timestamp[1] < 1) {
                                timestamp[1] = 0;
                            }

                        });

                    } else {
                        timestamp[1] = peekMap[timestamp[0]] ?  peekMap[timestamp[0]][1] : 0;
                    }

                    timestamp[0] = moment.utc(timestamp[0]).unix()*1000;
                });

                channel.toggleCampaign = function() {

                    if(channel.showCampaign) {
                        channel.chart.config.series[0].visible = false;
                    } else {
                        channel.chart.config.series[0].visible = true;
                    }
                };

                channel.chart.config.series.push({
                    type: 'line',
                    name: 'Viewers',
                    data: baseSeries
                });

                channel.chart.config.loading = false;
            });
    };

    function getDay(day) {
        vm.chart.config.loading = true;
        vm.loading = true;
    }

    function processData(response) {
        if(!vm.isDay && !vm.rawResponse) {
            vm.rawResponse = response;
        }

        if(!response) {
            response = vm.rawResponse;
        }

        vm.days = response.days;
        vm.totals = response.totals;
        if(!vm.channelMap) {
            vm.channelCount = Object.keys(response.channel_map).length;
            vm.channelMap = response.channel_map;
        }
        vm.channels = response.channels;

        if(!vm.isDay) {
            vm.chart.changeMetric(vm.chart.metrics[0]);
            vm.chart.config.options.xAxis.plotBands = [];
        } else {
            vm.chart.changeDayMetric(vm.chart.dayMetrics[0]);
            OutageService.getBands()
                .then(function(bands) {
                    vm.chart.config.options.xAxis.plotBands = bands;
                });
        }

        setChannels();
        vm.chart.config.loading = false;
        vm.loading = false;
    }

    function setChannels() {
        _.forEach(vm.channelMap, function(channel) {
            if(vm.channels[channel.id]) {
                var stats = vm.channels[channel.id];
                channel.stats = {
                    total_minutes: stats.total_minutes,
                    peek_count: stats.stream_time/vm.pullInterval,
                    peak_viewers: stats.peak_viewers,
                    average_viewers: stats.total_minutes/stats.stream_time
                };
                channel.played = true;
            } else {
                channel.stats = {
                    total_minutes: false,
                    peek_count: false,
                    peak_viewers: false,
                    average_viewers: false
                };
                channel.played = false;
            }

            channel.chart = false;
            channel.open = false;
        });
    }

    function init() {
        if($stateParams.day) {
            vm.isDay = true;
            vm.range.start = moment($stateParams.day);
        } else {
            vm.isDay = false;
            vm.range.start = moment.utc(Campaign.range.start).local();
        }

        vm.chart.config.helpers.setCursor(vm.isDay ? 'default' : 'pointer');

        vm.loading = true;
        vm.chart.config.loading = true;
        vm.chart.config.series = [];

        if(vm.rawResponse && !vm.isDay) {
            processData()
        } else {
            Campaign.one('report')
                .withHttpConfig({ timeout: RequestTimeoutService.promise() })
                .get({
                    day: $stateParams.day || null
                })
                .then(processData);
        }
    }

    init();
}

})();

(function() {
'use strict';

angular
    .module('Noscope')
    .service('CampaignReportService', CampaignReportService);

/** @ngInject */
function CampaignReportService(ENV) {
    var self = this;

    self.pullInterval = ENV.pullInterval;
    self.rawPeeks = false;
    self.range = false;

    self.ingestData = function(rawPeeks) {
        self.rawPeeks = rawPeeks;

        return self;
    };

    self.processData = function() {

        self.totals = {
            viewers: 0,
            peek_count: 0,
            streams: 0,
            participants: 0,
            peak_viewers: 0,
        };

        self.timeline = {
            minutes: [],
            channels: [],
            minutesPerChannel: [],
            streamTime: [],
            channelList: {}
        };

        self.streams = {};

        self.channels = {};

        self.days = {};

        _.forEach(self.rawPeeks, function(peek) {

            var pulledAt = moment.utc(peek.pa).local();

            if(!self.range || (self.range.start <= pulledAt && self.range.end > pulledAt)) {

                var date = pulledAt.format('YYYY-MM-DD');
                var unix = pulledAt.unix()*1000;

                //Add Totals
                self.totals.viewers += parseInt(peek.v);
                self.totals.peek_count++;

                //Add Stream to Stream Map for count
                self.streams[peek.tsi] = true;

                //Add Channel to Channel Map
                if(!self.channels[peek.tci]) {
                    self.channels[peek.tci] = [];
                }
                self.channels[peek.tci].push([ pulledAt.utc().unix(), peek.v ]);

                //Create Day Map
                if(!self.days[date]) {
                    self.days[date] = {
                        viewers: 0,
                        peek_count: 0,
                        channels: {},
                        peeks: {}
                    };
                }

                self.days[date].viewers += peek.v;
                self.days[date].peek_count++;
                self.days[date].channels[peek.tci] = true;
                self.days[date].peeks[pulledAt.format('HH:mm')] =  peek.v;

            }
        });

        //Add Totals
        self.totals.streams = Object.keys(self.streams).length;
        self.totals.participants = Object.keys(self.channels).length;

        self.generateDayMap();
        self.gernerateTimeline();

        return self;
    };

    self.setRange = function(start, end) {
        self.range = {
            start: moment.isMoment(start) ? start.clone() : moment(start),
            end: moment.isMoment(end) ? end.clone().add(1, 'days') : moment(end).add(1, 'days'),
        }

        return self;
    };

    self.generateDayMap = function() {
        var dayMap = [];

        var minDate = self.range.start.clone().startOf('day');
        var maxDate = self.range.end.clone().startOf('day');

        var max = 0;
        while(minDate.isBefore(maxDate) && max < 2000) {
            dayMap.push(minDate.clone().utc());

            minDate.add(1, 'day');
            max++;
        }

        self.dayMap = dayMap;

        return self;
    };

    self.generateMinuteMap = function(day) {
        var minuteMap = [];

        var start = day.clone().utc();
        var end = day.clone().add(1, 'day')

        var max = 0
        while(start < end && max < 1000) {
            minuteMap.push({ time: start.format('HH:mm'), unix: start.unix()*1000 });
            start.add(self.pullInterval, 'minutes');
            max++;
        }

        return minuteMap;
    };

    self.gernerateTimeline = function() {

        _.forEach(self.dayMap, function(day) {
            var date = day.format('YYYY-MM-DD');
            var unix = day.unix()*1000;

            if(self.days[date]) {
                //Sneak a count in this loop
                self.days[date].channelCount = Object.keys(self.days[date].channels).length;

                var totalMinutes = self.days[date].viewers * self.pullInterval;
                var channelCount = Object.keys(self.days[date].channels).length;
                var streamTime = self.days[date].peek_count * self.pullInterval;

                self.timeline.minutes.push([ unix, totalMinutes ]);
                self.timeline.channels.push([ unix, channelCount ]);
                self.timeline.minutesPerChannel.push([ unix, Math.round(totalMinutes/channelCount, 0) ]);
                self.timeline.streamTime.push([ unix, streamTime ]);
                self.timeline.channelList = self.days[date].channels;
            } else {
                self.timeline.minutes.push([ unix, 0 ]);
                self.timeline.channels.push([ unix, 0 ]);
                self.timeline.minutesPerChannel.push([ unix, 0 ]);
                self.timeline.streamTime.push([ unix, 0 ]);
                self.timeline.channelList = {};
            }

        });
    };

    self.getDayPeeks = function() {
        var start = self.range.start.clone();
        var date = start.format('YYYY-MM-DD');

        var dayPeeks = self.generateMinuteMap(start);

        _.forEach(dayPeeks, function(time, timeIndex) {
            if(self.days[date] && self.days[date].peeks && self.days[date].peeks[time.time]) {
                dayPeeks[timeIndex] = [ time.unix, self.days[date].peeks[time.time] ];
            } else {
                dayPeeks[timeIndex] = [ time.unix, 0 ];
            }
        });

        return dayPeeks;
    };

    return self;
  }
})();

(function() { //Refactored
'use strict';

angular
    .module('Noscope')
    .controller('CampaignsIndexController', campaignsIndexController);

/** @ngInject */
function campaignsIndexController(Campaigns, TitleService) { 
    var vm = this;

    TitleService.set('My Campaigns');

    vm.campaigns = Campaigns;

    vm.sorts = [
        {
            title: 'Most Recent',
            column: '-timestamp'
        },
        {
            title: 'Alphabetical',
            column: 'title'
        },
        {
            title: 'Most Channels',
            column: '-listeners[0].channel_count'
        },
        {
            title: 'Most Games',
            column: '-listeners[0].game_count'
        }
    ];

    vm.selectedSort = vm.sorts[0];

    vm.setSort = function(sort) {
        vm.selectedSort = sort;
    };

}

})();

(function() {
  "use strict";

  angular
    .module("Noscope")
    .controller("CampaignsCreateController", campaignsCreateController);

  /** @ngInject */
  function campaignsCreateController(
    AlgoliaService,
    $q,
    TwitchChannel,
    moment,
    $timeout,
    Restangular,
    Campaign,
    $state,
    $stateParams,
    EditCampaign
  ) {
    var vm = this;

    function init() {
      vm.isTemplate = EditCampaign && !$stateParams.campaign;

      if (vm.isTemplate || $stateParams.campaign) {
        vm.isEdit = !vm.isTemplate;

        if (vm.isTemplate) {
          EditCampaign.id = null;
        }

        vm.title = vm.isTemplate
          ? "Copy of " + EditCampaign.title
          : EditCampaign.title;
        vm.timeframes.selected[0].start = moment(
          EditCampaign.campaign_data[0].start
        );
        vm.timeframes.selected[0].end = moment(
          EditCampaign.campaign_data[0].end
        );
        vm.games.selected = EditCampaign.campaign_data[0].games;
        vm.channels.selected = EditCampaign.campaign_data[0].channels;
      }
    }

    var GameList = function() {
      var $this = this;

      $this.index = AlgoliaService.games();
      $this.selected = [];
      $this.loading = false;

      return this;
    };

    GameList.prototype.doSearch = function(searchString) {
      var $this = this;

      var defer = $q.defer();
      $this.loading = true;

      $this.index.search(searchString).then(function(content) {
        $this.loading = false;
        defer.resolve(content.hits);
      });

      return defer.promise;
    };

    GameList.prototype.select = function(game) {
      var $this = this;

      $this.searchString = "";

      if (
        _.find($this.selected, function(o) {
          return parseInt(o.id) === parseInt(game.id);
        })
      ) {
        return false;
      }

      $this.selected.unshift(game);
    };

    GameList.prototype.remove = function(game) {
      var $this = this;

      $this.selected = _.reject($this.selected, function(v) {
        return v.title === game.title;
      });
    };

    var TimeframeList = function() {
      var $this = this;

      $this.selected = [{ start: false, end: false }];

      return this;
    };

    TimeframeList.prototype.add = function() {
      var $this = this;

      $this.selected.unshift({ start: false, end: false });

      return $this;
    };

    vm.games = new GameList();
    vm.timeframes = new TimeframeList();

    vm.start = moment();
    vm.end = moment();

    vm.bulkImport = function() {
      if (!vm.bulkImportModel) {
        return false;
      }

      var commaString = vm.bulkImportModel
        .toLowerCase()
        .trim()
        .replace(/http:\/\//g, "")
        .replace(/https:\/\//g, "")
        .replace(/www\./g, "")
        .replace(/twitch\.tv/g, "")
        .replace(/twinge\.tv/g, "")
        .replace(/app.noscope.io\/channels\/twitch/g, "")
        .replace(/\//g, "")
        .replace(/ /g, "")
        .replace(/;/g, ",")
        .replace(/\n/g, ",")
        .replace(/(^,)|(,$)/g, "")
        .replace(/(\r\n|\n|\r)/gm, "");

      var count = commaString.split(",").length;

      if (count < 2 || count > 1000) {
        return false;
      }

      vm.importLoading = true;

      TwitchChannel.one("search")
        .post("multi", { channels: commaString })
        .then(function(channels) {
          angular.forEach(channels, function(v, i) {
            vm.channels.select(v);
            vm.bulkImportModel = "";

            vm.importLoading = false;
            vm.importResult = { entered: count, result: channels.length };
            $timeout(function() {
              vm.importResult = false;
            }, 3000);
          });
        });
    };

    vm.channels = {
      selected: [],
      loading: false,
      doSearch: function(string) {
        return TwitchChannel.one("search")
          .one(string)
          .getList();
      },
      select: function(channel) {
        vm.channels.searchString = "";

        if (
          _.find(vm.channels.selected, function(o) {
            return o.name === channel.name;
          })
        ) {
          return false;
        }

        channel.games = new GameList();

        vm.channels.selected.unshift(channel);
      },
      remove: function(channel) {
        vm.channels.selected = _.reject(vm.channels.selected, function(v) {
          return v.name === channel.name;
        });
      },
    };

    function validateForm() {
      if (!vm.title || vm.title === "") {
        return false;
      }

      if (!vm.timeframes.selected[0].start || !vm.timeframes.selected[0].end) {
        return false;
      }

      if (vm.games.selected.length === 0 || vm.channels.selected.length === 0) {
        return false;
      }

      return true;
    }

    vm.deleteCampaign = function() {
      vm.submitLoading = true;

      EditCampaign.remove(false).then(function() {
        $state.go("app.campaigns");
      });
    };

    vm.submitForm = function() {
      vm.submitAttempted = true;

      if (!validateForm()) {
        return false;
      }

      vm.submitLoading = true;

      var campaign = {
        title: vm.title,
        campaignData: [
          {
            start: vm.timeframes.selected[0].start,
            end: vm.timeframes.selected[0].end,
            channels: _.map(vm.channels.selected, "id"),
            games: _.map(vm.games.selected, "id"),
          },
        ],
      };

      if (!vm.isEdit) {
        Campaign.post(campaign).then(function() {
          $state.go("app.campaigns");
          // vm.submitLoading = false;
        });
      } else {
        EditCampaign.post(false, campaign).then(function() {
          $state.go("app.campaigns");
          // vm.submitLoading = false;
        });
      }
    };

    init();
  }
})();

(function() {
'use strict';

angular
    .module('Noscope')
    .directive('nsToggle', nsToggle); 

/** @ngInject */
function nsToggle() {
    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'app/ui-components/toggle/toggle.html',
        scope: {
            nsToggleModel: '=',
            nsToggleActiveLabel: '@',
            nsToggleInactiveLabel: '@',
            nsToggleLabel: '@',
            nsToggleClick: '='
        },
        /** @ngInject */
        controller: function($scope) {
            $scope.toggle = function() {
                $scope.nsToggleModel = ($scope.nsToggleModel) ? false : true;

                if($scope.nsToggleClick) {
                    $scope.nsToggleClick();
                }
            };
        }
    }
}
})();
(function() {
'use strict';

angular
    .module('Noscope')
    .directive('nsTimePicker', timePicker);

/** @ngInject */
function timePicker() {
    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'app/ui-components/time-picker/time-picker.html',
        scope: {
            'date': '=nsTimePickerMoment',
            'min':  '=nsTimePickerMin',
            'max':  '=nsTimePickerMax'
        },
        controller: function($scope) {}
    }
}
})();
(function() {
'use strict';

angular
    .module('Noscope')
    .directive('nsStats', nsStats);

/** @ngInject */
function nsStats() {
    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'app/ui-components/stats/stats.html',
        transclude: true,
        link: function($scope, $element) {
            $scope.items = angular.element($element).children().length;
        }
    }
}
})();
(function() {
'use strict';

angular
    .module('Noscope')
    .directive('nsStatsItem', nsStatsItem);

/** @ngInject */
function nsStatsItem() {
    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'app/ui-components/stats/item.html',
        scope: {
            'nsStatsItemLoading': '=',
            'nsStatsItemValue': '=',
            'nsStatsItemTitle': '@',
            'nsStatsItemChange': '=',
        }
    }
}
})();
(function() {
'use strict';

angular
    .module('Noscope')
    .directive('nsSectionDot', nsSectionDot);

/** @ngInject */
function nsSectionDot() {
    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'app/ui-components/section-dot/section-dot.html',
        scope: {
            'nsSectionDotIcon': '@',
            'nsSectionDotLoading': '='
        }
    }
}
})();
(function() {
'use strict';

angular
    .module('Noscope')
    .directive('nsReportCard', nsReportCard);

/** @ngInject */
function nsReportCard() {
    return {
        restrict: 'E',
        replace: true,
        template: [
            '<sup ng-hide="nsReportCardValue == 0"',
             'class="ns-reportCard"',
             'uib-tooltip="Averages {{ nsReportCardComparison | number:0 }}"',
             'ng-class="{ \'is-good\': nsReportCardValue > 0, \'is-bad\': nsReportCardValue < 0 }">',
                '<i class="icon is-up ion-arrow-up-a"></i>',
                '<i class="icon is-down ion-arrow-down-a"></i>',
                '{{ nsReportCardValue | absoluteValue | number: 0 }}%',
            '</sup>'
        ].join(''),
        scope: {
            nsReportCardValue: '@',
            nsReportCardComparison: '@'
        }
    }
}
})();

(function() {
'use strict';

angular
    .module('Noscope')
    .directive('nsRank', nsRank);

/** @ngInject */
function nsRank() {
    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'app/ui-components/rank/rank.html',
        scope: {
            nsRankIndex: '=',
            nsRankUnder: '@'
        },
        link: function() {

        },
        controller: function() {

        }
    }
}
})();
(function() {
'use strict';

angular
    .module('Noscope')
    .directive('nsRange', nsRange);

/** @ngInject */
function nsRange($state, $stateParams, $timeout, ENV, moment, TimeframeFactory) {
    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'app/ui-components/range/range.html',
        scope: {
            start:               '=nsRangeStart',
            end:                 '=nsRangeEnd',
            rangeChanged:        '=nsRangeChanged',
            callback:            '=nsRangeCallback',
            presets:             '@nsRangePresets',
            preset:              '@nsRangePreset',
            loading:             '=nsRangeLoading',
            selectedRangePreset: '=nsRangeSelected',
            noApply:             '@nsRangeNoApply',
            noTime:              '@nsNoTime',
            setParams:           '@nsSetParams'
        },
        link: function() {

        },
        controller: function($scope) {

            $scope.interval = ENV.pullInterval;
            $scope.now = moment().add(1, 'days').toDate();
            $scope.minimumDate = moment(ENV.minimumDate).toDate();

            function init() {
                //Get Presets
                var presetProperty = ($scope.presets && TimeframeFactory[$scope.presets]) ? $scope.presets : 'timeline';
                $scope.rangePresets = angular.copy(TimeframeFactory[presetProperty]);

                //Find initial Preset
                var initPreset = ($scope.preset && $scope.rangePresets[$scope.preset]) ? $scope.preset : 0;

                if($stateParams.start && $stateParams.end) {
                    var start = moment($stateParams.start);
                    var end   = moment($stateParams.end);

                    if(start.isValid() && end.isValid()) {
                        $scope.selectRangePreset({ start: start, end: end, title: 'Custom' }, true);
                    } else {
                        $scope.selectRangePreset($scope.rangePresets[initPreset], true);
                    }
                } else {
                    $scope.selectRangePreset($scope.rangePresets[initPreset], true);
                }


            }

            $scope.prevRange = function() {
                var diff = $scope.end.diff($scope.start, 'm') + 1;

                var start = moment($scope.start).subtract(diff, 'm');
                var end   = moment(start).add(diff, 'm').subtract(1, 'ms');

                $scope.startDate = start.toDate();
                $scope.endDate   = end.toDate();
            };

            $scope.nextRange = function() {
                var diff = $scope.end.diff($scope.start, 'm') + 1;

                var start = moment($scope.start).add(diff, 'm');
                var end   = moment($scope.start).add(diff*2, 'm').subtract(1, 'ms');

                $scope.startDate = start.toDate();
                $scope.endDate   = end.toDate();
            };

            $scope.selectRangePreset = function(range, initial) {

                if(!$scope.noApply)
                    $scope.selectedRangePreset = range;

                $scope.startDate = moment(range.start).toDate();
                $scope.endDate   = moment(range.end).toDate();

                $timeout(function() {
                    $scope.applyRange(initial);

                    if(!$scope.noApply)
                        $scope.rangeChanged = false;
                }, 1);
            };

            $scope.customRange = function() {

                if(!$scope.noApply)
                    $scope.selectedRangePreset = false;

                $scope.applyRange();
            };

            $scope.applyRange = function(initial) {

                if(!$scope.noApply)
                    $scope.rangeChanged = false;

                if($scope.setParams && !initial) {
                    $state.go($state.current.name, {
                        start: $scope.start.format(),
                        end:   $scope.end.format()
                    }, { notify: false });
                }

                if($scope.callback) {
                    $scope.callback()
                }
            };

            $scope.$watchGroup([ 'start', 'end' ], function() {

                if(!$scope.start || !$scope.end) {
                    return false;
                }

                var tempStart = moment($scope.start);
                var tempEnd = moment($scope.end);

                if(!$scope.start.isSame($scope.startDate)) {
                    $scope.startDate = tempStart.toDate();
                }

                if(!$scope.end.isSame($scope.endDate)) {
                    $scope.endDate = tempEnd.toDate();
                }

                $scope.daysBetween = Math.abs(tempEnd.diff(tempStart, 'days')) + 1;
            });

            $scope.$watchGroup([ 'startDate', 'endDate' ], function() {

                if(!$scope.noApply)
                    $scope.rangeChanged = true;

                if($scope.endDate < $scope.startDate) {
                    $scope.endDate = moment($scope.startDate).add($scope.interval-1, 'minute').toDate();
                }

                $scope.start = moment($scope.startDate);
                $scope.end = moment($scope.endDate);
            });


            init();
        }
    }
}
})();

(function() {
'use strict';

/** @ngInject */
function nsPaginationController() {
    var vm = this;

    vm.limitSet = function(limit) {
        vm.limitCallback(limit);
    }

    vm.pageSet = function() {
        vm.pageCallback(vm.page);
    }
}

angular
    .module('Noscope')
    .component('nsPagination', {
        bindings: {
            page:          '=nsPaginationPage',
            total:         '<nsPaginationTotal',
            limit:         '=nsPaginationLimit',
            loading:       '<nsPaginationLoading',
            pageCallback:  '<nsPaginationChangePage',
            limitCallback: '<nsPaginationChangeLimit',
            hideLimit:     '@nsPaginationHideLimit',
        },
        templateUrl: 'app/ui-components/pagination/pagination.html',
        controller: nsPaginationController
    });
})();
(function() {
'use strict';

angular
    .module('Noscope')
    .directive('nsLiveDot', nsLiveDot);

/** @ngInject */
function nsLiveDot() {
    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'app/ui-components/live-dot/live-dot.html',
        scope: {
            peek: '=nsLiveDotPeek',
            game: '@nsLiveDotGame',
            text: '@nsLiveDotText',
        },
        controller: function($scope, $filter) {
            var viewers = $filter('number')($scope.peek.viewers);
            
            $scope.isGame = ($scope.game && $scope.game == $scope.peek.twitch_game.title);

            $scope.tooltip = [
                '<div class="u-tal">',
                    '<h4><i class="u-color--noscope icon ion-ios-pulse-strong"></i> Live Now</h4>',
                    '<hr>',
                    '<p><b>' + $scope.peek.twitch_game.title + '</b></p>',
                    '<p>' + viewers + ' Viewers</p>',
                '</div>'
            ].join('');
        }
    }
}
})();
(function() {
'use strict';

angular
    .module('Noscope')
    .directive('nsImage', nsImage);

/** @ngInject */
function nsImage() {
    return {
        restrict: 'E',
        replace: true,
        transclude: true,
        templateUrl: 'app/ui-components/image/image.html',
        scope: {
            src:    '@nsImageSrc',
            height: '@',
            width:  '@'
        }
    }
}
})();
(function() {
'use strict';

angular
    .module('Noscope')
    .directive('nsHidingLabel', nsHidingLabel);

/** @ngInject */
function nsHidingLabel() {
    return {
        restrict: 'A',
        scope: {
            ngModel: '='
        },
        /** @ngInject */
        controller: function($scope, $element, $compile) {
            var placeholderText = $element.attr('placeholder');            
            $scope.label = $compile('<label class="hidingLabel" ng-class="{ \'is-shown\': ngModel.length > 0 }">' + placeholderText +'</label>')($scope);
            $scope.el = $element.parent()[0].insertBefore($scope.label[0], $element[0]);
        },
        link: function($scope, $element) {

        }
    }
}
})();
(function() {
'use strict';

angular
    .module('Noscope')
    .directive('nsDropdown', nsDropdown);

/** @ngInject */
function nsDropdown() {
    return {
        restrict: 'E',
        replace: true,
        transclude: true,
        templateUrl: 'app/ui-components/dropdown/dropdown.html',
        scope: {
            'nsDropdownTitle':    '=',
            'nsDropdownOptions':  '=',
            'nsDropdownSelect':   '=',
            'nsDropdownDisplay':  '@',
            'nsDropdownModel':    '=',
            'nsDropdownAddClass': '@',
            'nsDropdownAdd':      '@',
            'direction':          '@nsDropdownDirection'
        },
        /** @ngInject */
        controller: function($scope) {
            $scope.toggle = function() {
            };

            $scope.select = function(option) {
                $scope.nsDropdownSelect(option);
                if($scope.nsDropdownModel) {
                    $scope.nsDropdownModel = option;
                }
            };
        }
    }
}
})();
(function() {
'use strict';

/** @ngInject */
function dateRangeComponent($stateParams, ENV, UrlService) {
    var vm = this;

    vm.$onInit = function() {
        if($stateParams.start || $stateParams.end) {
            vm.setDates($stateParams.start || this.dates.start, $stateParams.end || this.dates.end) 
        }

        if(!vm.min) {
            vm.minimumDate = moment(ENV.minimumDate);
        }

        if(!vm.max) {
            vm.maxDate = moment().add(5, 'years');
        }
    }

    vm.setDates = function(start, end) {
        vm.dates = {
            start: moment(start),
            end:   moment(end)
        }
    }
}

angular
    .module('Noscope')
    .component('nsDateRange', {
        templateUrl: 'app/ui-components/date-range/date-range.html',
        bindings: {
            loading: '<nsDateRangeLoading',
            dates:   '=nsDateRangeDates',
            min:     '<nsDateRangeMin',
            max:     '<nsDateRangeMax',
        },
        controller: dateRangeComponent
    }); 
})();
(function() {
'use strict';

angular
    .module('Noscope')
    .directive('nsDatePicker', nsDatePicker);

/** @ngInject */
function nsDatePicker() {
    return {
        restrict: 'A',
        replace: true,
        transclude: true,
        templateUrl: 'app/ui-components/date-picker/date-picker.html',
        controllerAs: '$ctrl',
        scope: {
            model: '=nsDatePickerModel',
            min:   '=nsDatePickerMin',
            max:   '=nsDatePickerMax',
        },
        controller: function($scope, $interval) {
            var vm = this;

            vm.model  = $scope.model;
            vm.date   = moment($scope.model).toDate();
            vm.locked = true;
            vm.min    = $scope.min;
            vm.max    = $scope.max;

            vm.togglePicker = function() {
                vm.isOpen = !vm.isOpen;
            }

            vm.update = function() {
                $scope.model = moment(vm.date);
            }

            $scope.$watch('model', function() {
                vm.date  = moment($scope.model).toDate();
            });
        }
    }
}
})();
(function() {
'use strict';

angular
    .module('Noscope')
    .directive('nsChart', nsChart);

/** @ngInject */
function nsChart() {
    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'app/ui-components/chart/chart.html',
        scope: {
            config: '=nsChartConfig',
            data:   '=nsChartData',
            empty:  '@nsChartEmpty',
            loading:'=nsChartLoading',
        },
        controller: function($scope) {
            function init() {
                $scope.changeMetric(_.head($scope.config.metrics));
            }

            function setSeries() {
                if(!$scope.config.series) {
                    $scope.config.series = []
                }

                if($scope.config.metrics && $scope.data && $scope.data[$scope.config.selectedMetric.column]) {

                    var set = $scope.data[$scope.config.selectedMetric.column];

                    $scope.config.series = _.isArray(set) ? set : [ set ];
                }
            }

            $scope.changeMetric = function(metric) {
                $scope.config.selectedMetric = metric;
                setSeries();
                if(metric.callback) {
                    metric.callback($scope.config.series);
                }
            };

            $scope.config.changeMetric = $scope.changeMetric;

            $scope.$watch('loading', function() {
                $scope.config.loading = $scope.loading;
            })

            $scope.$watchGroup([ 'data' ], function() {
                if($scope.config.metrics && !$scope.config.selectedMetric) {
                    $scope.changeMetric(_.head($scope.config.metrics));
                }

                setSeries();
            }, true);

            init();
        }
    }
}
})();

(function() {
'use strict';

angular
    .module('Noscope')
    .config(RightNowFullRoute);

/** @ngInject */
function RightNowFullRoute($stateProvider) {
    $stateProvider
        .state('app.live', {
            url: '/live/twitch',
            abstract: true,
            templateUrl: 'app/pages/right-now-full/right-now-full.html'
        })
        .state('app.live.channels', {
            url: '/channels?page&game&pull',
            templateUrl: 'app/pages/right-now-full/_channels.html',
            controller: 'RightNowFullController',
            controllerAs: 'cLive',
            resolve: {
                /** @ngInject */
                Results: function(ApiV1, $stateParams) {
                    return ApiV1
                        .one('twitch', 'live')
                        .one('channels')
                        .get({
                            page: $stateParams.page,
                            game: $stateParams.game,
                            pull: $stateParams.pull,
                            limit: 30
                        });
                },
            }
        })
        .state('app.live.games', {
            url: '/games?page&pull',
            templateUrl: 'app/pages/right-now-full/_games.html',
            controller: 'RightNowFullController',
            controllerAs: 'cLive',
            resolve: {
                /** @ngInject */
                Results: function(ApiV1, $stateParams) {
                    return ApiV1
                        .one('twitch', 'live')
                        .one('games')
                        .get({
                            page: $stateParams.page,
                            pull: $stateParams.pull,
                            limit: 30
                        });
                }
            }
        });
}

})();

(function() {
'use strict';

angular
    .module('Noscope')
    .controller('RightNowFullController', RightNowFullController);

/** @ngInject */
function RightNowFullController(Results, $stateParams, $state, TitleService) {
    var vm = this;
    vm.loading = false;

    vm.page = ($stateParams.page) ? $stateParams.page : 1;
    vm.pull = ($stateParams.pull) ? $stateParams.pull : null;
    vm.game = $stateParams.game | null;

    vm.version = ($state.current.name === 'app.live.channels') ? 'channels' : 'games';
    vm.results = Results;

    TitleService.set(vm.version === 'channels' ? 'Live Broadcasters' : 'Live Games');

    vm.changePage = function(page) {
        if(vm.loading) {
            return false;
        }

        vm.loading = true;
        if(vm.version === 'channels') {
            $state.go('app.live.channels', { page: page });
        } else {
            $state.go('app.live.games', { page: page });
        }
    }

    vm.clearGame = function() {
        $state.go('app.live.channels', { page: null, pull: $stateParams.pull, game: null });
    }
}
})();

(function() {
'use strict';

angular
    .module('Noscope')
    .config(RightNowRoute);

/** @ngInject */
function RightNowRoute($stateProvider) {
    $stateProvider
        .state('app.dashboard', {
            url: '/now',
            templateUrl: 'app/pages/right-now/right-now.html',
            controller: 'RightNowController',
            controllerAs: 'cRightNow',
            resolve: {
                /** @ngInject */
                RightNow: function(ApiV1) {
                    return ApiV1.one('twitch', 'reports')
                        .one('right-now')
                        .get({ limit: 13 });
                },
                /** @ngInject */
                DayChart: function(ApiV1) {
                    return ApiV1.one('twitch', 'reports')
                        .one('now-vs-week')
                        .get();
                }
            }
        });
}

})();
(function() {
'use strict';

angular
    .module('Noscope')
    .controller('RightNowController', RightNowController);

/** @ngInject */
function RightNowController(
    RightNow,
    DayChart,
    ChartHelpers, 
    ChartConfig,
    ChartDataService,
    moment
) {
    
    var vm = this;

    vm.totals = RightNow.totals;
    vm.topChannels = RightNow.channels;
    vm.topGames = RightNow.games.viewers;
    vm.popularGames = RightNow.games.streams;

    vm.chart = {
        config: {
            options: ChartConfig.get('right-now'),
            series: [],
            useHighStocks: true,
            size: {
                height: 324,
                width: 860
            },
        },
        metrics: [
            { column: 'viewers', title: 'Viewers Watching' },
            { column: 'stream_count', title: 'Live Streams' },
            { column: 'average_stream_viewers', title: 'Avg Viewers/Stream' }, 
        ],
        changeMetric: function(metric) {
            vm.chart.selectedMetric = metric;
            var selectedMetric = _.findIndex(vm.chart.metrics, metric);

            buildChart(selectedMetric)
        }
    };

    ChartHelpers.bootstrap(vm.chart.config);
    vm.chart.config.helpers.setPlotLine(moment());

    function buildChart(index) {

        var series = [
            ChartDataService.buildSeries(vm.chartStats.today, vm.chart.metrics)[index],
            ChartDataService.buildSeries(vm.chartStats.lastWeek, vm.chart.metrics)[index],
        ];

        if(series[0] && series[1]) {
            series[0].name = 'Today';
            series[1].name = 'Last ' + moment().format('dddd');

            series[1].color = '#aaa';
            series[1].lineWidth = 0;
            series[1].type = 'area';
            series[1].fillOpacity = 0.28;
        }

        vm.chart.config.series = series.reverse();
    }

    function init() {
        vm.chart.config.loading = true;
        vm.chart.selectedMetric = vm.chart.metrics[0];


        vm.chartStats = DayChart;

        var today = moment();

        angular.forEach(vm.chartStats.today, function(peek, i) {

            var pulledAt = moment.utc(peek.pulled_at)
                .local()
                .date(today.date())
                .month(today.month())
                .year(today.year());

            peek.pulled_at = pulledAt.format();
            peek.timestamp = pulledAt.unix();
        });

        angular.forEach(vm.chartStats.lastWeek, function(peek, i) {
            var pulledAt = moment.utc(peek.pulled_at)
                .local()
                .date(today.date())
                .month(today.month())
                .year(today.year());

            peek.pulled_at = pulledAt.format();
            peek.timestamp = pulledAt.unix();
        });

        vm.chartStats.lastWeek = _.sortBy(vm.chartStats.lastWeek, function(o) { return o.timestamp; });
        vm.chartStats.today = _.sortBy(vm.chartStats.today, function(o) { return o.timestamp; });

        if(DayChart.today.length) {
            buildChart(0); 
        }
        
        vm.chart.config.loading = false;

    }

    init();
}

})();
(function() {
'use strict';

angular
    .module('Noscope')
    .controller('ResetPasswordController', ResetPasswordController);

/** @ngInject */
function ResetPasswordController($state, $stateParams, ApiV1, User, localStorageService, UserObjectService) {
    var vm = this;

    vm.user = UserObjectService.get();
    vm.expired = $stateParams.expired ? true : false;
    vm.isForgotPassword = $stateParams.token ? true : false;

    if(!vm.user && !vm.isForgotPassword) {
        $state.go('login');
        return;
    }

    function savePassword() {
        ApiV1.one('auth').post('set-password', {
            password: vm.newPassword,
            'reset-token': $stateParams.token,
            email: $stateParams.email
        })
            .then(function(response) {
                if(vm.isForgotPassword) {
                    vm.isReset = true;
                } else {
                    UserObjectService.set(response.user);
                    $state.go('app.dashboard');
                }
            }, function(error) {
                vm.loading = false;

                if(error.data && error.data.validation_errors) {
                    vm.validationErrors = error.data.validation_errors.password;
                }
            });
    }

    vm.attempt = function(form) {
        if(!vm.newPassword || !vm.repeatPassword) {
            vm.validationErrors = [ 'Enter your new password' ];
            return;
        }

        if(vm.newPassword !== vm.repeatPassword) {
            vm.validationErrors = [ 'Passwords do not match' ];
            return;
        }

        vm.loading = true;
        savePassword();
    };

}

})();

(function() {
'use strict';

angular
    .module('Noscope')
    .controller('ForgotPasswordGateController', ForgotPasswordGateController);

/** @ngInject */
function ForgotPasswordGateController($stateParams, $state, ApiV1, UserObjectService) {
    var vm = this;

    function validateEmail(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    vm.next = function() {
        if(vm.loading) return;

        if(!validateEmail(vm.email)) {
            vm.invalid = true;
            return false;
        }

        vm.loading = true;

        UserObjectService.set(null);
        vm.invalid = false;

        ApiV1.one('auth', 'forgot-password').get({
            'reset-token': $stateParams.token,
            email: vm.email.toLowerCase()
        }).then(function(response) {
            $state.go('reset-password', {
                token: $stateParams.token,
                email: vm.email.toLowerCase()
            });
        }, function() {
            vm.loading = false;
            vm.expired = true;
        })
    }
}

})();

(function() {
'use strict';

angular
    .module('Noscope')
    .config(gameRoute);

/** @ngInject */
function gameRoute($stateProvider) {
    $stateProvider
        .state('app.game', {
            url: '/games/{slug}',
            templateUrl: 'app/pages/game/game.html',
            controller: 'GameController',
            controllerAs: 'cGame',
            reloadOnSearch: false,
            resolve: {
                /** @ngInject */
                Game: function(ApiV1, $stateParams) {
                    return ApiV1.one('games', $stateParams.slug).get();
                },
                /** @ngInject */
                LiveStats: function(Game, $stateParams) {
                    return Game.one('peek').get();
                }
            }
        })
        .state('app.game.report', {
            url: '/report?start&end',
            templateUrl: 'app/pages/game/_report.html'
        });
}

})();
(function() {
'use strict';

angular
    .module('Noscope')
    .controller('GameController', GameController);

/** @ngInject */
function GameController(Restangular, $state, moment, $filter, Game, LiveStats, TitleService, GameChartConfig, UrlService) {
    var vm = this;

    function init() {
        var slug = $state.params.slug;
        vm.game = Game;
        vm.game.liveStats = LiveStats;
      
        TitleService.set(vm.game.title);
        UrlService.setParameter('slug', vm.game.slug, 'quiet');
    }

    init();
}
})();

(function() {
'use strict';

angular
    .module('Noscope')
    .config(ChannelRoute);

/** @ngInject */
function ChannelRoute($stateProvider) {
    $stateProvider
        .state('app.channel', {
            url: '/channels/{platform}/{channel}?start&end&tab&game',
            templateUrl: 'app/pages/channel/channel.html',
            controller: 'ChannelController',
            controllerAs: 'cChannel',
            reloadOnSearch: false,
            resolve: {
                /** @ngInject */
                Channel: function($stateParams, $state, ApiV1) {

                    return ApiV1.one('twitch')
                        .one('channels', $stateParams.channel)
                        .get();
                },
                /** @ngInject */
                Peek: function(Channel) {
                    
                    return Channel
                        .one('peek')
                        .get();
                }
            }
        })
}

})();
(function() { //Refactored
'use strict';

angular
    .module('Noscope')
    .controller('ChannelController', ChannelController);

    /** @ngInject */
    function ChannelController(Channel, Peek, TitleService, $filter, $state, UrlService) { 
        var vm = this;
    
        vm.channel = Channel;
        vm.channel.peek = Peek;

        TitleService.set(vm.channel.display_name);
        UrlService.setParameter('channel', vm.channel.name, 'quiet');

        vm.channel.one('misc-stats').get()
            .then(function(stats) {
                vm.channel.miscStats = stats;
                vm.startTooltip = '<h4>Recent Starts</h4>';

                _.forEach(stats.stream_starts, function(start, i) {
                    var timestamp = $filter('dateUtcToLocal')(start);
                    timestamp = $filter('dateToFormat')(timestamp, 'h:mm A - MM/DD');

                    vm.startTooltip = vm.startTooltip + '<aside>' + timestamp + '</aside>';
                });
            });
        
  }
})();
(function() {
'use strict';

angular
    .module('Noscope')
    .config(ConfigRoute);

/** @ngInject */
function ConfigRoute($stateProvider) {
    $stateProvider
        //.state('app.rightNow', {
        .state('app.changelog', {
            url: '/changelog',
            templateUrl: 'app/pages/changelog/changelog.html',
            controller: 'ChangelogController',
            controllerAs: 'cChangelog',
            resolve: {
                /** @ngInject */
                Changelogs: function(Restangular) {
                    return Restangular.one('v1').one('changelogs').getList();
                }
            }
        });
}

})();
(function() {
'use strict';

angular
    .module('Noscope')
    .controller('ChangelogController', ChangelogController);

/** @ngInject */
function ChangelogController(Changelogs, Restangular, UserObjectService, localStorageService) {
    var vm = this;

    function init() {
        vm.changelogs = Changelogs;
        vm.user = UserObjectService.get();
        vm.newAfter = vm.user.last_changelog_id || 0;

        if(vm.user.changelogCount > 0) {
            resetNewCount();
        }
    }

    function resetNewCount() {
        Restangular.one('v1').one('changelogs').post('reset')
            .then(function() {
                vm.user.changelogCount = 0;
                vm.user.last_changelog_id = vm.changelogs[0].id;
                UserObjectService.set(vm.user);
                localStorageService.set('user', vm.user);
            });
}

    init();
}

})();
(function () { // Refactored
  'use strict';

  angular
    .module('Noscope')
    .config(campaignsRoute);

/** @ngInject */
  function campaignsRoute ($stateProvider) {
    var dir = 'app/pages/campaigns/';

    var index = {
      url: '/campaigns',
      templateUrl: dir + 'index/campaigns--index.html',
      controller: 'CampaignsIndexController',
      controllerAs: 'cCampaignsIndex',
      resolve: {
            /** @ngInject */
        Campaigns: function (ApiV1) {
          return ApiV1.one('campaigns').getList();
        }
      }
    };

    var show = {
      url: '/campaigns/:campaignId?day',
      templateUrl: dir + 'show/campaign--show.html',
      controller: 'CampaignsShowController',
      controllerAs: 'cCampaignsShow',
      resolve: {
            /** @ngInject */
        Campaign: function (ApiV1, $stateParams) {
          return ApiV1.one('campaigns', $stateParams.campaignId).get();
        }
      }
    };

    var create = {
      url: '/campaigns/new',
      templateUrl: dir + 'create/campaign--create.html',
      controller: 'CampaignsCreateController',
      controllerAs: 'cCampaignsCreate',
      params: {
        template: null
      },
      resolve: {
            /** @ngInject */
        EditCampaign: function ($stateParams, ApiV1) {
          if ($stateParams.template) {
            return ApiV1.one('campaigns', $stateParams.template).get({ 'v0': true });
          }

          return false;
        }
      }
    };

    var edit = {
      url: '/campaigns/{campaign}/edit',
      templateUrl: dir + 'create/campaign--create.html',
      controller: 'CampaignsCreateController',
      controllerAs: 'cCampaignsCreate',
      resolve: {
            /** @ngInject */
        EditCampaign: function (ApiV1, $stateParams) {
          return ApiV1.one('campaigns', $stateParams.campaign).get({ 'v0': true });
        }
      }
    };

    $stateProvider
        .state('app.campaigns', index)
        .state('app.newCampaign', create)
        .state('app.campaign', show)
        .state('app.editCampaign', edit);
  }
})();

(function() {
'use strict';

angular
    .module('Noscope')
    .filter('wrapCssUrl', wrapCssUrl);

/** @ngInject */
function wrapCssUrl() {
    return function(input) {
        if(!input) {
            return 'none';
        }

        return 'url(' + input + ')';
    };
}

})();

(function() {
'use strict';

angular
    .module('Noscope')
    .filter('urlencode', urlencode);

/** @ngInject */
function urlencode() {
    return function(input) {
        return escape(input);
    };
}

})();

(function() {
'use strict';

angular
    .module('Noscope')
    .filter('urlIgdbImage', urlIgdbImageFilter);

/** @ngInject */
function urlIgdbImageFilter() {
    return function(id, size) {
        if(!id) {
            return false;
        }

        var imageSize = size || 'cover_big_2x';
        var url = '//images.igdb.com/igdb/image/upload/t_' + imageSize + '/' + id + '.jpg';

        return url;
    };
}

})();

(function() {
'use strict';

angular
    .module('Noscope')
    .filter('urlBoxart', urlBoxartFilter);

/** @ngInject */
function urlBoxartFilter() {
    return function(input, height, width) {

        height = height || 272;
        width = width || Math.round((height)*0.7263);
        
        var base = "https://static-cdn.jtvnw.net/ttv-boxart/";

        var size = "-272x380";

        return (base + encodeURIComponent(input) + size + ".jpg").replace("'", '%27');
    };
}

})();
(function() {
'use strict';

angular
    .module('Noscope')
    .filter('unsafe', unsafeFilter);

/** @ngInject */
function unsafeFilter($sce) {
    return $sce.trustAsResourceUrl; 
}

})();
(function() {
'use strict';

angular
    .module('Noscope')
    .filter('avatar', avatarFilter);

/** @ngInject */
function avatarFilter() {
    return function(image) {
        return image || '/assets/images/blank-user.png';
    };
}

})();
(function() {
'use strict';

angular
    .module('Noscope')
    .filter('indexToDay', indexToDay);

/** @ngInject */
function indexToDay() {
    return function(input) {
        if(isNaN(input) || input > 6) {
            return 'Invalid Day'
        }

        return [ 'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday' ][input];
    };
}

})();

(function() {
'use strict';

angular
    .module('Noscope')
    .filter('firstLetter', firstLetter);

/** @ngInject */
function firstLetter() {
    return function(input, length) {

        if(!input) {
            return 'N/A';
        }

        function deromanize (str) {
            str = str.toUpperCase();
            var validator = /^M*(?:D?C{0,3}|C[MD])(?:L?X{0,3}|X[CL])(?:V?I{0,3}|I[XV])$/,
                token = /[MDLV]|C[MD]?|X[CL]?|I[XV]?/g,
                key = {M:1000,CM:900,D:500,CD:400,C:100,XC:90,L:50,XL:40,X:10,IX:9,V:5,IV:4,I:1},
                num = 0, m;
            if (!(str && validator.test(str))) {
                return false;
            }
            while ((m = token.exec(str)) !== null) {
                num += key[m[0]];
            }
            return num;
        }

        input = input.replace("'", '');

        var wordArray = input.split(/[\s,-]+/);
        angular.forEach(wordArray, function(v, i) {
            v = v.replace(':', '');
            var validator = /^M*(?:D?C{0,3}|C[MD])(?:L?X{0,3}|X[CL])(?:V?I{0,3}|I[XV])$/;
            
            if(validator.test(v)) {
                wordArray[i] = deromanize(v);
            }
        });

        var str = wordArray.join(' ');
        var matches = str.match(/\b(\w)/g);

        if(!matches) {
            return '-';
        }

        if(length && matches.length > length) {
            matches = matches.slice(0,length);
            matches.push('...');
        }

        var acronym = matches.join('');
        
        return acronym;
    };
}

})();
(function() {
'use strict';

angular
    .module('Noscope')
    .filter('round', roundFilter);

/** @ngInject */
function roundFilter() {
    return function(number, fractionSize) {
        var fraction = fractionSize || 0;

        if(!number) {
            return number;
        }

        return parseFloat(number).toFixed(parseInt(fraction));
    };
}

})();
(function() {
'use strict';

angular
    .module('Noscope')
    .filter('plusMinus', plusMinus);

/** @ngInject */
function plusMinus() {
    return function(input) {
        if(input > 0) {
            return '+' + input;
        }

        return input;
    };
}

})();
(function() {
'use strict';

angular
    .module('Noscope')
    .filter('percentageOf', percentageOf);

/** @ngInject */
function percentageOf() {
    return function(current, average) {

        if(!current || !average) {
            return 0;
        }

        var difference = current-average;

        return (difference/average)*100
    };
}

})();
(function() {
'use strict';

angular
    .module('Noscope')
    .filter('ordinal', ordinal);

/** @ngInject */
function ordinal($filter) {
    return function(input) {
        var s = ["th","st","nd","rd"],
        v = input%100;
        
        return $filter('number')(input)+(s[(v-20)%10]||s[v]||s[0]);
    };
}

})();
(function() {
'use strict';

angular
    .module('Noscope')
    .filter('dashedNumber', dashedNumber);

/** @ngInject */
function dashedNumber() {
    return function(input) {
        if(!input) 
            return '';
        
        return input.toString().match(/\d{3}(?=\d{2,3})|\d+/g).join("·");
    };
}
})();
(function() {
'use strict';

angular
    .module('Noscope')
    .filter('bigNumber', bigNumber);

/** @ngInject */
function bigNumber($filter) {
    return function(number, fractionSize) {
        if(number === null) {
            return null;
        }

        number = parseInt(number);

        if(number < 10000) {
            return $filter('number')(number);
        }

        if(!fractionSize || fractionSize < 0) {
            fractionSize = 1;
        }

        var abs = Math.abs(number);
        var rounder = Math.pow(10,fractionSize);
        var isNegative = number < 0;
        var key = '';
        var powers = [
            {key: "Q", value: Math.pow(10,15)},
            {key: "T", value: Math.pow(10,12)},
            {key: "B", value: Math.pow(10,9)},
            {key: "M", value: Math.pow(10,6)},
            {key: "K", value: 1000}
        ];

        for(var i = 0; i < powers.length; i++) {

            var reduced = abs / powers[i].value;

            reduced = Math.round(reduced * rounder) / rounder;

            if(reduced >= 1){
                abs = reduced;
                key = powers[i].key;
                break;
            }
        }

        return (isNegative ? '-' : '') + abs + key;
    };
}

})();
(function() {
'use strict';

angular
    .module('Noscope')
    .filter('absoluteValue', absoluteValue);

/** @ngInject */
function absoluteValue($filter) {
    return function(input) {
        return Math.abs(input);
    };
}
})();
(function() {
'use strict';

angular
    .module('Noscope')
    .filter('timeToLocal', timeToLocal);

/** @ngInject */
function timeToLocal(moment) {
    return function(time) {
        var now = new moment();
        var M = new moment.utc(now.format("YYYY-MM-DD ") + time);
        return M.local().format('h:mm A');
    };
}
})();
(function() {
'use strict';

angular
    .module('Noscope')
    .filter('stringToDuration', stringToDuration);

/** @ngInject */
function stringToDuration(moment) {
    return function(date) {
        return new moment.duration(date);
    };
}

})();
(function() {
'use strict';

angular
    .module('Noscope')
    .filter('durationToTimestamp', durationToTimestamp);

/** @ngInject */
function durationToTimestamp(moment) {
    return function(val, units) {

        var input = moment.duration().add(val, units);
         var hours = Math.floor(input.asHours());
        var days = input.days();
        var minutes = Math.ceil(input.minutes()/ 10) * 10;

        if(minutes === 60) {
            hours++;
            minutes = 0;
        }
      
        return hours + ":" + ((minutes < 10) ? ("0" + minutes) : minutes);
    };
}

})();
(function() {
'use strict';

angular
    .module('Noscope')
    .filter('durationToFormat', durationToFormat);

/** @ngInject */
function durationToFormat(moment) {
    return function(date, formatString) {
        return date.minutes() + ':' + date.seconds();
    };
}

})();
(function() {
'use strict';

angular
    .module('Noscope')
    .filter('durationBetweenDates', durationBetweenDates);

/** @ngInject */
function durationBetweenDates(moment, ENV) {
    return function(start, end) {

        var startTimestamp = moment(start).unix();
        var endTimestamp = moment(end).add(ENV.pullInterval, 'minutes').unix();
      
        return endTimestamp - startTimestamp;
    };
}

})();
(function() {
'use strict';

angular
    .module('Noscope')
    .filter('dateUtcToLocal', dateUtcToLocal);

/** @ngInject */
function dateUtcToLocal(moment) {
    return function(date) {
        if(moment.isMoment(date)) {
            return date.local();
        }

        return new moment.utc(date).local();
    };
}
})();
(function() {
'use strict';

angular
    .module('Noscope')
    .filter('dateToUrl', dateToUrl);

/** @ngInject */
function dateToUrl(moment) {
    return function(date, formatString) {
        return moment(date).format('YYYY-MM-DD_HH-mm');
    };
}

})();
(function() {
'use strict';

angular
    .module('Noscope')
    .filter('dateToTimeAgo', dateToTimeAgo);

/** @ngInject */
function dateToTimeAgo(moment) {
    return function(date) {
        return moment(date).fromNow();
    };
}

})();
(function() {
'use strict';

angular
    .module('Noscope')
    .filter('dateToSince', dateToSince);

/** @ngInject */
function dateToSince(moment) {
    return function(date) {
        return moment(date).fromNow();
    };
}

})();
(function() {
'use strict';

angular
    .module('Noscope')
    .filter('dateToFormat', dateToFormat);

/** @ngInject */
function dateToFormat(moment) {
    return function(date, formatString) {
        return moment(date).format(formatString);
    };
}

})();
(function() {
'use strict';

angular
    .module('Noscope')
    .filter('dateToCalendar', dateToCalendar);

/** @ngInject */
function dateToCalendar(moment) {
    return function(date) {
        return moment(date).calendar();
    };
}

})();
(function() {
'use strict';

angular
    .module('Noscope')
    .filter('dateLocalToUtc', dateLocalToUtc);

/** @ngInject */
function dateLocalToUtc(moment) {
    return function(date) {
        return moment(date).utc();
    };
}

})();
(function() {
  'use strict';

  angular
    .module('Noscope')
    .filter('dateDayStart', dateDayStart);

  /** @ngInject */
  function dateDayStart(moment) {
    return function(date) {
      if(moment.isMoment(date)) {
        return date.startOf('day');
      }

      return new moment(date).startOf('day');
    };
  }
})();
(function() {
'use strict';

angular
    .module('Noscope')
    .filter('toArray', toArrayFilter);

/** @ngInject */
function toArrayFilter() {
    return function (obj, addKey) {
        if (!angular.isObject(obj)) return obj;
        
        if ( addKey === false ) {
            return Object.keys(obj).map(function(key) {
                return obj[key];
            });
        } else {
            return Object.keys(obj).map(function (key) {
                var value = obj[key];
                return angular.isObject(value) ?
                    Object.defineProperty(value, '$key', { enumerable: false, value: key}) :
                { $key: key, $value: value };
            });
        }
    };
}
})();
(function() {
'use strict';

angular
    .module('Noscope')
    .filter('sumProperty', sumProperty);

/** @ngInject */
function sumProperty() {
    return function(inputArray, property) {
        var total = 0;

        angular.forEach(inputArray, function(item) {
            if(item[property]) {
                total = total + parseInt(item[property]);
            }
        });

        return total;
    };
}

})();
(function() {
'use strict';

angular
    .module('Noscope')
    .filter('streamAverageViewers', streamAverageViewers);

/** @ngInject */
function streamAverageViewers() {
    return function(inputArray, totalCount, count) {
        var total = 0;
        var countTotal = 0;

        angular.forEach(inputArray, function(item) {
            total = total +  parseInt(item[totalCount]) * parseInt(item[count]);
            countTotal = countTotal +  parseInt(item[count]);
        });

        if(countTotal === 0) {
            return false;
        }

        return total/countTotal;
    };
}

})();
(function() {
'use strict';

angular
    .module('Noscope')
    .filter('notNullPropertyCount', notNullPropertyCount);

/** @ngInject */
function notNullPropertyCount() {
    return function(inputArray, property) {
        var total = 0;

        angular.forEach(inputArray, function(item) {
            if(item[property] && property !== 0) {
                total++;
            }
        });

        return total;
    };
}

})();
(function() {
'use strict';

angular
    .module('Noscope')
    .filter('maxProperty', maxProperty);

/** @ngInject */
function maxProperty() {
    return function(inputArray, property) {
        var max = 0;

        angular.forEach(inputArray, function(item) {
            if(item[property] && max < item[property]) {
                max = parseInt(item[property]);
            }
        });

        return max;
    };
}

})();
(function() {
  'use strict';

  angular
    .module('Noscope')
    .factory('ReportChartConfig', ReportChartConfig);

  /** @ngInject */
  function ReportChartConfig() {

    return {
      chart: {
        type: 'line',
        animation: false,
        spacingTop: -15,
        spacingLeft: 5, 
        spacingRight: 5,
        spacingBottom: 30,
      },
      plotOptions: {
        line: {
          animation: false,
          lineWidth: 4,
          color: '#F85829',
          states: {
            hover: { halo: { size: 4 }, lineWidthPlus: 0 }
          }
        }
      },
      title: {
        text: 'Viewers',
        margin: 0,
        align: 'left',
        y: 35,
        x: 5,
        style: {
          fontWeight: 900,
          fontFamily: "'Lato', 'Helvetica', sans-serif",
          textTransform: 'uppercase',
          fontSize: 11,
          color: '#444',
        },
      },
      rangeSelector: {
        enabled: false,
        selected: 1,
        inputEnabled: false,
        height: 26,
        labelStyle: { display: 'none' },
        buttonTheme: {
          height: 14,
          fill: 'transparent',
          style: {
            fontSize: 11,
            color: '#999',
            fontWeight: '700',
            fontFamily: "'Lato', 'Helvetica', sans-serif",
            background: '#fff',
            textTransform: 'uppercase'
          },
          states: {
            hover: {
              fill: '#FB5719',
              style: { color: '#eee', backgroundColor: 'transparent' }
            },
            select: {
              fill: '#FB5719',
              style: { color: '#fff', fontWeight: 700 }
            },
            disabled: {
              style: { color: '#dcdcdc', cursor: 'default' }
            }
          }
        },
        buttons: [
          { type: 'day', count: 7, text: '7d' }, 
          { type: 'day', count: 14, text: '14d' }, 
          { type: 'day', count: 30, text: '30d' }, 
          { type: 'year', count: 1, text: '1y' }, 
          { type: 'mtd', text: 'MTD' },
          { type: 'ytd', text: 'YTD' }, 
          { type: 'all', text: 'All' }
        ]
      },
      credits: { enabled: false },
      navigator: {
        adaptToUpdatedData: false,
        enabled: true,
        maskInside: false,
        maskFill: 'rgba(250, 250, 250, 0.8)',
        outlineWidth: 1,
        outlineColor: '#dfdfdf',
        height: 50,
        margin: 10,
        series: {
          lineWidth: 3,
          color: '#F85829',
          fillOpacity: 0.1
        },
        handles: { backgroundColor: '#bbb', borderColor: '#eee' },
        xAxis: {
          labels: {
            y: 12,
            align: 'center',
            style: {
              fontWeight: 700,
              fontFamily: "'Lato', 'Helvetica', sans-serif",
              textTransform: 'uppercase',
              fontSize: 8.5,
              color: '#888'
            }
          }
        }
      },
      scrollbar: { enabled: false },
      tooltip: {
        backgroundColor: '#1F2427',
        borderRadius: 6,
        borderWidth: 0,
        shadow: false,
        headerFormat: '<p style="text-transform: uppercase; padding-bottom: 3px; font-size: 11px; font-weight: 700; margin-top: -2px">{point.key}</p>',
        useHTML: true,
        pointFormatter: function() {
          return '<div style="font-size: 13px; font-weight: 400; text-align: center;">' + this.series.name + ': ' +  this.y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + "</div>";
        },
        style: {
          color: '#fff',
          padding: '10px 20px',
          fontFamily: "'Lato', 'Helvetica', sans-serif"
        }
      },
      xAxis: {
        type: 'datetime',
        tickPosition: 'outside',
        tickLength: 4,
        tickWidth: 2,
        tickColor: '#ddd',
        lineColor: '#ddd',
        lineWidth: 2,
        events: {

        },
        labels: {
          y: 15,
          style: {
            fontWeight: 700,
            fontFamily: "'Lato', 'Helvetica', sans-serif",
            textTransform: 'uppercase',
            fontSize: 10,
            color: '#888'
          }
        },
        crosshair: {
          color: '#ddd'
        }
      },
      yAxis: {
        gridLineColor: '#EDEFF1',
        gridLineWidth: 1,
        alternateGridColor: '#F9FAFA',
        labels: {
          enabled: true,
          x: -4,
          y: -4,
          style: {
            fontWeight: 700,
            fontFamily: "'Lato', 'Helvetica', sans-serif",
            textTransform: 'uppercase',
            fontSize: 9,
            color: '#aaa'
          },
          zIndex: 1
        }
      }
    }
  }
})();
(function() {
  'use strict';

  angular
    .module('Noscope')
    .factory('PeeksChartFactory', PeeksChartFactory);

  /** @ngInject */
  function PeeksChartFactory() {
    var charts = {};

    charts.vod = {
      chart: {
        type: 'column',
        animation: false,
        spacingLeft: 0,
        spacingRight: 0,
        spacingBottom: 0,
        spacingTop: 0,
      },
      plotOptions: {
        column: {
          marker: {

          }
        }
      },
      title: {
        text: false
      },
      legend: {
        enabled: false
      },
      xAxis: {
        labels: {
          enabled: false
        }
      },
      yAxis: {
        title: false,
        labels: {
          enabled: false
        }
      },
      credits: { enabled: false },
      tooltip: {
        backgroundColor: '#1F2427',
        borderRadius: 6,
        borderWidth: 0,
        shadow: false,
        headerFormat: '<p style="text-transform: uppercase; padding-bottom: 3px; font-size: 11px; font-weight: 700; margin-top: -2px">{point.key}</p>',
        useHTML: true,
        pointFormatter: function() {
          return [ 
            '<div style="font-size: 13px; font-weight: 400;">', 
              this.series.name + ' - ' + this.y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
              ((this.estimated) ? ' (estimate)' : '' ),
            '</div>'
          ].join('');
        },
        style: {
          color: '#fff',
          padding: '10px 20px',
          fontFamily: "'Lato', 'Helvetica', sans-serif"
        }
      }
    };

    charts.stream = {
      chart: {
        type: 'line',
        animation: false,
        spacingLeft: 5,
        spacingRight: 5,
        spacingBottom: 30,
        spacingTop: 0,
        //backgroundColor: '#f8f8f8'
      },
      plotOptions: {
        line: {
          marker: {
            enabled: false,
            symbol: 'circle'
          },
          fillOpacity: 0.1,
          animation: false,
          lineWidth: 4,
          states: {
            hover: { halo: { size: 4 } }
          }
        }
      },
      title: {
        text: false
      },
      legend: {
        enabled: false
      },
      credits: { enabled: false },
      tooltip: {
        backgroundColor: '#1F2427',
        borderRadius: 6,
        borderWidth: 0,
        shadow: false,
        headerFormat: '<p style="text-transform: uppercase; padding-bottom: 3px; font-size: 11px; font-weight: 700; margin-top: -2px">{point.key}</p>',
        useHTML: true,
        pointFormatter: function() {
          return [ 
            '<div style="font-size: 13px; font-weight: 400;">', 
              this.series.name + ' - ' + this.y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
              ((this.estimated) ? ' (estimate)' : '' ),
            '</div>'
          ].join('');
        },
        style: {
          color: '#fff',
          padding: '10px 20px',
          fontFamily: "'Lato', 'Helvetica', sans-serif"
        }
      },
      xAxis: {
        type: 'datetime',
        tickPosition: 'outside',
        tickLength: 4,
        tickWidth: 2,
        tickColor: '#ddd',
        lineColor: '#ddd',
        lineWidth: 2,
        dateTimeLabelFormats: {
          second: '%l:%M%p',
          minute: '%l:%M%p',
          hour: '%l:%M%p',
          day: '<strong>%m/%e/%y</strong>',
          week: '%Y<br/>%m-%d',
          month: '%Y-%m',
          year: '%Y'
        },
        title: {
          text: false
        },
        labels: {
          y: 15,
          style: {
            fontWeight: 700,
            fontFamily: "'Lato', 'Helvetica', sans-serif",
            textTransform: 'uppercase',
            fontSize: 10,
            color: '#888'
          }
        },
        crosshair: {
          color: '#ddd'
        }
      },
      yAxis: {
        gridLineColor: '#EDEFF1',
        gridLineWidth: 1,
        alternateGridColor: '#F9FAFA',
        opposite: true,
        title: {
          text: false
        },
        labels: {
          enabled: true,
          align: 'right',
          x: -4,
          y: -6,
          style: {
            fontWeight: 700,
            fontFamily: "'Lato', 'Helvetica', sans-serif",
            textTransform: 'uppercase',
            fontSize: 9,
            color: '#ccc'
          },
          zIndex: 1
        }
      }
    }

    return {
      stream: angular.copy(charts.stream),
      vod: angular.copy(charts.vod),
    };
  }
})();
(function() {
  'use strict';

  angular
    .module('Noscope')
    .factory('NowChartConfig', NowChartConfig);

  /** @ngInject */
  function NowChartConfig() {

    return {
      chart: {
        type: 'line',
        animation: false,
        spacingTop: 0,
        spacingLeft: 0, 
        spacingRight: 0,
        spacingBottom: 10,
      },
      plotOptions: {
        line: {
          animation: false,
          lineWidth: 4,
          color: '#F85829',
          states: {
            hover: { halo: { size: 4 } }
          }
        }
      },
      rangeSelector: {
        enabled: false,
        selected: 2,
        inputEnabled: false,
        height: 26,
        labelStyle: { display: 'none' },
        buttonTheme: {
          height: 14,
          fill: 'transparent',
          style: {
            fontSize: 11,
            color: '#999',
            fontWeight: '700',
            fontFamily: "'Lato', 'Helvetica', sans-serif",
            background: '#fff',
            textTransform: 'uppercase'
          },
          states: {
            hover: {
              fill: '#FB5719',
              style: { color: '#eee', backgroundColor: 'transparent' }
            },
            select: {
              fill: '#FB5719',
              style: { color: '#fff', fontWeight: 700 }
            },
            disabled: {
              style: { color: '#dcdcdc', cursor: 'default' }
            }
          }
        },
        buttons: [
          { type: 'day', count: 7, text: '7d' }, 
          { type: 'day', count: 14, text: '14d' }, 
          { type: 'day', count: 30, text: '30d' }, 
          { type: 'year', count: 1, text: '1y' }, 
          { type: 'mtd', text: 'MTD' },
          { type: 'ytd', text: 'YTD' }, 
          { type: 'all', text: 'All' }
        ]
      },
      credits: { enabled: false },
      navigator: {
        adaptToUpdatedData: false,
        baseSeries: 2,
        enabled: false,
        maskInside: false,
        maskFill: 'rgba(250, 250, 250, 0.8)',
        outlineWidth: 1,
        outlineColor: '#dfdfdf',
        height: 40,
        margin: 10,
        series: {
          lineWidth: 3,
          color: '#F85829',
          fillOpacity: 0.1
        },
        handles: { backgroundColor: '#bbb', borderColor: '#eee' },
        xAxis: {
          labels: {
            y: 12,
            align: 'center',
            style: {
              fontWeight: 700,
              fontFamily: "'Lato', 'Helvetica', sans-serif",
              textTransform: 'uppercase',
              fontSize: 8.5,
              color: '#888'
            }
          }
        }
      },
      scrollbar: { enabled: false },
      tooltip: {
        backgroundColor: '#1F2427',
        borderRadius: 6,
        borderWidth: 0,
        shadow: false,
        headerFormat: '<p style="border-bottom: 1px solid rgba(255,255,255,0.1); text-transform: uppercase; padding-bottom: 5px; font-size: 12px; font-weight: 600; margin-top: -4px; margin-bottom: 5px">{point.key}</p>',
        xDateFormat: '%l:%M%p',
        useHTML: true,
        pointFormatter: function() {
          return '<div style="padding: 2px 0; font-size: 12px; font-weight: 400; text-align: left;"><div style="display: inline-block; width: 90px;"><b>' + this.series.name + '</b>:</div> ' +  this.y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + "</div>";
        },
        style: {
          color: '#fff',
          padding: '10px 20px',
          fontFamily: "'Lato', 'Helvetica', sans-serif"
        }
      },
      xAxis: {
        type: 'datetime',
        tickPosition: 'outside',
        tickLength: 4,
        tickWidth: 2,
        tickColor: '#ddd',
        lineColor: '#ddd',
        lineWidth: 2,
        dateTimeLabelFormats: {
          millisecond: '%l:%M%p',
          second: '%l:%M%p',
          minute: '%l:%M%p',
          hour: '%l:%M%p',
          day: '%l:%M%p',
          week: '%l:%M%p',
          month: '%l:%M%p',
          year: '%l:%M%p'
        },
        labels: {
          y: 15,
          style: {
            fontWeight: 700,
            fontFamily: "'Lato', 'Helvetica', sans-serif",
            textTransform: 'uppercase',
            fontSize: 10,
            color: '#888'
          }
        },
        crosshair: {
          color: '#ddd'
        }
      },
      yAxis: {
        gridLineColor: '#EDEFF1',
        gridLineWidth: 1,
        alternateGridColor: '#F9FAFA',
        labels: {
          enabled: true,
          x: -4,
          y: -4,
          style: {
            fontWeight: 700,
            fontFamily: "'Lato', 'Helvetica', sans-serif",
            textTransform: 'uppercase',
            fontSize: 9,
            color: '#aaa'
          },
          zIndex: 1
        }
      }
    }
  }
})();
(function() {
  'use strict';

  angular
    .module('Noscope')
    .factory('GameChartConfig', GameChartConfig);

  /** @ngInject */
  function GameChartConfig() {

    return {
      chart: {
        type: 'line',
        animation: false,
        spacingTop: 7,
        spacingLeft: 5, 
        spacingRight: 5,
        spacingBottom: 30,
      },
      plotOptions: {
        line: {
          animation: false,
          lineWidth: 4,
          color: '#F85829',
          states: {
            hover: { halo: { size: 4 } }
          }
        }
      },
      rangeSelector: {
        enabled: true,
        selected: 2,
        inputEnabled: false,
        height: 26,
        labelStyle: { display: 'none' },
        buttonTheme: {
          height: 14,
          fill: 'transparent',
          style: {
            fontSize: 11,
            color: '#999',
            fontWeight: '700',
            fontFamily: "'Lato', 'Helvetica', sans-serif",
            background: '#fff',
            textTransform: 'uppercase'
          },
          states: {
            hover: {
              fill: '#FB5719',
              style: { color: '#eee', backgroundColor: 'transparent' }
            },
            select: {
              fill: '#FB5719',
              style: { color: '#fff', fontWeight: 700 }
            },
            disabled: {
              style: { color: '#dcdcdc', cursor: 'default' }
            }
          }
        },
        buttons: [
          { type: 'day', count: 7, text: '7d' }, 
          { type: 'day', count: 14, text: '14d' }, 
          { type: 'day', count: 30, text: '30d' }, 
          { type: 'year', count: 1, text: '1y' }, 
          { type: 'mtd', text: 'MTD' },
          { type: 'ytd', text: 'YTD' }, 
          { type: 'all', text: 'All' }
        ]
      },
      credits: { enabled: false },
      navigator: {
        adaptToUpdatedData: false,
        enabled: true,
        maskInside: false,
        maskFill: 'rgba(250, 250, 250, 0.8)',
        outlineWidth: 1,
        outlineColor: '#dfdfdf',
        height: 40,
        margin: 10,
        series: {
          lineWidth: 3,
          color: '#F85829',
          fillOpacity: 0.1
        },
        handles: { backgroundColor: '#bbb', borderColor: '#eee' },
        xAxis: {
          labels: {
            y: 12,
            align: 'center',
            style: {
              fontWeight: 700,
              fontFamily: "'Lato', 'Helvetica', sans-serif",
              textTransform: 'uppercase',
              fontSize: 8.5,
              color: '#888'
            }
          }
        }
      },
      scrollbar: { enabled: false },
      tooltip: {
        backgroundColor: '#1F2427',
        borderRadius: 6,
        borderWidth: 0,
        shadow: false,
        headerFormat: '<p style="text-transform: uppercase; padding-bottom: 3px; font-size: 11px; font-weight: 700; margin-top: -2px">{point.key}</p>',
        useHTML: true,
        pointFormatter: function() {
          return '<div style="font-size: 13px; font-weight: 400; text-align: center;">' + this.series.name + ': ' +  this.y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + "</div>";
        },
        style: {
          color: '#fff',
          padding: '10px 20px',
          fontFamily: "'Lato', 'Helvetica', sans-serif"
        }
      },
      xAxis: {
        type: 'datetime',
        tickPosition: 'outside',
        tickLength: 4,
        tickWidth: 2,
        tickColor: '#ddd',
        lineColor: '#ddd',
        lineWidth: 2,
        labels: {
          y: 15,
          style: {
            fontWeight: 700,
            fontFamily: "'Lato', 'Helvetica', sans-serif",
            textTransform: 'uppercase',
            fontSize: 10,
            color: '#888'
          }
        },
        crosshair: {
          color: '#ddd'
        }
      },
      yAxis: {
        gridLineColor: '#EDEFF1',
        gridLineWidth: 1,
        alternateGridColor: '#F9FAFA',
        labels: {
          enabled: true,
          x: -4,
          y: -4,
          style: {
            fontWeight: 700,
            fontFamily: "'Lato', 'Helvetica', sans-serif",
            textTransform: 'uppercase',
            fontSize: 9,
            color: '#ccc'
          },
          zIndex: 1
        }
      }
    }
  }
})();
(function() {
'use strict';

angular
    .module('Noscope')
    .directive('nsRefreshMetaData', nsRefreshMetaData);

/** @ngInject */
function nsRefreshMetaData(ApiV1, moment) {
    return {
        restrict: 'A',
        scope: {
            game: '=game',
            loading: '=nsRefreshMetaDataLoading'
        },
        controller: function($scope, $element) {
            function doRefresh() {
                if($scope.loading) return;

                $scope.loading = true;
                $scope.$apply();

                ApiV1.one('games', $scope.game.id).post('refresh-meta')
                    .then(function(metaData) {
                        $scope.loading = false;

                        $scope.game.igdb_data = metaData.id ? metaData : false
                        $scope.game.meta_checked_at = moment().utc().format("YYYY-MM-DD HH:mm:ss");
                    });
            }

            $element.on('click', doRefresh);

            $scope.$on('$destroy', function() {
                $element.off('click', doRefresh);
            });
        }
    }
}
})();

(function () { // Refactored
  'use strict';

  angular
    .module('Noscope')
    .directive('workWith', workWith);

/** @ngInject */
  function workWith () {
    return {
      restrict: 'E',
      scope: {
        channel: '='
      },
      templateUrl: 'app/components/work-with/work-with.html',
        /** @ngInject */
      controller: function ($scope, UserObjectService, ApiV1, ENV) {

        $scope.user = UserObjectService.get();

        $scope.form = {
          email: $scope.user.email,
          notes: ''
        };

        $scope.toggle = function () {
          $scope.isOpen = !$scope.isOpen;
        };

        $scope.validateEmail = function (email) {
          var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return re.test(email.toLowerCase());
        };

        $scope.contact = function () {
          if ($scope.loading) {
            return false;
          }

          if (!$scope.validateEmail($scope.form.email)) {
            $scope.invalid = true;

            return false;
          }

          $scope.invalid = false;
          $scope.loading = true;

          $scope.channel.post('work-with', {
            notes: $scope.form.notes,
            email: $scope.form.email
          })
            .then(function (response) {
              $scope.done = true;
            });
        };
      }
    };
  }
})();

(function() {
'use strict';

angular
    .module('Noscope')
    .controller('TermsController', TermsController);

/** @ngInject */
function TermsController($scope, $rootScope, Terms, Agreed, localStorageService, Restangular) {
    $scope.terms = Terms;
    $scope.agreed = Agreed;

    function agree() {
        Restangular.one('v1').one('users', 'me').one('agree-to-terms').post()
            .then(function() {
                $rootScope.user.terms.agreed = true;
                localStorageService.set('user', $rootScope.user);
            })
    };

    $scope.close = function() {
        if(!$scope.agreed) {
            agree();
        }
        $scope.$close();
    }
}

})();
(function() {
'use strict';

angular
    .module('Noscope')
    .directive('tagger', taggerComponent);

/** @ngInject */
function taggerComponent() {
    return {
        restrict: 'E',
        replace: true,
        scope: { 
            model: '='
        },
        templateUrl: 'app/components/tagger/tagger.html',
        /** @ngInject */
        controller: function($scope, $timeout, ApiV1, UserTagsService) {

            function init() {
                $scope.loading = true;
                $scope.tagList = [];

                UserTagsService.get()
                    .then(function(tags) {
                        $scope.tagList = tags;
                    });
                         
                $scope.model.getList('tags')
                    .then(function(tags) {
                        $scope.loading = false;
                        $scope.tags = tags;
                    });
            }

            $scope.addTag = function(name) {
                $scope.tagModel = null;

                if(name.trim() === '') {
                    return false;
                }

                name = name.trim().toLowerCase();

                if(_.find($scope.tags, { name: name })) {
                    return false;
                }

                $scope.tags.push({ name: name });

                $scope.model.post('tags', { name: name })
                    .then(function(newTag) {
                        _.forEach($scope.tags, function(tag) {
                            if(tag.name === name) {
                                tag.id = newTag.id;
                            }
                        });

                        //Update Tags
                        UserTagsService.refresh()
                            .then(function() {
                                UserTagsService.get()
                                    .then(function(tags) {
                                        $scope.tagList = tags;
                                    });  
                            });
                        
                    });
            };

            $scope.delete = function(tag) {
                $timeout(function() {
                    $scope.tags = _.filter($scope.tags, function(listedTag) { 
                        return listedTag.id !== tag.id;
                    });
                }, 151);

                tag.hidden = true;

                //Update Tags
                UserTagsService.remove(tag.name);
                UserTagsService.get()
                    .then(function(tags) {
                        $scope.tagList = tags;
                    });
                
                ApiV1.one('tags', tag.id).remove()
                    .then(function() {
                        
                    });
            };

            init();
        }
    }
}
})();
(function() {
  'use strict';

angular
    .module('Noscope')
    .controller('VodController', VodController);

/** @ngInject */
function VodController(ENV, ApiV1, $interval, $scope, $timeout, $window, $uibModalInstance, channel, end, map, start, $document) {

    var vm = this;

    function getPeekOffset(peek) {
        var start = peek.start
        return start.diff(vm.start) * vm.secondWidth;
    }

    function windowSizes() {
        vm.height = ($window.innerHeight) -40;
        vm.width = ($window.innerWidth*0.94);
    }

    function setSizes() {

        vm.start  = moment.utc(_.head(vm.peeks).pulled_at);
        vm.end    = moment.utc(_.last(vm.peeks).pulled_at);
        vm.length = vm.end.diff(vm.start);
        vm.secondWidth = (vm.width/vm.length);

        vm.maxY = 0;
        vm.minY = 0;

        var peekWidth = (ENV.pullInterval * 60 * 1000) * vm.secondWidth;

        _.forEach(vm.peeks, function(v,i) {

            if(i === 0) {
                vm.maxY = v.viewers;
                vm.minY = v.viewers;
            }

            if(vm.maxY < v.viewers) {
                vm.maxY = v.viewers;
            }

            if(vm.minY > v.viewers) {
                vm.minY = v.viewers;
            }

            if(i === 0) {
                v.start = moment.utc(v.pulled_at);
                vm.peeks[i+1].start = moment.utc(vm.peeks[i+1].pulled_at);
            }

            if(i === vm.peeks.length-1) {
                v.start = moment.utc(v.pulled_at);
                v.width = peekWidth;
            } else {
                vm.peeks[i+1].start = moment.utc(vm.peeks[i+1].pulled_at)
                v.width = vm.peeks[i+1].start.diff(v.start) * vm.secondWidth;
            }

            v.distance = getPeekOffset(v);
        });

        vm.lineString = '';
        _.forEach(vm.peeks, function(v,i) {
            v.y = 50-45*((v.viewers-vm.minY)/(vm.maxY-vm.minY));

            if(i === 0) {
                vm.lineString = 'M ' + v.distance + ' ' + v.y;
            } else {
                vm.lineString = vm.lineString + ' L ' + v.distance + ' ' + v.y;
            }
        });
    }

    function setVodLimits(vod) {
        vod.start = moment(vod.created_at);
        vod.end   = moment(vod.created_at).add(vod.length, 'seconds');
        vod.size  = vm.secondWidth*(vod.length*1000);

        vod.offset  = (vod.start.diff(vm.start)) * vm.secondWidth;

        vod.preOffset  = (vm.start.diff(vod.start)) * vm.secondWidth;
        vod.postOffset = (vod.end.diff(vm.start)) * vm.secondWidth + vod.preOffset;
        vod.postLength = vm.width - (vod.postOffset);
    }

    vm.start   = start;
    vm.end     = end;
    vm.map     = map;
    vm.channel = channel;
    vm.vods    = [];
    vm.loading = true;
    vm.vodsPulled = [];

    vm.info = {
        height: 60,
        width: 150
    };

    vm.showInfo = function(peek) {
        vm.infoPeek = peek;
        $timeout(function() {
            var ele = document.querySelectorAll(".js-vodInfo")[0];
            var offset = peek.distance - (ele.offsetWidth/2) + 3;

            if(offset < 8) {
                offset = 8;
                vm.info.noArrow = true;
            } else if(offset + ele.offsetWidth > vm.width) {
                offset = vm.width - ele.offsetWidth;
                vm.info.noArrow = true;
            } else {
                vm.info.noArrow = false;
            }

            vm.infoMargin = offset;
        }, 1);

    };

    vm.render = function() {
        _.forEach(vm.streams, function(stream) {
            if(!vm.activeVod && vm.streamMap[stream]) {
                vm.activeVod = vm.streamMap[stream].vod;
                vm.changeVod(vm.activeVod);
            }
        });
    };

    function init() {

        vm.channel
            .one('peeks')
            .get({
                start:  vm.start.format(),
                end:    vm.end.format(),
                group: 'false'
            })
            .then(function(peeks) {
                vm.peeks = peeks;

                vm.streamMap = {};
                vm.streams = [];

                _.forEach(vm.peeks, function(peek) {
                    if(!vm.streamMap[peek.twitch_stream_id]) {
                        vm.streamMap[peek.twitch_stream_id] = {};
                        vm.streams.push(peek.twitch_stream_id);
                    }
                });

                _.forEach(vm.streams, function(streamId, i) {
                    $timeout(function() {
                        getVod(streamId);
                    }, 300*i)
                });

                windowSizes();
                setSizes();
            });
    }

    function getVod(streamId) {

        ApiV1.one('twitch')
            .one('streams', streamId)
            .one('vod')
            .get()
            .then(function(vod) {
                if(vod._id && moment(vod.created_at).add(vod.length, 's').isAfter(vm.start)) {
                    vm.streamMap[streamId].vod = vod;
                    setVodLimits(vm.streamMap[streamId].vod);
                } else {
                    vm.streamMap[streamId].vod = false;
                }

                vm.vodsPulled.push(streamId);

                var ready = true;

                _.forEach(vm.streamMap, function(stream) {
                    if(typeof stream.vod === 'undefined') {
                        ready = false;
                    }
                })

                if(ready) {
                    vm.render();
                }
            });
    }

    angular.element($window).bind('resize', function() {
        windowSizes();
        setSizes();

        _.forEach(vm.streamMap, function(stream) {
            if(stream.vod) {
                setVodLimits(stream.vod);
            }
        })

        $scope.$apply();
    });

    vm.seekTo = function(peek) {
        var seekTo = peek.start.diff(vm.activeVod.start)/1000;
        vm.player.seek(seekTo);
        vm.currentTime = vm.player.getCurrentTime()*1000;
    };

    vm.seekOffset = function() {
        return (vm.secondWidth * vm.currentTime) - vm.activeVod.preOffset;
    };

    vm.changeVod = function(vod) {
        vm.activeVod = vod;

        if(!vm.player) {
            vm.initVideo();
        } else {
            vm.player.setVideo(vod._id);
        }
    };

    vm.videoReady = function() {
        vm.infoElement = document.querySelectorAll(".js-vodInfo")[0];

        var interval = $interval(function() {
            vm.currentTime = vm.player.getCurrentTime() * 1000;
        }, 150)

        vm.player.addEventListener(Twitch.Player.PLAY, vm.videoPlaying);

        $scope.$on('modal.closing', function (event, data) {
            $interval.cancel(interval);

            vm.player.removeEventListener(Twitch.Player.READY, vm.videoReady);
            vm.player.removeEventListener(Twitch.Player.PLAY, vm.videoPlaying);
        });
    }

    vm.close = function() {
        $uibModalInstance.close();
    };

    vm.videoPlaying = function() {
        vm.loading = false;
    }

    vm.initVideo = function() {
        vm.player = new Twitch.Player("vod", {
            width: '100%',
            height: vm.height - 69,
            video: vm.activeVod._id,
        });


        vm.player.addEventListener(Twitch.Player.READY, vm.videoReady);
    }

    windowSizes();
    init();

    return vm;
}
})();

(function() {
'use strict';

angular
    .module('Noscope')
    .directive('streamBreakdown', streamBreakdown);

/** @ngInject */
function streamBreakdown(ExportService, ChartConfig, TwitchStream, PeeksChartFactory, ChartDataService, $uibModal, Restangular, $window, ApiV1, ENV, $timeout) {
    return {
        restrict: 'E',
        scope: {
            streamId: '@',
            channel: '=',
            start: '=',
            end: '=',
            showChannel: '='
        },
        templateUrl: 'app/components/stream-breakdown/stream-breakdown.html',
        /** @ngInject */
        controller: function($scope) {

            $scope.interval = ENV.pullInterval;

            $scope.chartConfig = {
                options: ChartConfig.get('steam-breakdown'),
                size: { width: 750, height: 320 },
                series: [],
                useHighStocks: true,
                loading: true
            };

            $scope.chartConfig.options.xAxis = {};
            $scope.chartConfig.options.xAxis.plotBands = [];

            $scope.sort = 'title';
            $scope.colors = Highcharts.getOptions().colors;

            $scope.openVod = function() {

                $uibModal.open({
                    templateUrl: 'app/components/stream-breakdown/vod.html',
                    size: 'vod',
                    //animation: false,
                    resolve: {
                        start:   $scope.segmentStart,
                        end:     $scope.segmentEnd,
                        map:     $scope.colorMap,
                        channel: $scope.model
                    },
                    controller: 'VodController',
                    controllerAs: 'cVod'
                });

            };

            $scope.changeSort = function(sort) {
                $scope.sort = ($scope.sort === sort) ? '-' + sort : sort;
            };

            $scope.close = function() {
                $scope.stream.breakdown = false;
            };

            function generateTotals(peeks) {
                var map = {};

                _.forEach(peeks, function(peek) {
                    if(!map[peek.twitch_game.id]) {
                        map[peek.twitch_game.id] = {
                            id: peek.twitch_game.id,
                            title: peek.twitch_game.title,
                            minutes_watched: 0,
                            total_viewers: 0,
                            peek_count: 0,
                            average_viewers: 0,
                            peak_viewers: 0
                        }
                    }

                    var game = map[peek.twitch_game.id];

                    game.minutes_watched = game.minutes_watched + (peek.viewers * $scope.interval);
                    game.total_viewers = game.total_viewers + peek.viewers;
                    if(peek.viewers > 0) {
                        game.peek_count++;
                    }
                    game.average_viewers = game.total_viewers/game.peek_count;
                    game.peak_viewers = game.peak_viewers < peek.viewers ?  peek.viewers : game.peak_viewers;
                });

                var output = [];

                _.forEach(map, function(game) {
                    output.push(game);
                });

                return output;
            }

            function determineIfVod(streams) {

                if(typeof $scope.iVod === 'undefined') {
                    $scope.iVod = 0;
                }

                if(typeof $scope.hasVod !== 'undefined' || !streams[$scope.iVod]) {
                    $scope.hasVod = false;
                    return false;
                }

                var streamId = streams[$scope.iVod];

                ApiV1.one('twitch')
                    .one('streams', streamId)
                    .one('vod')
                    .get()
                    .then(function(vod) {

                        if(vod._id && moment(vod.recorded_at).add(vod.length, 's').isAfter($scope.segmentStart)) {
                            $scope.hasVod = true;
                            return false;
                        }

                        $scope.iVod++;
                        determineIfVod(streams);
                    }, function() {
                        $scope.iVod++;
                        determineIfVod(streams);
                    });
            }

            $scope.fullBroadcast = function() {
                $scope.chartConfig.series = [];
                $scope.chartConfig.loading = true;
                $scope.fromSegment = true;

                delete $scope.iVod;
                delete $scope.hasVod;

                init(true);
            };

            $scope.segment = function() {
                $scope.chartConfig.series = [];
                $scope.chartConfig.loading = true;
                $scope.fromSegment = false;

                delete $scope.iVod;
                delete $scope.hasVod;

                init();
            };

            function getSegment() {
                var start = moment.utc($scope.start);
                var end   = moment.utc($scope.end).subtract(1, 'ms');

                //Determine which model to use
                if($scope.channel.restangularized) {
                    $scope.model = $scope.channel;
                } else {
                    $scope.model = ApiV1.one('twitch').one('channels', $scope.channel.id);
                }

                $scope.model
                    .one('peeks')
                    .get({
                        start:  $scope.segmentStart.local().format(),
                        end:    $scope.segmentEnd.local().format(),
                        group: 'false'
                    })
                    .then(function(peeks) {
                        $scope.peeks = peeks;
                        $scope.games = generateTotals(peeks);

                        $scope.colorMap = ChartDataService.colorMap(peeks, 'twitch_game');
                        $scope.chartConfig.series = ChartDataService.streamBreakdown(peeks, $scope.colorMap, moment(peeks[0].pullled_at), $scope.end);
                        //$scope.chartConfig.series = ChartDataService.streamBreakdown(peeks, $scope.colorMap, $scope.start, $scope.end);
                        $scope.chartConfig.loading = false;

                        var streams = {};

                        _.forEach($scope.peeks, function(peek) {
                            streams[peek.twitch_stream_id] = true;
                        });

                        $scope.streamCount = Object.keys(streams).length;
                        var streamIds = [];

                        _.forEach(streams, function(exists, streamId) {
                            streamIds.push(streamId);
                        });

                        determineIfVod(streamIds);

                        //Determine Missing Pieces of broadcast
                        if($scope.type === 'broadcast_segment') {
                            var segmentLength = $scope.segmentEnd.diff($scope.segmentStart);
                            var broadcastLength = $scope.streamEnd.diff($scope.streamStart);

                            $scope.missing = (broadcastLength - segmentLength)/1000;
                        }
                    });
            }

            $scope.exportGames = function() {

                var getData = function() {
                    var prepped = [];

                    _.forEach($scope.games, function(game) {
                        var newGame = angular.copy(game);

                        newGame.peek_count = newGame.peek_count * $scope.interval;
                        delete newGame.$$hashKey;
                        delete newGame.id;
                        delete newGame.total_viewers;

                        prepped.push(newGame);
                    });

                    return prepped;
                };

                ExportService.doExport({
                    title: $scope.channel.display_name + ' - Broadcast Games',
                    start: $scope.segmentStart,
                    end:   $scope.segmentEnd,
                    filename: $scope.channel.name + '-broadcast_games'
                }, [
                    'Game',
                    'Minutes Watched',
                    'Minutes Streamed',
                    'Average Viewers',
                    'Peak Viewers',
                ], getData);
            };

            function init(ignoreRange) {

                $scope.vods = [];
                $scope.chartConfig.options.xAxis.plotBands = [];

                //Moment Inputs
                var start = moment.utc($scope.start);
                var end   = moment.utc($scope.end).add($scope.interval, 'm').subtract(1, 'ms');

                if($scope.streamId) {
                    ApiV1.one('twitch')
                        .one('streams', $scope.streamId)
                        .get()
                        .then(function(stream) {
                            $scope.stream = stream;
                            $scope.streamStart = moment.utc(stream.pulled_at);
                            $scope.streamEnd = stream.full_ended_at ? moment.utc(stream.full_ended_at) : moment.utc(stream.ended_at).add(10, 'minute');

                            if($scope.start && $scope.end) {

                                //Trim Range
                                $scope.segmentStart = start.isBefore($scope.streamStart) || ignoreRange
                                    ? moment($scope.streamStart)
                                    : start;

                                $scope.segmentEnd = end.isAfter($scope.streamEnd) || ignoreRange
                                    ? moment($scope.streamEnd)
                                    : end;

                                if(ignoreRange) {
                                    $scope.chartConfig.options.xAxis.plotBands.push({
                                        label: {
                                            text: 'Segment',
                                            textAlign: 'left',
                                            align: 'left',
                                            x: 5,
                                            rotation: 90,
                                            style: {
                                                color: "#888",
                                                fontWeight: 300
                                            }
                                        },
                                        from: start.unix() * 1000,
                                        to:   end.unix() * 1000,
                                        zIndex: 2,
                                        color: 'rgba(0,0,0,0.05)',
                                    })
                                }

                                var segmentEndTest = moment($scope.segmentEnd).add(1, 'ms');

                                if($scope.segmentStart.isSame($scope.streamStart) && (segmentEndTest.isSame($scope.streamEnd) || $scope.segmentEnd.isSame($scope.streamEnd)) ) {
                                    $scope.type = 'broadcast'
                                } else {
                                    $scope.type = 'broadcast_segment'
                                }

                                getSegment();
                            } else {
                                $scope.segmentStart = $scope.streamStart;
                                $scope.segmentEnd   = $scope.streamEnd;
                                getSegment();
                                $scope.type = 'broadcast';
                            }
                        });
                } else if($scope.start && $scope.end) {
                    $scope.segmentStart = start;
                    $scope.segmentEnd   = end;
                    getSegment();
                    $scope.type = 'segment'
                }
            }

            init();
        }
    }
}
})();

(function() {
  'use strict';

  angular
    .module('Noscope')
    .directive('searchFilter', searchFilter);

  /** @ngInject */
  function searchFilter($q, $timeout, UserTagsService, $filter) {
    return {
      restrict: 'E',
      scope: {
        list: '=',
        type: '@',
        title: '@',
        selected: '=',
        callback: '=',
        loading: '=',
        options: '=',
        selectedOption: '='
      },
      templateUrl: 'app/components/search-filter/search-filter.html',
      /** @ngInject */
      controller: function($scope) {

        $scope.selectedTags = [];

        $scope.addToList = function(item, list) {
          if($scope.list.selectedGames && $scope.list.selectedGames[item.objectID]) {
            $scope.showGameMessage = true;
            return false;
          }
          
          list.push(item);
          $scope.callback();

          if($scope.type === 'game' || $scope.type === 'games') {
            $scope.list.selectedGames = $scope.list.selectedGames || {};
            $scope.list.selectedGames[item.objectID] = true;
          } else {
            item.selected = true;
          }
        };

        $scope.searchGames = function(searchString) {
          var defer = $q.defer();
          $scope.listSearchLoading = true;

          $scope.list.search(searchString)
            .then(function(content) {
              $scope.listSearchLoading = false;
              defer.resolve(content.hits);
            });

          return defer.promise;
        };

        $scope.searchTags = function(searchString) {
          var defer = $q.defer();
          $scope.searchLoading = true;

          UserTagsService.get()
            .then(function(tags) {
              var filteredResults = $filter('limitTo')($filter('filter')(tags, searchString), 8);
              defer.resolve(filteredResults);
              $scope.searchLoading = false;
            })

          return defer.promise;
        }

        $scope.addTag = function(tag) {
          if(_.find($scope.selectedTags, { name: tag.name })) {
            return false;
          }
          $scope.selectedTags.push(tag);
        } 

        $scope.setOption = function(item) {
          if(item.selected) {
            $scope.selectedOption = false;
            delete item.selected;
            $scope.callback();
            return false;
          }
          $scope.selectedOption = true;
          angular.forEach($scope.options, function(option) {
            if(option.selected) {
              delete option.selected;
            }
          });
          item.selected = true;
          $scope.callback();
        };

        $scope.setRange = function(min, max) {
          if($scope.loading) {
            return false;
          }

          if(min && max && min > max) {
            var oldMax = max;
            var oldMin = min;
            min = oldMax;
            max = oldMin;

            $scope.min = 22222;
          }
          $scope.selected.min = min;
          $scope.selected.max = max;
          $scope.callback();
        };

        $scope.removeFromList = function(index, list, item) {
          if($scope.loading) {
            return false;
          }

          if($scope.type === 'game' || $scope.type === 'games') {
            $scope.list.selectedGames = $scope.list.selectedGames || {};
            $scope.list.selectedGames[item.objectID] = false;
          } else {
            delete list[index].selected;
          }
          
          list.splice(index, 1);
          $scope.callback();
        }
      }
    }
  }
})();
(function() {
    "use strict";

    angular.module("Noscope").directive("search", search);

    /** @ngInject */
    function search() {
        return {
            restrict: "E",
            scope: {
                channel: "=",
            },
            templateUrl: "app/components/search/search.html",
            /** @ngInject */
            controller: function(
                SearchService,
                $scope,
                $timeout,
                $state,
                localStorageService,
                Restangular,
                $q,
                AlgoliaService,
                ApiV1
            ) {
                $scope.types = {
                    channel: "Channel",
                    game: "Game",
                };

                $scope.searchCategories = [
                    { title: "Channel", value: "channel" },
                    { title: "Game", value: "game" },
                ];

                $scope.savedSearch = localStorageService.get("search.type");
                $scope.currentSearch = $scope.savedSearch
                    ? $scope.savedSearch
                    : "channel";

                $scope.currentSearch =
                    $scope.currentSearch === "campaign"
                        ? "channel"
                        : $scope.currentSearch;

                $scope.setType = function(newType) {
                    $scope.currentSearch = newType.value;
                    $scope.focus = true;
                    localStorageService.set("search.type", newType.value);
                };

                $scope.goTo = function(result, $event) {
console.log(result);
                    if (result.name) {
                        $state.go("app.channel", {
                            channel: result.name,
                            platform: "twitch",
                            game: null,
                        });
                    } else if (result.title) {
                        $state.go("app.game", { slug: result.objectID });
                    }

                    $scope.blur();
                    $scope.$viewValue = "";
                };

                $scope.blur = function() {
                    $scope.focus = false;
                    $scope.noResults = false;
                    $scope.resultSelected = "";
                };

                $scope.gamesIndex = AlgoliaService.games();

                $scope.doSearch = function(searchString) {
                    if (searchString.length < 3) {
                        return false;
                    }

                    if ($scope.timeoutSearch) {
                        $scope.timeoutSearch.resolve();
                    }

                    $scope.timeoutSearch = $q.defer();

                    if ($scope.currentSearch === "channel") {
                        return ApiV1.one("search", "channels")
                            .withHttpConfig({ timeout: $scope.timeoutSearch })
                            .get({ limit: 8, query: searchString })
                            .then(function(response) {
                                var results = response.data;
                                return results;
                            });
                    }

                    if ($scope.currentSearch === "game") {
                        var defer = $q.defer();

                        $scope.gamesIndex
                            .search(searchString)
                            .then(function(content) {
                                defer.resolve(content.hits);
                            });

                        return defer.promise;
                    }
                };
            },
        };
    }
})();

(function() {
'use strict';

angular
    .module('Noscope')
    .controller('LoadedInfoController', LoadedInfoController);

/** @ngInject */
function LoadedInfoController($scope, ApiV1, UserObjectService) {

    $scope.user = UserObjectService.get();

    $scope.form = {
        email: $scope.user.email,
        notes: ''
    };

    $scope.close = function() {
        $scope.formOpen = false;
        $scope.$close();
    }

    $scope.open = function() {
        $scope.formOpen = true;
    }

    $scope.validateEmail = function (email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email.toLowerCase());
    };

    $scope.letsTalk = function() {
        if ($scope.loading) {
            return false;
        }

        if (!$scope.validateEmail($scope.form.email)) {
            $scope.invalid = true;

            return false;
        }


        $scope.loading = true;

        ApiV1.one('lets-talk')
            .post(null, {
                notes: $scope.form.notes,
                email: $scope.form.email
            })
            .then(function (response) {
                $scope.done = true;
            });
    }
}

})();

(function() {
'use strict';

angular
    .module('Noscope')
    .directive('growthReport', growthReportDirective);

/** @ngInject */
function growthReportDirective(ApiV1, ChartConfig, ChartDataService, ExportService) {
    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'app/components/growth-report/growth-report.html',
        scope: {
            channel: '='
        },
        link: function() {

        },
        controller: function($scope) {
            $scope.points = [];
            $scope.chart = {
                options: ChartConfig.get('timeline'),
                series: [],
                size: { height: 340, width: 849 },
                useHighStocks: false,
                loading: $scope.loading,
                metrics: [
                    { column: 'average_viewers_shorterm', title: 'Average Viewers (40hrs)' },
                    { column: 'average_viewers_longterm', title: 'Average Viewers (200hrs)' },
                    { column: 'followers',                title: 'Followers' },
                    { column: 'views',                    title: 'Views' }
                ]
            };

            function init() {
                $scope.channel.getList('historicals')
                    .then(function(response) {
                        $scope.historicals = response;

                        _.forEach($scope.historicals, function(historical) {
                            historical.pulled_at = moment.utc(historical.created_at).startOf('hour').local();
                            historical.start = moment(historical.pulled_at).subtract(1, 'day').unix();
                            historical.end = moment(historical.pulled_at).subtract(1, 'second').unix();
                        });

                        $scope.loading = false;
                        $scope.applyRange();
                    });

                $scope.inactive = moment.utc($scope.channel.last_streamed_at)
                    .isBefore(moment().subtract(7, 'days'));
            }

            function filterHistoricals() {
                var start = moment($scope.start).subtract(1, 'day').unix();
                var end   = moment($scope.end).add(1, 'day').unix();

                $scope.filteredHistoricals = [];

                _.forEach($scope.historicals, function(historical) {
                    if(historical.start >= start && historical.end <= end) {
                        $scope.filteredHistoricals.push(historical);
                    }
                });
            }

            function getDifference(series, property) {
                var first = _.head(series)[property];
                var last  = _.last(series)[property];

                return last - first;
            }

            function generateStats() {
                var stats = {
                    average_viewers_longterm: 0,
                    average_viewers_shorterm: 0,
                    followers: 0,
                    views: 0
                }

                if($scope.filteredHistoricals.length === 0) {
                    return stats;
                }

                return {
                    average_viewers_longterm: getDifference($scope.filteredHistoricals, 'average_viewers_longterm'),
                    average_viewers_shorterm: getDifference($scope.filteredHistoricals, 'average_viewers_shorterm'),
                    followers: getDifference($scope.filteredHistoricals, 'followers'),
                    views: getDifference($scope.filteredHistoricals, 'views')
                }
            }

            $scope.changeMetric = function(index) {
                $scope.chart.selectedMetric = $scope.chart.metrics[index];
                $scope.chart.series[0] = $scope.points[$scope.chart.metrics[index].column];
            }

            $scope.doExport = function() {
                var headers = [
                    'Recorded At',
                    'Average Viewers (40hrs)',
                    'Average Viewers (200hrs)',
                    'Followers',
                    'Views'
                ];

                var getData = function() {
                    var data = [];

                    _.forEach($scope.filteredHistoricals, function(historical) {
                        data.push({
                            recorded_at: historical.pulled_at,
                            average_viewers_shorterm: historical.average_viewers_shorterm,
                            average_viewers_longterm: historical.average_viewers_longterm,
                            followers: historical.followers,
                            views: historical.views
                        });
                    });

                    return data;
                };

                ExportService.doExport({
                    title: $scope.channel.display_name + ' - Growth',
                    start: $scope.start,
                    end:   $scope.end,
                    filename: $scope.channel.name + '-growth',
                    ignore: [],
                }, headers, getData);
            };

            $scope.applyRange = function() {
                filterHistoricals();

                if($scope.filteredHistoricals.length > 0) {

                    $scope.series = ChartDataService.process($scope.filteredHistoricals, {
                        metrics: $scope.chart.metrics
                    });

                } else {
                    $scope.series = [];
                }

                $scope.points = $scope.series;
                $scope.stats = generateStats();
            }

            $scope.loading = true;

            init();
            
        }
    }
}
})();

(function() {
'use strict';

/** @ngInject */
function gameReportController($window, $scope, ReportConfigFactory, $q, LanguageFactory, Report, $state, $stateParams, moment, ApiV1, RequestTimeoutService, ExportService, $interval, ENV, $filter, TimeframeFactory, ChartDataService, ChartConfig, $timeout, UrlService, OutageService, ChartHelpers) {
    var vm = this;

    var vis = (function(){
        var stateKey, eventKey, keys = {
            hidden: "visibilitychange",
            webkitHidden: "webkitvisibilitychange",
            mozHidden: "mozvisibilitychange",
            msHidden: "msvisibilitychange"
        };
        for (stateKey in keys) {
            if (stateKey in document) {
                eventKey = keys[stateKey];
                break;
            }
        }
        return function(c) {
            if (c) document.addEventListener(eventKey, c);
            return !document[stateKey];
        }
    })();

    vm.audio = new Audio('/assets/click.mp3');

    vm.defaults = {
        start: angular.copy(TimeframeFactory.timeline)[0].start,
        end:   angular.copy(TimeframeFactory.timeline)[0].end,
    }

    vm.$onInit = function() {
        vm.interval = ENV.pullInterval;
        vm.languageFactory = LanguageFactory.languageMap;

        vm.reports = {
            channels:     new Report(ReportConfigFactory.game.getChannels(vm.game)),
            days:         new Report(ReportConfigFactory.game.getDays(vm.game)),
            languages:    new Report(ReportConfigFactory.game.getLanguages(vm.game)),
            primaryGame:  new Report(ReportConfigFactory.game.getPrimaryGames(vm.game)),
            streams:      new Report(ReportConfigFactory.game.getStreams(vm.game)),
        }

        //Set values from URL parameters
        vm.start = ($stateParams.start) ? moment($stateParams.start) : vm.defaults.start;
        vm.end   = ($stateParams.end)   ? moment($stateParams.end)   : vm.defaults.end;
    }

    vm.chart = {
        options: ChartConfig.get('timeline'),
        series: [],
        size: { height: 340, width: 849 },
        useHighStocks: false,
        metrics: [
            { column: 'minutes_watched',  title: 'Minutes Watched' },
            { column: 'minutes_streamed', title: 'Minutes Streamed' },
            { column: 'best_rank',        title: 'Best Rank' },
            { column: 'average_viewers',  title: 'Average Viewers' },
            { column: 'average_streams',  title: 'Average Streams' },
            { column: 'peak_viewers',     title: 'Peak Viewers' },
        ],
    };

    vm.chart.options.plotOptions.series.cursor = 'pointer';
    vm.chart.options.plotOptions.series.events = { click: clickPoint }
    ChartHelpers.bootstrap(vm.chart);
    vm.chart.helpers.setPlotLine(moment().startOf('day'));

    vm.chartDay = {
        options: ChartConfig.get('timelineDay'),
        series: [],
        size: { height: 340, width: 849 },
        useHighStocks: false,
        metrics: [
            { column: 'viewers',      title: 'Viewers' },
            { column: 'stream_count', title: 'Stream Count' },
            { column: 'rank',         title: 'Rank' },
            { column: 'most_viewers', title: 'Peak Stream Viewers' },
            { column: 'top_ten',      title: 'Top 10 Channel Share', callback: function(series) {
                vm.getTopChannels(series);
            } },
        ]
    }

    vm.chartDay.options.plotOptions.series.cursor = 'pointer';
    vm.chartDay.options.plotOptions.series.events = { click: clickDayPoint }
    ChartHelpers.bootstrap(vm.chartDay);
    vm.chartDay.helpers.setPlotLine(moment());

    vm.getTopChannels = function(series) {
        if(vm.topChannelsLoaded) {
            return false;
        }

        vm.peeksLoading = true;

        vm.game
            .withHttpConfig({ timeout: RequestTimeoutService.promise() })
            .one('reports')
            .getList('top-channels', {
                start: vm.start.format(),
                end:   vm.end.format()
            })
            .then(function(peeks) {
                var channelPeekMap = {};

                _.forEach(peeks, function(v, i) {

                    if(!channelPeekMap[v.twitch_channel_id]) {
                        channelPeekMap[v.twitch_channel_id] = {
                            name: v.twitch_channel_id,
                            data: []
                        };

                        if(v.channel) {
                            channelPeekMap[v.twitch_channel_id].name = v.channel.display_name;
                        }

                        if(v.twitch_channel_id === 0) {
                            channelPeekMap[v.twitch_channel_id].color = "#888";
                            channelPeekMap[v.twitch_channel_id].fillOpacity = "0.3";
                            channelPeekMap[v.twitch_channel_id].name = 'Everyone Else';
                        }
                    }

                    channelPeekMap[v.twitch_channel_id].data
                        .push([ moment.utc(v.pulled_at).unix()*1000, v.viewers ]);
                });

                var chartData = [];

                _.forEach(channelPeekMap, function(v, i) {
                    v.type = "area";
                    series.push(v);
                });

                vm.topChannelsLoaded = true;
                vm.peeksLoading = false;
            });
    };

    vm.resetAllReports = function() {
        _.forEach(vm.reports, function(report) {
            report.active = false;
            report.reset();
        });
    };

    vm.resetInactiveReports = function() {
        _.forEach(vm.reports, function(report) {
            if(!report.active) {
                report.active = false;
                report.reset();
            }
        });
    };

    vm.applyRange = function() {
        vm.getPeeks();

        if(vm.selectedReport) {
            vm.selectedReport.page = 1;

            vm.runReport(vm.selectedReport)
                .then(function() {
                    vm.resetInactiveReports();
                });
        } else {
            vm.resetAllReports();
            vm.updateRoute();
        }
    };

    vm.changeTab = function(report) {
        if(vm.reportLoading) { return false; }

        if ($window.analytics && ENV.segmentIo.code) {
            try {
                $window.analytics.track('Game Report Tab Change', {
                  to: report.name,
                  from: !vm.selectedReport ? null : vm.selectedReport.name
                });
            } catch (exception) {
                console.log(exception);
            }
          }

        if(vm.selectedReport && vm.selectedReport.name === report.name) {
            report.active = false;
            vm.selectedReport = null;
            vm.updateRoute();

            return false;
        }

        cancelAllReports();

        if(!report.data) {
            report.loading = true;

            vm.runReport(report)
                .then(function() {
                    report.active = true;
                    report.loading = false;
                    vm.selectedReport = report;
                    vm.updateRoute();
                });
        } else {
            report.active = true;
            vm.selectedReport = report;
        }
    };

    vm.updateRoute = function() {
        var params = {}
        params.start = vm.defaults.start.isSame(vm.start) ? undefined : vm.start.format();
        params.end = vm.defaults.end.isSame(vm.end) ? undefined : vm.end.format();

        UrlService.setParameters(params, 'history');
    }

    vm.runReport = function(report) {
        var defer = $q.defer();
        vm.reportLoading = true;

        report.start = moment(vm.start).format();
        report.end = moment(vm.end).format();

        report.run()
            .then(function(results) {
                vm.reportLoading = false;
                vm.updateRoute();
                defer.resolve(results);
                if (!vis() && !vm.peeks.loading) {
                    vm.audio.play();
                }
            });

        return defer.promise;
    }

    vm.changePage = function(page) {
        vm.selectedReport.page = page;
        vm.runReport(vm.selectedReport);
    };

    vm.setLimit = function(limit) {
        vm.selectedReport.limit = limit;
        vm.selectedReport.page  = 1;
        vm.runReport(vm.selectedReport);
    };

    vm.addFilter = function(input) {
        vm.filter = input;
        vm.resetInactiveReports();
        vm.runReport(vm.selectedReport);
    }

    vm.clearFilter = function(input) {
        vm.filter = null;
        vm.resetInactiveReports();
    }

    vm.getExact = function(channel) {
        if(channel.loading || !channel.estimated) {
            return false;
        }

        channel.loading = true;

        ApiV1.one('twitch')
            .one('channels', channel.twitch_channel_id)
            .one('peeks')
            .get({
                start: vm.start.format(),
                end:   vm.end.format(),
                game:  vm.game.id,
                group: 'false'
            })
            .then(function(peeks) {
                channel.minutes_watched = _.sum(_.map(peeks, 'viewers')) * vm.interval;
                channel.average_viewers = _.sum(_.map(peeks, 'viewers'))/peeks.length;
                channel.peak_viewers    = _.max(_.map(peeks, 'viewers'));
                channel.peek_count      = peeks.length;

                channel.estimated = false;
                channel.loading = false;
            });
    };

    vm.getPeeks = function() {
        vm.loaded = true;
        vm.peeksLoading = true;
        vm.peeks = null;

        vm.game
            .withHttpConfig({ timeout: RequestTimeoutService.promise() })
            .getList('peeks', {
                start: vm.start.format(),
                end:   vm.end.format()
            })
            .then(function(peeks) {

                vm.isDay = (peeks[0] && peeks[0].id);
                vm.rawPeeks = peeks;
                vm.topChannelsLoaded = false;

                //No results
                if(peeks.length < 1) {
                    vm.stats = {};
                    vm.peeks = {};
                    (vm.isDay ? vm.chartDay : vm.chart).series = [];
                    vm.peeksLoading = false;
                    return;
                }

                vm.peeks = ChartDataService.process(peeks, {
                    start: moment(vm.start),
                    end: moment(vm.end),
                    metrics: vm.isDay ? vm.chartDay.metrics : vm.chart.metrics
                });

                if(vm.isDay) {
                    var stage = angular.copy(vm.peeks.viewers);
                    stage.type = 'column';

                    vm.peeks.top_ten = [];
                }

                vm.stats = generateStats(vm.peeks, vm.isDay);
                vm.peeksLoading = false;

                if (!vis() && !vm.reportLoading) {
                    vm.audio.play();
                }
            });
    }

    vm.exportPeeks = function() {

        var filter = {
            id: function(id, peek) {
                var pulled_at = peek.pulled_at;
                delete peek.pulled_at;
                return moment.utc(pulled_at).local().format();
            }
        }

        var headers = vm.isDay ? [
            'Pulled At',
            'Viewers',
            'Rank',
            'Stream Count',
            'Top Stream Viewers',
        ] : [
            'Day',
            'Minutes Watched',
            'Minutes Streamed',
            'Best Rank',
            'Average Viewers',
            'Peak Viewers',
            'Average Streams'
        ];

        var meta = {
            title: vm.game.title + ' - Timeline',
            start: vm.start,
            end:   vm.end,
            filename: vm.game.slug + '-timeline',
            filter: vm.isDay ? filter : {},
        };

        ExportService.doExport(meta, headers, function() {
            return vm.rawPeeks;
        });
    };

    function cancelAllReports() {
        _.forEach(vm.reports, function(report) {
            report.active = false;
            report.loading = false;
        });
    }

    function clickPoint(event) {
        if(vm.reportLoading || vm.loading || vm.peeksLoading) {
            return false;
        }

        var pointX = moment(event.point.x);
        vm.start = pointX;
        vm.end = moment(vm.start).add(1, 'day').subtract(1, 'second');
        vm.applyRange();
        vm.selectedRange = { title: 'Day' };

        $timeout(function() {
            vm.changed = false;
        }, 1);
    }

    function clickDayPoint(event) {
        if(vm.reportLoading || vm.loading || vm.peeksLoading) return false;

        var pointX = moment(event.point.x);

        $state.go('app.live.channels', { game: vm.game.id, pull: pointX.format() });
    }

    function returnSecond (objects) {
      return _.map(objects, function(o) { return o[1] })
    }

    function generateStats(peeks, isDay) {

        var stats = {};

        if(isDay) {
            stats.minutes_watched  = _.sum(returnSecond(peeks['viewers'].data)) * vm.interval;
            stats.hours_watched    = stats.minutes_watched/60;
            stats.peak_viewers     = _.max(returnSecond(peeks['viewers'].data));
            stats.minutes_streamed = _.sum(returnSecond(peeks['stream_count'].data)) * vm.interval;
            stats.average_viewers  = _.sum(returnSecond(peeks['viewers'].data))/peeks['viewers'].data.length;
            return stats;
        }

        stats.minutes_watched  = _.sum(returnSecond(peeks['minutes_watched'].data));
        stats.hours_watched    = stats.minutes_watched/60;
        stats.peak_viewers     = _.max(returnSecond(peeks['peak_viewers'].data));
        stats.minutes_streamed = _.sum(returnSecond(peeks['minutes_streamed'].data));
        stats.average_viewers  = _.sum(returnSecond(peeks['average_viewers'].data))/peeks['average_viewers'].data.length;

        return stats;
    }
}

angular
    .module('Noscope')
    .component('gameReport', {
        templateUrl: 'app/components/game-report/game-report.html',
        bindings: {
            game: '<'
        },
        controller: gameReportController
    });
})();

(function() {
'use strict';

/** @ngInject */
function gameReportTableController($q, $scope) {
    var vm = this;

    vm.setSort = function(sort, dontRefresh) {
        if(vm.loading) return false;

        var column = sort.replace(/^-/, '');
        var firstDesc = (sort.substring(0, 1) === "-");
        var currentSort = vm.report.sort;
        var parameter;

        if(currentSort !== column && currentSort !== '-' + column) {
            parameter = sort;
        } else if(currentSort === column) {
            parameter = '-' + column;
        } else {
            parameter = column;
        }

        vm.report.sort = parameter;
        vm.report.page  = 1;

        if(dontRefresh) return false;
            
        vm.parent.runReport(vm.report);
    };

    vm.showStreamBreakdown = function (stream) {
        if(stream.breakdown) {
            stream.breakdown = false;
            vm.activeStreamBreakdown.breakdown = false;
            vm.activeStreamBreakdown.peeks = false
            vm.activeStreamBreakdown = false;
    
            return false;
        }

        if(vm.activeStreamBreakdown) {
            vm.activeStreamBreakdown.breakdown = false;
            vm.activeStreamBreakdown.peeks = false;
        }
  
        stream.breakdown = stream;
        vm.activeStreamBreakdown = stream;
    };
}

angular
    .module('Noscope')
    .component('gameReportTable', {
        require: {
            parent: '^^gameReport'
        },
        bindings: {
            report: '='
        },
        templateUrl: 'app/components/game-report/game-report-table.html',
        controller: gameReportTableController
    });
})();
(function() {
  'use strict';

  angular
    .module('Noscope')
    .directive('gameLive', gameLive);

  /** @ngInject */
  function gameLive() {
    return {
      restrict: 'E',
      scope: {
        game: '=',
      },
      templateUrl: 'app/components/game-live/game-live.html',
      /** @ngInject */
      controller: function($scope) {
        
      }
    }
  }
})();
(function() {
'use strict';

angular
    .module('Noscope')
    .directive('gameLists', gameLists);

/** @ngInject */
function gameLists(
    Restangular, 
    $stateParams, 
    RequestTimeoutService, 
    localStorageService, 
    ENV, 
    ChartDataService, 
    ChartConfig, 
    $state, 
    TimeframeFactory,
    Helpers,
    ChartHelpers,
    TwitchChannel,
    OutageService,
    ExportService
) {
    return {
        restrict: 'E',
        templateUrl: 'app/components/game-lists/game-lists.html',
        scope: {
            game: '=',
        },
        /** @ngInject */
        controller: function($scope) {

            $scope.metrics = [
                { column: 'total_minutes_watched', title: 'Total Minutes Watched' },
                { column: 'minutes_streamed', title: 'Total Minutes Streamed' },
                { column: 'rank', title: 'Best Rank' },
                { column: 'average_total_viewers', title: 'Averaged Daily Viewership' },
                { column: 'stream_count', title: 'Averaged Daily Broadcasters' },
                { column: 'peak_viewers', title: 'Peak Viewership' }
            ];

            $scope.dayMetrics = [
                { column: 'total_viewers', title: 'Viewers' },
                { column: 'stream_count', title: 'Stream Count' },
                { column: 'rank', title: 'Rank' },
                { column: 'peak_stream_viewers', title: 'Peak Stream Viewership' },
                { column: 'channels', title: 'Top 10 Channel Share' },
            ];

            $scope.ranges = TimeframeFactory.standard;

            function init() {
                $scope.today = moment().startOf('day');
                $scope.minimumDate = moment.unix(ENV.twitch.dataMinimumData).startOf('day');
                $scope.pullInterval = ENV.pullInterval;
                $scope.currentPage = 1;
                $scope.perPage = 8;
                $scope.tab = 'streams';
                $scope.chart = {};

                $scope.chart = {
                    options: ChartConfig.get('game-timeline'),
                    series: [],
                    size: { height: 340, width: 849 },
                    loading: true,
                    useHighStocks: false
                };

                $scope.channelsChart = {
                    options: ChartConfig.get('game-day-channels'),
                    series: [],
                    size: { height: 340, width: 849 },
                    loading: true,
                    useHighStocks: true
                };

                ChartHelpers.bootstrap($scope.chart);
                $scope.chart.helpers.setNavigator(false);

                pullChart();
                $scope[$scope.tab].pull();
            }

            function processChannelData(peeks) {
                var channelPeekMap = {};

                _.forEach(peeks, function(v, i) {

                    if(!channelPeekMap[v.twitch_channel_id]) {
                        channelPeekMap[v.twitch_channel_id] = {
                            name: v.twitch_channel_id,
                            data: []
                        };

                        if(v.channel) {
                            channelPeekMap[v.twitch_channel_id].name = v.channel.display_name;
                        }

                        if(v.twitch_channel_id === 0) {
                            channelPeekMap[v.twitch_channel_id].color = "#888";
                            channelPeekMap[v.twitch_channel_id].fillOpacity = "0.3";
                            channelPeekMap[v.twitch_channel_id].name = 'Everyone Else';
                        }
                    }

                    channelPeekMap[v.twitch_channel_id].data
                        .push([ moment.utc(v.pulled_at).unix()*1000, v.viewers ]);
                });

                var chartData = [];

                _.forEach(channelPeekMap, function(v, i) { chartData.push(v); });

                return chartData;
            }

            function setInitialDates() {
                if(!$stateParams.start || !$stateParams.end) {
                    return $scope.changeRange($scope.ranges[0]);
                }

                $scope.start = moment($stateParams.start);
                $scope.end = moment($stateParams.end);
            }

            function setDateStrings() {
                $scope.startDate = moment($scope.start).format('YYYY-MM-DD');
                $scope.endDate = moment($scope.end).format('YYYY-MM-DD');
            }

            function setStateParams() {
                $state.go('app.game', { 
                    slug: $scope.game.slug,
                    start: $scope.startDate, 
                    end: $scope.endDate 
                }, { 
                    notify: false, 
                    replace: true,
                });
            }

            function pullChart() {

                var wasDay = $scope.isDay;
                $scope.isDay = ($scope.startDate === $scope.endDate);
                $scope.chart.series = [];

                //Set Chart Settings
                $scope.chart.helpers.setCursor(($scope.isDay) ? 'default' : 'pointer');
                $scope.chart.helpers.setPlotLine(($scope.isDay) ? moment() : $scope.today);
                $scope.chart.helpers.setClick(function() {
                    if(!$scope.isDay) {
                        $scope.start = moment(this.x);
                        $scope.end = moment(this.x);
                        $scope.$apply();
                    }
                });

                //Change Tooltip
                if($scope.isDay) {
                    $scope.chart.options.tooltip.pointFormatter = function() {
                        return '<p class="hc-tooltip__point">' +  this.y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + '<b>' + moment(this.x).local().format('LT') + "</b></p>";
                    };

                    OutageService.getBands()
                        .then(function(bands) {
                            $scope.chart.options.xAxis.plotBands = bands;
                        });
                        
                } else {
                    $scope.chart.options.tooltip.pointFormatter = function() {
                        return '<p class="hc-tooltip__point">' +  this.y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + '<b>' + moment(this.x).local().format('MMMM DD, YYYY') + "</b></p>";
                    }

                    $scope.chart.options.xAxis.plotBands = [];
                }

                Restangular.one('v0').one('games', $scope.game.id)
                    .withHttpConfig({ timeout: RequestTimeoutService.promise() })
                    .getList('day-peeks', { 
                        start: $scope.startDate,
                        end: $scope.endDate
                    })
                    .then(function(peeks) {

                    $scope.chart.peeks = peeks;

                    //Set total minutes
                    $scope.chart.minutesWatched = _.sum(peeks, function(o) { 
                        return  ($scope.isDay) ? o.total_viewers * $scope.pullInterval : o.total_minutes_watched;
                    });

                    _.forEach(peeks, function(peek) {
                        if (!peek.rank) {
                            peek.rank = 0;
                        }
                    })

                    if(!$scope.isDay) {
                        if(typeof wasDay === 'undefined' || wasDay) {
                            $scope.metric = $scope.metrics[0];
                        }

                        var processedData = ChartDataService.process(peeks, {
                            start: moment($scope.start),
                            end: moment($scope.end),
                            metrics: $scope.metrics,
                            xAxisColumn: 'day'
                        });

                        var stagedSeries = [];
                        
                        _.forEach($scope.metrics, function(metric) {
                            if(processedData[metric.column]) {
                                stagedSeries.push(processedData[metric.column]);
                            }
                        });

                        $scope.chart.series = stagedSeries;
                    } else {
                        $scope.metric = $scope.dayMetrics[0];
                        $scope.chart.series = ChartDataService.buildSeries(peeks, $scope.dayMetrics, 'pulled_at');
                    }

                    $scope.changeMetric($scope.metric);
                    $scope.chart.loading = false;

                    if($scope.isDay) {
                        $scope.channelsChart.loading = true;
                        Restangular.one('v0').one('games', $scope.game.id)
                            .withHttpConfig({ timeout: RequestTimeoutService.promise() })
                            .getList('day-peeks', { 
                                day: $scope.startDate,
                                channels: true
                            })
                            .then(function(peeks) {
                                $scope.channelsChart.series = processChannelData(peeks);
                                $scope.channelsChart.loading = false;
                            })
                    }
                });
            }

            $scope.streams = {
                sort: '-pulled_at',
                filters: {},
                pull: function(callback) {

                    $scope.loading = true;
                    return Restangular.one('v0').one('games', $scope.game.id).one('streams')
                        .withHttpConfig({ timeout: RequestTimeoutService.promise() })
                        .get({ 
                            sort: $scope.streams.sort, 
                            page: $scope.currentPage,
                            channel: ($scope.streams.filters.channel) ? $scope.streams.filters.channel.id : null,
                            hour: $scope.streams.filters.hour || null,
                            live: $scope.streams.filters.live || null,
                            limit: $scope.perPage,
                            start: $scope.startDate,
                            end: $scope.endDate
                        })
                            .then(function(streams) {
                                $scope.streams.data = streams.data;
                                $scope.streams.total = streams.total;
                                $scope.total = streams.total;
                                $scope.loading = false;
                                $scope.from = streams.from;
                                $scope.to = streams.to;
                                
                                if(callback) {
                                    callback();
                                }
                            });
                }
            };

            $scope.channels = {
                sort: '-total_viewers',
                filters: {},
                pull: function(callback) {
                    $scope.loading = true;
                    var start = moment.isMoment($scope.start) ? $scope.start.format('YYYY-MM-DD') : moment($scope.start).format('YYYY-MM-DD');
                    var end = moment.isMoment($scope.end) ? $scope.end.format('YYYY-MM-DD') : moment($scope.end).format('YYYY-MM-DD');

                    return Restangular.one('v0').one('games', $scope.game.slug).one('channels')
                        .withHttpConfig({ timeout: RequestTimeoutService.promise() })
                        .get({ 
                            sort: $scope.channels.sort, 
                            page: $scope.currentPage,
                            limit: $scope.perPage,
                            start: $scope.startDate,
                            end: $scope.endDate,
                            channel: ($scope.channels.filters.channel) ? $scope.channels.filters.channel.id : null,
                        })
                            .then(function(channels) {
                                $scope.channels.data = channels.data;
                                $scope.channels.total = channels.total;
                                $scope.total = channels.total;
                                $scope.perPage = channels.per_page;
                                $scope.loading = false;
                                $scope.from = channels.from;
                                $scope.to = channels.to;

                                if(callback) {
                                    callback();
                                }
                            });
                    }
            };

            $scope.toggleChannels = function() {
                if($scope.chart && $scope.chart.loading)
                    return false;

                $scope.currentPage = 1;
                $scope.channels.pull(function() {
                    $scope.tab = 'channels';
                });
            };

            $scope.toggleStreams = function() {
                if($scope.chart && $scope.chart.loading)
                    return false;

                $scope.currentPage = 1;
                $scope.streams.pull(function() {
                    $scope.tab = 'streams';
                });
            };

            $scope.pageChanged = function() {
                $scope[$scope.tab].pull();
            };

            $scope.setChannel = function(channel) {
                $scope.currentPage = 1;
                $scope[$scope.tab].filters = {
                    channel: channel
                };
                
                $scope[$scope.tab].pull();
            };

            $scope.searchChannels = function(string) {
                return TwitchChannel.one('search').one(string).getList();
            };

            $scope.clearChannel = function() {
                $scope.currentPage = 1;
                $scope[$scope.tab].filters.channels = null;

                $scope[$scope.tab].pull();
            };

            $scope.setFilter = function(filter) {
                if($scope.chart.loading)
                    return false;

                $scope[$scope.tab].filters[filter] = $scope[$scope.tab].filters[filter] ? null : true;
                $scope[$scope.tab].pull();
            };


            $scope.changeSort = function(sort) {
                var newSort = Helpers.parseSortString(sort);
                var oldSort = Helpers.parseSortString($scope[$scope.tab].sort);

                if(newSort.column === oldSort.column) {
                    newSort.direction = (oldSort.direction === 'DESC') ? 'ASC' : 'DESC' ;
                }

                $scope[$scope.tab].sort = Helpers.encodeSortString(newSort);

                $scope.currentPage = 1;
                $scope[$scope.tab].pull();
            };

            $scope.showChannelStreams = function(channel) {
                $scope.tab = 'streams';
                $scope.setChannel(channel);
            };

            $scope.showBreakdown = function(stream) {

                if(stream.breakdown) {
                    stream.breakdown = false;
                    $scope.activeStream.breakdown = false;
                    $scope.activeStream.peeks = false
                    $scope.activeStream = false;

                    return false;
                }

                if($scope.activeStream) {
                    $scope.activeStream.breakdown = false;
                    $scope.activeStream.peeks = false;
                }
                  
                stream.breakdown = stream;
                $scope.activeStream = stream;
            };

            $scope.changeRange = function(range) {
                if($scope.chart && $scope.chart.loading)
                    return false;

                $scope.start = range.start;
                $scope.end = range.end;
            };

            $scope.changePerPage = function(limit) {
                $scope.perPage = limit;
                $scope[$scope.tab].pull();
            };

            $scope.export = function() {
                ExportService.game($scope.game, $scope.startDate, $scope.endDate);
            };

            $scope.changeMetric = function(metric) {
                $scope.metric = metric;
                var metricIndex = _.findIndex(($scope.isDay) ? $scope.dayMetrics : $scope.metrics, metric);
                localStorageService.set('game-chart.metric', metric);

                _.forEach($scope.chart.series, function(series, seriesIndex) {
                    series.visible = (seriesIndex === metricIndex);
                });

                $scope.chart.options.navigator.baseSeries = metricIndex;

                if($scope.metric.column === 'rank') {
                    $scope.chart.options.yAxis.reversed = true;
                    $scope.chart.options.yAxis.allowDecimals = false;
                } else {
                    $scope.chart.options.yAxis.reversed = false;
                    $scope.chart.options.yAxis.allowDecimals = true;
                }
            };

            setInitialDates();
            setDateStrings();
            init();

            $scope.$watchGroup([ 'start', 'end' ], function(newVal, oldVal) {
                if($scope.start && $scope.end && newVal !== oldVal) {
                    setDateStrings();
                    setStateParams();
                    $scope.chart.loading = true;
                    $scope.startDate = moment($scope.start).format('YYYY-MM-DD');
                    $scope.endDate = moment($scope.end).format('YYYY-MM-DD');

                    $scope.currentPage = 1;

                    pullChart();
                    $scope[$scope.tab].pull();
                }
            });
        }
    }
}

})();
(function () {
  'use strict';

  angular
    .module('Noscope')
    .directive('gameCard', gameCard);

/** @ngInject */
  function gameCard () {
    return {
      restrict: 'E',
      scope: {
        game: '='
      },
      templateUrl: 'app/components/game-card/game-card.html',
        /** @ngInject */
      controller: function ($scope, $interval, $filter) {
        $scope.limit = 150;

        $scope.readMore = function () {
          $scope.limit = false;
        };

        $scope.requestReview = function () {
          $scope.reviewRequestLoading = true;

          $scope.game.one('review-request').post()
                    .then(function () {
                      $scope.reviewRequested = true;
                      $scope.reviewRequestLoading = false;
                    }, function () {
                      $scope.reviewRequested = true;
                      $scope.reviewRequestLoading = false;
                    });
        };

        function determineBanner () {
          var data = $scope.game.igdb_data;

          if (!data) {
            return $scope.game.banner = false;
          }

          if (!data.version && !data.game) {
            return $scope.game.banner = false;
          }

          var screenshots = (data.version) ? data.screenshots : data.game.screenshots;
          $scope.hasIgdbData = true;

          if (!screenshots || screenshots.length < 1) {
            return $scope.game.banner = false;
          }

          var imageProperty = (data.version) ? 'cloudinary_id' : 'id';

          if (screenshots.length > 0 && screenshots[0].image_id) {
            imageProperty = 'image_id';
          }

          var bannerIndex = Math.floor(Math.random() * screenshots.length);
          $scope.game.banner = screenshots[bannerIndex][imageProperty];

                // PRELOAD
          if (screenshots.length > 1) {
            angular.forEach(screenshots, function (screenshot) {
              angular.element('<img src="' + $filter('urlIgdbImage')(screenshot[imageProperty]) + '">');
            });
          }

                // ROTATE BANNER
          $interval(function () {
            bannerIndex++;
            if (bannerIndex === screenshots.length) {
              bannerIndex = 0;
            }

            $scope.game.banner = screenshots[bannerIndex][imageProperty];
          }, 7000);
        }

        function convertIgdbData () {
          var data = $scope.game.igdb_data;

          var version = (data.game && angular.isObject(data.game)) ? 1 : 2;

          $scope.gameData = (version === 2) ? data : data.game;
          $scope.gameData.imageProperty = (version === 2) ? 'cloudinary_id' : 'id';

                // CONVERT RELEASE DATE
          if (version === 2 && $scope.gameData.release_dates && $scope.gameData.release_dates.length > 0) {
            $scope.gameData.release_date = _.min($scope.gameData.release_dates, function (o) { return o.date; }).date;
          }

                // CONVERT COMPANIES
          if (version === 2 && ($scope.gameData.publishers || $scope.gameData.developers)) {
            $scope.gameData.companies = [];
            var map = {};

            if ($scope.gameData.publishers) {
              _.forEach($scope.gameData.publishers, function (company) {
                if (!map[company.slug]) {
                  map[company.slug] = { name: company.name };
                }

                map[company.slug].publisher = true;
              });
            }

            if ($scope.gameData.developers) {
              _.forEach($scope.gameData.developers, function (company) {
                if (!map[company.slug]) {
                  map[company.slug] = { name: company.name };
                }

                map[company.slug].developer = true;
              });
            }

            _.forEach(map, function (company) {
              $scope.gameData.companies.push(company);
            });
          }
        }

        determineBanner();

        if ($scope.hasIgdbData) {
          convertIgdbData();
        }
      }
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('Noscope')
    .directive('followButton', followButton);

  /** @ngInject */
  function followButton($rootScope, UserObjectService) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        type: '@',
        object: '='
      },
      templateUrl: 'app/components/follow-button/follow-button.html',
      controllerAs: 'cFollowButton',
      /** @ngInject */
      controller: function($scope, $rootScope) {
        var vm = this;

        vm.type = $scope.type;

        var properties = {
          game: 'followed_games',
          channel: 'followed_channels'
        };

        function init() {
          if($rootScope.user[properties[$scope.type]] && $rootScope.user[properties[$scope.type]][$scope.object.id]) {
            vm.active = true;
          }
        }

        init();

        vm.toggleFollow = function() {
          if(vm.loading) {
            return false;
          }
          vm.loading = true;

          $scope.object.one('follow').post()
            .then(function(response) {
              vm.active = (response.outcome === 'follow');
              vm.loading = false;

              UserObjectService.updateProperty(properties[$scope.type], response.list);
            });
        }
      }
    }
  }
})();
(function() {
  'use strict';

  angular
    .module('Noscope')
    .directive('dateOld', date);

  /** @ngInject */
  function date() {
    return {
      restrict: 'E',
      scope: {
        moment: '=',
        min: '=',
        max: '=',
        display: '=',
        local: '@',
        dateText: '@'
      },
      templateUrl: 'app/components/date-old/date.html',
      /** @ngInject */
      controller: function($scope) {

      }
    }
  }
})();
(function() {
  'use strict';

  angular
    .module('Noscope')
    .directive('date', date);

  /** @ngInject */
  function date() {
    return {
      restrict: 'E',
      scope: {
        moment: '=',
        min: '=',
        max: '=',
        display: '=',
        local: '@',
        dateText: '@'
      },
      templateUrl: 'app/components/date/date.html',
      /** @ngInject */
      controller: function($scope) {

      }
    }
  }
})();
(function () {
  'use strict';

  angular
    .module('Noscope')
    .directive('channelReport', channelReport);

/** @ngInject */
  function channelReport ($window, $state, $stateParams, moment, ApiV1, RequestTimeoutService, ExportService, $interval, ENV, $filter, TimeframeFactory, ChartDataService, ChartConfig, $timeout, OutageService, ChartHelpers) {
    return {
      restrict: 'E',
      replace: true,
      scope: { channel: '=' },
      templateUrl: 'app/components/channel-report/channel-report.html',
        /** @ngInject */
      controller: function ($scope) {
        $scope.interval = ENV.pullInterval;
        $scope.scope = 'all';

        function init () {
          setLoading();

          $scope.nav = {
            streams: {
              sort: '-pulled_at',
              changePage: getStreams
            },
            games: {
              sort: 'title',
              changePage: getGames
            },
            days: {
              sort: 'dow',
              changePage: getDays
            }
          };

                // SET DEFAULTS
          $scope.tab = ($stateParams.tab && $scope.nav[$stateParams.tab]) ? $stateParams.tab : 'streams';
          $scope.perPage = $scope.limit || 8;
          $scope.currentPage = $scope.page || 1;
          $scope.orderBy = $scope.sort || '-pulled_at';
          $scope.gameFilter = parseInt($stateParams.game);

          if ($scope.gameFilter) {
            getGame();
          }

          $scope.$watch('scope', function () {
            if (!$scope.optionsReady) {
              return false;
            }

            $scope.changeScope();
          });
        }

        function getGame () {
          $scope.gameInfo = ApiV1.one('games', $scope.gameFilter).get().$object;
        }

        function clickPoint (event) {
          if ($scope.nav[$scope.tab].loading || $scope.loading) {
            return false;
          }

          var pointX = moment(event.point.x);
          $scope.start = pointX;
          $scope.end = moment($scope.start).add(1, 'day').subtract(1, 'second');
          $scope.applyRange();
          $scope.selectedRange = { title: 'Day' };
          $timeout(function () {
            $scope.changed = false;
          }, 1);

          $state.go($state.current.name, {
            start: $scope.start.format(),
            end: $scope.end.format()
          }, { notify: false });
        }

        function setLoading (state) {
          var to = typeof state === 'undefined' ? true : state || false;

          $scope.loading = to;
        }

        function returnSecond (objects) {
          return _.map(objects, function(o) { return o[1] })
        }

        function generateStats (clear) {
          $scope.stats = {};

          if (clear) {
            return false;
          }

          if ($scope.isDay) {
            $scope.stats.minutes_watched = _.sum(returnSecond($scope.peeks['viewers'].data)) * $scope.interval;
            $scope.stats.hours_watched = $scope.stats.minutes_watched / 60;
            $scope.stats.peak_viewers = _.max(returnSecond($scope.peeks['viewers'].data));
            $scope.stats.minutes_streamed = _.sum(returnSecond($scope.peeks['peek_count'].data)) * $scope.interval;
            $scope.stats.peek_count = _.sum(returnSecond($scope.peeks['peek_count'].data));
            $scope.stats.average_viewers = _.sum(returnSecond($scope.peeks['viewers'].data)) / $scope.stats.peek_count;
            return true;
          }

          $scope.stats.minutes_watched = _.sum(returnSecond($scope.peeks['minutes_watched'].data));
          $scope.stats.hours_watched = $scope.stats.minutes_watched / 60;
          $scope.stats.peak_viewers = _.max(returnSecond($scope.peeks['peak_viewers'].data));
          $scope.stats.minutes_streamed = _.sum(returnSecond($scope.peeks['minutes_streamed'].data));
          $scope.stats.peek_count = _.sum(returnSecond($scope.peeks['peek_count'].data));
          $scope.stats.average_viewers = _.sum(returnSecond($scope.peeks['total_viewers'].data)) / $scope.stats.peek_count;
        }

        function getPeeks (forceDay) {
          setLoading();

          $scope.optionsReady = true;

          $scope.channel
            .withHttpConfig({ timeout: RequestTimeoutService.promise() })
            .getList('peeks', {
              start: $scope.start.format(),
              end: $scope.end.format(),
              game: $scope.gameFilter,
              scope: $scope.scope
            })
            .then(function (peeks) {
              var duration = moment.duration($scope.end.diff($scope.start)).asDays();

              $scope.isDay = (duration < 1);
              $scope.rawPeeks = peeks;

              if (peeks.length < 1) {
                $scope.peeks = false;
                generateStats(true);
                setLoading(false);
              } else {
                $scope.peeks = ChartDataService.process(peeks, {
                  start: moment($scope.start),
                  end: moment($scope.end),
                  metrics: $scope.isDay ? $scope.chartDay.metrics : $scope.chart.metrics
                });
                $scope.chart.series = $scope.peeks;

                generateStats();
                setLoading(false);
              }
            });
        }

        function getGames (page) {
          $scope.nav.games.loading = true;

          $scope.channel
                    .withHttpConfig({ timeout: RequestTimeoutService.promise() })
                    .one('games')
                    .get({
                      start: $scope.start.format(),
                      end: $scope.end.format(),
                      limit: $scope.perPage,
                      page: page || $scope.currentPage,
                      sort: $scope.nav.games.sort || 'title',
                      game: $scope.gameFilter || null,
                      scope: $scope.scope
                    })
                    .then(function (games) {
                      $scope.nav.games.loading = false;
                      $scope.games = games;
                      $scope.nav.games.total = games.total;
                      $scope.tab = 'games';
                      $scope.tabLoading = false;
                    });
        }

        function getStreams (page) {
          $scope.nav.streams.loading = true;

          $scope.channel
                    .withHttpConfig({ timeout: RequestTimeoutService.promise() })
                    .one('streams')
                    .get({
                      start: $scope.start.format(),
                      end: $scope.end.format(),
                      limit: $scope.perPage,
                      page: page || $scope.currentPage,
                      sort: $scope.nav.streams.sort || '-pulled_at',
                      game: $scope.gameFilter || null,
                      scope: $scope.scope
                    })
                    .then(function (streams) {
                      buildTooltips(streams.data);
                      $scope.nav.streams.loading = false;
                      $scope.streams = streams;
                      $scope.nav.streams.total = streams.total;
                      $scope.tab = 'streams';
                      $scope.tabLoading = false;
                    });
        }

        function getDays (page) {
          $scope.nav.days.loading = true;

          $scope.channel
                    .withHttpConfig({ timeout: RequestTimeoutService.promise() })
                    .one('days')
                    .get({
                      start: $scope.start.format(),
                      end: $scope.end.format(),
                      limit: $scope.perPage,
                      page: page || $scope.currentPage,
                      sort: $scope.nav.streams.sort || '-pulled_at',
                      game: $scope.gameFilter || null,
                      scope: $scope.scope
                    })
                    .then(function (days) {
                      $scope.nav.days.loading = false;
                      $scope.days = days;
                      $scope.nav.days.total = days.length;
                      $scope.tab = 'days';
                      $scope.tabLoading = false;
                    });
        }

        $scope.clearGame = function () {
          $scope.gameFilter = null;
          $scope.gameInfo = null;

          $state.go($state.current.name, {
            game: null
          }, { notify: false });

          $scope.currentPage = 1;
          $scope.nav[$scope.tab].changePage();
          getPeeks();
        };

        $scope.applyRange = function () {
          $scope.currentPage = 1;
          getPeeks();

          $scope.nav[$scope.tab].changePage();
        };

        $scope.changeTab = function (tab) {
          if ($scope.nav[$scope.tab].loading || $scope.tabLoading) {
            return false;
          }

          if ($window.analytics && ENV.segmentIo.code) {
            try {
                $window.analytics.track('Channel Report Tab Change', {
                  to: tab,
                  from: $scope.tab
                });
            } catch (exception) {}
          }

          $scope.tabLoading = true;
          $scope.nav[tab].loading = true;
          $scope.currentPage = 1;
          $scope.nav[tab].changePage();

          $state.go($state.current.name, {
            tab: tab,
            game: $scope.gameFilter || null
          }, { notify: false });
        };

        $scope.setLimit = function (limit) {
          $scope.perPage = limit;
          $scope.currentPage = 1;
          $scope.nav[$scope.tab].changePage();
        };

        function buildTooltips (streams) {
          _.forEach(streams, function (stream) {
            _.forEach(stream.streamed_games, function (streamedGame) {
                var tooltip = [
                  '<h4>' + ((streamedGame.twitch_game) ? streamedGame.twitch_game.title : 'N/A') + '</h4>',
                  '<aside>Stream Time: ' + $filter('durationToTimestamp')(streamedGame.peek_count * $scope.interval, 'm') + '</aside>',
                  '<aside>Peak: ' + $filter('number')(streamedGame.peek_viewers) + '</aside>',
                  '<aside>Average: ' + $filter('number')(streamedGame.average_viewers, 0) + '</aside>'
                ];

                streamedGame.tooltip = tooltip.join('');
            });
          });
        }

        $scope.showBreakdown = function (stream) {
          if (stream.breakdown) {
            stream.breakdown = false;
            $scope.activeStream.breakdown = false;
            $scope.activeStream.peeks = false;
            $scope.activeStream = false;

            return false;
          }

          if ($scope.activeStream) {
            $scope.activeStream.breakdown = false;
            $scope.activeStream.peeks = false;
          }

          stream.breakdown = stream;
          $scope.activeStream = stream;
        };

        $scope.setGame = function (game) {
          if (game.id === $scope.gameFilter) {
            $scope.clearGame();
            return false;
          }

          $scope.gameFilter = game.id;
          $scope.gameInfo = null;
          getGame();
          $state.go($state.current.name, {
            game: game.id
          }, { notify: false });

          $scope.currentPage = 1;
          $scope.nav[$scope.tab].changePage();
          getPeeks();
        };

        $scope.changeSort = function (sort) {
          var column = sort.replace(/^-/, '');
          var firstDesc = (sort.substring(0, 1) === '-');
          var currentSort = $scope.nav[$scope.tab].sort;

          if (currentSort !== column && currentSort !== '-' + column) {
            $scope.nav[$scope.tab].sort = sort;
          } else if (currentSort === column) {
            $scope.nav[$scope.tab].sort = '-' + column;
          } else {
            $scope.nav[$scope.tab].sort = column;
          }

          $scope.currentPage = 1;

          if ($scope.tab !== 'days') {
            $scope.nav[$scope.tab].changePage();
          }
        };

        var doExport = {
          days: function () {
            var promise = $scope.channel
                        .withHttpConfig({ timeout: RequestTimeoutService.promise() })
                        .one('days')
                        .get({
                          start: $scope.start.format(),
                          end: $scope.end.format(),
                          limit: $scope.perPage,
                          page: $scope.currentPage,
                          sort: $scope.nav.streams.sort || '-pulled_at',
                          game: $scope.gameFilter || null,
                          scope: $scope.scope
                        });

            var headers = [
              'Day of the Week',
              'Minutes Streamed',
              'Peak Viewers',
              'Average Viewers',
              'Minutes Watched',
              'Games Played'
            ];

            var getData = function () {
              var prepped = [];

              _.forEach($scope.days, function (day) {
                var newDay = angular.copy(day);
                newDay.dow = $filter('indexToDay')(newDay.dow);
                newDay.peek_count = newDay.peek_count * $scope.interval;
                delete newDay.start;
                delete newDay.end;

                prepped.push(newDay);
              });

              return prepped;
            };

            var start = $filter('dateToUrl')($scope.start);
            var end = $filter('dateToUrl')($scope.end);
            var prettyStart = $filter('dateToCalendar')($scope.start);
            var prettyEnd = $filter('dateToCalendar')($scope.end);

            ExportService.doExport({
              title: $scope.channel.display_name + ' - Days',
              start: $scope.start,
              end: $scope.end,
              filename: $scope.channel.name + '-days'
            }, headers, getData);
          },
          games: function () {
            var headers = [
              'Title',
              'Minutes Streamed',
              'Peak Viewers',
              'Average Viewers',
              'Minutes Watched'
            ];

            var getData = $scope.channel
                        .withHttpConfig({ timeout: RequestTimeoutService.promise() })
                        .one('games')
                        .get({
                          start: $scope.start.format(),
                          end: $scope.end.format(),
                          limit: $scope.nav[$scope.tab].total,
                          page: 1,
                          sort: $scope.nav.games.sort || 'title',
                          game: $scope.gameFilter || null,
                          scope: $scope.scope
                        });

            ExportService.doExport({
              title: $scope.channel.display_name + ' - Games',
              start: $scope.start,
              end: $scope.end,
              filename: $scope.channel.name + '-games',
              ignore: [ 'first_play', 'last_play', 'id', 'order_title' ],
              filter: {
                'peek_count': function (count) {
                  return count * $scope.interval;
                }
              }
            }, headers, getData);
          },
          streams: function () {
            var headers = [
              'Stream Id',
              'Minutes Streamed',
              'Peak Viewers',
              'Average Viewers',
              'Minutes Watched',
              'Started At',
              'Games'
            ];

            var getData = $scope.channel
                        .withHttpConfig({ timeout: RequestTimeoutService.promise() })
                        .one('streams')
                        .get({
                          start: $scope.start.format(),
                          end: $scope.end.format(),
                          limit: $scope.nav[$scope.tab].total,
                          page: 1,
                          sort: $scope.nav.streams.sort || '-pulled_at',
                          game: $scope.gameFilter || null,
                          scope: $scope.scope
                        });

            ExportService.doExport({
              title: $scope.channel.display_name + ' - Broadcasts',
              start: $scope.start,
              end: $scope.end,
              limit: 1000,
              filename: $scope.channel.name + '-broadcasts',
              ignore: [
                'pulled_at',
                'twitch_game_ids',
                'ended_at',
                'twitch_streamed_game_ids',
                'twitch_stream_ids'
              ],
              filter: {
                'peek_count': function (count) {
                  return count * $scope.interval;
                },
                stream: function (stream) {
                  return stream.pulled_at;
                },
                streamed_games: function (streamedGames) {
                  var games = [];

                  _.forEach(streamedGames, function (game) {
                    games.push(game.twitch_game.title);
                  });

                  return games.join(', ');
                }

              }
            }, headers, getData);
          }

        };

        $scope.exportPeeks = function () {
          if ($scope.rawPeeks.length < 1) {
            return false;
          }

          var headers = (!$scope.isDay)
                    ? [ 'Date', 'Minutes Streamed', 'Games Played', 'Average Viewers', 'Peak Viewers', 'Minutes Watched', 'Hours Watched' ]
                    : [ 'Date', 'Viewers', 'Game' ];

          var getData = $scope.channel
                    .withHttpConfig({ timeout: RequestTimeoutService.promise() })
                    .getList('peeks', {
                      start: $scope.start.format(),
                      end: $scope.end.format(),
                      game: $scope.gameFilter,
                      scope: $scope.scope
                    });

          var meta = {
            title: $scope.channel.display_name + ' - Timeline',
            start: $scope.start,
            end: $scope.end,
            filename: $scope.channel.name + '-timeline',
            ignore: [
              'twitch_stream_ids',
              'twitch_game_ids',
              'peek_count',
              'total_viewers',
              'average_viewers'
            ]
          };

          var dayMeta = {
            title: $scope.channel.display_name + ' - Timeline',
            start: $scope.start,
            end: $scope.end,
            filename: $scope.channel.name + '-timeline',
            filter: {
              twitch_game: function (peek) {
                return peek.title;
              }
            },
            ignore: [
              'id',
              'peek_count',
              'twitch_game_id',
              'twitch_stream_id'
            ]
          };

          ExportService.doExport(($scope.isDay ? dayMeta : meta), headers, getData);
        };

        $scope.exportList = function () {
          if ($scope.nav[$scope.tab].loading) {
            return false;
          }

          doExport[$scope.tab]();
        };

        $scope.chart = {
          options: ChartConfig.get('timeline'),
          series: [],
          size: { height: 340, width: 849 },
          useHighStocks: false,
          metrics: [
                    { column: 'minutes_watched', title: 'Minutes Watched' },
                    { column: 'minutes_streamed', title: 'Minutes Streamed' },
                    { column: 'live_average_viewers', title: 'Average Viewers' },
                    { column: 'peak_viewers', title: 'Peak Viewers' },
                    { column: 'game_count', title: 'Games Played' }
          ]
        };

        $scope.chart.options.plotOptions.series.cursor = 'pointer';
        $scope.chart.options.plotOptions.series.events = { click: clickPoint };
        ChartHelpers.bootstrap($scope.chart);
        $scope.chart.helpers.setPlotLine(moment().startOf('day'));

        $scope.chartDay = {
          options: ChartConfig.get('timelineDay'),
          series: [],
          size: { height: 340, width: 849 },
          useHighStocks: false,
          metrics: [
                    { column: 'viewers', title: 'Viewers' }
          ]
        };
        ChartHelpers.bootstrap($scope.chartDay);
        $scope.chartDay.helpers.setPlotLine(moment());

        $scope.changeScope = function () {
          getPeeks();
          $scope.currentPage = 1;
          $scope.nav[$scope.tab].changePage();
        };

        OutageService.getBands()
                .then(function (bands) {
                  $scope.chartDay.options.xAxis.plotBands = bands;
                });

        init();
      }
    };
  }
})();

(function() {
'use strict';

angular
    .module('Noscope')
    .directive('channelMedia', channelMedia);

/** @ngInject */
function channelMedia($timeout, TwitchAPI) {
    return {
        restrict: 'E',
        scope: {
            channel: '='
        },
        templateUrl: 'app/components/channel-media/channel-media.html',
        /** @ngInject */
        controller: function($scope) {

            function init() {
                var limit = (function() {
                    return ($scope.channel.is_live) ? 5: 6;
                })();

                $scope.media = {};
                $scope.isLoaded = false;

                if($scope.channel.is_live) {
                    $scope.openStream(false);
                }

                $scope.channel.one('highlights').get()
                    .then(function(highlights) {
                        $scope.media.highlights = highlights;

                        _.remove($scope.media.highlights.videos, function(v) {
                            return v._id.charAt(0) !== 'v';
                        });

                        if(!$scope.channel.is_live && $scope.media.highlights.videos.length > 0) {
                            $scope.openVideo($scope.media.highlights.videos[0]);
                        }

                        $scope.isLoaded = true;
                    });
            }

            $scope.openVideo = function(video, autoplay) {
                var play = (autoplay) ? 'true' : 'false';
                $scope.url = false;
                $scope.selected = video._id;
          
                $timeout(function() {
                    $scope.url = 'https://player.twitch.tv/?video=' + video._id + '&autoplay=' + play;
                }, 25);
            }

            $scope.openStream = function(autoplay) {
                var play = (autoplay) ? 'true' : 'false';
                $scope.url = false;
                $scope.selected = 'live';
          
                $timeout(function() {
                    $scope.url = 'https://player.twitch.tv/?channel=' + $scope.channel.name + '&autoplay=' + play;
                }, 25);
            }

            init();
        }
    }
}
})();
(function() {
'use strict';

angular
    .module('Noscope')
    .directive('channelLive', channelLive);

/** @ngInject */
function channelLive() {
    return {
        restrict: 'E',
        scope: {
            channel: '=',
        },
        templateUrl: 'app/components/channel-live/channel-live.html',
        /** @ngInject */
        controller: function($scope) {}
    }
}
})();
(function() {
'use strict';

angular
    .module('Noscope')
    .directive('channelGameProfile', channelGameProfile);

/** @ngInject */
function channelGameProfile() {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            channel: '=',
            limit: '@',
            days: '@'
        },
        templateUrl: 'app/components/channel-game-profile/channel-game-profile.html',
        /** @ngInject */
        controller: function($scope, ApiV1, ENV) {
            var vm = this;
            $scope.page = 1;
            $scope.shown = 0;
            $scope.offset = 0;

            $scope.interval = ENV.pullInterval;

            $scope.profileRanges = [
                { title: 'Last 7 Days',  days: 7 },
                { title: 'Last 14 Days', days: 14 },
                { title: 'Last 30 Days', days: 30 },
                { title: 'Last 90 Days', days: 90 },
                { title: 'Last 365 Days', days: 365 },
                { title: 'Last ' + ENV.daysOfData + ' Days',     days: 0 },
            ];

            $scope.changeProfileRange = function(range) {
                $scope.loading = true;
                $scope.selectedProfileRanges = range;

                var query = ($scope.channel.restangularized)
                    ? $scope.channel
                    :  ApiV1.one('twitch').one('channels', $scope.channel.id);

                query.one('game-profile')
                    .get({ days: $scope.selectedProfileRanges.days })
                    .then(function(gameProfile) {
                        $scope.page = 1;
                        $scope.offset = 0;
                        $scope.shown = 0;

                        $scope.channel.gameProfile = gameProfile;
                        $scope.adjustedLimit = getAdjustedLimit();
                        $scope.peekTotal = getPeekTotal();
                        $scope.loading = false;
                    });
            };

            $scope.prevPage = function() {
                $scope.page--;
                var adjustedLimit = getAdjustedLimit();
                $scope.offset = $scope.offset - adjustedLimit;
                $scope.adjustedLimit = getAdjustedLimit();
            };

            $scope.nextPage = function() {
                var adjustedLimit = getAdjustedLimit();
                $scope.offset = $scope.offset + adjustedLimit;
                $scope.page++;
                $scope.adjustedLimit = getAdjustedLimit();
            };

            function getPeekTotal() {
                var peekTotal = 0;
                
                _.forEach($scope.channel.gameProfile, function(game) {
                    peekTotal += game.peek_count;
                });

                return peekTotal;
            }

            function getAdjustedLimit() {

                var gameLength = $scope.channel.gameProfile.length;

                //No pages needed
                if(gameLength <= $scope.limit) {
                    return $scope.limit;
                }

                //First Page
                if($scope.page === 1) {
                    return $scope.limit - 1;
                }

                if($scope.page !== 1 && gameLength > $scope.page*$scope.limit) {
                    return $scope.limit - 2;
                }

                return $scope.limit - 2;
            }

            function getGameProfile() {
                //return $scope.channel.one('gameprofile').get().$object;
            }

            function setDefaults() {
                $scope.limit = $scope.limit || 15;
            }

            function init() {
                setDefaults();

                if($scope.days) {
                    var range = _.find($scope.profileRanges, { days: parseInt($scope.days) });
                    $scope.selectedProfileRanges = range || $scope.profileRanges[1];
                } else {
                    $scope.selectedProfileRanges = $scope.profileRanges[1];
                }

                $scope.changeProfileRange($scope.selectedProfileRanges);
            }

            init();
        }
    }
}
})();
(function () { // Refactored
  'use strict';

  angular
    .module('Noscope')
    .directive('channelCard', channelCard);

/** @ngInject */
  function channelCard () {
    return {
      restrict: 'E',
      scope: {
        channel: '='
      },
      templateUrl: 'app/components/channel-card/channel-card.html',
        /** @ngInject */
      controller: function ($scope, UserObjectService) {
        $scope.user = UserObjectService.get();
        $scope.$watch('channel', function () {
          if ($scope.channel.name && !$scope.channel.primaryGame) {
            $scope.channel.primaryGame = $scope.channel
                        .one('primary-game')
                        .get()
                        .$object;
          }
        });
      }
    };
  }
})();

(function() {
'use strict';

angular
    .module('Noscope')
    .directive('campaignChannel', campaignChannel);

/** @ngInject */
function campaignChannel() {
    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'app/components/campaign-channel/campaign-channel.html',
        scope: {
            channel: '=',
            campaign: '=',
            peeks: '='
        },
        /** @ngInject */
        controller: function($timeout, $scope, $stateParams, ChartConfig, Helpers, OutageService, RequestTimeoutService) {
            $scope.page = 1;
            $scope.perPage = 5;
            $scope.broadcastsSort = 'pulled_at';

            $scope.isDay = ($stateParams.day) ? true : false;

            if($scope.isDay) {
                $scope.channel.chart.config.options.tooltip.pointFormatter = function() {
                    if(this.series._i === 0)
                        return '';

                    return '<p class="hc-tooltip__point">' +  this.y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + '<b>' + moment(this.x).local().format('MMM Do, YYYY - LT') + "</b></p>";
                };
            } else {
                $scope.channel.chart.config.options.tooltip.pointFormatter = function() {
                    if(this.series._i === 0)
                        return '';

                    return '<p class="hc-tooltip__point">' +  this.y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + '<b>' + moment(this.x).local().format('MMMM Do, YYYY') + "</b></p>";
                }
            }

            $scope.showBroadcastBreakdown = function(broadcast) {

                if(broadcast.breakdown) {
                    broadcast.breakdown = false;
                    $scope.activeStream.breakdown = false;
                    $scope.activeStream.peeks = false
                    $scope.activeStream = false;

                    return false;
                }

                if($scope.activeStream) {
                    $scope.activeStream.breakdown = false;
                    $scope.activeStream.peeks = false;
                }

                broadcast.breakdown = broadcast;
                $scope.activeStream = broadcast;
            };

            $scope.changeSort = function(sort) {
                var newSort = Helpers.parseSortString(sort);
                var oldSort = Helpers.parseSortString($scope.broadcastsSort);

                if(newSort.column === oldSort.column) {
                    newSort.direction = (oldSort.direction === 'DESC') ? 'ASC' : 'DESC' ;
                }

                $scope.broadcastsSort = Helpers.encodeSortString(newSort);

                $scope.page = 1;
                $scope.getBroadcasts();
            };

            $scope.getBroadcasts = function() {

                $scope.broadcastsLoading = true;

                $timeout(function() {

                    $scope.campaign.one('broadcasts')
                        .withHttpConfig({ timeout: RequestTimeoutService.promise() })
                        .get({
                            day: $stateParams.day || null,
                            channel: $scope.channel.id,
                            sort: $scope.broadcastsSort,
                            page: $scope.page
                        })
                        .then(function(broadcasts) {
                            $scope.broadcasts = broadcasts;

                            if(!$scope.broadcastsTotal) {
                                $scope.broadcastsTotal = $scope.broadcasts.total;
                            }

                            $scope.broadcastsLoading = false;
                        });

                }, 1);
            }

            function init() {
                $scope.getBroadcasts();
            }

            init();
        }
    }
}
})();

(function () {
  'use strict';

/** @ngInject */
  function adminBarGame (UserObjectService) {
    var vm = this;

    vm.$onInit = function () {
      vm.user = UserObjectService.get();
    };
  }

  angular
    .module('Noscope')
    .component('adminBarGame', {
      bindings: {
        game: '<'
      },
      templateUrl: 'app/components/admin-bar-game/admin-bar-game.html',
      controller: adminBarGame
    });
})();

(function() {
'use strict';

angular
    .module('Noscope')
    .controller('AdminUsersController', AdminUsersController);

/** @ngInject */
function AdminUsersController(Users, Restangular, $auth, User, localStorageService, $window, UserObjectService, Helpers) {
    var vm = this;

    vm.sort = '-loginSort';

    function validateEmail(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    function init() {
        _.forEach(Users, function(user) {
            user.loginSort = (user.login_at) ? moment(user.login_at).unix() : 0;
        });
        vm.users = Users;
    }

    vm.changeSort = function(sort) {
        var newSort = Helpers.parseSortString(sort);
        var oldSort = Helpers.parseSortString(vm.sort);

        if(newSort.column === oldSort.column) {
            newSort.direction = (oldSort.direction === 'DESC') ? 'ASC' : 'DESC' ;
        }

        vm.sort = Helpers.encodeSortString(newSort);
    };

    vm.createUser = function() {
        if(!vm.first_name || !vm.last_name || !vm.email || !validateEmail(vm.email) || !vm.company) {
            return false;
        }  

        Restangular.one('v1').post('users', {
            first_name: vm.first_name,
            last_name: vm.last_name,
            email: vm.email,
            company: vm.company
        })
            .then(function(user) {
                vm.users.unshift(user);
                vm.newIsOpen = false;
                vm.first_name = '';
                vm.last_name = '';
                vm.company = '';
                vm.email = '';
            });
    };

    vm.loginAs = function(user) {
        Restangular.one('v1').one('users', user.id).post('login')
            .then(function(token) {
                $auth.setToken(token.token);
            });
    };

    vm.newOpen = function() {
        vm.newIsOpen = (vm.newIsOpen) ? false : true;
    };

    init();
}

})();
(function() {
  'use strict';

  angular
    .module('Noscope')
    .controller('AdminPullsController', AdminPullsController);

  /** @ngInject */
  function AdminPullsController(Stats, Pulls, $stateParams, $state) {
    var vm = this;

    vm.stats = Stats;
    vm.pulls = Pulls;

    vm.page = $stateParams.page;
    vm.changePage = function() {
      $state.go('app.admin.pulls', { page: vm.page });
    };

    return this;
  }
})();

(function() {
  'use strict';

  angular
    .module('Noscope')
    .controller('AdminPullController', AdminPullController);

  /** @ngInject */
  function AdminPullController(Pull) {
    var vm = this;

    vm.pull = Pull;

    return this;
  }
})();

(function() {
  'use strict';

  angular
    .module('Noscope')
    .controller('AdminGroupingController', AdminGroupingController);

  /** @ngInject */
  function AdminGroupingController(Games, Restangular, algolia, $timeout, $window, $state, $stateParams, ApiV1) {
    var vm = this;

    vm.page = $stateParams.page;
    vm.indexed = $stateParams.indexed;

    vm.listSearch = {
        search: function() {
            $state.go('app.admin.grouping', { type: vm.listSearch.searchString, page: 1 })
        }
    };

    vm.groupGame = {
        selected: false,
        select: function(game) {
            vm.groupGame.selected = game;
            game.info = ApiV1.one('games', game.slug).get().$object;
        },
        remove: function() {
            vm.groupGame.selected = false;
        }
    };

    vm.changePage = function(page) {
        vm.games = $state.go('app.admin.grouping', { page: page });
    };

    vm.games = Games;
    vm.total = Games.total;

    var algoliaClient = algolia.Client(ENV.algolia.id, ENV.algolia.key);
    var gameIndex = algoliaClient.initIndex('games');

    vm.getCount = function(game) {
        game.count = Restangular.one('admin').one('group-count').get({ game: game.id }).$object;
    };

    vm.queryAlgolia = function() {

        vm.groupGame.loading = true;

        gameIndex.search(vm.groupGame.searchString)
            .then(function searchSuccess(content) {
                vm.groupGame.results = content;
                vm.groupGame.loading = false;
            });
    };

    vm.ignoreGame = function(game) {

        if(game.loading) {
            return false;
        }

        if(!game.confirm) {
            game.confirm = true;
            $timeout(function() {
                game.confirm = false;
            }, 4000)

            return false;
        }

        game.loading = true;

        if(!game.ignored) {
            Restangular.one('v1').one('games', game.id).customPUT({}, 'ignore')
                .then(function() {
                    game.ignored = true;
                    game.loading = false;
                    game.confirm = false;
                });
        } else {
            Restangular.one('v1').one('games', game.id).customDELETE('ignore')
                .then(function() {
                    game.ignored = false;
                    game.loading = false;
                    game.confirm = false;
                });
        }

    };

    vm.linkGame = function(game) {

        if(game.loading) {
            return false;
        }

        if(!game.confirm) {
            game.confirm = true;
            $timeout(function() {
                game.confirm = false;
            }, 4000)

            return false;
        }

        game.loading = true;

        Restangular.one('admin').customPOST({ game: game.id, linkto: vm.groupGame.selected.objectID }, 'group-game')
            .then(function() {
                game.deleted = true;
            });
    };

    return this;
  }
})();

(function() {
'use strict';

angular
    .module('Noscope')
    .controller('GameReviewsController', GameReportsController);

/** @ngInject */
function GameReportsController($state, $stateParams, ApiV1, games) {
    var vm = this;

    function init() {
        vm.games = games;
    }

    vm.changePage = function(page) {
        $state.go('app.admin.gameReviews', { page: page });
    }

    vm.resolve = function(game) {
        if(game.resolveLoading) return;

        game.resolveLoading = true;

        game.one('review-request').remove()
            .then(function() {
                _.remove(vm.games, function(g) { return game.id === g.id; });
            });
    }

    init();
}

})();

(function() {
'use strict';

angular
    .module('Noscope')
    .service('UserObjectService', UserObjectService);

/** @ngInject */
function UserObjectService($rootScope, localStorageService, $window) {

    this.set = function(userObject) {
        $rootScope.user = userObject;

        if ($window.analytics) {
            try {
                $window.analytics.identify(userObject.id, {
                    name: userObject.first_name + ' ' + userObject.last_name,
                    company: userObject.company,
                    email: userObject.email,
                    logins: userObject.login_count,
                    timezone: userObject.timezone
                });
            } catch (exception) {}
          }
    };

    this.updateProperty = function(property, value) {
        $rootScope.user[property] = value;
        localStorageService.set('user', $rootScope.user);
    };

    this.getProperty = function(property) {
        return $rootScope.user[property];
    };

    this.get = function() {
        return ($rootScope.user) ? $rootScope.user : localStorageService.get('user');
    };

    return this;
}

})();

(function() {
'use strict';

angular
    .module('Noscope')
    .service('UserTagsService', UserTagsService);

/** @ngInject */
function UserTagsService(localStorageService, ApiV1, $q) {

    this.refreshed = false;

    this.refresh = function() {
        var deferred = $q.defer();
        var self = this;

        ApiV1.one('tags').get()
            .then(function(tagList) {
                self.tags = tagList;
                self.set();
                deferred.resolve(tagList);
                self.refreshed = true;
            });

        return deferred.promise;
    };

    this.set = function() {
        localStorageService.set('user-tags', this.tags);
    }

    this.add = function(tagName) {
        var self = this;

        //If tag exists add to count
        var existing = _.find(this.tags, { name: tagName });

        if(existing) {
            existing.count++;
            this.set();
            return true;
        }

        //Doesn't exist create tag
        this.tags.push({
            name: tagName,
            count: 1
        });

        this.tags = _.orderBy(self.tags, ['name']);
        this.set();

        return true;
    };

    this.remove = function(tagName) {
        var self;

        var tag = _.find(this.tags, { name: tagName });

        //Subtract count
        if(tag.count > 1) {
            tag.count--;
            this.set();
            return true;
        }

        //Remove tag
        this.tags = _.filter(this.tags, function(o) { return o.name !== tagName; });
        this.tags = _.orderBy(this.tags, ['name']);
        this.set();

        return true;
    }

    this.get = function() {
        var deferred = $q.defer();
        var self = this;

        if(this.refreshed) {
            deferred.resolve(this.tags);
        } else {
            this.refresh()
                .then(function() {
                    deferred.resolve(self.tags);
                });
        }

        return deferred.promise;
    };

    return this;
}

})();

(function() {
'use strict';

angular
    .module('Noscope')
    .service('UrlService', UrlService);

/** @ngInject */
function UrlService($state, $stateParams) {

    this.options = {
        default: null,
        history: { notify: false },
        quiet:   { notify: false, location: 'replace' }
    };

    this.getOptions = function(name) {
       return this.options[name] || this.options['default'];
    };
    
    this.setParameter = function(parameter, value, options) {
        if($stateParams[parameter] !== value) {
            var input = {};
            input[parameter] = value;
            
            $state.go($state.current.name, input, this.getOptions(options));
        }
    };

    this.setParameters = function(parameters, options) {
        var stage = {};

        _.forEach(parameters, function(value, param) {
            if($stateParams[param] !== value) {
                stage[param] = value;
            }
        });

        if(!_.isEmpty(stage)) {
            $state.go($state.current.name, stage, this.getOptions(options));
        }
    }

    return this;
  }
})();
(function() {
'use strict';

angular
    .module('Noscope')
    .service('TitleService', TitleService);

/** @ngInject */
function TitleService($rootScope) {

    this.set = function(title) {
        $rootScope.title = title;
    }

    this.get = function() {
        return $rootScope.title;
    };

    this.clear = function() {
        $rootScope.title = '';
    }

    return this;
}

})();
(function() {
  'use strict';

  angular
    .module('Noscope')
    .service('SearchService', SearchService);

  /** @ngInject */
  function SearchService(Restangular) {
    this.search = function(searchString, params) {

      var parameters = params || {};

      return Restangular.one('search', searchString).get(parameters);
    }

    return this;
  }
})();
(function() {
'use strict';

angular
    .module('Noscope')
    .service('RequestTimeoutService', RequestTimeoutService);

/** @ngInject */
function RequestTimeoutService($rootScope, $q) {

    this.promise = function() {
        return $rootScope.abortRequests.promise;
    }

    this.resolve = function() {
        if($rootScope.abortRequests) {
            $rootScope.abortRequests.resolve();
        }
    }

    this.defer = function() {
        $rootScope.abortRequests = $q.defer();
    }

    return this;
}
})();
(function() {
  'use strict';

  angular
    .module('Noscope')
    .service('QueryService', QueryService);

  /** @ngInject */
  function QueryService() {

    this.decode = function(query, filters) {

      angular.forEach(query, function(queryFilter) {
        
        if(queryFilter.column === 'primary_game' && queryFilter.selection) {
          filters.primaryGame.games.push(queryFilter.selection);
        } else if(queryFilter.column === 'played' && queryFilter.argument === '$' && queryFilter.selection) {
          filters.played.games.push(queryFilter.selection);
        } else if(queryFilter.column === 'played' && queryFilter.argument === '!' && queryFilter.selection) {
          filters.neverPlayed.games.push(queryFilter.selection);
        }

        if(filters[_.camelCase(queryFilter.column)]) {
          var filter = filters[_.camelCase(queryFilter.column)];

          switch(filter.type) {
            case 'range':
              if(queryFilter.argument === '-') {
                filter.range.max = parseInt(queryFilter.value);
              } else if(queryFilter.argument === '+') {
                filter.range.min = parseInt(queryFilter.value);
              }
              break;

            case 'option':
              filter.selectedOption = true;
              angular.forEach(filter.options, function(v) {
                if(v.value && v.value.toString() == queryFilter.value && v.argument == queryFilter.argument) {
                  v.selected = true;
                }
              });
              break;
          }
        }

      });

      return filters;
    };

    this.encode = function(filters) {
      var encodedFilters = [];

      angular.forEach(filters, function(filter, name) {
        switch(filter.type) {
          
          case 'games':
            angular.forEach(filter.games, function(game) {
              var string = '(' + 'played' + ((name === 'played') ? '$' : '!') + game.slug + ')';
              encodedFilters.push(string);
            });
            break;

          case 'game':
            if(filter.games.length > 0) {
              encodedFilters.push('(' + _.snakeCase(name) + '$' + filter.games[0].slug + ')');
            }
            break;

          case 'range':
            if(filter.range.min) {
              encodedFilters.push('(' + _.snakeCase(name) + '+' + filter.range.min + ')');
            }

            if(filter.range.max) {
              encodedFilters.push('(' + _.snakeCase(name) + '-' + filter.range.max + ')');
            }
            break;

          case 'option':
            angular.forEach(filter.options, function(option) {
              if(option.selected) {
                if(option.value) {
                  encodedFilters.push('(' + _.snakeCase(name) + option.argument + option.value + ')');
                } else if(option.name) {
                  encodedFilters.push('(' + _.snakeCase(name) + '$' + option.name + ')');
                }
              }
            });
            break;
        }
      });

      return encodedFilters.join('');
    };

    return this;
  }
})();
function camelToUnderscore(str) {
    return str.replace(/\W+/g, '_').replace(/([a-z\d])([A-Z])/g, '$1_$2').toLowerCase();
}

(function() {
'use strict';

angular
    .module('Noscope')
    .service('Helpers', Helpers);

    /** @ngInject */
    function Helpers() {

        this.parseSortString = function(sortString) {
            var column = sortString.replace(/^-/, '');
            var firstDesc = (sortString.substring(0, 1) === "-");

            return {
                column: column,
                direction: (firstDesc) ? 'DESC' : 'ASC'
            };
        };

        this.encodeSortString = function(sortObject) {
            return (sortObject.direction === 'DESC') ? '-' + sortObject.column : sortObject.column;
        };


        return this;
    }
})();
(function () {
  'use strict';

  angular
    .module('Noscope')
    .service('ChartDataService', ChartDataService);

/** @ngInject */
  function ChartDataService (Restangular, ENV, $log) {
    this.process = function (rawData, options) {
      var pullInterval = ENV.pullInterval;

        // Strip Restangular data
      var data = rawData.restangularized ? Restangular.stripRestangular(rawData) : rawData;

        // Validate payload
      if (!_.isArray(data) || data.length < 1) {
        $log.error('ChartDataService.process - Invalid data or empty');
        return [];
      }

        // Metrics naming map
      if (options && options.metrics && _.isArray(options.metrics)) {
        var metricsMap = _.keyBy(angular.copy(options.metrics), 'column');
      }

        // Determine columns based on first object
      var map = [];

      _.forOwn(data[0], function (value, key) {
        if (!isNaN(value)) {
          map[key] = {
            name: (metricsMap && metricsMap[key]) ? metricsMap[key].title : key,
            data: []
          };
        }
      });

        // Determine X Axis
      var xAxisColumn = data[0].pulled_at ? 'pulled_at' : data[0].date ? 'date' : data[0].day ? 'day' : false;

      if (!xAxisColumn) {
        $log.error('ChartDataService.process - missing xAxis column');
        return [];
      }

        // Zero out
      if (options && options.start && options.end) {
        var startFrom = (xAxisColumn === 'date' || xAxisColumn === 'day') ? moment(options.start) : moment.utc(options.start);
        var endAt = (xAxisColumn === 'date' || xAxisColumn === 'day') ? moment(options.end) : moment.utc(options.end);

            // Determine Steps
        var unit = (xAxisColumn === 'pulled_at') ? 'minute' : 'day';
        var interval = (xAxisColumn === 'pulled_at') ? pullInterval : 1;

        var zeroMap = {};

            // Create empty object
        var prototype = {};
        _.forOwn(map, function (value, column) {
          prototype[column] = 0;
        });

        while (startFrom.isBefore(endAt) || startFrom.isSame(endAt)) {
          var emptyObject = angular.copy(prototype);

          var formattedData = startFrom.format((xAxisColumn === 'pulled_at') ? 'YYYY-MM-DD HH:mm:ss' : 'YYYY-MM-DD');
          emptyObject[xAxisColumn] = formattedData;

                // add empty object
          zeroMap[formattedData] = emptyObject;

          startFrom.add(interval, unit);
        }

            // Replace empty objects with real data
        _.forEach(data, function (row, index) {
          zeroMap[row[xAxisColumn]] = row;
        });

        var data = [];

        _.forOwn(zeroMap, function (object, date) {
          //if (moment(date).isSameOrBefore(moment())) {
            data.push(object);
          //}
        });
      }

        // Sort Data (This is kind of awkward)
      _.forEach(data, function (row, index) {
        if (row[xAxisColumn]) {
          row.xAxisValue = (xAxisColumn === 'date' || xAxisColumn === 'day') ? moment(row[xAxisColumn]).valueOf() : moment.utc(row[xAxisColumn]).local().valueOf();
        } else {
          row.xAxisValue = 0;
        }
      });

      data = _.sortBy(data, 'xAxisValue');

        // Build Data Map
      _.forEach(data, function (row, index) {
        _.forOwn(row, function (value, column) {
          if (map[column]) {
            map[column].data.push([
              row.xAxisValue,
              parseInt(value)
            ]);
          }
        });
      });

      return map;
    };

    this.buildSeries = function (rawData, metrics, xAxis, dontZero, local, ENV) {
      var map = {};
      var seriesArray = [];
      xAxis = xAxis || 'pulled_at';

      angular.forEach(rawData, function (data, dataIndex) {
        angular.forEach(metrics, function (metric, metricIndex) {
          // Create new series
          if (!map[metric.column]) {
            map[metric.column] = {
              name: metric.title,
              data: []
            };
          }

          var point = [];

          if (!dontZero) {
            if (local) {
              point.push(moment(data[xAxis]).unix() * 1000);
            } else {
              point.push(moment.utc(data[xAxis]).unix() * 1000);
            }
            point.push(parseInt(data[metric.column]) || 0);
          } else {
            if (data[metric.column]) {
              if (local) {
                point.push(moment(data[xAxis]).unix() * 1000);
              } else {
                point.push(moment.utc(data[xAxis]).unix() * 1000);
              }
              point.push(parseInt(data[metric.column]));
            }
          }

          // Add Points to series
          if (point.length > 0) {
            map[metric.column].data.push(point);
          }

          // Push series into series array
          if (dataIndex === rawData.length - 1 && map[metric.column].data.length > 0) {
            seriesArray.push(map[metric.column]);
          }
        });
      });

      return seriesArray;
    };

    this.zeroOutGaps = function (rawData, start, end, count, measurement, column) {
      var map = {};
      column = column || 'pulled_at';

      start = start.utc();

      while (start.isBefore(end)) {
        map[start.format()] = true;
        start.add(count, measurement);
      }

      var peekMap = {};

      angular.forEach(rawData, function (data) {
        var m = moment(data[column]).seconds(0);
        var remainder = (10 - m.minute()) % 10;
        var roundedTime = moment(m).add('minutes', remainder);

        peekMap[roundedTime.format()] = m;

        if (map[m.format()] && !moment.isMoment(map[m.format()])) {
          map[m.format()] = m;
        }
      });
    };

    this.colorMap = function (peeks, parameter) {
      var map = {};
      var colors = Highcharts.getOptions().colors;
      var nextColor = 0;

      _.forEach(peeks, function (peek, i) {
            // Create property if new game
        if (!map[peek.twitch_game.id]) {
          map[peek.twitch_game.id] = {
            name: peek[parameter].title,
            color: colors[nextColor]
          };

                // Recycle Colors
          if (nextColor + 1 === colors.length) {
            nextColor = 0;
          } else {
            nextColor++;
          }
        }
      });

      return map;
    };

    this.gameMap = function (stream) {
      var gameMap = {};
      var colors = Highcharts.getOptions().colors;
      var nextColor = 0;

      angular.forEach(stream.streamed_games, function (streamedGame, i) {
        // Create property if new game
        if (!gameMap[streamedGame.twitch_game_id]) {
          gameMap[streamedGame.twitch_game_id] = {
            name: streamedGame.twitch_game.title,
            color: colors[nextColor]
          };

          if (nextColor + 1 === colors.length) {
            nextColor = 0;
          } else {
            nextColor++;
          }
        }
      });

      return gameMap;
    };

    this.streamBreakdown = function (peeks, gameMap, start, end) {
      var series = [];
      var data = [];
      var pullInterval = ENV.pullInterval;

      if (start && end) {
        var startFrom = moment.utc(start);
        var endAt = moment.utc(end);

        var unit = 'minute';
        var interval = pullInterval;

        var zeroMap = {};

            // Create empty object
        var prototype = {
          id: 0,
          peek_count: 1,
          twitch_game: false,
          twitch_game_id: 0,
          twitch_stream_id: 0,
          viewers: 0
        };

        while (startFrom.isBefore(endAt) || startFrom.isSame(endAt)) {
          var emptyObject = angular.copy(prototype);

          var formattedData = startFrom.format('YYYY-MM-DD HH:mm:ss');
          emptyObject['pulled_at'] = formattedData;

                // add empty object
          zeroMap[formattedData] = emptyObject;

          startFrom.add(interval, unit);
        }

            // Replace empty objects with real data
        _.forEach(peeks, function (row, index) {
          zeroMap[row['pulled_at']] = row;
        });

        var newPeeks = [];

        _.forEach(zeroMap, function (object) {
          newPeeks.push(object);
        });

        peeks = newPeeks;
      }

      angular.forEach(peeks, function (peek, index) {
        // Game has changed since last peek
        if (index > 0 && peeks[index - 1].twitch_game_id !== peek.twitch_game_id) {
          var lastPoint = peeks[index - 1];
          var thisPoint = peek;

          var seriesColor = gameMap[lastPoint.twitch_game_id] ? gameMap[lastPoint.twitch_game_id].color : '#ccc';
          var seriesName = gameMap[lastPoint.twitch_game_id] ? gameMap[lastPoint.twitch_game_id].name : 'Not Live';

            // Find point between both games
          var pointDiff = moment.utc(thisPoint.pulled_at).unix() - moment.utc(lastPoint.pulled_at).unix();

            // Create previous series point
          data.push({
            y: Math.round((lastPoint.viewers + thisPoint.viewers) / 2, 0),
            x: moment.utc(lastPoint.pulled_at).startOf('minute').add(pointDiff / 2, 'second').unix() * 1000,
            estimated: true
          });

          series.push({
            color: seriesColor,
            data: data,
            name: seriesName
          });

          data = [];

            // Create current series point
          data.push([
            moment.utc(thisPoint.pulled_at).startOf('minute').subtract(pointDiff / 2, 'second').unix() * 1000,
            Math.round((lastPoint.viewers + thisPoint.viewers) / 2, 0)
          ]);
        }

        var seriesColor = gameMap[peek.twitch_game_id] ? gameMap[peek.twitch_game_id].color : '#ccc';
        var seriesName = gameMap[peek.twitch_game_id] ? gameMap[peek.twitch_game_id].name : 'Not Live';

        data.push([
          moment.utc(peek.pulled_at).startOf('minute').unix() * 1000,
          parseInt(peek.viewers)
        ]);

        // Push the last series
        if (index + 1 === peeks.length) {
          series.push({
            color: seriesColor,
            name: seriesName,
            data: data
          });
        }
      });

      return series;
    };

    this.buildZeroedSeries = function (input) {
      var defaults = {
        data: [],
        day: moment(),
        start: moment(),
        end: moment(),
        metrics: [],
        interval: 'day',
        xAxis: 'pulled_at',
        local: false
      };

      input = angular.extend(defaults, input);
      input.day = moment(input.day);

      var start = moment.utc(input.start);
      var end = moment.utc(input.end);
      var map = {};
      var blank = {};
      var output = [];
      var seriesMap = {};

        // Create blank point
      _.forEach(input.metrics, function (metric) {
        blank[metric.column] = 0;
      });

        // Create Day Map
      while (start.isBefore(end)) {
        if (input.interval === 'pull') {
          var date = start.format('YYYY-MM-DD HH:mm:ss');
          start = start.add(ENV.pullInterval, 'minute');
        } else if (input.interval === 'day') {
          var date = start.startOf('day').format('YYYY-MM-DD');
          start = start.add(1, 'day');
        }

        map[date] = blank;
      }

        // Create series and Series Map
      _.forEach(input.metrics, function (metric, seriesIndex) {
        var series = {
          name: metric.title,
          data: []
        };

        seriesMap[metric.column] = seriesIndex;
        output.push(series);
      });

      _.forEach(input.data, function (point) {
        if (input.interval === 'day') {
          var date = moment(point.pulled_at).startOf('day').format('YYYY-MM-DD');
        } else if (input.interval === 'pull') {
          var date = point.pulled_at;
        }

        if (map[date]) {
          map[date] = point;
        }
      });

      _.forEach(map, function (point, date) {
        _.forEach(input.metrics, function (metric, seriesIndex) {
          if (input.local) {
            var x = moment(date).unix() * 1000;
          } else {
            var x = moment.utc(date).unix() * 1000;
          }

          output[seriesIndex].data.push([
            x,
            point[metric.column]
          ]);
        });
      });

      return output;
    };

    return this;
  }
})();

(function() {
'use strict';

angular
    .module('Noscope')
    .service('ChartHelpers', ChartHelpers);

    /** @ngInject */
    function ChartHelpers() {

        this.bootstrap = function(chart) {
            chart.helpers = {
                chart: chart,
                setTooltipFormat: function(format) {
                    chart.options.tooltip.pointFormatter = function() {
                        return '<p class="hc-tooltip__point">' + this.y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + "<b>" + moment(this.x).local().format('YYYY') + "</b></p>";
                    };
                },
                setCursor: function(cursor) {
                    if(!chart.options.plotOptions)
                        chart.options.plotOptions = {};

                    if(!chart.options.plotOptions.line)
                        chart.options.plotOptions.line = {};

                    chart.options.plotOptions.line.cursor = cursor;
                    return chart;
                },
                setClick: function(callback) {
                    if(!chart.options.plotOptions)
                        chart.options.plotOptions = {};

                    if(!chart.options.plotOptions.series)
                        chart.options.plotOptions.series = {};

                    if(!chart.options.plotOptions.series.point)
                        chart.options.plotOptions.series.point = {};

                    if(!chart.options.plotOptions.series.point.events)
                        chart.options.plotOptions.series.point.events = {};
                    
                    chart.options.plotOptions.series.point.events.click = callback;
                    return chart;
                },
                setPlotLine: function(moment) {
                    if(!chart.options.xAxis) {
                        chart.options.xAxis = {};
                    }

                    chart.options.xAxis.plotLines = [
                        {
                            color: '#ddd', 
                            value: moment.unix()*1000,
                            width: 1,
                            zIndex: 2,
                            dashStyle: 'dash'
                        }
                    ];
                    return chart;
                },
                setNavigator: function(boolean) {
                    chart.options.navigator.enabled = boolean;
                    return chart;
                }
            }

            return chart;
        };

        return this;
    }
})();
(function() {
'use strict';

angular
    .module('Noscope')
    .service('AlgoliaService', AlgoliaService);

/** @ngInject */
function AlgoliaService(algolia, ENV) {

    this.games = function() {
        var algoliaClient = algolia.Client(ENV.algolia.id, ENV.algolia.key);
        return algoliaClient.initIndex('games');
    }

    return this;
}
})();
(function() {
'use strict';

angular
    .module('Noscope')
    .service('OutageService', OutageService);

/** @ngInject */
function OutageService(moment, Pulls, $q) {
    
    this.getOutages = function() {

        var deferred = $q.defer();
        var This = this;

        if(this.outages) {
            deferred.resolve();
        }

        Pulls.one('outages')
            .getList()
            .then(function(outages) {
                This.outages = outages;
                deferred.resolve();
            });

        return deferred.promise;
    };

    this.getBands = function(start, end) {

        var deferred = $q.defer();
        var This = this;

        this.getOutages()
            .then(function() {

                var bands = [];

                angular.forEach(This.outages, function(outage) {
                    bands.push({
                        color: 'rgba(245, 89, 52, 0.125)',
                        from: moment.utc(outage.start).unix()*1000,
                        to: moment.utc(outage.end).unix()*1000,
                        zIndex: 2,
                        label: {
                            text: 'API OUTAGE',
                            style: {
                                fontWeight: 900,
                                fontSize: 10,
                                color: '#555'
                            }
                        }
                    });
                });

                deferred.resolve(bands);
            });

        return deferred.promise;
    };

    return this;
  }
})();
(function() {
'use strict';

angular
    .module('Noscope')
    .service('ExportService', ExportService);

/** @ngInject */
function ExportService(Restangular, $timeout, $q, $filter) {

    this.game = function(game, start, end) {
        var self = this;

        this.cancel = $q.defer();

        self.headers = [
            'Channel Name',
            'Channel\'s Followers',
            'Channel\'s Average Viewers',
            'Channel\'s Profile',
            'Total Minutes Watched',
            'Minutes Streamed',
            'Stream Count',
            'Average Viewers',
            'Peak Viewers',
            'First Played',
            'Last Played'
        ];

        self.title = game.title;
        self.range = start + ' through ' + end;
        self.filename = game.slug + '_' + start + '_-_' + end + '.csv';

        if(self.loading) {
            return false;
        }

        self.data = false;
        self.active = true;
        self.loading = true;

        Restangular.one('v0')
            .one('games', game.id)
            .withHttpConfig({ timeout: self.cancel.promise })
            .getList('export', { 
                start: start,
                end: end
            })
            .then(function(data) {
                self.data = data;
                self.loading = false;
            });
    };

    this.doExport = function(meta, headers, promise) {
        var self = this;

        if(self.loading) {
            return false;
        }
        
        this.cancel = $q.defer();

        self.headers = headers;
        self.title = meta.title;
        self.range = $filter('dateToCalendar')(meta.start) + ' through ' + $filter('dateToCalendar')(meta.end);
        self.filename = meta.filename + '_' + $filter('dateToUrl')(meta.start) + '_-_' + $filter('dateToUrl')(meta.end) + '.csv';

        self.data = false;
        self.active = true;
        self.loading = true;

        if(promise.then) {
            promise.then(function(data) {

                var stage = (data.data) ? data.data : data;

                stage = stage.restangularized ? Restangular.stripRestangular(stage) : stage;

                if(meta.ignore) {
                    _.forEach(stage, function(row) {
                        _.forEach(meta.ignore, function(ignore) {
                            delete row[ignore];
                        })
                    });
                }

                if(meta.filter) {
                    _.forEach(stage, function(row) {
                        _.forEach(meta.filter, function(filter, column) {
                            row[column] = filter(row[column], row);
                        })
                    });
                }

                self.data = stage;
                self.loading = false;

            });
        } else {
            var data =  promise();

            var stage = data.restangularized ? Restangular.stripRestangular(data) : data;

            if(meta.filter) {
                _.forEach(stage, function(row) {
                    _.forEach(meta.filter, function(filter, column) {
                        row[column] = filter(row[column], row);
                    })
                });
            }

            self.data = stage;
            self.loading = false;
        }
    };

    this.cancelExport = function() {
        this.cancel.resolve();
        this.discard();
    };

    this.discard = function() {
        var self = this;

        self.active = false;
        
        $timeout(function() {
            self.loading = false;
            self.data = false;
            self.headers = [];
            self.filename = '';
            self.title = '';
            self.range = '';
        }, 300);
    };

    return this;
  }
})();
(function() {
'use strict';

angular
    .module('Noscope')
    .run(setHighchartsValues);

/** @ngInject */
function setHighchartsValues(highchartsNG, ChartTheme) {

    highchartsNG.ready(function() {
      
        Highcharts.theme = ChartTheme;
        Highcharts.setOptions(Highcharts.theme);
        Highcharts.setOptions({ global: { useUTC: false } });

    }, this);

}

})();

(function () {
  'use strict';

  angular
    .module('Noscope')
    .factory('ApiV1', ApiV1);

/** @ngInject */
  function ApiV1 (Restangular, ENV) {
    return Restangular.withConfig(function (RestangularConfigurer) {
      RestangularConfigurer.setBaseUrl(ENV.url.api + '/v1/');
    });
  }
})();

(function() {
'use strict';

angular
    .module('Noscope')
    .factory('Pulls', Pulls);

/** @ngInject */
function Pulls(Restangular) {
    var service = Restangular.one('v1').one('pulls');

    return service;
}
})();
(function() {
'use strict';

angular
    .module('Noscope')
    .run(transitionMiddleware);

/** @ngInject */
function transitionMiddleware($rootScope, $anchorScroll, $document) {
    $rootScope.$on('$stateChangeStart', function(event, toState  , toParams, fromState, fromParams) {

        if(!toState.data || (toState.data && !toState.data.noTransition)) {
            angular.element($document[0].body).addClass('is-loading');
        }

    });

    $rootScope.$on('$stateChangeSuccess', function(event, toState  , toParams, fromState, fromParams) {

        if(!toState.data || (toState.data && !toState.data.noTransition)) {
            $anchorScroll('top');
        }

        angular.element($document[0].body).removeClass('is-loading');
    });
}

})();
(function() {
'use strict';

angular
    .module('Noscope')
    .run(titleMiddleware);

/** @ngInject */
function titleMiddleware($rootScope, TitleService, $state) {

    $rootScope.$on('$stateChangeSuccess', function(event, toState  , toParams, fromState, fromParams) {

        if($state.current.data && $state.current.data.title) {
            TitleService.set($state.current.data.title);
        } else {
            TitleService.clear();
        }

    });
}

})();
(function() {
'use strict';

angular
    .module('Noscope')
    .run(statusMiddleware);

/** @ngInject */
function statusMiddleware($rootScope, $state) {

    $rootScope.$on('$stateChangeError', function(event, toState, toParams) {
        switch(toState.name) {
            case 'app.channel':
                $state.go('app.channel404');
                break;
            case 'app.game':
                $state.go('app.game404');
                break;
            default:
                $state.go('app.404');
                break;
        }
    });
}

})();

(function() {
'use strict';

angular
    .module('Noscope')
    .run(requestTimeoutMiddleware);

/** @ngInject */
function requestTimeoutMiddleware($rootScope, RequestTimeoutService) {

    $rootScope.$on('$stateChangeStart', function() {
        //Abort requests on state change
        RequestTimeoutService.resolve();
    });

    $rootScope.$on('$stateChangeSuccess', function() {
        //Abort requests on state change
        RequestTimeoutService.defer();
    });
}

})();
(function() {
'use strict';

angular
    .module('Noscope')
    .run(redirectToMiddleware);

/** @ngInject */
function redirectToMiddleware($rootScope, RequestTimeoutService, $state) {

    $rootScope.$on('$stateChangeStart', function(event, toState, toParams) {
        if(toState.name === 'app.game') {
            event.preventDefault();
            $state.go('app.game.report', toParams);
        }
    });
}

})();
(function() {
'use strict';

angular
    .module('Noscope')
    .run(authMiddleware);

/** @ngInject */
function authMiddleware($auth, $state, $rootScope) {

    $rootScope.$on('$stateChangeStart', function(event, toState  , toParams, fromState, fromParams) {

        var isLogin = toState.name === "login";
        var isNoAuth = toState.data && toState.data.noAuth;
        var isAuthed = $auth.isAuthenticated();


        //Redirect past login page
        if(isLogin && isAuthed) {
            event.preventDefault();

            return $state.go('app.dashboard');
        }

        //Let user log in
        if(isLogin && !isAuthed || isNoAuth) {
            return;
        }

        //Redirect to login
        if(!isAuthed) {
            event.preventDefault();
            $state.nextState = { state: toState, params: toParams };

            return $state.go('login');
        }

    });

}
})();

(function () {
  'use strict';

  angular
    .module('Noscope')
    .run(analyticsConfig);

/** @ngInject */
  function analyticsConfig (ENV, $timeout, $auth, $rootScope, $window, UserObjectService, $location) {
    $rootScope.$on('$stateChangeSuccess', function (event, toState) {

      // Initialize Segment
      if ($window.analytics && ENV.segmentIo.code) {
        try {
          $window.analytics.page(toState.name, null, {
            title: null,
            path: $location.path(),
            url: $location.absUrl()
          });
        } catch (exception) {}
      }
    });
  }
})();

(function() {
'use strict';

angular
    .module('Noscope')
    .factory('MaintenanceModeInterceptor', MaintenanceModeInterceptor);

function MaintenanceModeInterceptor($log, $q, $window, $injector) {

    var factory = {
        responseError: function(rejection) {

            if (rejection.status === 503 && rejection.data && rejection.data.status === 'down') {
                $injector.get('$state').go('be-right-back');
            }

            return $q.reject(rejection);
        }
    }

    return factory;
}
})();

(function() {
'use strict';

angular
    .module('Noscope')
    .factory('BadTokenInterceptor', BadTokenInterceptor);

function BadTokenInterceptor($log, $q, $window, $injector, $document) {

    function checkForHandledError(rejection, type) {
        return rejection.status === 400 && rejection.data.error && rejection.data.error === type;
    }

    var factory = {
        responseError: function(rejection) {

            if(checkForHandledError(rejection, 'token_not_provided')) {
                $injector.get('$state').go('logout');
                angular.element($document[0].body).removeClass('is-loading');
            }

            if(checkForHandledError(rejection, 'reset_password')) {
                $injector.get('$state').go('reset-password', { expired: true });
                angular.element($document[0].body).removeClass('is-loading');
            }

            return $q.reject(rejection);
        }
    }

    return factory;
}
})();

(function() {
'use strict';

angular
    .module('Noscope')
    .factory('ReportConfigFactory', ReportConfigFactory);

/** @ngInject */
function ReportConfigFactory(RequestTimeoutService, $filter) {
    var service = {}

    service.game = {}

    service.game.getChannels = function(model) {
        return {
            name: 'channels',
            display: 'Broadcasters',
            icon: 'ion-person',
            sort: '-minutes_watched',
            getData: function() {
                return model.withHttpConfig({ timeout: RequestTimeoutService.promise() })
                    .one('reports', 'channels');
            },
            export: {
                headers: [
                    'Followers',
                    "Channel's Average Viewership",
                    'Broadcaster Language',
                    'Minutes Watched',
                    'Minutes Streamed',
                    'Average Viewers',
                    'Peak Viewers',
                    'Streams',
                    'Name'
                ],
                options: {
                    title: model.title + ' - Channels',
                    filename: model.slug + '_channels',
                    ignore: [ 
                        'twitch_channel_id',
                        'estimated',
                        'display_name',
                        'peek_count',
                        'logo',
                        'is_live'
                    ],
                }
            }
        }
    }

    service.game.getDays = function(model) {
        return {
            name: 'days',
            display: 'Days',
            icon: 'ion-calendar',
            sort: 'dow',
            getData: function() {
                return model.withHttpConfig({ timeout: RequestTimeoutService.promise() })
                    .one('reports', 'days');
            },
            export: {
                headers: [
                    'Day of Week',
                    'Minutes Watched',
                    'Peak Viewers',
                    'Average Viewers',
                    'Minutes Streamed'
                ],
                options: {
                    title: model.title + ' - Days',
                    filename: model.slug + '_days',
                    ignore: [
                        'peek_count',
                        'start',
                        'end'
                    ],
                    filter: {
                        dow: function(val) {
                            return $filter('indexToDay')(val);
                        }
                    }
                }
            }
        }
    };

    service.game.getLanguages = function(model) {
        return {
            name: 'languages',
            display: 'Languages',
            icon: 'ion-mic-a',
            sort: '-minutes_watched',
            export: {
                headers: [
                    'Language',
                    'Minutes Watched',
                    'Minutes Streamed',
                    'Peak Viewers',
                    'Average Viewers',
                    'Channel Count'
                ],
                options: {
                    title: model.title + ' - Languages',
                    filename: model.slug + '_languages',
                    filter: {
                        peek_count: function(val) {
                            return val*10;
                        }
                    }
                }
            },
            getData: function() {
                return model.withHttpConfig({ timeout: RequestTimeoutService.promise() })
                    .one('reports', 'languages');
            }
        }
    };

    service.game.getPrimaryGames = function(model) {
        return {
            name: 'primaryGame',
            display: 'Primary Games',
            icon: 'ion-ios-game-controller-b',
            template: 'primary_games',
            sort: '-minutes_watched',
            export: {
                headers: [
                    'Title',
                    'Minutes Watched',
                    'Minutes Streamed',
                    'Channel Count',
                    'Average Viewers'
                ],
                options: {
                    title: model.title + ' - Primary Games',
                    filename: model.slug + '_primarygames',
                    filter: {
                        peek_count: function(val) {
                            return val*10;
                        }
                    }
                }
            },
            getData: function() {
                return model.withHttpConfig({ timeout: RequestTimeoutService.promise() })
                    .one('reports', 'primary-games');
            }
        };
    };

    service.game.getStreams = function(model) {
        return {
            name: 'streams',
            display: 'Streams',
            icon: 'ion-ios-recording',
            sort: '-pulled_at',
            export: {
                headers: [
                    'Minutes Streamed',
                    'Peak Viewers',
                    'Average Viewers',
                    'Started At',
                    'Ended At',
                    'Channel',
                ],
                options: {
                    title: model.title + ' - Streams',
                    filename: model.slug + '_streams',
                    ignore: [ 'twitch_channel_id', 'twitch_stream_id' ],
                    filter: {
                        channel: function(val, row) {
                            return val.name;
                        }
                    }
                }
            },
            getData: function() {
                return model.withHttpConfig({ timeout: RequestTimeoutService.promise() })
                    .one('reports', 'streams');
            }
        }
    };

    return service;
}
})();

(function() {
'use strict';

angular
    .module('Noscope')
    .factory('Report', Report);

/** @ngInject */
function Report($q, ExportService) {
    var report = function(options) {
        var self = this;

        self.start    = null;
        self.end      = null;
        
        self.sort     = options.sort || null;
        self.limit    = options.limit || 8;
        
        //Config
        self.name     = options.name || null;
        self.icon     = options.icon || null;
        self.display  = options.display || null;
        self.export   = options.export || null;
        self.getData  = options.getData;
        self.template = options.template || self.name || null;
        
        //State
        self.active   = false;
        self.data     = null;
        self.loading  = false;
        self.page     = options.page || 1;
        self.total    = 0;

        return this;
    };

    report.prototype.cancelRequest = function() {

    };

    report.prototype.doExport = function() {
        var self = this;

        if(!self.export) {
            return false;
        }

        var settings = angular.extend({
            start:  moment(self.start),
            end:    moment(self.end),
        }, self.export.options);

        var getData = self.getData().get({
                page:   self.page,
                limit:  500000,
                sort:   self.sort,
                start:  self.start,
                end:    self.end,
                export: 1
            });

        ExportService.doExport(settings, self.export.headers, getData);
    }

    report.prototype.run = function() {
        var self = this;
        var defer = $q.defer();
        var parameters = {
            start:  self.start,
            end:    self.end,
            page:   self.page,
            limit:  self.limit,
            sort:   self.sort
        };

        self.loading = true;

        _.forEach(self.parameters, function(value, parameter) {
            parameters[parameter] = value;
        });

        self.getData().get(parameters)
            .then(function(results) {
                self.data  = results.data;
                self.total = parseInt(results.total);
                self.limit = parseInt(results.per_page);
                self.page  = parseInt(results.current_page);

                self.loading = false;
                defer.resolve(results);
            }, function() {
                self.data = [];
                self.loading = false;
                defer.resolve([]);
            });

        return defer.promise;
    };

    report.prototype.reset = function() {
        var self = this;

        self.data     = null;
        self.page     = 1;
        self.total    = 0;
    };

    return report;
}
})();
(function() {
  'use strict';

  angular
    .module('Noscope')
    .factory('User', User);

  /** @ngInject */
  function User(Restangular) {
    var service = Restangular.service("users");

    service.me = function() {
      return Restangular.one('me');
    };

    return service;
  }
})();

(function() {
  'use strict';

  angular
    .module('Noscope')
    .factory('TwitchStream', TwitchStream);

  /** @ngInject */
  function TwitchStream(Restangular) {
    var service = Restangular.service('streams', Restangular.one('twitch'));

    return service;
  }
})();
(function() {
  'use strict';

  angular
    .module('Noscope')
    .factory('TwitchChannel', TwitchChannel);

  /** @ngInject */
  function TwitchChannel(Restangular) {
    var service = Restangular.service('channels', Restangular.one('twitch'));

    service.streams = function () {
        return Restangular.service('streams', service);
    };

    service.query = function (params) {
        return Restangular.one('channels');
    };

    return service;
  }
})();
(function() {
  'use strict';

  angular
    .module('Noscope')
    .factory('TwitchAPI', TwitchAPI);

  /** @ngInject */
  function TwitchAPI(Restangular, ENV) {
    return Restangular.withConfig(function(RestangularConfigurer) {
        RestangularConfigurer.setBaseUrl('https://api.twitch.tv/kraken/');
        RestangularConfigurer.setDefaultHeaders({ 'Client-ID': ENV.twitch.key });
    });
  }
})();
(function() {
'use strict';

angular
    .module('Noscope')
    .factory('TimeframeFactory', TimeframeFactory);

/** @ngInject */
function TimeframeFactory(moment) {
    this.standard = [
        {
            title: 'Today',
            start: moment().startOf('day'),
            end: moment().startOf('day'),
        },
        {
            title: 'Yesterday',
            start: moment().subtract(1, 'day').startOf('day'),
            end: moment().subtract(1, 'day').startOf('day'),
        },
        {
            title: 'This Week',
            start: moment().startOf('week'),
            end: moment().endOf('week'),
        },
        {
            title: 'Last Week',
            start: moment().subtract(1, 'week').startOf('week'),
            end: moment().subtract(1, 'week').endOf('week'),
        },
        {
            title: 'This Month',
            start: moment().startOf('month'),
            end: moment().endOf('month'),
        },
        {
            title: 'Last Month',
            start: moment().subtract(1, 'month').startOf('month'),
            end: moment().subtract(1, 'month').endOf('month'),
        },
        {
            title: 'This Year',
            start: moment().startOf('year'),
            end: moment().endOf('year'),
        },
        {
            title: 'Since ' + moment.unix(ENV.twitch.dataMinimumData).format('M/YY'),
            start: moment.unix(ENV.twitch.dataMinimumData).startOf('day'),
            end: moment().startOf('day'),
        },
    ];

    this.timeline = [
        {
            title: 'Today',
            start: moment().startOf('day'),
            end: moment().startOf('day').add(1, 'day').subtract(1, 'ms'),
        },
        {
            title: 'Yesterday',
            start: moment().subtract(1, 'day').startOf('day'),
            end: moment().startOf('day').subtract(1, 'second'),
        },
        {
            title: 'This Week',
            start: moment().startOf('week'),
            end: moment().endOf('week'),
        },
        {
            title: 'Last Week',
            start: moment().subtract(1, 'week').startOf('week'),
            end: moment().subtract(1, 'week').endOf('week'),
        },
        {
            title: 'This Month',
            start: moment().startOf('month'),
            end: moment().endOf('month'),
        },
        {
            title: 'Last Month',
            start: moment().subtract(1, 'month').startOf('month'),
            end: moment().subtract(1, 'month').endOf('month'),
        },
        {
            title: 'This Year',
            start: moment().startOf('year'),
            end: moment().endOf('year'),
        },
        {
            title: 'Last Year',
            start: moment().subtract(1, 'year').startOf('year'),
            end: moment().subtract(1, 'year').endOf('year'),
        },
        {
            title: 'Since ' + moment.unix(ENV.twitch.dataMinimumData).format('M/YY'),
            start: moment.unix(ENV.twitch.dataMinimumData).startOf('day'),
            end: moment().startOf('day').subtract(1, 'ms'),
        },
    ];
    
    return this;
}
})();
(function() {
  'use strict';

  angular
    .module('Noscope')
    .factory('Series', Series);

  /** @ngInject */
  function Series(moment) {
    var Series = function(rawData, options) { 
        var defaults = {
            xAxis: 'pulled_at',
            localTime: true,
            interval: 10,
            ignore: []
        };
        var settings = _.extend({}, defaults, options)
        return this.init(rawData, settings) 
    };

    Series.prototype.init = function(rawData, settings) {
        this.raw = rawData;
        this.settings = settings;

        return this.build();
    };

    Series.prototype.buildMap = function() {
        var This = this;
        This.map = {};

        var i = 0;
        _.forEach(this.raw[0], function(value, column) {
            if(column !== This.settings.xAxis & _.indexOf(This.settings.ignore, column) < 0) {
                This.map[column] = {
                    index: i,
                    data: [],
                    column: column
                }
                i++;
            }
        });
    }

    Series.prototype.package = function() {
        var This = this;
        This.data = [];

        _.forEach(This.map, function(series) {
            This.data.push(series);
        });

        return This;
    };

    Series.prototype.zero = function(count, measurement) {
        var This = this;

        This.timeMap = {};
        var start = moment(This.raw[0][This.settings.xAxis]).utc();
        var end = moment().utc();

        while(start.isBefore(end)) {
          This.timeMap[start.format()] = true;
          start.add(count, measurement);
        }

        _.forEach(This.raw, function(metric) {
            
        });

        return this;
    };

    Series.prototype.build = function() {
        var This = this;
        This.buildMap();

        _.forEach(this.raw, function(point) {
            var x = moment(point[This.settings.xAxis]);
            _.forEach(point, function(metric, index) {
                if(This.map[index]) {
                    var point = { x: x, y: metric };
                    This.map[index].data.push(point);
                }
            });
        });

        return this.package();
    };

    return Series;
  }
})();
(function() {
  'use strict';

  angular
    .module('Noscope')
    .factory('SavedSearch', SavedSearch);

  /** @ngInject */
  function SavedSearch(Restangular) {
    var service = Restangular.service('searches');

    return service;
  }
})();
(function() {
'use strict';

angular
    .module('Noscope')
    .factory('LanguageFactory', languageFactory);

/** @ngInject */
function languageFactory() {
    var service = {}

    service.languageMap = {
        'af': 'Afrikaans',
        'af-ZA': 'Afrikaans (South Africa)',
        'ar': 'Arabic',
        'ar-AE': 'Arabic (U.A.E.)',
        'ar-BH': 'Arabic (Bahrain)',
        'ar-DZ': 'Arabic (Algeria)',
        'ar-EG': 'Arabic (Egypt)',
        'ar-IQ': 'Arabic (Iraq)',
        'ar-JO': 'Arabic (Jordan)',
        'ar-KW': 'Arabic (Kuwait)',
        'ar-LB': 'Arabic (Lebanon)',
        'ar-LY': 'Arabic (Libya)',
        'ar-MA': 'Arabic (Morocco)',
        'ar-OM': 'Arabic (Oman)',
        'ar-QA': 'Arabic (Qatar)',
        'ar-SA': 'Arabic (Saudi Arabia)',
        'ar-SY': 'Arabic (Syria)',
        'ar-TN': 'Arabic (Tunisia)',
        'ar-YE': 'Arabic (Yemen)',
        'asl': 'American Sign Language',
        'az': 'Azeri (Latin)',
        'az-AZ': 'Azeri (Latin) (Azerbaijan)',
        'be': 'Belarusian',
        'be-BY': 'Belarusian (Belarus)',
        'bg': 'Bulgarian',
        'bg-BG': 'Bulgarian (Bulgaria)',
        'bs-BA': 'Bosnian (Bosnia and Herzegovina)',
        'ca': 'Catalan',
        'ca-ES': 'Catalan (Spain)',
        'cs': 'Czech',
        'cs-CZ': 'Czech (Czech Republic)',
        'cy': 'Welsh',
        'cy-GB': 'Welsh (United Kingdom)',
        'da': 'Danish',
        'da-DK': 'Danish (Denmark)',
        'de': 'German',
        'de-AT': 'German (Austria)',
        'de-CH': 'German (Switzerland)',
        'de-DE': 'German (Germany)',
        'de-LI': 'German (Liechtenstein)',
        'de-LU': 'German (Luxembourg)',
        'dv': 'Divehi',
        'dv-MV': 'Divehi (Maldives)',
        'el': 'Greek',
        'el-GR': 'Greek (Greece)',
        'en': 'English',
        'en-AU': 'English (Australia)',
        'en-BZ': 'English (Belize)',
        'en-CA': 'English (Canada)',
        'en-CB': 'English (Caribbean)',
        'en-GB': 'English (United Kingdom)',
        'en-IE': 'English (Ireland)',
        'en-JM': 'English (Jamaica)',
        'en-NZ': 'English (New Zealand)',
        'en-PH': 'English (Republic of the Philippines)',
        'en-TT': 'English (Trinidad and Tobago)',
        'en-US': 'English (United States)',
        'en-ZA': 'English (South Africa)',
        'en-ZW': 'English (Zimbabwe)',
        'eo': 'Esperanto',
        'es': 'Spanish',
        'es-AR': 'Spanish (Argentina)',
        'es-BO': 'Spanish (Bolivia)',
        'es-CL': 'Spanish (Chile)',
        'es-CO': 'Spanish (Colombia)',
        'es-CR': 'Spanish (Costa Rica)',
        'es-DO': 'Spanish (Dominican Republic)',
        'es-EC': 'Spanish (Ecuador)',
        'es-ES': 'Spanish (Spain)',
        'es-GT': 'Spanish (Guatemala)',
        'es-HN': 'Spanish (Honduras)',
        'es-MX': 'Spanish (Mexico)',
        'es-NI': 'Spanish (Nicaragua)',
        'es-PA': 'Spanish (Panama)',
        'es-PE': 'Spanish (Peru)',
        'es-PR': 'Spanish (Puerto Rico)',
        'es-PY': 'Spanish (Paraguay)',
        'es-SV': 'Spanish (El Salvador)',
        'es-UY': 'Spanish (Uruguay)',
        'es-VE': 'Spanish (Venezuela)',
        'et': 'Estonian',
        'et-EE': 'Estonian (Estonia)',
        'eu': 'Basque',
        'eu-ES': 'Basque (Spain)',
        'fa': 'Farsi',
        'fa-IR': 'Farsi (Iran)',
        'fi': 'Finnish',
        'fi-FI': 'Finnish (Finland)',
        'fo': 'Faroese',
        'fo-FO': 'Faroese (Faroe Islands)',
        'fr': 'French',
        'fr-BE': 'French (Belgium)',
        'fr-CA': 'French (Canada)',
        'fr-CH': 'French (Switzerland)',
        'fr-FR': 'French (France)',
        'fr-LU': 'French (Luxembourg)',
        'fr-MC': 'French (Principality of Monaco)',
        'gl': 'Galician',
        'gl-ES': 'Galician (Spain)',
        'gu': 'Gujarati',
        'gu-IN': 'Gujarati (India)',
        'he': 'Hebrew',
        'he-IL': 'Hebrew (Israel)',
        'hi': 'Hindi',
        'hi-IN': 'Hindi (India)',
        'hr': 'Croatian',
        'hr-BA': 'Croatian (Bosnia and Herzegovina)',
        'hr-HR': 'Croatian (Croatia)',
        'hu': 'Hungarian',
        'hu-HU': 'Hungarian (Hungary)',
        'hy': 'Armenian',
        'hy-AM': 'Armenian (Armenia)',
        'id': 'Indonesian',
        'id-ID': 'Indonesian (Indonesia)',
        'is': 'Icelandic',
        'is-IS': 'Icelandic (Iceland)',
        'it': 'Italian',
        'it-CH': 'Italian (Switzerland)',
        'it-IT': 'Italian (Italy)',
        'ja': 'Japanese',
        'ja-JP': 'Japanese (Japan)',
        'ka': 'Georgian',
        'ka-GE': 'Georgian (Georgia)',
        'kk': 'Kazakh',
        'kk-KZ': 'Kazakh (Kazakhstan)',
        'kn': 'Kannada',
        'kn-IN': 'Kannada (India)',
        'ko': 'Korean',
        'ko-KR': 'Korean (Korea)',
        'kok': 'Konkani',
        'kok-IN': 'Konkani (India)',
        'ky': 'Kyrgyz',
        'ky-KG': 'Kyrgyz (Kyrgyzstan)',
        'lt': 'Lithuanian',
        'lt-LT': 'Lithuanian (Lithuania)',
        'lv': 'Latvian',
        'lv-LV': 'Latvian (Latvia)',
        'mi': 'Maori',
        'mi-NZ': 'Maori (New Zealand)',
        'mk': 'FYRO Macedonian',
        'mk-MK': 'FYRO Macedonian (Former Yugoslav Republic of Macedonia)',
        'mn': 'Mongolian',
        'mn-MN': 'Mongolian (Mongolia)',
        'mr': 'Marathi',
        'mr-IN': 'Marathi (India)',
        'ms': 'Malay',
        'ms-BN': 'Malay (Brunei Darussalam)',
        'ms-MY': 'Malay (Malaysia)',
        'mt': 'Maltese',
        'mt-MT': 'Maltese (Malta)',
        'nb': 'Norwegian (Bokm?l)',
        'nb-NO': 'Norwegian (Bokm?l) (Norway)',
        'nl': 'Dutch',
        'nl-BE': 'Dutch (Belgium)',
        'nl-NL': 'Dutch (Netherlands)',
        'nn-NO': 'Norwegian (Nynorsk) (Norway)',
        'no': 'Norwegian',
        'ns': 'Northern Sotho',
        'ns-ZA': 'Northern Sotho (South Africa)',
        'pa': 'Punjabi',
        'pa-IN': 'Punjabi (India)',
        'pl': 'Polish',
        'pl-PL': 'Polish (Poland)',
        'ps': 'Pashto',
        'ps-AR': 'Pashto (Afghanistan)',
        'pt': 'Portuguese',
        'pt-BR': 'Portuguese (Brazil)',
        'pt-PT': 'Portuguese (Portugal)',
        'qu': 'Quechua',
        'qu-BO': 'Quechua (Bolivia)',
        'qu-EC': 'Quechua (Ecuador)',
        'qu-PE': 'Quechua (Peru)',
        'ro': 'Romanian',
        'ro-RO': 'Romanian (Romania)',
        'ru': 'Russian',
        'ru-RU': 'Russian (Russia)',
        'sa': 'Sanskrit',
        'sa-IN': 'Sanskrit (India)',
        'se': 'Sami (Northern)',
        'se-FI': 'Sami (Finland)',
        'se-NO': 'Sami (Norway)',
        'se-SE': 'Sami (Sweden)',
        'sk': 'Slovak',
        'sk-SK': 'Slovak (Slovakia)',
        'sl': 'Slovenian',
        'sl-SI': 'Slovenian (Slovenia)',
        'sq': 'Albanian',
        'sq-AL': 'Albanian (Albania)',
        'sr-BA': 'Serbian (Bosnia and Herzegovina)',
        'sr-SP': 'Serbian (Serbia and Montenegro)',
        'sv': 'Swedish',
        'sv-FI': 'Swedish (Finland)',
        'sv-SE': 'Swedish (Sweden)',
        'sw': 'Swahili',
        'sw-KE': 'Swahili (Kenya)',
        'syr': 'Syriac',
        'syr-SY': 'Syriac (Syria)',
        'ta': 'Tamil',
        'ta-IN': 'Tamil (India)',
        'te': 'Telugu',
        'te-IN': 'Telugu (India)',
        'th': 'Thai',
        'th-TH': 'Thai (Thailand)',
        'tl': 'Tagalog',
        'tl-PH': 'Tagalog (Philippines)',
        'tn': 'Tswana',
        'tn-ZA': 'Tswana (South Africa)',
        'tr': 'Turkish',
        'tr-TR': 'Turkish (Turkey)',
        'tt': 'Tatar',
        'tt-RU': 'Tatar (Russia)',
        'ts': 'Tsonga',
        'uk': 'Ukrainian',
        'uk-UA': 'Ukrainian (Ukraine)',
        'ur': 'Urdu',
        'ur-PK': 'Urdu (Islamic Republic of Pakistan)',
        'uz': 'Uzbek (Latin)',
        'uz-UZ': 'Uzbek (Uzbekistan)',
        'vi': 'Vietnamese',
        'vi-VN': 'Vietnamese (Viet Nam)',
        'xh': 'Xhosa',
        'xh-ZA': 'Xhosa (South Africa)',
        'zh': 'Chinese',
        'zh-CN': 'Chinese (S)',
        'zh-HK': 'Chinese (Hong Kong)',
        'zh-MO': 'Chinese (Macau)',
        'zh-SG': 'Chinese (Singapore)',
        'zh-TW': 'Chinese (Taiwan)',
        'zu': 'Zulu',
        'zu-ZA': 'Zulu (South Africa)',
    };

    service.getLanguageName = function(abbreviation) {
        return (service.languageMap[abbreviation]) ? '[' + abbreviation.toUpperCase() + '] - ' +service.languageMap[abbreviation] : abbreviation.toUpperCase();
    }

    return service;
}
})();
(function() {
  'use strict';

  angular
    .module('Noscope')
    .factory('Game', Game);

  /** @ngInject */
  function Game(Restangular) {
    var service = Restangular.service('games');

    service.streams = function () {
        //return Restangular.service('streams', service);
    };

    return service;
  }
})();
(function() {
  'use strict';

  angular
    .module('Noscope')
    .factory('ColorsFactory', ColorsFactory);

  /** @ngInject */
  function ColorsFactory() {
    this.chartSet = [
      '#FB5718',
      '#FE9700', 
      '#8AC249',
      '#CA272E',
      '#535055',
      '#6B4E98',
      '#8F2228',
      '#F34235', 
      '#FEC006', 
      '#9C27B0', 
      '#4BAE4F', 
      '#FF5722', 
      '#009587',
      '#2095F2' 
    ];
    
    return this;
  }
})();
(function() {
  'use strict';

  angular
    .module('Noscope')
    .factory('Campaign', Campaign);

  /** @ngInject */
  function Campaign(Restangular) {
    var service = Restangular.service('campaigns');

    return service;
  }
})();
(function() {
'use strict';

angular
    .module('Noscope')
    .directive('tableSort', tableSort);

/** @ngInject */
function tableSort() {
    return {
        restrict: 'A',
        scope: {
            tableSort: '=',
            tableSortColumn: '@'
        },
        link: function($scope, $element) {
            $element.addClass('is-sort')
                .append('<i class="icon--sort ion-android-arrow-dropdown"></i>');

            $scope.$watch('tableSort', function() {
                if($scope.tableSort === $scope.tableSortColumn) {
                    $element.addClass('is-sort--asc').removeClass('is-sort--desc');
                } else if($scope.tableSort === '-' + $scope.tableSortColumn) {
                    $element.addClass('is-sort--desc').removeClass('is-sort--asc');
                } else {
                    $element.removeClass('is-sort--desc').removeClass('is-sort--asc');
                }
            })
        }
    }
}
})();
(function() {
'use strict';

angular
    .module('Noscope')
    .directive('setFocus', setFocus);

/** @ngInject */
function setFocus($timeout) {
    return {
        scope: { 
            trigger: '=setFocus' 
        },
        link: function(scope, element) {
            scope.$watch('trigger', function(value) {
            
                if(value === true) { 
                    $timeout(function() {
                        element[0].focus();
                    });
                }
            });
        }
    }
}

})();
(function() {
'use strict';

angular
    .module('Noscope')
    .directive('selectOnClick', selectOnClick);

/** @ngInject */
function selectOnClick($window) {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            element.on('click', function () {
                if (!$window.getSelection().toString()) {
                    this.setSelectionRange(0, this.value.length)
                }
            });
        }
    };
  }
})();
(function() {
'use strict';

angular
    .module('Noscope')
    .directive('reportCard', reportCard);

/** @ngInject */
function reportCard() {
    return {
        restrict: 'E',
        replace: true,
        template: [
            '<sup ng-hide="value == 0"', 
             'class="reportCard"',
             'uib-tooltip="Averages {{ comparison | number:0 }}"',
             'ng-class="{ \'is-good\': value > 0, \'is-bad\': value < 0 }">',
                '<i class="icon is-up ion-arrow-up-a"></i>',
                '<i class="icon is-down ion-arrow-down-a"></i>',
                '{{ value | absoluteValue | number: 0 }}%',
            '</sup>'
        ].join(''),
        scope: {
            value: '@',
            comparison: '@'
        }
    }
}
})();
(function() {
'use strict';

angular
    .module('Noscope')
    .directive('noSpecialChars', noSpecialChars);
 
/** @ngInject */
function noSpecialChars() {
    return {
        require: 'ngModel',
        restrict: 'A',
        link: function($scope, element, attrs, modelCtrl) {
            modelCtrl.$parsers.push(function(inputValue) {

                if (inputValue == null) {
                    return '';
                }

                // make lower case and trim
                var slug = inputValue.toLowerCase().trim();
    
                // replace invalid chars with spaces
                slug = slug.replace(/[^a-z0-9\s-]/g, ' ');
    
                // replace multiple spaces or hyphens with a single hyphen
                slug = slug.replace(/[\s-]+/g, '-');

                if (slug != inputValue) {
                    modelCtrl.$setViewValue(slug);
                    modelCtrl.$render();
                }
    
                return slug;
            });
        }
    }
}

})();
(function() {
'use strict';

angular
    .module('Noscope')
    .directive('duration', duration);

/** @ngInject */
function duration(ENV) {
    return {
        restrict: 'E',
        replace: true,
        template: [
            '<span class="m-duration" uib-tooltip="{{ (peeks) ? peeks*pullInterval : (start | durationBetweenDates : end)/60 | number }} min">',
                '<i class="icon--fade icon--margin ion-android-stopwatch"></i> ',
                '<span ng-if="start && end && start === end">< 0:10</span>',
                '<span ng-if="start && end && start !== end">',
                    '{{ start | durationBetweenDates : end | durationToTimestamp:\'s\' }}',
                '</span>',
                '<span ng-if="peeks && peeks > 1">',
                    '{{ peeks*pullInterval | durationToTimestamp:\'m\' }}',
                '</span>',
                '<span ng-if="peeks && peeks == 1">',
                    '< 0:10',
                '</span>',
            '</span>'
        ].join(''),
        scope: {
            start: '=',
            end: '=',
            peeks: '='
        },
        link: function($scope) {
            $scope.pullInterval = ENV.pullInterval;
        }
    }
}
})();
(function() {
'use strict';

angular
    .module('Noscope')
    .directive('bigNumber', bigNumber);

/** @ngInject */
function bigNumber($filter) {
    return {
        restrict: 'E',
        replace: true,
        template: '<span uib-tooltip="{{ number | number }}" tooltip-enable="number >= 10000">{{ number | bigNumber }}</span>',
        scope: {
            number: '='
        }
    }
}
})();
(function() {
'use strict';

angular
    .module('Noscope')
    .directive('bgImg', bgImg);

/** @ngInject */
function bgImg() {
    return {
        restrict: 'E',
        replace: true,
        transclude: true,
        template: [
            '<div class="bgImg"',
            'ng-style="{',
                'backgroundImage: \'url(\' + image + \')\',',
                'height: height + \'px\',',
                'lineHeight: height + \'px\',',
                'width: width + \'px\'',
            '}">',
                '<ng-transclude class="bgImg__content"></ng-transclude>',
            '</div>'
        ].join(''),
        scope: {
            image: '@',
            height: '@',
            width: '@',
        }
    }
}

/*function bgImgOld($timeout) {
    return {
        restrict: 'E',
        replace: true,
        transclude: true,
        template: [
            '<div class="bgImg"',
            'ng-style="{ \'background-image\': backgroundImage }"',
            'ng-class="{ \'is-loading\': isLoading }"',
            'ng-cloak>',
                '<div ng-style="{ \'border-color\': spinnerColor }" class="spinner--small--dark bgImg__loading"></div>',
                '<ng-transclude class="bgImg__content"></ng-transclude>',
            '</div>'
        ].join(''),
        scope: {
            image: '@',
            height: '@',
            width: '@',
            spinnerColor: '@'
        },
        link: function($scope, $element, attr) {

            $element.css({
                lineHeight: $scope.height + 'px',
                height: $scope.height + 'px'
            });

            if($scope.width) {
                $element.css({ width: $scope.width + 'px' });
            }

            $scope.$watch('image', function() {
                $scope.backgroundImage = 'none';

                if($scope.image) {
                    $scope.isLoading = true;
                    angular.element('<img src=' + $scope.image + '>').bind('load', function() {
                        $scope.isLoading = false;
                        $timeout(function() {
                            $scope.backgroundImage = 'url(' + $scope.image + ')';
                        });
                    });
                }
            });
        }
    }
}*/
})();

(function() {
'use strict';

angular
    .module('Noscope')
    .config(uiBootstrapConfig);

/** @ngInject */
function uiBootstrapConfig($uibTooltipProvider) {
    $uibTooltipProvider.options({
      animation: false,
      appendToBody: true
    });
    
    $uibTooltipProvider.setTriggers({
      'mouseenter': 'mouseleave'
    });
}

})();
(function() {
'use strict';

angular
    .module('Noscope')
    .config(restangularConfig);

/** @ngInject */
function restangularConfig(RestangularProvider, ENV) {
    RestangularProvider.setBaseUrl(ENV.url.api);
    RestangularProvider.addResponseInterceptor(parseApiResponse);

    function parseApiResponse(data, operation) {
        var response = data;

        if (operation === 'getList' && data.data) {
            response = data.data;
            response.metadata = _.omit(data, 'data');
        }

        return response;
    }
}

})();

(function() {
'use strict';

angular
    .module('Noscope')
    .config(qConfig);

/** @ngInject */
function qConfig($qProvider) {
    $qProvider.errorOnUnhandledRejections(false);
}

})();
(function() {
'use strict';

angular
    .module('Noscope')
    .config(momentConfig);

/** @ngInject */
function momentConfig(moment) {
    
    moment.locale('en-US', {
      calendar : {
        lastDay : '[Yesterday] [at] LT',
        sameDay : '[Today] [at] LT',
        nextDay : '[Tomorrow] [at] LT',
        lastWeek : 'dddd [at] LT',
        nextWeek : 'dddd [at] LT',
        sameElse : 'll [at] LT'
      },
      ordinal : function (number, token) {
        var b = number % 10;
        var output = (~~ (number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
      }
    });
}

})();
(function() {
'use strict';

angular
    .module('Noscope')
    .config(locationConfig);

/** @ngInject */
function locationConfig($locationProvider) {
    $locationProvider.html5Mode(true);
}

})();
(function() {
'use strict';

angular
    .module('Noscope')
    .config(localStorageConfig);

/** @ngInject */
function localStorageConfig(localStorageServiceProvider) {
    localStorageServiceProvider.setPrefix('noscope');
}

})();
(function() {
'use strict';

angular
    .module('Noscope')
    .config(loadingBarConfig);

/** @ngInject */
function loadingBarConfig(cfpLoadingBarProvider) {
    cfpLoadingBarProvider.includeSpinner = false;
}

})();

(function() {
'use strict';

angular
    .module('Noscope')
    .config(config);

/** @ngInject */
function config($logProvider, moment, ENV) {
    ENV.minimumDate = moment(ENV.twitch.dataMinimumData*1000);
    ENV.daysOfData = moment().diff(ENV.minimumDate, 'days');

    // Enable log
    $logProvider.debugEnabled(ENV.debug);

    if (window.analytics) {
        window.analytics.load(ENV.segmentIo.code);
    } else {
        console.log('no segement');
    }
}

})();

(function() {
'use strict';

angular
    .module('Noscope')
    .config(httpConfig);

/** @ngInject */
function httpConfig($httpProvider, moment) {
    $httpProvider.defaults.headers.common.UTCoffset = moment().utcOffset();
    $httpProvider.defaults.headers.common['Client-Timezone'] = moment.tz.guess();
    $httpProvider.interceptors.push('MaintenanceModeInterceptor');
    $httpProvider.interceptors.push('BadTokenInterceptor');
}

})();

(function() {
'use strict';

angular
    .module('Noscope')
    .config(bugsnagConfig);

/** @ngInject */
function bugsnagConfig(bugsnagProvider, ENV) {

    bugsnagProvider
        .noConflict()
        .apiKey(ENV.bugsnag.api)
        .releaseStage(ENV.stage)
        .beforeNotify(['$log', function ($log) {
            return function (error, metaData) {
                $log.debug(error.name);
                return true;
            };
        }]);
}

})();
(function() {
'use strict';

angular
    .module('Noscope')
    .config(authConfig);

/** @ngInject */
function authConfig($authProvider) {
    $authProvider.loginUrl = ENV.url.api + '/auth';
}

})();

(function() {
    'use strict';

    angular
        .module('Noscope')
        .factory('ChartTheme', ChartTheme);

    /** @ngInject */
    function ChartTheme(ColorsFactory) {
        return {
            colors: ColorsFactory.chartSet,
            chart: {
                animation: false,
                spacingTop: 0,
                spacingLeft: 5, 
                spacingRight: 5,
                spacingBottom: 15,
                className: 'd-highchart',
                style: {
                    fontFamily: '"Lato", sans-serif',
                    fontSize: '12px'
                }
            },
            credits: { enabled: false },
            legend: { enabled: false },
            loading: {
                style: {
                    opacity: 1
                }
            },
            navigator: {
                adaptToUpdatedData: false,
                baseSeries: 0,
                enabled: true,
                handles: { 
                    backgroundColor: '#bbb', 
                    borderColor: '#eee' 
                },
                height: 47,
                margin: 10,
                maskFill: 'rgba(250, 250, 250, 0.8)',
                maskInside: false,
                outlineColor: '#dfdfdf',
                outlineWidth: 1,
                series: {
                    lineWidth: 3,
                    color: '#F85829',
                    fillOpacity: 0.1
                },
                xAxis: {
                    labels: {
                        enabled: false,
                        y: 12,
                        align: 'center',
                        style: {
                            fontWeight: 600,
                            textTransform: 'uppercase',
                            fontSize: 9,
                            color: '#a0a0a0'
                        }
                    }
                }
            },
            plotOptions: {
                line: {
                    animation: false,
                    color: '#F85829',
                    lineWidth: 4,
                    marker: {
                        enabled: false,
                        symbol: 'circle',
                        radius: 3,
                        states: {
                            hover: {
                                enabled: true,
                                lineWidthPlus: 2
                            }
                        }
                    },
                    states: {
                        hover: { 
                            lineWidthPlus: 0,
                            halo: { size: 6 } 
                        }
                    }
                },
                area: {
                    animation: false,
                    lineWidth: 0,
                    stacking: 'normal',
                    fillOpacity: 0.8,
                    states: {
                        hover: { 
                            halo: { size: 6 } 
                        }
                    },
                }
            },
            rangeSelector: {
                buttonSpacing: 10,
                buttonTheme: {
                    height: 15,
                    fill: 'transparent',
                    y: 6,
                    r: 2,
                    width: 46,
                    style: {
                        fontSize: 11,
                        color: '#999',
                        fontWeight: '600',
                        background: '#fff',
                        textTransform: 'uppercase',
                    },
                    states: {
                        hover: {
                            fill: '#FB5719',
                            style: { color: '#fff', backgroundColor: 'transparent' }
                        },
                        select: {
                            fill: '#FB5719',
                            style: { color: '#fff', fontWeight: 600 }
                        },
                        disabled: {
                            style: { color: '#dcdcdc', cursor: 'default' }
                        }
                    }
                },
                buttons: [
                    { type: 'day', count: 7, text: '7 Days' }, 
                    { type: 'day', count: 14, text: '14 Days' }, 
                    { type: 'day', count: 30, text: '30 Days' }, 
                    { type: 'day', count: 90, text: '90 Days' }, 
                    { type: 'year', count: 1, text: '1 Year' }, 
                    { type: 'ytd', text: 'Year' }, 
                    { type: 'all', text: 'All' }
                ],
                height: 31,
                inputEnabled: false,
                labelStyle: { display: 'none' },
                selected: 2,
            },
            scrollbar: { enabled: false },
            tooltip: {
                backgroundColor: '#1F2427',
                borderRadius: 6,
                borderWidth: 0,
                headerFormat: '<h4 class="hc-tooltip__title">{point.series.name}</h4>',
                pointFormatter: function(point) {
                  return '<p class="hc-tooltip__point">' +  this.y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + '<b>' + point.key + "</b></p>";
                },                 
                xDateFormat: '%b %e, %Y - %l:%M%p',
                shadow: false,
                useHTML: true,
                style: {
                  color: '#fff',
                  padding: '7px',
                }
            },
            xAxis: {
                type: 'datetime',
                tickPosition: 'outside',
                tickLength: 4,
                tickWidth: 2,
                tickColor: '#ddd',
                lineColor: '#ddd',
                lineWidth: 2,
                dateTimeLabelFormats: {
                    millisecond: '%l:%M %p',
                    second: '%l:%M %p',
                    minute: '%l:%M %p',
                    hour: '%l %p',
                    day: '%b %e',
                    week: '%b %e',
                    month: '%b %y',
                    year: '%Y'
                },
                labels: {
                    y: 15,
                    style: {
                        fontWeight: 600,
                        textTransform: 'uppercase',
                        fontSize: 10,
                        color: '#a0a0a0'
                    }
                },
                crosshair: {
                    color: '#dfdfdf'
                }
            },
            yAxis: {
                gridLineColor: '#F6F7F7',
                gridLineWidth: 1,
                alternateGridColor: '#F9FAFA',
                labels: {
                    enabled: true,
                    x: -4,
                    y: -4,
                    style: {
                        fontWeight: 600,
                        textTransform: 'uppercase',
                        fontSize: 10,
                        color: '#a0a0a0'
                    },
                    zIndex: 1
                }
            }
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('Noscope')
        .factory('ChartConfig', ChartConfig);

    /** @ngInject */
    function ChartConfig($state) {

        var configs = {
            'game-timeline': {
                chart: { 
                    type: 'line', 
                    spacingLeft: 0, 
                    spacingRight: 0,
                },
                plotOptions: { 
                    line: { 
                        lineWidth: 4,
                        cursor: 'pointer',
                        marker: {
                            enabled: false
                        },
                    },
                    series: { point: { events: {} } }
                },
                title: {
                    text: null,
                },
                xAxis: {},
                yAxis: {
                    title: { enabled: false },
                    opposite: true,
                    labels: {
                        align: 'right',
                        y: 15,
                        style: {
                            fontWeight: 600,
                            textTransform: 'uppercase',
                            fontSize: 10,
                            color: '#a0a0a0'
                        }
                    },
                },
                navigator: { enabled: false },
                scrollbar: { enabled: false },
                rangeSelector: { enabled: false, selected: 2 },
                tooltip: { pointFormatter: function() {
                    return '<p class="hc-tooltip__point">' +  this.y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + '<b>' + moment(this.x).local().format('MMMM DD, YYYY') + "</b></p>";
                }}
            },
            timelineDay: {
                chart: { 
                    type: 'line', 
                    spacingLeft: 0, 
                    spacingRight: 0,
                },
                plotOptions: { 
                    line: { 
                        cursor: 'default',
                    },
                    series: { point: { events: {} } }
                },
                title: {
                    text: null,
                },
                xAxis: {},
                yAxis: {
                    title: { enabled: false },
                    opposite: true,
                    labels: {
                        align: 'right',
                        y: 15,
                        style: {
                            fontWeight: 600,
                            textTransform: 'uppercase',
                            fontSize: 10,
                            color: '#a0a0a0'
                        }
                    },
                },
                navigator: { enabled: false },
                scrollbar: { enabled: false },
                rangeSelector: { enabled: false, selected: 2 },
                tooltip: { pointFormatter: function() {
                    return '<p class="hc-tooltip__point">' +  this.y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + '<b>' + moment(this.x).local().format('LT') + "</b></p>";
                }}
            },
            timeline: {
                chart: { 
                    type: 'line', 
                    spacingLeft: 0, 
                    spacingRight: 0,
                },
                plotOptions: { 
                    line: { 
                        cursor: 'default',
                    },
                    series: { point: { events: {} } }
                },
                title: {
                    text: null,
                },
                xAxis: {},
                yAxis: {
                    title: { enabled: false },
                    opposite: true,
                    labels: {
                        align: 'right',
                        y: 15,
                        style: {
                            fontWeight: 600,
                            textTransform: 'uppercase',
                            fontSize: 10,
                            color: '#a0a0a0'
                        }
                    },
                },
                navigator: { enabled: false },
                scrollbar: { enabled: false },
                rangeSelector: { enabled: false, selected: 2 },
                tooltip: { pointFormatter: function() {
                    return '<p class="hc-tooltip__point">' +  this.y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + '<b>' + moment(this.x).local().format('MMMM DD, YYYY') + "</b></p>";
                }}
            },
            'campaign-overview-channel': {
                chart: { type: 'line', spacingLeft: 11, spacingRight: 11, spacingTop: 12 },
                plotOptions: {
                    area: {
                        color: '#aaa',
                        lineWidth: 0,
                        type: 'area',
                        fillOpacity: 0.28,
                        states: {
                            hover: {
                                enabled: false
                            }
                        }
                    }
                },
                navigator: { 
                    enabled: false
                },
                tooltip: { pointFormatter: function() {
                    return '<p class="hc-tooltip__point">' +  this.y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + '<b>' + moment(this.x).local().format('MMMM DD, YYYY') + "</b></p>";
                }},
                scrollbar: { enabled: false },
                rangeSelector: { 
                    enabled: false,
                    buttons: [
                        { type: 'day', count: 1, text: '1 Day' }, 
                        { type: 'day', count: 7, text: '7 Days' }, 
                        { type: 'day', count: 14, text: '14 Days' }, 
                        { type: 'day', count: 30, text: '30 Days' },  
                        { type: 'all', text: 'All' }
                    ],
                },
                xAxis: {
                    events: {},
                }
            },
            'campaign-overview': {
                chart: { type: 'line', spacingLeft: 0, spacingRight: 0 },
                plotOptions: {
                },
                navigator: { 
                    enabled: false
                },
                tooltip: { pointFormatter: function() {
                    return '<p class="hc-tooltip__point">' +  this.y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + '<b>' + moment(this.x).local().format('MMMM DD, YYYY') + "</b></p>";
                }},
                scrollbar: { enabled: false },
                rangeSelector: { 
                    enabled: false,
                    buttons: [
                        { type: 'day', count: 1, text: '1 Day' }, 
                        { type: 'day', count: 7, text: '7 Days' }, 
                        { type: 'day', count: 14, text: '14 Days' }, 
                        { type: 'day', count: 30, text: '30 Days' },  
                        { type: 'all', text: 'All' }
                    ],
                },
                xAxis: {
                    events: {},
                }
            },
            'game-day-channels': {
                chart: { type: 'area' },
                rangeSelector: { enabled: false },
                navigator: { enabled: false },
                scrollbar: { enabled: false },
                tooltip: { 
                    headerFormat: '<h4 class="hc-tooltip__title">{point.key}</h4>',
                    pointFormatter: function() {
                        var channel = this.series.name;
                        var color = this.series.color;
                        var viewers = this.y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

                        return '<p class="hc-tooltip__point is-small is-color" style="border-color: ' + color + '">' + '<b>' + channel + '</b>' + viewers + '</p>';
                    }
                }
            },
            'game-day-timeline': {
                chart: { type: 'line' },
                navigator: { enabled: true },
                scrollbar: { enabled: false },
                rangeSelector: { enabled: false },
                tooltip: { pointFormatter: function() {
                    return '<p class="hc-tooltip__point">' +  this.y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + '<b>' + moment(this.x).local().format('LT') + "</b></p>";
                }}
            },
            'steam-breakdown': {
                chart: { type: 'line' },
                navigator: { enabled: false },
                scrollbar: { enabled: false },
                rangeSelector: { enabled: false },
                tooltip: { pointFormatter: function() {
                    if(this.index === 0 && this.series.index !== 0)
                        return '';

                    return '<p class="hc-tooltip__point">' +  this.y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + ' Viewers<b>' +  moment(this.x).local().format('lll') + "</b></p>";
                }}
            },
            'channel-growth': {
                chart: { type: 'line' },
                navigator: { enabled: true },
                scrollbar: { enabled: false },
                rangeSelector: { 
                    enabled: true,
                    buttons: [
                        { type: 'day', count: 7, text: '7 Days' }, 
                        { type: 'day', count: 14, text: '14 Days' }, 
                        { type: 'day', count: 30, text: '30 Days' }, 
                        { type: 'ytd', text: 'YTD' }, 
                        { type: 'all', text: 'All' }
                    ],
                },
                tooltip: { pointFormatter: function() {
                    var date = moment(this.x).local().subtract(1, 'days').format('MMMM DD, YYYY');
                    return '<p class="hc-tooltip__point">' +  this.y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + '<b>' + date + "</b></p>";
                }}
            },
            'right-now': {
                chart: { type: 'line' },
                rangeSelector: { enabled: false },
                scrollbar: { enabled: false },
                tooltip: {
                    headerFormat: '<h4 class="hc-tooltip__title">{point.key}</h4>',
                    pointFormatter: function() {
                        return '<div style="padding: 2px 0; font-size: 12px; font-weight: 400; text-align: left;"><div style="display: inline-block; width: 90px;"><b>' + this.series.name + '</b>:</div> ' +  this.y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + "</div>";
                    },
                },
                plotOptions: {
                    area: {
                        states: {
                            hover: {
                                enabled: false
                            }
                        }
                    }
                },
                xAxis: {
                    crosshair: {
                        color: '#ddd'
                    }
                }
            }
        }

        return {
            get: function(name) {
                return angular.copy(configs[name]);
            }
        };
    }
})();

(function() {
  'use strict';

  angular
    .module('Noscope')
    .controller('ChannelsController', ChannelsController);

  /** @ngInject */
  function ChannelsController(UserTagsService, BroadcasterLanguages, TwitchChannel, TitleService, $state, $stateParams, Restangular, $scope, $timeout, $anchorScroll, QueryService, ENV, AlgoliaService, User, SavedSearches, SavedSearch, LanguageFactory, ApiV1) {
    var vm = this;

    TitleService.set('Find Broadcasters');

    vm.sort = $stateParams.sort;
    vm.query = $stateParams.query;
    vm.filters = {
      primaryGame: {
        games: [], type: 'game'
      },
      played: {
        games: [], type: 'games'
      },
      neverPlayed: {
        games: [], type: 'games'
      },
      averageViewersShorterm: {
        range: {}, type: 'range'
      },
      followers: {
        range: {}, type: 'range'
      },
      views: {
        range: {}, type: 'range'
      },
      hasTag: {
        type: 'option',
        selectedOption: false
      },
      daysPerWeek: {
        type: 'option',
        selectedOption: false,
        options: [
          { title: 'Every Day', argument: '+', value: 7 },
          { title: '6 or More', argument: '+', value: 6 },
          { title: '5 or More', argument: '+', value: 5 },
          { title: '4 or More', argument: '+', value: 4 },
          { title: '3 or More', argument: '+', value: 3 },
          { title: '2 or More', argument: '+', value: 2 },
          { title: '1 or More', argument: '+', value: 1 },
        ]
      },
      mature: {
        type: 'option',
        selectedOption: false,
        options: [
          { title: 'Flagged Mature', argument: '$', value: true },
          { title: 'Not Flagged Mature', argument: '$', value: 'false' }
        ]
      },
      partner: {
        type: 'option',
        selectedOption: false,
        options: [
          { title: 'Is Partnered', argument: '$', value: true },
          { title: 'Is Not Partnered', argument: '$', value: 'false' }
        ]
      },
      broadcasterLanguage: {
        type: 'option',
        selectedOption: false,
        options: []
      }
    }

    UserTagsService.get()
      .then(function(tags) {
        vm.filters.hasTag.options = tags;g
      });

    vm.gameList = AlgoliaService.games();
    vm.searchList = SavedSearches;

    //Set language options
    angular.forEach(BroadcasterLanguages, function(v, i) {
      vm.filters.broadcasterLanguage.options.push({
        title: LanguageFactory.getLanguageName(v),
        argument: '$',
        value: v
      });
    });

    vm.clearQuery = function() {
      vm.setQueryString('');
      $state.go('app.channels', {
        sort: vm.sort,
        query: null,
        page: 1
      });
    };

    vm.setHasChanged = function() {
      vm.runQuery();
    };

    vm.runQuery = function() {
      var queryString = QueryService.encode(vm.filters);
      vm.setQueryString(queryString);
      vm.query = queryString;
      vm.pagination.currentPage = 1;
      vm.pagination.changePage();
      vm.queryChanged = false;
    };

    vm.pagination = {
      total: 0,
      perPage: 30,
      currentPage: 1,
      changePage: function(page) {
        page = page || 1;
        $anchorScroll('top');
        vm.loading = true;
        vm.channelNameList = false;
        vm.pagination.currentPage = page;
        TwitchChannel.query().get({
          page: vm.pagination.currentPage,
          query: vm.query,
          sort: vm.sort
        })
          .then(function(channels) {
            vm.loading = false;
            vm.channels = channels;
            vm.pagination.total = channels.total;
          });
      }
    };

    vm.loading = true;
    TwitchChannel.query().get({
      page: $stateParams.page,
      query: vm.query,
      sort: vm.sort,
    })
      .then(function(channels) {
        vm.loading = false;
        vm.pagination.currentPage = $stateParams.page;
        vm.channels = channels;
        vm.setQueryString(channels.queryString);
        vm.pagination.total = channels.total;
        vm.filters = QueryService.decode(channels.query, vm.filters);
      });

    vm.showGameProfile = function(channel) {
      if(vm.activeProfile) {
        vm.activeProfile.gameProfile = false;
      }

      if(vm.activeProfile === channel) {
        vm.activeProfile.gameProfile = false;
        vm.activeProfile = false;
        return false;
      }
      vm.activeProfile = channel;
      //channel.gameProfile = TwitchChannel.one(channel.name).one('gameprofile').get().$object;
    };

    vm.changeSort = function(sort, asc) {
      if(asc) {
        vm.sort = (vm.sort === sort) ? '-' + sort : sort;
      } else {
        vm.sort = (vm.sort === '-' + sort) ? sort : '-' + sort;
      }
      vm.pagination.currentPage = 1;
      vm.pagination.changePage(1);
    };

    vm.runSavedSearch = function(search) {
      vm.setQueryString('');
      $state.go('app.channels', {
        sort: vm.sort,
        query: search.query,
        page: 1
      });
    };

    vm.setQueryString = function(queryString) {
      if($state.current.name !== 'app.channels') {
        return false;
      }
      vm.queryString = queryString;
      $state.go('app.channels', {
        sort: vm.sort,
        query: queryString,
        page: vm.pagination.currentPage
      },
      {
        notify: false
      });
    };

    vm.saveSearch = function() {
      vm.saveSearchLoading = true;

      if(!vm.newSearchTitle) {
        vm.saveSearchLoading = false;
        vm.invalidTitle = true;
        $timeout(function() {
          vm.invalidTitle = false;
        }, 3000);
        return false;
      }

      ApiV1.one('users', 'me').post('saved-searches', { title: vm.newSearchTitle, query: vm.queryString })
        .then(function(response) {
          vm.saveSearchLoading = false;
          vm.newSearchTitle = '';

          vm.searchList.push(Restangular.restangularizeElement(null, response.search, 'searches'));
        });
    };

    vm.deleteSearch = function(search) {
      if(!search.confirmDelete) {
        search.confirmDelete = true;

        $timeout(function() {
          search.confirmDelete = false;
        }, 3000);

        return false;
      }

      vm.saveSearchLoading = true;

      ApiV1.one('users', 'me').one('saved-searches', search.id).customDELETE()
        .then(function(response) {
            vm.saveSearchLoading = false;

            _.remove(vm.searchList, function(v, i) {
                return v.id == search.id;
            });
        });
    };

    vm.searchExists = function() {
      return _.findIndex(vm.searchList, 'query', vm.queryString) >= 0;
    };

    vm.exportNames = function() {
        vm.exportNamesLoading = true;
        TwitchChannel.query().get({
          page: vm.pagination.currentPage,
          query: vm.query,
          sort: vm.sort,
          'name-only': true
        })
          .then(function(channels) {
            vm.exportNamesLoading = false;
            vm.channelNameList = channels.join("\n");
          });
    };

    vm.clearExport = function() {
        vm.channelNameList = false;
    };

    return vm;
  }
})();

(function () { // Refactored
  'use strict';

  angular
    .module('Noscope')
    .controller('AuthController', AuthController);

/** @ngInject */
  function AuthController ($auth, $state, $log, localStorageService, $window, User, $timeout, ApiV1) {
    var vm = this;
    vm.email = localStorageService.get('email');

    vm.login = function () {
      if (vm.loading) return false;

      if (!vm.email || !vm.password) {
        vm.failed = 'invalid_credentials';
        return false;
      }

      vm.loading = true;

      $auth.login({ email: vm.email.toLowerCase(), password: vm.password })
            .then(function (response) {
              vm.failed = false;

              var user = response.data.user;
              user.expires = $auth.getPayload().exp;
              localStorageService.set('user', user);
              localStorageService.set('email', user.email);

              if ($state.nextState) {
                return $state.go($state.nextState.state.name, $state.nextState.params);
              }

              $window.userSet = false;

              return $state.go('app.dashboard');
            }, function (error) {
              vm.failed = (error.status === 401) ? error.data.message : 'error';
              vm.loading = false;
            });
    };

    vm.resetPassword = function () {
      if (vm.loading) {
        return false;
      }

      vm.loading = true;

      ApiV1.one('auth').post('forgot-password', { email: vm.email })
            .then(function (response) {
              vm.emailSent = true;
            }, function (response) {
              if (response.status === 400) {
                vm.failed = 'no_user';
                vm.loading = false;
                return false;
              }

              vm.failed = 'error';
              vm.loading = false;
            });
    };
  }
})();

(function() {
'use strict';

angular
    .module('Noscope')
    .controller('AppController', AppController);

/** @ngInject */
function AppController($uibModal, localStorageService, UserObjectService, $state, ExportService, moment, Restangular, User, $rootScope) {
    var vm = this;

    vm.export = ExportService;
    vm.now = moment();
    vm.user = localStorageService.get('user');
    vm.showLoaded = localStorageService.get('showLoaded') === false ? false : true;

    if(!vm.user) {
        $state.go('logout');
    }


    UserObjectService.set(vm.user);
    Restangular.one('v1').one('changelogs', 'new').getList()
        .then(function(changes) {
            vm.user.changelogCount = changes.length;
            UserObjectService.set(vm.user);
        });

    vm.userOptions = [
        {
            title: 'Change Password',
            do: function() {
                $state.go('reset-password');
            }
        },
        {
            title: 'Logout',
            do: function() {
                $state.go('logout');
            }
        }
    ];

    vm.adminOptions = [
        {
            title: 'Game Grouping',
            analyst: false,
            do: function() {
                $state.go('app.admin.grouping');
            }
        },
        {
            title: 'Game Reviews',
            do: function() {
                $state.go('app.admin.gameReviews');
            }
        },
        {
            title: 'Pull Dashboard',
            analyst: true,
            do: function() {
                $state.go('app.admin.pulls');
            }
        },
        {
            title: 'Users',
            analyst: false,
            do: function() {
                $state.go('app.admin.users');
            }
        }
    ];

    vm.filterAdminOptions = function() {
        vm.adminOptions = _.filter(vm.adminOptions, function(v) {
            return v.analyst === true;
        });
    };

    if(!vm.user.is_admin && vm.user.is_analyst)
        vm.filterAdminOptions();

    vm.avatarSelection = function(which) {
        which.do();
    }

    vm.adminSelection = function(which) {
        which.do();
    }

    vm.loadedDetails = function() {
        var modalInstance = $uibModal.open({
          templateUrl: 'app/components/loaded-info/loaded-info.html',
          size: 'lg',
          backdrop: true,
          animation: true,
          backdropClass: 'loaded-info__backdrop',
          controller: 'LoadedInfoController'
        });
    }

    vm.dismissLoaded = function() {
        vm.showLoaded = false;
        localStorageService.set('showLoaded', false);
    };

    vm.showTerms = function() {
        if(!vm.user.terms)
            return false;

        var modalInstance = $uibModal.open({
            animation: true,
            templateUrl: 'app/components/terms/terms.html',
            controller: 'TermsController',
            backdrop: 'static',
            resolve: {
                Terms: function() {
                    return vm.user.terms;
                },
                Agreed: function() {
                    return  vm.user.terms.agreed;
                }
            }
        });
    };

    if(vm.user.terms && !vm.user.terms.agreed)  {
        vm.showTerms();
    }
}

})();

(function() { //Refactored
'use strict';

angular
    .module('Noscope')
    .config(adminRoute);

/** @ngInject */
function adminRoute($stateProvider) {

    $stateProvider
    .state('app.admin', {
        url: '/admin',
        abstract: true,
        templateUrl: 'app/admin/admin.html',
        controller: 'AdminController',
        controllerAs: 'cAdmin'
    })
    .state('app.admin.grouping', {
        url: '/grouping/:type?page&indexed',
        templateUrl: 'app/admin/grouping/grouping.html',
        controller: 'AdminGroupingController',
        controllerAs: 'cAdminGrouping',
        resolve: {
            /** @ngInject */
            Games: function(Restangular, $stateParams) {
                return Restangular.one('admin').one('games').get({
                        sort: $stateParams.type,
                        page: $stateParams.page,
                        indexed: $stateParams.indexed
                    });
            }
        }
    })
    .state('app.admin.pulls', {
        url: '/pulls?page',
        templateUrl: 'app/admin/pulls/pulls.html',
        controller: 'AdminPullsController',
        controllerAs: 'cAdminPulls',
        resolve: {
            /** @ngInject */
            Stats: function(Restangular, $stateParams) {
                return Restangular.one('admin').one('pull-stats').get();
            },
            Pulls: function(Restangular, $stateParams) {
                return Restangular.one('admin', 'pulls').get({
                    page: $stateParams.page
                });
            }
        }
    })
    .state('app.admin.pull', {
        url: '/pulls/:pull',
        templateUrl: 'app/admin/pulls/pull.html',
        controller: 'AdminPullController',
        controllerAs: 'cAdminPull',
        resolve: {
            /** @ngInject */
            Pull: function(Restangular, $stateParams) {
                return Restangular.one('admin', 'pulls')
                    .get({ pull: $stateParams.pull });
            }
        }
    })
    .state('app.admin.users', {
        url: '/users',
        templateUrl: 'app/admin/users/users.html',
        controller: 'AdminUsersController',
        controllerAs: 'cAdminUsers',
        resolve: {
            /** @ngInject */
            Users: function(Restangular) {
                return Restangular.one('v1').one('users').getList();
            }
        }
    })
    .state('app.admin.gameReviews', {
        url: '/game-reviews?page',
        templateUrl: 'app/admin/game-reviews/game-reviews.html',
        controller: 'GameReviewsController',
        controllerAs: '$ctrl',
        resolve: {
            /** @ngInject */
            games: function($stateParams, ApiV1) {
                return ApiV1.all('games').getList({
                    'needs_review': true,
                    'with_model': [ 'game_groupings', 'review_request_user' ].join(','),
                    'page': $stateParams.page,
                    'sort': '-title'
                });
            }
        }
    });
}

})();

(function() { //Refactored
  'use strict';

  angular
    .module('Noscope')
    .controller('AdminController', AdminController);

  /** @ngInject */
  function AdminController() {
    var vm = this;
  }
})();

(function() {
'use strict';

angular
    .module('Noscope')
    .config(routerConfig);

/** @ngInject */
function routerConfig($stateProvider, $urlRouterProvider) {

    $stateProvider

        .state('login', {
            url: '/login',
            templateUrl: 'app/auth/auth.html',
            controller: 'AuthController',
            controllerAs: 'cAuth',
            data: {
                title: 'Login',
                noAuth: true
            }
        })

        .state('forgot-password-gate', {
            url: '/reset-password-gate/:token',
            templateUrl: 'app/pages/reset-password/gate.html',
            controller: 'ForgotPasswordGateController',
            controllerAs: 'cForgotPasswordGate',
            data: {
                title: 'Reset Password',
                noAuth: true
            }
        })

        .state('reset-password', {
            url: '/auth/reset?expired&token&email',
            templateUrl: 'app/pages/reset-password/index.html',
            controller: 'ResetPasswordController',
            controllerAs: 'cResetPassword',
            data: {
                title: 'Reset Password',
                noAuth: true
            }
        })

        .state('app', {
            abstract: true,
            templateUrl: 'app/app/app.html',
            controller: 'AppController',
            controllerAs: 'cApp',
            resolve: {
                /** @ngInject */
                StatusPage: function($state, Restangular) {
                    Restangular.one('status').get()
                        .then(function(response) {
                            if(!response.status || response.status !== 'up') {
                                $state.go('be-right-back');
                            }
                        }, function() {
                            $state.go('be-right-back');
                        });
                }
            }
        })

        .state('be-right-back', {
            templateUrl: 'app/pages/brb.html'
        })

        .state('logout', {
            url: '/logout',
            /** @ngInject */
            controller: function($state, $auth, localStorageService, UserTagsService, UserObjectService) {
                var email = localStorageService.get('email');
                localStorageService.clearAll();
                localStorageService.set('email', email);
                $auth.logout();
                UserTagsService.refreshed = false;
                UserObjectService.set(null);

                return $state.go('login');
            },
            controllerAs: 'cLogout',
            data: {
                noAuth: true
            }
        })



        .state('app.games', {
            url: '/games/',
            templateUrl: 'app/games/games.html',
            controller: 'GamesController',
            controllerAs: 'cGames',
        })

        .state('app.game.day', {
            url: '/{day}',
            views: {
                chart: {
                    templateUrl: 'app/game/chart-day.html'
                }
            }
        })

        .state('app.channels', {
            url: '/broadcasters/:sort/:page/:query',
            templateUrl: 'app/channels/channels.html',
            controller: 'ChannelsController',
            controllerAs: 'cChannels',
            resolve: {
              /** @ngInject */
              BroadcasterLanguages: function(ApiV1) {
                return ApiV1.one('options')
                    .one('twitch')
                    .one('channels')
                    .withHttpConfig({ cache: true })
                    .getList('broadcaster_language');
              },
              /** @ngInject */
              SavedSearches: function(ApiV1) {
                return ApiV1.one('users', 'me').all('saved-searches').getList()
              }
            }
        })


        //Error Routes
        .state('app.channel404', { template: 'Channel Not Found' })
        .state('app.game404', { template: 'Game Not Found' })
        .state('app.404', { template: 'Page Not Found' });

        $urlRouterProvider.otherwise('/login');
    }

})();

/* global, moment:false */
(function() {
'use strict';

angular
    .module('Noscope')
    .constant('moment', moment)
    .constant('ENV', ENV); 

})();

angular.module("Noscope").run(["$templateCache", function($templateCache) {$templateCache.put("app/admin/admin.html","<div ui-view=\"\"></div>");
$templateCache.put("app/app/app.html","<header class=\"header\"><div class=\"u-constrict\"><ul class=\"header__nav\"><a ng-if=\"cApp.user.company === \'Loaded\'\" class=\"header__navLink\" href=\"https://lda.gg\">LD/A</a> <a class=\"header__navLink is-active\" ui-sref-active=\"is-active\" ui-sref=\"app.channels({ page: 1, sort: \'-followers\' })\">Broadcasters</a> <a class=\"header__navLink\" ui-sref-active=\"is-active\" ui-sref=\"app.campaigns()\">My Campaigns</a><ns-dropdown ng-if=\"cApp. .is_admin || cApp.user.is_analyst\" ns-dropdown-display=\"title\" ns-dropdown-options=\"cApp.adminOptions\" ns-dropdown-select=\"cApp.adminSelection\" ns-dropdown-add-class=\"mainNav__userDropdown\" ns-dropdown-direction=\"right\"><a class=\"header__navLink header__navLink--dropdown\">Admin Tools</a></ns-dropdown><li class=\"header__navContainer\"><search></search></li><ns-dropdown ns-dropdown-display=\"title\" ns-dropdown-options=\"cApp.userOptions\" ns-dropdown-select=\"cApp.avatarSelection\" ns-dropdown-add-class=\"mainNav__userDropdown\" ns-dropdown-direction=\"right\"><a class=\"header__navLink header__navLink--dropdown header__navLink--user\"><div class=\"header__avatar\"><ns-image width=\"44\" height=\"44\" ns-image-src=\"{{ cApp.user.avatar ? cApp.user.avatar : \'/assets/images/blank-user.png\' }}\">{{ user.first_name | firstLetter }}{{ user.last_name | firstLetter }}</ns-image></div></a></ns-dropdown></ul><a ui-sref=\"app.dashboard\" class=\"header__home\"><div class=\"header__loading wait wait--noscope wait--big u-vam\"></div><svg class=\"header__logo\" id=\"sprite-loaded-text\" viewbox=\"0 0 997.9 202\"><title>loaded-text</title><path fill=\"#fff\" d=\"M904.6 4.9c26.5 0 48.7 9.2 66.5 27.6 17.8 18.4 26.8 41.2 26.8 68.5 0 27.3-8.9 50.1-26.8 68.5-17.8 18.4-40 27.6-66.5 27.6H825V4.9h79.6zm0 138.9c11.2 0 20.3-4 27.6-11.9 7.2-8 10.8-18.2 10.8-30.9 0-12.6-3.6-22.9-10.8-30.9-7.2-8-16.4-11.9-27.6-11.9h-22v85.6h22zm-160.7 2.7h70V197H689V4.9h124.9v49.9h-70v20.9H807v49.4h-63.1v21.4zM584.6 4.9c26.5 0 48.7 9.2 66.5 27.6 17.8 18.4 26.8 41.2 26.8 68.5 0 27.3-8.9 50.1-26.8 68.5-17.8 18.4-40 27.6-66.5 27.6H505V4.9h79.6zm0 138.9c11.2 0 20.3-4 27.6-11.9 7.2-8 10.8-18.2 10.8-30.9 0-12.6-3.6-22.9-10.8-30.9-7.2-8-16.4-11.9-27.6-11.9h-22v85.6h22zm-149 53.2l-6.6-24.7h-55.4L367 197h-59L369.2 4.9h64.2L494.6 197h-59zm-50.2-68.6h31.8l-15.9-59-15.9 59zm-77.2-80L268 88.6l-29.2 29.2h27.8c-9.3 24.6-36.8 37.1-61.5 27.8-6.3-2.4-12.1-6.1-16.9-10.9l-37.7 37.7c39.5 39.4 103.4 39.4 142.8 0 33.1-33 39.2-84.2 14.9-124zm-132.3 65l29.2-29.2h-27.8c9.3-24.6 36.8-37.1 61.5-27.8 6.3 2.4 12.1 6.1 16.9 10.9l37.7-37.7C254-9.9 190-9.9 150.6 29.6c-32.9 33-39.1 84.2-14.8 124l40.1-40.2zm-121 30.4H118V197H0V4.9h54.9v138.9z\"></path></svg></a></div></header><div class=\"exportNotification\" ng-class=\"{ \'is-active\': cApp.export.active }\"><div class=\"inner\"><div ng-if=\"cApp.export.loading\" class=\"exportNotification__loading\"><div class=\"exportNotification__discard\" ng-click=\"cApp.export.cancelExport()\"><i class=\"ion-close\"></i></div><div class=\"spinner spinner--colorB\"></div>Generating Export</div><div ng-if=\"cApp.export.data\"><div class=\"exportNotification__discard\" ng-click=\"cApp.export.discard()\"><i class=\"ion-close\"></i></div><div class=\"exportNotification__name\"><p class=\"title\">{{ cApp.export.title }}</p><p class=\"range\">{{ cApp.export.range }}</p></div><button type=\"button\" class=\"exportNotification__download\" ng-csv=\"cApp.export.data\" filename=\"{{ cApp.export.filename }}\" csv-header=\"cApp.export.headers\" lazy-load=\"true\"><i class=\"icon ion-android-download\"></i> Download</button></div></div></div><div class=\"u-constrict\"><div class=\"globalMessages\" ng-hide=\"!cApp.hideEmergency\"><p class=\"globalMessage globalMessage--warning\"><i class=\"ion-close globalMessage__close\" ng-click=\"cApp.hideEmergency = true;\"></i> <i class=\"ion-alert-circled globalMessage__icon\"></i> We are currently experiencing Twitch API outages, we apologize for any inconvenience.</p></div><div class=\"loadedMessage\" ng-if=\"cApp.showLoaded && false\"><div class=\"loadedMessage__container\"><div class=\"loadedMessage__mask\"><a ng-click=\"cApp.dismissLoaded()\" class=\"is-close\"><i class=\"ion-close\"></i></a> We\'re making some changes for a new and improved <b>NOSCOPE</b>, you may notice a few things during this process <a class=\"learn-more\" ng-click=\"cApp.loadedDetails()\">Learn More</a></div></div></div><div ui-view=\"\" class=\"appView\"></div></div><div class=\"main-footer\">&copy; {{ cApp.now | dateToFormat: \'YYYY\' }} &nbsp; | &nbsp; A product of <a href=\"https://loaded.gg\" target=\"_blank\"><img src=\"/assets/images/loaded/logo.svg\" class=\"loaded\"></a></div>");
$templateCache.put("app/auth/auth.html","<div class=\"l-login\"><form class=\"loginForm layer\" ng-class=\"{ \'is-loading\': cAuth.loading }\"><div class=\"loginForm__inner layer__inner\"><h2 class=\"layerCap\"><svg id=\"sprite-loaded-text\" viewbox=\"0 0 997.9 202\"><title>loaded-text</title><path d=\"M904.6 4.9c26.5 0 48.7 9.2 66.5 27.6 17.8 18.4 26.8 41.2 26.8 68.5 0 27.3-8.9 50.1-26.8 68.5-17.8 18.4-40 27.6-66.5 27.6H825V4.9h79.6zm0 138.9c11.2 0 20.3-4 27.6-11.9 7.2-8 10.8-18.2 10.8-30.9 0-12.6-3.6-22.9-10.8-30.9-7.2-8-16.4-11.9-27.6-11.9h-22v85.6h22zm-160.7 2.7h70V197H689V4.9h124.9v49.9h-70v20.9H807v49.4h-63.1v21.4zM584.6 4.9c26.5 0 48.7 9.2 66.5 27.6 17.8 18.4 26.8 41.2 26.8 68.5 0 27.3-8.9 50.1-26.8 68.5-17.8 18.4-40 27.6-66.5 27.6H505V4.9h79.6zm0 138.9c11.2 0 20.3-4 27.6-11.9 7.2-8 10.8-18.2 10.8-30.9 0-12.6-3.6-22.9-10.8-30.9-7.2-8-16.4-11.9-27.6-11.9h-22v85.6h22zm-149 53.2l-6.6-24.7h-55.4L367 197h-59L369.2 4.9h64.2L494.6 197h-59zm-50.2-68.6h31.8l-15.9-59-15.9 59zm-77.2-80L268 88.6l-29.2 29.2h27.8c-9.3 24.6-36.8 37.1-61.5 27.8-6.3-2.4-12.1-6.1-16.9-10.9l-37.7 37.7c39.5 39.4 103.4 39.4 142.8 0 33.1-33 39.2-84.2 14.9-124zm-132.3 65l29.2-29.2h-27.8c9.3-24.6 36.8-37.1 61.5-27.8 6.3 2.4 12.1 6.1 16.9 10.9l37.7-37.7C254-9.9 190-9.9 150.6 29.6c-32.9 33-39.1 84.2-14.8 124l40.1-40.2zm-121 30.4H118V197H0V4.9h54.9v138.9z\"></path></svg></h2><div class=\"loginForm__field\" ng-hide=\"cAuth.emailSent\"><label class=\"loginForm__label\" ng-class=\"{ \'is-shown\': cAuth.email }\">Email Address</label> <input name=\"email\" type=\"text\" select-on-click=\"\" ng-disabled=\"cAuth.loading\" ng-model=\"cAuth.email\"></div><div class=\"loginForm__field\" ng-hide=\"cAuth.emailSent\"><label class=\"loginForm__label\" ng-class=\"{ \'is-shown\': cAuth.password }\">Password</label> <input name=\"password\" type=\"password\" select-on-click=\"\" ng-model=\"cAuth.password\" ng-disabled=\"cAuth.loading\"></div><div ng-if=\"cAuth.emailSent\" class=\"u-paddingTop--10 u-tac\" ng-cloak=\"\">We\'ve sent an email to <span class=\"u-color--noscope\">{{ cAuth.email }}</span>. Click the link in the email to reset your password.</div></div><div class=\"loginForm__message\" ng-class=\"{ \'is-shown\': cAuth.failed }\" ng-hide=\"cAuth.emailSent\"><span ng-show=\"cAuth.failed === \'invalid_credentials\'\">Invalid Username/Password. <a ng-if=\"cAuth.email\" ng-click=\"cAuth.resetPassword()\">Forgot password?</a></span> <span ng-show=\"cAuth.failed === \'error\'\">There was an error, please try again.</span> <span ng-show=\"cAuth.failed === \'no_user\'\">We couldn\'t find your account with that email address</span> <span ng-show=\"cAuth.failed === \'inactive\'\">This account is no longer active</span> <span ng-show=\"cAuth.failed === \'locked\'\">This account is temporarily locked.<br>Try again in a few minutes.</span></div><div ng-hide=\"cAuth.emailSent\"><div class=\"loginForm__buttonContainer\"><button class=\"button button--colorA button--fullWidth button--noRadius loginForm__submit\" ng-class=\"{ \'is-loading\': cAuth.loading }\" ng-click=\"cAuth.login()\"><div class=\"spinner--dark\"></div>Login</button></div></div></form></div>");
$templateCache.put("app/channels/channels.html","<div class=\"l-channels\"><div class=\"l-channels__leftColumn\"><div class=\"searchResults\"><div class=\"inner\"><div class=\"layerCap layerCap--noBorder\"><div class=\"layerCap__aside layerCap__aside--export l-channels__nameExportButton\" ng-class=\"{ \'is-disabled\': cChannels.loading }\" ng-if=\"cChannels.pagination.total\"><div class=\"is-nameLoading\" ng-if=\"cChannels.exportNamesLoading\"><div class=\"spinner--dark\"></div></div><div class=\"is-do\" ng-hide=\"cChannels.channelNameList || cChannels.exportNamesLoading\" ng-click=\"cChannels.exportNames()\"><i class=\"icon--export ion-android-download\"></i> <span ng-if=\"cChannels.pagination.total > 250\">Export Top 250</span> <span ng-if=\"cChannels.pagination.total < 250\">Export All</span></div><div class=\"is-done\" ng-click=\"cChannels.clearExport()\" ng-show=\"cChannels.channelNameList && !cChannels.exportNamesLoading\">Copy Names Below <i class=\"icon ion-close-round\"></i></div><textarea ng-if=\"cChannels.channelNameList\" class=\"l-channels__nameExport\" select-on-click=\"\" ng-blur=\"cChannels.clearExport()\">{{ cChannels.channelNameList }}</textarea></div><ns-pagination ns-pagination-loading=\"cChannels.loading\" ns-pagination-page=\"cChannels.pagination.currentPage\" ns-pagination-total=\"cChannels.pagination.total\" ns-pagination-limit=\"cChannels.pagination.perPage\" ns-pagination-change-page=\"cChannels.pagination.changePage\" ns-pagination-hide-limit=\"true\"></ns-pagination></div><table><thead ng-hide=\"!cChannels.channels\"><tr><th class=\"u-tal u-cp\" ng-click=\"cChannels.changeSort(\'name\', true)\"><div class=\"inner\">Channel Name <i ng-show=\"cChannels.sort === \'-name\'\" class=\"icon ion-android-arrow-dropdown\"></i> <i ng-show=\"cChannels.sort === \'name\'\" class=\"icon ion-android-arrow-dropup\"></i></div></th><th class=\"u-tac u-cp\" ng-click=\"cChannels.changeSort(\'followers\')\"><div class=\"inner\">Followers <i ng-show=\"cChannels.sort === \'-followers\'\" class=\"icon ion-android-arrow-dropdown\"></i> <i ng-show=\"cChannels.sort === \'followers\'\" class=\"icon ion-android-arrow-dropup\"></i></div></th><th class=\"u-tac u-cp\" ng-click=\"cChannels.changeSort(\'views\')\"><div class=\"inner\">Views <i ng-show=\"cChannels.sort === \'-views\'\" class=\"icon ion-android-arrow-dropdown\"></i> <i ng-show=\"cChannels.sort === \'views\'\" class=\"icon ion-android-arrow-dropup\"></i></div></th><th class=\"u-tac u-cp\" ng-click=\"cChannels.changeSort(\'average_viewers_shorterm\')\"><div class=\"inner\">Average Viewers <i ng-show=\"cChannels.sort === \'-average_viewers_shorterm\'\" class=\"icon ion-android-arrow-dropdown\"></i> <i ng-show=\"cChannels.sort === \'average_viewers_shorterm\'\" class=\"icon ion-android-arrow-dropup\"></i></div></th><th class=\"u-cp\" ng-click=\"cChannels.changeSort(\'days_per_week\')\"><div class=\"inner\">Streams Last Wk <i ng-show=\"cChannels.sort === \'-days_per_week\'\" class=\"icon ion-android-arrow-dropdown\"></i> <i ng-show=\"cChannels.sort === \'days_per_week\'\" class=\"icon ion-android-arrow-dropup\"></i></div></th><th><div class=\"inner\">Usual Start</div></th><th class=\"u-cp\" ng-click=\"cChannels.changeSort(\'last_streamed_at\')\"><div class=\"inner\">Last Stream <i ng-show=\"cChannels.sort === \'-last_streamed_at\'\" class=\"icon ion-android-arrow-dropdown\"></i> <i ng-show=\"cChannels.sort === \'last_streamed_at\'\" class=\"icon ion-android-arrow-dropup\"></i></div></th><th><div class=\"inner\">Primary Game</div></th><th><div class=\"inner\">More</div></th></tr></thead><tbody ng-class=\"{ \'is-loading\': cChannels.loading }\"><tr ng-show=\"cChannels.channels.data.length === 0\"><td colspan=\"9\" class=\"u-tac searchResults__noResults\">There\'s nothing here... &nbsp; No channels match your search criteria</td></tr><tr ng-show=\"!cChannels.channels\"><td colspan=\"9\" class=\"u-tac searchResults__loading\"><div class=\"spinner\"></div></td></tr><tr ng-repeat-start=\"channel in cChannels.channels.data\" ng-class=\"{ \'is-even\': $index%2 === 0 }\"><td class=\"cell--title searchResults__channel\"><a class=\"is-image\" ui-sref=\"app.channel({ platform: \'twitch\', channel: channel.name })\"><bg-img height=\"54\" width=\"54\" class=\"logo u-highlight\" image=\"{{ channel.logo || \'/assets/images/blank-user.png\' }}\"></bg-img></a><div class=\"inner\"><h4 class=\"title\"><div class=\"liveDot\" ng-show=\"channel.is_live\"><i class=\"icon ion-ios-pulse-strong\"></i></div><a class=\"m-inheritLink\" ui-sref=\"app.channel({ platform: \'twitch\', channel: channel.name })\">{{ channel.display_name }}</a></h4><p class=\"subtitle\"><span class=\"info\" ng-if=\"channel.broadcaster_language\"><i class=\"icon ion-mic-a\"></i>{{ channel.broadcaster_language }}</span> <span class=\"info\" ng-if=\"channel.partner\"><i class=\"icon ion-social-twitch-outline\"></i>Partner</span></p></div></td><td class=\"u-tac cell--data\">{{ channel.followers | bigNumber }}</td><td class=\"u-tac cell--data\">{{ channel.views | bigNumber }}</td><td class=\"u-tac cell--data\">{{ channel.average_viewers_shorterm | bigNumber }}</td><td class=\"u-tac cell--data\">{{ channel.days_per_week }}</td><td class=\"u-tac cell--bigData\"><span class=\"m-duration\"><i class=\"icon--fade icon--margin ion-android-time\"></i> {{ channel.usual_start | timeToLocal }}</span></td><td class=\"u-tac cell--bigData\">{{ channel.last_streamed_at | dateUtcToLocal | dateToTimeAgo }}</td><td class=\"u-tac cell--data\"><a ui-sref=\"app.game.report({ slug: channel.primary_game.title })\"><bg-img height=\"54\" width=\"46\" class=\"logo u-highlight\" image=\"{{ channel.primary_game.title | urlBoxart:190:138 }}\" uib-tooltip=\"{{ channel.primary_game.title }}\"><div class=\"inner\">{{ channel.primary_game.title | firstLetter:5 }}</div></bg-img></a></td><td class=\"cell--more u-cp\" ng-class=\"{ \'is-active\': channel === cChannels.activeProfile }\" ng-click=\"cChannels.showGameProfile(channel)\"><a><i class=\"icon ion-ios-game-controller-a\"></i></a></td></tr><tr ng-repeat-end=\"\" ng-if=\"channel === cChannels.activeProfile\"><td colspan=\"9\" class=\"u-tac searchResults__gameProfile\"><channel-game-profile channel=\"channel\" limit=\"16\" days=\"90\"></channel-game-profile></td></tr></tbody></table><ns-pagination ns-pagination-loading=\"cChannels.loading\" ns-pagination-page=\"cChannels.pagination.currentPage\" ns-pagination-total=\"cChannels.pagination.total\" ns-pagination-limit=\"cChannels.pagination.perPage\" ns-pagination-change-page=\"cChannels.pagination.changePage\" ns-pagination-hide-limit=\"true\"></ns-pagination></div></div></div><div class=\"l-channels__rightColumn\"><div ng-include=\"\'app/channels/filters.html\'\"></div></div></div>");
$templateCache.put("app/channels/filters.html","<div class=\"searchFilters\" ng-cloak=\"\"><div class=\"inner\"><h3 class=\"section-title\"><div class=\"options\" ng-click=\"cChannels.clearQuery()\"><div class=\"title\"><i class=\"ion-android-close\"></i>&nbsp; Clear All</div></div><i class=\"icon ion-funnel\"></i> Filters</h3><div class=\"searchFilters__save\"><h4 class=\"title\" ng-click=\"savedSearchsOpen = (savedSearchsOpen) ? false : true;\"><i class=\"u-fr expand icon ion-android-add\" ng-hide=\"savedSearchsOpen\"></i> <i class=\"u-fr expand icon ion-android-remove\" ng-show=\"savedSearchsOpen\"></i> <i class=\"icon ion-search\"></i> Saved Searches</h4><div ng-show=\"savedSearchsOpen\" ng-class=\"{ \'is-loading\': cChannels.saveSearchLoading }\"><ul class=\"searchFilters__searchList\" ng-show=\"cChannels.searchList.length\"><li ng-repeat=\"search in cChannels.searchList | orderBy: \'title\'\" ng-class=\"{ \'is-active\': cChannels.query === search.query }\"><a ng-click=\"cChannels.deleteSearch(search)\" class=\"delete\" uib-tooltip=\"Delete This?\" tooltip-is-open=\"search.confirmDelete\" tooltip-trigger=\"none\"><span ng-hide=\"search.confirmDelete\"><i class=\"icon ion-backspace\"></i></span> <span class=\"confirm\" ng-show=\"search.confirmDelete\"><i class=\"icon ion-help\"></i></span></a> <a ng-click=\"cChannels.runSavedSearch(search)\" class=\"link\"><i class=\"icon ion-checkmark-circled checked\"></i> {{ search.title }}</a></li></ul><div ng-hide=\"cChannels.searchExists()\" class=\"save\"><form ng-submit=\"cChannels.saveSearch()\"><input ng-disable=\"cChannels.saveSearchLoading\" uib-tooltip=\"You need to name this search\" tooltip-is-open=\"cChannels.invalidTitle\" tooltip-trigger=\"none\" maxlength=\"50\" type=\"text\" ng-model=\"cChannels.newSearchTitle\" placeholder=\"What do we call this search?\"> <button ng-disable=\"cChannels.saveSearchLoading\" class=\"button-a--small\">Save this search</button></form></div></div></div><div class=\"searchFilters__controls\" sticky=\"\" offset=\"75\" sticky-class=\"is-sticky\"><div class=\"searchFilters__resultsTotal\" ng-hide=\"cChannels.queryChanged || cChannels.loading\"><span ng-hide=\"cChannels.channels.data.length === 0\"><b>{{ cChannels.pagination.total | number }}</b> &nbsp;of&nbsp; <b>{{ cChannels.channels.allCount | number }} Match</b></span> <span ng-show=\"cChannels.channels.data.length === 0\">No Channels Match</span></div><button class=\"submit button-a--full\" ng-click=\"cChannels.runQuery()\" ng-show=\"cChannels.queryChanged || cChannels.loading\" ng-class=\"{ \'is-loading\': cChannels.loading }\"><div class=\"spinner--dark\"></div>Apply Filters</button></div><ul class=\"searchFilters__list\"><li><search-filter title=\"Has Tag\" type=\"option\" selected=\"cChannels.filters.hasTag.selected\" callback=\"cChannels.setHasChanged\" loading=\"!cChannels.filters.hasTag\" options=\"cChannels.filters.hasTag.options\" selected-option=\"cChannels.filters.hasTag.selectedOption\"></search-filter></li><li><search-filter title=\"Primary Game\" list=\"cChannels.gameList\" type=\"game\" selected=\"cChannels.filters.primaryGame.games\" callback=\"cChannels.setHasChanged\" loading=\"cChannels.loading\"></search-filter></li><li><search-filter title=\"Has Streamed Game\" list=\"cChannels.gameList\" type=\"games\" selected=\"cChannels.filters.played.games\" callback=\"cChannels.setHasChanged\" loading=\"cChannels.loading\"></search-filter></li><li ng-if=\"false\"><search-filter title=\"Hasn\'t Streamed Game\" list=\"cChannels.gameList\" type=\"games\" selected=\"cChannels.filters.neverPlayed.games\" callback=\"cChannels.setHasChanged\" loading=\"cChannels.loading\"></search-filter></li><li><search-filter title=\"Average Viewership\" type=\"range\" selected=\"cChannels.filters.averageViewersShorterm.range\" callback=\"cChannels.setHasChanged\" loading=\"cChannels.loading\"></search-filter></li><li><search-filter title=\"Followers\" type=\"range\" selected=\"cChannels.filters.followers.range\" callback=\"cChannels.setHasChanged\" loading=\"cChannels.loading\"></search-filter></li><li><search-filter title=\"Views\" type=\"range\" selected=\"cChannels.filters.views.range\" callback=\"cChannels.setHasChanged\" loading=\"cChannels.loading\"></search-filter></li><li><search-filter title=\"Days Live This Week\" type=\"option\" selected=\"cChannels.filters.daysPerWeek.selected\" callback=\"cChannels.setHasChanged\" loading=\"cChannels.loading\" options=\"cChannels.filters.daysPerWeek.options\" selected-option=\"cChannels.filters.daysPerWeek.selectedOption\"></search-filter></li><li><search-filter title=\"Mature\" type=\"option\" selected=\"cChannels.filters.mature.selected\" callback=\"cChannels.setHasChanged\" loading=\"cChannels.loading\" options=\"cChannels.filters.mature.options\" selected-option=\"cChannels.filters.mature.selectedOption\"></search-filter></li><li><search-filter title=\"Partnership\" type=\"option\" selected=\"cChannels.filters.partner.selected\" callback=\"cChannels.setHasChanged\" loading=\"cChannels.loading\" options=\"cChannels.filters.partner.options\" selected-option=\"cChannels.filters.partner.selectedOption\"></search-filter></li><li><search-filter title=\"Broadcaster Language\" type=\"option\" selected=\"cChannels.filters.broadcasterLanguage.selected\" callback=\"cChannels.setHasChanged\" loading=\"cChannels.loading\" options=\"cChannels.filters.broadcasterLanguage.options\" selected-option=\"cChannels.filters.broadcasterLanguage.selectedOption\"></search-filter></li></ul></div></div>");
$templateCache.put("app/pages/brb.html","<div class=\"l-login\"><div class=\"loginForm layer\"><div class=\"loginForm__inner layer__inner\"><h2 class=\"layerCap\"><img class=\"loginForm__logo\" alt=\"NOSCOPE\" src=\"/assets/images/noscope-logo-black.svg\"></h2><div class=\"u-tac u-paddingTop--10\" style=\"line-height: 40px; font-size: 20px; font-weight: 300; color: #666;\">Be right back. <img src=\"/assets/images/mog.gif\" class=\"u-vam\" style=\"margin-left: -40px; float: right\"></div></div></div></div>");
$templateCache.put("app/admin/game-reviews/game-reviews.html","<div class=\"base\"><div class=\"u-padding--15 u-separatorBorder--bottom\"><ns-pagination ns-pagination-loading=\"$ctrl.loading\" ns-pagination-page=\"$ctrl.games.metadata.current_page\" ns-pagination-total=\"$ctrl.games.metadata.total\" ns-pagination-limit=\"$ctrl.games.metadata.per_page\" ns-pagination-change-page=\"$ctrl.changePage\"></ns-pagination></div><table class=\"base-table\"><tr class=\"base-table__row\"><th class=\"base-table__headerCell u-tac\" width=\"56\">Resolve</th><th class=\"base-table__headerCell\" colspan=\"2\">Game Title</th><th class=\"base-table__headerCell u-tac\" width=\"100\">Groupings</th><th class=\"base-table__headerCell u-tac\" width=\"80\">IGDB Data</th><th class=\"base-table__headerCell u-tac\" width=\"150\">IGDB Checked</th><th class=\"base-table__headerCell\" colspan=\"2\">Requested By</th></tr><tr class=\"base-table__row\" ng-repeat=\"game in $ctrl.games\" ng-class-odd=\"\'base-table__row--odd\'\"><td class=\"base-table-cell base-table-cell--icon base-table-cell--link\" ng-click=\"$ctrl.resolve(game)\"><i class=\"ion-checkmark\" ng-hide=\"game.resolveLoading\"></i><div class=\"wait wait--dark\" ng-show=\"game.resolveLoading\"></div></td><td class=\"base-table-cell base-table-cell--avatar\" width=\"60\"><ns-image height=\"54\" width=\"46\" target=\"_blank\" ui-sref=\"app.game.report({ slug: game.title })\" ns-image-src=\"{{ game.title | urlBoxart:190:138 }}\"></ns-image></td><td class=\"base-table-cell\" width=\"300\"><h4 class=\"base-table-cell__name\"><a ui-sref=\"app.game.report({ slug: game.title })\" target=\"_blank\" ng-bind=\"game.title\"></a><ul class=\"base-table-cell__underName\"><li ng-bind=\"game.slug\"></li></ul></h4></td><td class=\"base-table-cell base-table-cell--value\">{{ game.game_groupings.length }}</td><td class=\"base-table-cell base-table-cell--link u-tac\" ns-refresh-meta-data=\"\" ns-refresh-meta-data-loading=\"game.metaRefreshLoading\" game=\"game\" ng-class=\"{ \'is-true\': game.igdb_data, \'base-table-cell--boolean\': !game.metaRefreshLoading }\" uib-tooltip=\"Refresh IGDB Data\"><div class=\"wait wait--dark\" ng-if=\"game.metaRefreshLoading\"></div></td><td class=\"base-table-cell base-table-cell--timeAgo u-tac\"><span ng-if=\"game.meta_checked_at\" am-time-ago=\"game.meta_checked_at | amUtc | amLocal\"></span></td><td class=\"base-table-cell base-table-cell--avatar\" width=\"44\"><ns-image height=\"32\" width=\"32\" ns-image-src=\"{{ game.review_request_user.avatar | avatar }}\"></ns-image></td><td class=\"base-table-cell\" width=\"200\"><h4 class=\"base-table-cell__name base-table-cell__name--smaller u-ellipsis u-mw--150\">{{ game.review_request_user.first_name }} {{ game.review_request_user.last_name }}</h4><ul class=\"base-table-cell__underName\"><li ng-bind=\"game.review_request_user.company\"></li></ul></td></tr></table><div class=\"base-table__noResults\" ng-show=\"$ctrl.games.length < 1\">No Open Review Requests</div><div class=\"u-padding--15 u-separatorBorder--top\"><ns-pagination ns-pagination-loading=\"$ctrl.loading\" ns-pagination-page=\"$ctrl.games.metadata.current_page\" ns-pagination-total=\"$ctrl.games.metadata.total\" ns-pagination-limit=\"$ctrl.games.metadata.per_page\" ns-pagination-change-page=\"$ctrl.changePage\"></ns-pagination></div></div>");
$templateCache.put("app/admin/grouping/games.html","<div class=\"m-layer a-games\"><uib-pagination total-items=\"cAdminGrouping.total\" items-per-page=\"50\" ng-model=\"cAdminGrouping.page\" ng-change=\"cAdminGrouping.changePage()\" max-size=\"12\" rotate=\"false\"></uib-pagination><ul class=\"a-games__gameList\"><li ng-repeat=\"game in cAdminGrouping.games.data\" ng-class=\"{ \'is-deleted\': game.deleted }\"><i ng-show=\"game.has_data\" class=\"icon ion-stats-bars is-data\"></i> <a target=\"_blank\" href=\"/games/{{ game.slug }}\">{{ game.title }}</a> <a ng-click=\"cAdminGrouping.getCount(game)\" class=\"is-count\">{{ game.count.grouping_count }} <i ng-hide=\"game.count.grouping_count\" class=\"icon ion-android-list\"></i></a> <input class=\"u-fr\" type=\"text\" ng-model=\"game.searchString\" ng-change=\"cAdminGrouping.queryAlgolia(game)\" placeholder=\"Game to group to...\"><ul class=\"a-games__matchList\"><li ng-repeat=\"match in game.algolia.hits\"><a ng-click=\"cAdminGrouping.linkGame(match, game)\"><i ng-hide=\"match.confirm\" class=\"icon ion-link\"></i> <span ng-show=\"match.confirm\">Are you sure?</span></a> ({{ match.twitch_games.length }}) <a target=\"_blank\" href=\"/games/{{ match.slug }}\">{{ match.title }}</a></li><li ng-if=\"game.algolia.hits.length == 0\">No Matches</li></ul></li></ul><uib-pagination total-items=\"cAdminGrouping.total\" items-per-page=\"50\" ng-model=\"cAdminGrouping.page\" ng-change=\"cAdminGrouping.changePage()\" max-size=\"12\" rotate=\"false\"></uib-pagination></div>");
$templateCache.put("app/admin/grouping/grouping.html","<div class=\"l-adminGrouping\"><div class=\"l-adminGrouping__leftColumn\"><form ng-submit=\"cAdminGrouping.listSearch.search()\"><ul class=\"nav\"><li class=\"u-fr\"><input type=\"text\" ng-model=\"cAdminGrouping.listSearch.searchString\" placeholder=\"Search For Game...\"></li><li><a class=\"m-inheritLink\" ui-sref=\"app.admin.grouping({ page: null, type: \'-today\' })\">Today</a></li><li><a class=\"m-inheritLink\" ui-sref=\"app.admin.grouping({ page: null, type: \'-yesterday\' })\">Yesterday</a></li><li><a class=\"m-inheritLink\" ui-sref=\"app.admin.grouping({ page: null, type: \'-week\' })\">This Week</a></li><li><a class=\"m-inheritLink\" ui-sref=\"app.admin.grouping({ page: null, type: null })\">Alphabetical</a></li><li><a class=\"m-inheritLink\" ui-sref=\"app.admin.grouping({ page: null, type: \'-new\' })\">New</a></li><li><a class=\"m-inheritLink\" ui-sref=\"app.admin.grouping({ indexed: null })\" ng-if=\"cAdminGrouping.indexed\"><i class=\"icon ion-android-checkbox\"></i> Indexed</a> <a class=\"m-inheritLink\" ui-sref=\"app.admin.grouping({ indexed: true })\" ng-if=\"!cAdminGrouping.indexed\"><i class=\"icon ion-android-checkbox-outline-blank\"></i> Indexed</a></li></ul></form><ns-pagination ns-pagination-page=\"cAdminGrouping.page\" ns-pagination-total=\"cAdminGrouping.total\" ns-pagination-limit=\"50\" ns-pagination-change-page=\"cAdminGrouping.changePage\"></ns-pagination><ul class=\"l-adminGrouping__gameList\"><li ng-repeat=\"game in cAdminGrouping.games.data\" ng-class=\"{ \'is-deleted\': game.deleted, \'is-ignored\': game.ignored }\"><div class=\"link-button\" ng-if=\"!cAdminGrouping.groupGame.selected && ! game.deleted\" ng-click=\"cAdminGrouping.ignoreGame(game)\" ng-class=\"{ \'is-loading\': game.loading }\"><div class=\"spinner\" ng-if=\"game.loading\"></div><i class=\"ion-eye-disabled\" ng-if=\"!game.loading && !game.confirm\"></i> <i class=\"ion-help\" ng-if=\"game.confirm && !game.loading\"></i></div><div class=\"link-button\" ng-if=\"cAdminGrouping.groupGame.selected && game.id != cAdminGrouping.groupGame.selected.objectID && ! game.deleted\" ng-click=\"cAdminGrouping.linkGame(game)\" ng-class=\"{ \'is-loading\': game.loading }\"><div class=\"spinner\" ng-if=\"game.loading\"></div><i class=\"ion-link\" ng-if=\"!game.loading && !game.confirm\"></i> <i class=\"ion-help\" ng-if=\"game.confirm && !game.loading\"></i></div><bg-img class=\"logo\" height=\"60\" width=\"50\" image=\"{{ game.title | urlBoxart:190:138 }}\"></bg-img><div class=\"inner\"><h2 ng-class=\"{ \'is-primary\': game.has_data }\"><i class=\"icon ion-stats-bars is-data\"></i> <a target=\"_blank\" href=\"/games/{{ game.slug }}\" class=\"m-inheritLink\">{{ game.title }}</a> <span class=\"aside\">{{ game.slug }}</span></h2><ul><li>Created: {{ game.created_at | dateUtcToLocal | dateToTimeAgo }}</li><li>Updated: {{ game.updated_at | dateUtcToLocal | dateToTimeAgo }}</li><li>Time: {{ game.total_minutes | durationToTimestamp: \'m\' }}</li><li>Games: <a ng-hide=\"game.count.grouping_count\" ng-click=\"cAdminGrouping.getCount(game)\">Get</a> {{ game.count.grouping_count }}</li></ul></div><ul class=\"a-games__matchList\"><li ng-repeat=\"match in game.algolia.hits\"><a ng-click=\"cAdminGrouping.linkGame(match, game)\"><i ng-hide=\"match.confirm\" class=\"icon ion-link\"></i> <span ng-show=\"match.confirm\">Are you sure?</span></a> ({{ match.twitch_games.length }}) <a target=\"_blank\" href=\"/games/{{ match.slug }}\">{{ match.title }}</a></li><li ng-if=\"game.algolia.hits.length == 0\">No Matches</li></ul></li></ul><ns-pagination ns-pagination-page=\"cAdminGrouping.page\" ns-pagination-total=\"cAdminGrouping.total\" ns-pagination-limit=\"50\" ns-pagination-change-page=\"cAdminGrouping.changePage\"></ns-pagination></div><div class=\"l-adminGrouping__rightColumn\"><div class=\"l-adminGrouping__groupGame\" sticky=\"\" offset=\"102\" sticky-class=\"is-sticky\"><div class=\"inner\"><h2 class=\"section-title\"><i class=\"icon ion-link\"></i> Group to Game</h2><form class=\"game\" ng-show=\"!cAdminGrouping.groupGame.selected\" ng-submit=\"cAdminGrouping.queryAlgolia()\"><input type=\"text\" ng-model=\"cAdminGrouping.groupGame.searchString\" placeholder=\"Game to group to...\"><ul class=\"results\"><li ng-repeat=\"result in cAdminGrouping.groupGame.results.hits\" ng-click=\"cAdminGrouping.groupGame.select(result)\"><bg-img class=\"logo\" height=\"40\" width=\"36\" image=\"{{ result.title | urlBoxart:190:138 }}\"></bg-img>{{ result.title }}</li></ul></form><div class=\"selectedGame\" ng-if=\"cAdminGrouping.groupGame.selected\"><i class=\"icon ion-close\" ng-click=\"cAdminGrouping.groupGame.remove()\"></i><bg-img class=\"logo\" height=\"120\" width=\"100\" image=\"{{ cAdminGrouping.groupGame.selected.title | urlBoxart:190:138 }}\"></bg-img><h3>{{ cAdminGrouping.groupGame.selected.title }}</h3><ul><li ng-if=\"!cAdminGrouping.groupGame.selected.info.route\"><div class=\"spinner\"></div></li><li ng-if=\"cAdminGrouping.groupGame.selected.info.route\">Average Viewers: <b>{{ cAdminGrouping.groupGame.selected.info.average_viewers | number: 0 }}</b></li><li ng-if=\"cAdminGrouping.groupGame.selected.info.route\">Total Minutes: <b>{{ cAdminGrouping.groupGame.selected.info.total_minutes | bigNumber }}</b></li><li ng-if=\"cAdminGrouping.groupGame.selected.info.route\">Grouped Games: <b>{{ cAdminGrouping.groupGame.selected.info.twitch_games.length }}</b></li></ul></div></div></div></div></div>");
$templateCache.put("app/admin/pulls/pull.html","<div class=\"l-adminPull\" ng-repeat=\"pull in cAdminPull.pull\"><a class=\"link\" ng-click=\"(cAdminPull.open === $index) ? cAdminPull.open = false : cAdminPull.open = $index;\">Pull #{{ $index+1 }}<a><div><textarea class=\"data\" ng-if=\"cAdminPull.open === $index\" select-on-click=\"\">{{ pull.data }}</textarea></div></a></a></div>");
$templateCache.put("app/admin/pulls/pulls.html","<div class=\"l-adminPulls\"><ul class=\"m-statBar--big\"><li class=\"item\" style=\"width: 12.5%\"><h2 class=\"value\">Month</h2><h3 class=\"title\">Pulls</h3></li><li class=\"item\" style=\"width: 12.5%\"><h2 class=\"value\">{{ cAdminPulls.stats.all_time.total | number: 0 }}</h2><h3 class=\"title\">Total Pulls</h3></li><li class=\"item\" style=\"width: 12.5%\"><h2 class=\"value\">{{ cAdminPulls.stats.all_time.total - cAdminPulls.stats.all_time.successes | number: 0 }}</h2><h3 class=\"title\">Failed Pulls</h3></li><li class=\"item\" style=\"width: 12.5%\"><h2 class=\"value\">{{ cAdminPulls.stats.all_time.attempt_count | number: 0 }}</h2><h3 class=\"title\">Total Calls</h3></li><li class=\"item\" style=\"width: 12.5%\"><h2 class=\"value\">{{ cAdminPulls.stats.all_time.fail_count/cAdminPulls.stats.all_time.attempt_count *100 | number: 1 }}%</h2><h3 class=\"title\">Call Fail Rate</h3></li><li class=\"item\" style=\"width: 12.5%\"><h2 class=\"value\">{{ cAdminPulls.stats.all_time.average_pull_count | number: 1 }}</h2><h3 class=\"title\">Average Calls</h3></li><li class=\"item\" style=\"width: 12.5%\"><h2 class=\"value\">{{ cAdminPulls.stats.all_time.average_time | stringToDuration | durationToFormat }}</h2><h3 class=\"title\">Average Pull Time</h3></li><li class=\"item\" style=\"width: 12.5%\"><h2 class=\"value\">{{ cAdminPulls.stats.all_time.worst_time | stringToDuration | durationToFormat }}</h2><h3 class=\"title\">Worst Pull Time</h3></li></ul><ul class=\"m-statBar--big\"><li class=\"item\" style=\"width: 12.5%\"><h2 class=\"value\">Week</h2><h3 class=\"title\">Pulls</h3></li><li class=\"item\" style=\"width: 12.5%\"><h2 class=\"value\">{{ cAdminPulls.stats.week.total | number: 0 }}</h2><h3 class=\"title\">Total Pulls</h3></li><li class=\"item\" style=\"width: 12.5%\"><h2 class=\"value\">{{ cAdminPulls.stats.week.total - cAdminPulls.stats.week.successes | number: 0 }}</h2><h3 class=\"title\">Failed Pulls</h3></li><li class=\"item\" style=\"width: 12.5%\"><h2 class=\"value\">{{ cAdminPulls.stats.week.attempt_count | number: 0 }}</h2><h3 class=\"title\">Total Calls</h3></li><li class=\"item\" style=\"width: 12.5%\"><h2 class=\"value\">{{ cAdminPulls.stats.week.fail_count/cAdminPulls.stats.week.attempt_count *100 | number: 1 }}%</h2><h3 class=\"title\">Call Fail Rate</h3></li><li class=\"item\" style=\"width: 12.5%\"><h2 class=\"value\">{{ cAdminPulls.stats.week.average_pull_count | number: 1 }}</h2><h3 class=\"title\">Average Calls</h3></li><li class=\"item\" style=\"width: 12.5%\"><h2 class=\"value\">{{ cAdminPulls.stats.week.average_time | stringToDuration | durationToFormat }}</h2><h3 class=\"title\">Average Pull Time</h3></li><li class=\"item\" style=\"width: 12.5%\"><h2 class=\"value\">{{ cAdminPulls.stats.week.worst_time | stringToDuration | durationToFormat }}</h2><h3 class=\"title\">Worst Pull Time</h3></li></ul><ul class=\"m-statBar--big\"><li class=\"item\" style=\"width: 12.5%\"><h2 class=\"value\">Day</h2><h3 class=\"title\">Pulls</h3></li><li class=\"item\" style=\"width: 12.5%\"><h2 class=\"value\">{{ cAdminPulls.stats.day.total | number: 0 }}</h2><h3 class=\"title\">Total Pulls</h3></li><li class=\"item\" style=\"width: 12.5%\"><h2 class=\"value\">{{ cAdminPulls.stats.day.total - cAdminPulls.stats.day.successes | number: 0 }}</h2><h3 class=\"title\">Failed Pulls</h3></li><li class=\"item\" style=\"width: 12.5%\"><h2 class=\"value\">{{ cAdminPulls.stats.day.attempt_count | number: 0 }}</h2><h3 class=\"title\">Total Calls</h3></li><li class=\"item\" style=\"width: 12.5%\"><h2 class=\"value\">{{ cAdminPulls.stats.day.fail_count/cAdminPulls.stats.day.attempt_count *100 | number: 1 }}%</h2><h3 class=\"title\">Call Fail Rate</h3></li><li class=\"item\" style=\"width: 12.5%\"><h2 class=\"value\">{{ cAdminPulls.stats.day.average_pull_count | number: 1 }}</h2><h3 class=\"title\">Average Calls</h3></li><li class=\"item\" style=\"width: 12.5%\"><h2 class=\"value\">{{ cAdminPulls.stats.day.average_time | stringToDuration | durationToFormat }}</h2><h3 class=\"title\">Average Pull Time</h3></li><li class=\"item\" style=\"width: 12.5%\"><h2 class=\"value\">{{ cAdminPulls.stats.day.worst_time | stringToDuration | durationToFormat }}</h2><h3 class=\"title\">Worst Pull Time</h3></li></ul><div class=\"l-adminPulls__pulls\"><uib-pagination total-items=\"cAdminPulls.pulls.total\" items-per-page=\"25\" ng-model=\"cAdminPulls.page\" ng-change=\"cAdminPulls.changePage()\" max-size=\"8\" rotate=\"false\"></uib-pagination><table class=\"m-zebraTable m-layer l-adminPulls__table\" style=\"width: 100%;\"><tr><th>Status</th><th>Pulled At</th><th>ID</th><th>Success</th><th>Attempt</th><th>Fail</th><th>Time</th><th>Server</th></tr><tr ng-repeat=\"pull in cAdminPulls.pulls.data\"><td><span class=\"success\" ng-if=\"pull.status === \'success\'\"><i class=\"icon ion-checkmark-circled\"></i> Success</span> <span class=\"failed\" ng-if=\"pull.status === \'failed\'\"><i class=\"icon ion-alert-circled\"></i> Failed</span></td><td>{{ pull.pull_time | dateUtcToLocal | dateToCalendar }}</td><td><a class=\"m-inheritLink\" ui-sref=\"app.admin.pull({ pull: pull.id })\">{{ pull.id }}</a></td><td>{{ pull.success_count }}</td><td>{{ pull.attempt_count }}</td><td>{{ pull.fail_count }}</td><td>{{ pull.time | stringToDuration | durationToFormat }}</td><td>{{ pull.server }}</td></tr></table><uib-pagination total-items=\"cAdminPulls.pulls.total\" items-per-page=\"25\" ng-model=\"cAdminPulls.page\" ng-change=\"cAdminPulls.changePage()\" max-size=\"8\" rotate=\"false\"></uib-pagination></div></div>");
$templateCache.put("app/admin/users/users.html","<div class=\"l-adminUsers__new\"><a ng-click=\"cAdminUsers.newOpen()\"><i class=\"icon ion-android-add-circle\"></i> New User</a></div><div class=\"l-adminUsers\"><table class=\"l-adminUsers__table\"><tr><th width=\"70\" table-sort=\"cAdminUsers.sort\" ng-click=\"cAdminUsers.changeSort(\'-active\')\" table-sort-column=\"active\">Active</th><th width=\"50\"></th><th class=\"is-left\" width=\"87\" ng-click=\"cAdminUsers.changeSort(\'first_name\')\" table-sort=\"cAdminUsers.sort\" table-sort-column=\"first_name\">First Name</th><th class=\"is-left\" width=\"82\" ng-click=\"cAdminUsers.changeSort(\'last_name\')\" table-sort=\"cAdminUsers.sort\" table-sort-column=\"last_name\">Last Name</th><th class=\"is-left\" ng-click=\"cAdminUsers.changeSort(\'company\')\" table-sort=\"cAdminUsers.sort\" table-sort-column=\"company\">Company Name</th><th width=\"260\" class=\"is-left\" ng-click=\"cAdminUsers.changeSort(\'email\')\" table-sort=\"cAdminUsers.sort\" table-sort-column=\"email\">Email Address</th><th width=\"150\" ng-click=\"cAdminUsers.changeSort(\'-login_count\')\" table-sort=\"cAdminUsers.sort\" table-sort-column=\"login_count\">Logins</th><th width=\"150\" ng-click=\"cAdminUsers.changeSort(\'-loginSort\')\" table-sort=\"cAdminUsers.sort\" table-sort-column=\"loginSort\">Last Login</th><th width=\"170\">Temp Password</th></tr><tr ng-show=\"cAdminUsers.newIsOpen\" class=\"is-new\"><td class=\"is-boolean is-active\"><i class=\"icon ion-checkmark-circled\"></i></td><td class=\"is-logo\"><bg-img class=\"logo\" image=\"{{ \'/assets/images/blank-user.png\' }}\" height=\"48\" width=\"48\"></bg-img></td><td class=\"is-channel is-noLogo\" colspan=\"3\"><div class=\"inner\"><h4 class=\"title\"><input ng-model=\"cAdminUsers.first_name\" type=\"text\" placeholder=\"First Name...\"> <input ng-model=\"cAdminUsers.last_name\" type=\"text\" placeholder=\"Last Name...\"></h4><p class=\"subtitle\"><input ng-model=\"cAdminUsers.company\" type=\"text\" placeholder=\"Company...\"></p></div></td><td class=\"is-value\"><input type=\"text\" placeholder=\"Email Address...\" ng-model=\"cAdminUsers.email\"></td><td class=\"is-number\">0</td><td class=\"is-since\">Soon</td><td class=\"u-tac\"><a class=\"button-a\" ng-click=\"cAdminUsers.createUser()\">Create</a></td></tr><tr ng-repeat=\"user in cAdminUsers.users | orderBy: cAdminUsers.sort\"><td class=\"is-boolean\" ng-class=\"{ \'is-active\': user.active }\"><i class=\"icon ion-checkmark-circled\"></i></td><td class=\"is-logo\"><bg-img class=\"logo\" image=\"{{ user.avatar || \'/assets/images/blank-user.png\' }}\" height=\"48\" width=\"48\"></bg-img></td><td class=\"is-channel is-noLogo\" colspan=\"3\"><div class=\"inner\"><h4 class=\"title\">{{ user.first_name }} {{ user.last_name }}</h4><p class=\"subtitle\">{{ user.company }}</p></div></td><td class=\"is-value\">{{ user.email }}</td><td class=\"is-number\">{{ user.login_count }}</td><td class=\"is-since\">{{ (user.login_at) ? ((user.login_at) | dateUtcToLocal | dateToSince) : \'Never\' }}</td><td class=\"is-value u-tac\">{{ user.temp_password }}</td></tr></table></div>");
$templateCache.put("app/components/admin-bar-game/admin-bar-game.html","<ul class=\"admin-bar u-marginBottom--20\" ng-if=\"$ctrl.user.is_admin\" ng-cloak=\"\"><li class=\"admin-bar__cap\">Admin</li><a class=\"admin-bar__button\" ns-refresh-meta-data=\"\" ns-refresh-meta-data-loading=\"$ctrl.loadingMeta\" game=\"$ctrl.game\" ng-class=\"{ \'is-loading\': $ctrl.loadingMeta }\"><span class=\"wait wait--small wait--noscope\"></span> Refresh Meta</a></ul>");
$templateCache.put("app/components/campaign-channel/campaign-channel.html","<div class=\"p-campaign--report__channelPerformance\"><h2 class=\"section-title\"><ns-toggle class=\"u-fr\" ns-toggle-model=\"channel.showCampaign\" ns-toggle-label=\"Show Campaign\" ns-toggle-click=\"channel.toggleCampaign\"></ns-toggle><ns-section-dot ns-section-dot-icon=\"ion-person\" ns-section-dot-loading=\"channel.chart.config.loading\"></ns-section-dot>{{ channel.display_name }}\'s Performance</h2><highchart config=\"channel.chart.config\"></highchart><div class=\"p-campaign--report__channelBroadcasts\"><h2 class=\"section-title\"><ns-section-dot ns-section-dot-icon=\"ion-mic-c\" ns-section-dot-loading=\"broadcastsLoading\"></ns-section-dot>{{ broadcastsTotal }} Broadcast<span ng-hide=\"broadcastsTotal === 1\">s</span></h2><table class=\"p-campaign--report__broadcastTable\" ng-class=\"{ \'is-loading\': broadcastsLoading }\"><tr><th class=\"is-left\">Stream ID</th><th width=\"105\" ng-click=\"changeSort(\'-total_minutes\')\" table-sort=\"broadcastsSort\" table-sort-column=\"total_minutes\">Min Watched</th><th width=\"115\" ng-click=\"changeSort(\'-average_viewers\')\" table-sort=\"broadcastsSort\" table-sort-column=\"average_viewers\">Average Viewers</th><th width=\"115\" ng-click=\"changeSort(\'-peak_viewers\')\" table-sort=\"broadcastsSort\" table-sort-column=\"peak_viewers\">Peak Viewers</th><th width=\"84\" ng-click=\"changeSort(\'-peek_count\')\" table-sort=\"broadcastsSort\" table-sort-column=\"peek_count\">Duration</th><th width=\"80\" ng-click=\"changeSort(\'-pulled_at\')\" table-sort=\"broadcastsSort\" table-sort-column=\"pulled_at\">Date</th><th width=\"100\" ng-click=\"changeSort(\'-pulled_at\')\" table-sort=\"broadcastsSort\" table-sort-column=\"pulled_at\">Start Time</th><th width=\"74\">More</th></tr><tr ng-if=\"broadcastsLoading && !broadcastsTotal\"><td colspan=\"8\" class=\"u-tac\"><div class=\"spinner\"></div></td></tr><tr ng-repeat-start=\"broadcast in broadcasts.data\" ng-class-odd=\"\'is-odd\'\"><td class=\"is-title\">{{ broadcast.twitch_stream_id | dashedNumber: 3 }}</td><td class=\"is-number\">{{ broadcast.total_minutes | bigNumber: 0 }}<p class=\"percent\">{{ (broadcast.total_minutes/channel.stats.total_minutes) * 100 | number: 1 }}%</p></td><td class=\"is-number\">{{ broadcast.average_viewers | number: 0 }}<report-card value=\"{{ broadcast.average_viewers | percentageOf: channel.average_viewers_shorterm }}\" comparison=\"{{ channel.average_viewers_shorterm }}\"></report-card></td><td class=\"is-number\">{{ broadcast.peak_viewers | number: 0 }}</td><td class=\"is-duration\"><duration peeks=\"broadcast.peek_count\"></duration></td><td class=\"is-date\"><date display=\"true\" moment=\"broadcast.pulled_at\"></date></td><td class=\"is-duration\"><span class=\"m-duration\"><i class=\"icon--fade icon--margin ion-android-time\"></i> {{ broadcast.pulled_at | dateUtcToLocal | dateToFormat: \'LT\' }}</span></td><td class=\"is-more\" ng-click=\"showBroadcastBreakdown(broadcast)\" ng-class=\"{ \'is-active\': activeStream === broadcast }\"><i ng-hide=\"activeStream === broadcast\" class=\"icon ion-stats-bars\"></i> <i ng-show=\"activeStream === broadcast\" class=\"icon--close ion-close\"></i></td></tr><tr ng-repeat-end=\"\" ng-if=\"activeStream === broadcast\"><td colspan=\"8\" class=\"layerTable__cell--drawer\"><stream-breakdown channel=\"channel\" stream-id=\"{{ broadcast.twitch_stream_id }}\"></stream-breakdown></td></tr></table><div class=\"p-campaign--report__pagination\" ng-show=\"perPage < broadcastsTotal\"><ns-pagination ns-pagination-loading=\"broadcastsLoading || channel.chart.config.loading\" ns-pagination-page=\"page\" ns-pagination-total=\"broadcastsTotal\" ns-pagination-limit=\"perPage\" ns-pagination-change-page=\"getBroadcasts\"></ns-pagination></div></div></div>");
$templateCache.put("app/components/channel-card/channel-card.html","<div class=\"card\" bindonce=\"channel\"><div class=\"card__banner base__banner\" bo-if=\"channel.profile_banner\" bo-style=\"{ backgroundImage: (channel.profile_banner | wrapCssUrl ) }\"></div><div class=\"card__banner is-none base__banner\" bo-if=\"!channel.profile_banner\"></div><div class=\"card__hPadding\"><div class=\"card__header\"><div><ns-image class=\"channelLogo\" width=\"100\" height=\"100\" bo-href=\"channel.url\" target=\"_blank\" uib-tooltip=\"View on Twitch\" tooltip-placement=\"right\" ns-image-src=\"{{ channel.logo || \'/assets/images/blank-user.png\' }}\"></ns-image><div class=\"liveStatus\" bo-class=\"{ \'is-online\': channel.is_live }\"><span bo-hide=\"channel.is_live\">Offline</span> <span bo-show=\"channel.is_live\">Live Now</span></div></div><div><h2 class=\"u-ellipsis\" bo-text=\"channel.display_name\"></h2><h3>Twitch Broadcaster</h3></div></div><ul class=\"card__list\"><li bo-if=\"channel.partner\"><i class=\"icon ion-social-twitch-outline\"></i> Partnered</li><li bo-if=\"channel.broadcaster_language\"><i class=\"icon ion-mic-a\"></i> Language: <span bo-text=\"channel.broadcaster_language | uppercase\"></span></li><li bo-if=\"channel.mature\"><i class=\"icon ion-alert\"></i> Flagged Mature</li></ul><div bindonce=\"channel.primaryGame.twitchGame\"><div class=\"card__primaryGame is-loading\" bo-hide=\"channel.primaryGame.twitchGame.id || !channel.primary_twitch_game_id\"><div class=\"wait wait--small\"></div></div><div class=\"card__primaryGame\" bo-if=\"channel.primaryGame.twitchGame.id\"><ns-image width=\"52\" height=\"60\" class=\"u-marginRight--10\" ui-sref=\"app.game.report({ slug: channel.primaryGame.twitchGame.title })\" ns-image-src=\"{{ channel.primaryGame.twitchGame.title | urlBoxart:190:138 }}\"></ns-image><div class=\"inner\"><h4><a class=\"u-invisibleLink\" ui-sref=\"app.game.report({ slug: channel.primaryGame.twitchGame.title })\" bo-text=\"channel.primaryGame.twitchGame.title\"></a></h4><h5>Primary Game</h5></div><aside><div><span bo-text=\"channel.primaryGame.primaryCount*10 | durationToTimestamp: \'m\'\"></span> <span bo-if=\"channel.primaryGame.primaryCount > 0\" bo-text=\"((channel.primaryGame.primaryCount/channel.primaryGame.peekCount)*100 | round) + \'%\'\"></span><p>last 14 days</p></div></aside></div></div></div><ul bindonce=\"channel\" class=\"card__columns u-marginBottom--20\"><li><span bo-text=\"channel.usual_start | timeToLocal\"></span><h4>Usual Start</h4></li><li><span bo-text=\"channel.days_per_week || \'0\'\"></span><h4>Streams this week</h4></li><li><span bo-text=\"channel.last_streamed_at | dateUtcToLocal | dateToTimeAgo\"></span><h4>Last Seen</h4></li></ul><ns-stats class=\"card__stats\"><ns-stats-item ns-stats-item-value=\"channel.followers | bigNumber\" ns-stats-item-title=\"Followers\" uib-tooltip=\"{{ channel.followers | number }}\"></ns-stats-item><ns-stats-item ns-stats-item-value=\"channel.average_viewers_shorterm | round: 0 | bigNumber\" ns-stats-item-title=\"Average Viewers\" uib-tooltip=\"{{ channel.average_viewers_shorterm | round:0 | number }}\"></ns-stats-item><ns-stats-item ng-if=\"user.company === \'Loaded\'\" style=\"border-left: none;\" ns-stats-item-value=\"channel.average_viewers_longterm | round: 0 | bigNumber\" ns-stats-item-title=\"Average (200hr)\" uib-tooltip=\"{{ channel.average_viewers_longterm | round:0 | number }}\"></ns-stats-item><ns-stats-item ns-stats-item-value=\"channel.views | bigNumber\" ns-stats-item-title=\"Views\" uib-tooltip=\"{{ channel.views | number }}\"></ns-stats-item></ns-stats></div>");
$templateCache.put("app/components/channel-game-profile/channel-game-profile.html","<div class=\"layer paddingBottom--5 channelGameProfile\" bindonce=\"channel.gameProfile\"><div class=\"layer__hPadding\"><h2 class=\"layerCap\"><ns-dropdown class=\"layerCap__dropdown\" ns-dropdown-display=\"title\" ns-dropdown-options=\"profileRanges\" ns-dropdown-select=\"changeProfileRange\">{{ selectedProfileRanges.title }} <i class=\"ion-android-arrow-dropdown\"></i></ns-dropdown><ns-section-dot ns-section-dot-icon=\"ion-ios-game-controller-a\" ns-section-dot-loading=\"loading\"></ns-section-dot>{{ channel.gameProfile.length || 0 }} Game<span ng-hide=\"channel.gameProfile.length === 1\">s</span> Played <span class=\"layerCap__also\">{{ peekTotal * interval | durationToTimestamp: \'m\' }}</span></h2><div class=\"channelGameProfile__games u-vPadding--15\" ng-class=\"{ \'u-opacity--5\': loading }\"><div class=\"channelGameProfile__none\" ng-if=\"channel.gameProfile.length === 0\">No Games Played</div><ul class=\"channelGameProfile__list\" ng-if=\"channel.gameProfile.length > 0\"><a class=\"channelGameProfile__more u-cp\" ng-if=\"page > 1\" ng-click=\"prevPage()\"><h5>{{ offset }}</h5><p class=\"title\">More</p></a> <a class=\"is-image\" ng-if=\"1==2\" ui-sref=\"app.game.report({ slug: game.game.title })\" uib-tooltip-html=\"\'<h4>\' + game.game.title + \'</h4>\' + \'<aside>\' + (game.peek_count*interval | durationToTimestamp:\'m\') + \' - \' + (game.last_stream | dateToTimeAgo) + \'</aside>\'\" ng-repeat=\"game in channel.gameProfile | limitTo: adjustedLimit : offset | orderBy: \'-peekCount\'\"><bg-img class=\"u-cp\" height=\"64\" image=\"{{ game.game.title | urlBoxart:190:138 }}\"><div class=\"inner\">{{ game.game.title | firstLetter:5 }}</div></bg-img><p class=\"channelGameProfile__percentage\">{{ (game.peek_count/peekTotal)*100 | round: 1 }}%</p></a><div class=\"channelGameProfile__game\" ng-repeat=\"game in channel.gameProfile | limitTo: adjustedLimit : offset | orderBy: \'-peekCount\'\"><ns-image height=\"64\" width=\"55\" ui-sref=\"app.game.report({ slug: game.game.title })\" uib-tooltip-html=\"[ \'<h4>\', game.game.title, \'</h4>\', \'<aside>\', (game.peek_count*interval | durationToTimestamp:\'m\'), \' - \', (game.last_stream | dateToTimeAgo), \'</aside>\' ].join(\'\')\" ns-image-src=\"{{ game.game.title | urlBoxart:190:138 }}\"><span bo-text=\"game.game.title | firstLetter:5\"></span></ns-image><p class=\"channelGameProfile__percentage\" bo-text=\"((game.peek_count/peekTotal)*100 | round: 1) + \'%\'\"></p></div><a class=\"channelGameProfile__more u-cp\" ng-if=\"channel.gameProfile.length > adjustedLimit + offset\" ng-click=\"nextPage()\"><h5>{{ channel.gameProfile.length - getAdjustedLimit - offset }}</h5><p class=\"title\">More</p></a></ul></div></div></div>");
$templateCache.put("app/components/channel-live/channel-live.html","<div class=\"base base--margin\" bindonce=\"channel.peek\"><div class=\"base-live\" ng-class=\"{ \'base-live--notLive\': !channel.peek.viewers }\"><div class=\"base-live__section base-live__section--cap\" uib-tooltip=\"Pulled {{ channel.peek.pulled_at | dateUtcToLocal | dateToTimeAgo }}\" tooltip-placement=\"left\" tooltip-enable=\"channel.peek.pulled_at\"><div><i class=\"base-live__capIcon ion-ios-pulse-strong\"></i><h3 class=\"base-live__label\">Right Now</h3></div></div><div class=\"base-live__message\"><b>Not Live</b> Currently no live broadcasts with 10 or more viewers</div><div class=\"base-live__section base-live__section--half\"><div><h4 class=\"base-live__value\" bo-bind=\"channel.peek.rank | number: 0\"></h4><h3 class=\"base-live__label\">Rank</h3></div></div><div class=\"base-live__section\"><div><h4 class=\"base-live__value\"><big-number number=\"channel.peek.viewers\"></big-number><ns-report-card ns-report-card-value=\"{{ channel.peek.viewers | percentageOf: channel.average_viewers_shorterm }}\" ns-report-card-comparison=\"{{ channel.average_viewers_shorterm }}\"></ns-report-card></h4><h3 class=\"base-live__label\">Viewers</h3></div></div><a ui-sref=\"app.game.report({ slug: channel.peek.twitch_game.title })\" class=\"base-live__section base-live__section--double base-live__section--left\"><ns-image width=\"38\" height=\"45\" ns-image-src=\"{{ channel.peek.twitch_game.title | urlBoxart:190:138 }}\"></ns-image><div><h4 class=\"base-live__value base-live__value--small u-ellipsis u-mw--300\" bo-bind=\"channel.peek.twitch_game.title\"></h4><h3 class=\"base-live__label\">Playing</h3></div></a></div></div>");
$templateCache.put("app/components/channel-media/channel-media.html","<div class=\"d-channelMedia__none\" ng-if=\"isLoaded && media.highlights.videos.length < 1 && !channel.is_live\">No Media available</div><div class=\"d-channelMedia\" ng-hide=\"isLoaded && media.highlights.videos.length < 1 && !channel.is_live\"><div class=\"d-channelMedia__video\"><div ng-if=\"!url\" class=\"spinner--black\"></div><iframe frameborder=\"0\" ng-if=\"url\" width=\"100%\" height=\"500\" ng-src=\"{{ url | unsafe }}\" allowfullscreen=\"\"></iframe></div><ul class=\"d-channelMedia__list\"><li ng-class=\"{ \'is-active\': selected === \'live\' }\" class=\"is-live item\" ng-if=\"channel.is_live\" ng-click=\"openStream(true)\"><div class=\"inner\"><h4 class=\"title\"><i class=\"icon ion-ios-pulse-strong\"></i><br>Live Now</h4></div></li><li class=\"item\" ng-class=\"{ \'is-active\': selected === video._id }\" ng-click=\"openVideo(video, true)\" uib-tooltip=\"{{ video.views | bigNumber }} Views - {{ video.created_at | dateUtcToLocal | dateToSince }}\" uib-tooltip-placement=\"bottom\" ng-repeat=\"video in media.highlights.videos | limitTo: (channel.is_live) ? 5 : 6\"><bg-img image=\"{{ video.preview }}\" height=\"85\"><div class=\"inner\"><h4 class=\"title\">{{ video.title }}</h4></div></bg-img></li></ul></div>");
$templateCache.put("app/components/channel-report/_days.html","<thead><tr><th colspan=\"2\" class=\"layerTable__header\" table-sort=\"nav.days.sort\" table-sort-column=\"dow\" ng-click=\"changeSort(\'dow\')\">Day of the Week</th><th width=\"125\" class=\"layerTable__header u-tac\" table-sort=\"nav.days.sort\" table-sort-column=\"peek_count\" ng-click=\"changeSort(\'-peek_count\')\">Stream Time</th><th width=\"125\" class=\"layerTable__header u-tac\" table-sort=\"nav.days.sort\" table-sort-column=\"minutes_watched\" ng-click=\"changeSort(\'-minutes_watched\')\">Min Watched</th><th width=\"125\" class=\"layerTable__header u-tac\" table-sort=\"nav.days.sort\" table-sort-column=\"peak_viewers\" ng-click=\"changeSort(\'-peak_viewers\')\">Peak Viewers</th><th width=\"140\" class=\"layerTable__header u-tac\" table-sort=\"nav.days.sort\" table-sort-column=\"average_viewers\" ng-click=\"changeSort(\'-average_viewers\')\">Avg Viewers</th><th width=\"115\" class=\"layerTable__header u-tac\" table-sort=\"nav.days.sort\" table-sort-column=\"twitch_game_count\" ng-click=\"changeSort(\'-twitch_game_count\')\">Games Played</th></tr></thead><tbody ng-class=\"{ \'u-opacity--5\': nav.days.loading }\" class=\"u-animate--loadingOpacity\"><tr ng-if=\"!days || nav.days.total === 0\"><td colspan=\"7\" class=\"layerTable__cell--none\">No Activity in this Range</td></tr><tr ng-repeat=\"day in days | orderBy: nav.days.sort\" bindonce=\"day\" ng-class=\"{ \'is-odd\': ($index%2 == 0), \'is-live\': (channel.is_live && $index === 0), \'is-open\': activeStream === stream }\"><td class=\"layerTable__cell--type\"><i class=\"ion-android-calendar\"></i></td><td class=\"layerTable__cell--title\"><h5 bo-text=\"day.dow | indexToDay\"></h5></td><td class=\"u-tac\"><duration peeks=\"day.peek_count\"></duration></td><td class=\"layerTable__cell--value\" uib-tooltip=\"{{ day.minutes_watched | number: 0 }}\" bo-text=\"day.minutes_watched | bigNumber\"></td><td class=\"layerTable__cell--value\" bo-text=\"day.peak_viewers | number\"></td><td class=\"layerTable__cell--value\"><span bo-text=\"day.average_viewers | number:0\"></span><report-card value=\"{{ day.average_viewers | percentageOf: channel.average_viewers_shorterm }}\" comparison=\"{{ channel.average_viewers_shorterm }}\"></report-card></td><td class=\"layerTable__cell--value\" bo-text=\"day.twitch_game_count\"></td></tr></tbody>");
$templateCache.put("app/components/channel-report/_games.html","<thead><tr><th class=\"layerTable__header\" table-sort=\"nav.games.sort\" table-sort-column=\"title\" ng-click=\"changeSort(\'title\')\" colspan=\"3\">Title</th><th width=\"100\" class=\"layerTable__header u-tac\" table-sort=\"nav.games.sort\" table-sort-column=\"peek_count\" ng-click=\"changeSort(\'-peek_count\')\">Time Played</th><th width=\"120\" class=\"layerTable__header u-tac\" table-sort=\"nav.games.sort\" table-sort-column=\"total_minutes\" ng-click=\"changeSort(\'-total_minutes\')\">Min Watched</th><th width=\"140\" class=\"layerTable__header u-tac\" table-sort=\"nav.games.sort\" table-sort-column=\"average_viewers\" ng-click=\"changeSort(\'-average_viewers\')\">Avg Viewers</th><th width=\"110\" class=\"layerTable__header u-tac\" table-sort=\"nav.games.sort\" table-sort-column=\"peak_viewers\" ng-click=\"changeSort(\'-peak_viewers\')\">Peak Viewers</th><th class=\"layerTable__header u-tac\" width=\"60\">Filter</th></tr></thead><tbody ng-class=\"{ \'u-opacity--5\': nav.games.loading }\" class=\"u-animate--loadingOpacity\"><tr ng-if=\"!games || nav.games.total === 0\"><td colspan=\"8\" class=\"layerTable__cell--none\">No Activity in this Range</td></tr><tr ng-repeat=\"game in games.data\" bindonce=\"game\" bo-class=\"{ \'is-odd\': $index%2 == 0 }\"><td class=\"layerTable__cell--type\"><i class=\"ion-ios-game-controller-a\"></i></td><td class=\"layerTable__cell--boxArt\" width=\"60\"><ns-image height=\"54\" width=\"46\" class=\"u-fl u-ofh\" ui-sref=\"app.game.report({ slug: game.title })\" ns-image-src=\"{{ game.title | urlBoxart:190:138 }}\"><span ng-bind=\"((game.peek_count/stats.peek_count * 100) | round: 1) + \'%\'\"></span></ns-image></td><td class=\"layerTable__cell--title\"><h5><ns-live-dot bo-if=\"(channel.is_live && channel.is_live.twitch_game.title === game.title)\" ns-live-dot-peek=\"channel.is_live\"></ns-live-dot><a class=\"u-invisibleLink\" ui-sref=\"app.game.report({ slug: game.title })\" bo-bind=\"game.title === \'\' ? \'<No Game>\' : game.title\"></a></h5></td><td class=\"u-tac\"><duration peeks=\"game.peek_count\"></duration></td><td class=\"layerTable__cell--value\" uib-tooltip=\"{{ game.total_minutes | number: 0 }}\" bo-text=\"game.total_minutes | bigNumber\"></td><td class=\"layerTable__cell--value\"><span bo-text=\"game.average_viewers | number:0\"></span><report-card value=\"{{ game.average_viewers | percentageOf: channel.average_viewers_shorterm }}\" comparison=\"{{ channel.average_viewers_shorterm }}\"></report-card></td><td class=\"layerTable__cell--value\" bo-text=\"game.peak_viewers | number\"></td><td class=\"layerTable__cell--more\" uib-tooltip=\"Show only this title\" ng-click=\"setGame(game)\"><i ng-if=\"!gameFilter\" class=\"ion-funnel\"></i> <i ng-if=\"gameFilter\" class=\"ion-close\"></i></td></tr></tbody>");
$templateCache.put("app/components/channel-report/_streams.html","<thead><tr><th colspan=\"2\" class=\"layerTable__header\" table-sort=\"nav.streams.sort\" table-sort-column=\"pulled_at\" ng-click=\"changeSort(\'-pulled_at\')\">Start Time</th><th width=\"96\" class=\"layerTable__header u-tac\" table-sort=\"nav.streams.sort\" table-sort-column=\"total_minutes\" ng-click=\"changeSort(\'-total_minutes\')\">Min Watched</th><th width=\"104\" class=\"layerTable__header u-tac\" table-sort=\"nav.streams.sort\" table-sort-column=\"peak_viewers\" ng-click=\"changeSort(\'-peak_viewers\')\">Peak Viewers</th><th width=\"104\" class=\"layerTable__header u-tac\" table-sort=\"nav.streams.sort\" table-sort-column=\"average_viewers\" ng-click=\"changeSort(\'-average_viewers\')\">Avg Viewers</th><th width=\"86\" class=\"layerTable__header u-tac\" table-sort=\"nav.streams.sort\" table-sort-column=\"peek_count\" ng-click=\"changeSort(\'-peek_count\')\">Duration</th><th width=\"163\" class=\"layerTable__header\">Games Played</th><th width=\"60\" class=\"layerTable__header u-tac\">More</th></tr></thead><tbody class=\"u-animate--loadingOpacity\" ng-class=\"{ \'u-opacity--5\': nav.streams.loading }\"><tr ng-if=\"!streams || nav.streams.total === 0\"><td colspan=\"7\" class=\"layerTable__cell--none\">No Activity in this Range</td></tr><tr ng-repeat-start=\"stream in streams.data\" bindonce=\"stream\" bo-class=\"{ \'is-odd\': $index%2 == 0, \'is-live\': (channel.is_live && $index === 0), \'is-open\': activeStream === stream }\"><td class=\"layerTable__cell--type\"><i class=\"ion-mic-c\" bo-if=\"!stream.is_vodcast\"></i> <i class=\"ion-refresh\" bo-if=\"stream.is_vodcast\"></i></td><td class=\"layerTable__cell--title\"><h5><ns-live-dot bo-if=\"(channel.is_live && channel.is_live.twitch_stream_id === stream.id)\" ns-live-dot-peek=\"channel.is_live\"></ns-live-dot><span bo-text=\"stream.stream.pulled_at | dateUtcToLocal | dateToFormat: \'l LT\'\"></span></h5><p bo-if=\"stream.is_vodcast\" uib-tooltip=\"Vodcast (Not Live)\"><span class=\"channelReport__vodcast\">VOD</span></p><p bo-if=\"stream.pulled_at !== stream.stream.pulled_at || stream.ended_at !== stream.stream.ended_at\" uib-tooltip=\"Selected range cuts off part of this Broadcast\"><i class=\"ion-scissors u-fontOpacity--3\"></i></p><p bo-text=\"stream.stream.pulled_at | dateUtcToLocal | dateToFormat: \'ddd\'\"></p><p uib-tooltip-html=\"\'<h4>Multiple Streams</h4>\' + stream.twitch_stream_ids.join(\'<br>\')\" tooltip-enable=\"stream.twitch_stream_ids.length > 1\"><sup><i class=\"ion-pound u-fontOpacity--3\"></i></sup> <span bo-text=\"stream.id | dashedNumber\"></span> <span bo-show=\"stream.twitch_stream_ids.length > 1\" bo-text=\"\'(+\' + (stream.twitch_stream_ids.length - 1) + \')\'\"></span></p></td><td class=\"layerTable__cell--value\" uib-tooltip=\"{{ stream.total_minutes | number: 0 }}\" bo-text=\"stream.total_minutes | bigNumber\"></td><td class=\"layerTable__cell--value\" bo-text=\"stream.peak_viewers | number\"></td><td class=\"layerTable__cell--value\"><span bo-text=\"stream.average_viewers | number:0\"></span><report-card value=\"{{ stream.average_viewers | percentageOf: channel.average_viewers_shorterm }}\" comparison=\"{{ channel.average_viewers_shorterm }}\"></report-card></td><td class=\"u-tac\"><duration start=\"stream.pulled_at\" end=\"stream.ended_at\"></duration></td><td class=\"gameRow\"><ns-image height=\"54\" width=\"46\" ui-sref=\"app.game.report({ slug: streamedGame.twitch_game.title })\" ng-repeat=\"streamedGame in stream.streamed_games | orderBy:\'pulled_at\' | limitTo: ((stream.streamed_games.length > 3) ? 2 : 3)\" uib-tooltip-html=\"streamedGame.tooltip\" ns-image-src=\"{{ streamedGame.twitch_game.title | urlBoxart:190:138 }}\"><span bo-text=\"streamedGame.twitch_game.title | firstLetter:5\"></span></ns-image><a class=\"gameRow__more\" ng-if=\"stream.streamed_games.length > 3\"><h5>{{ stream.streamed_games.length - 2 }}</h5><p class=\"title\">More</p></a></td><td class=\"layerTable__cell--more\" ng-click=\"showBreakdown(stream, $index)\" ng-class=\"{ \'is-active\': activeStream === stream, \'is-disabled\': stream.peek_count < 2 }\"><i class=\"ion-stats-bars\"></i> <i class=\"ion-close\"></i></td></tr><tr class=\"layerTable__row--small\" bo-class=\"{ \'is-first\': $index == 0, \'is-odd\': $index%2 == 0 }\" ng-repeat=\"continuation in stream.twitch_stream_ids track by $index\" ng-if=\"stream.open\" bindonce=\"continuation\"><td class=\"layerTable__cell--title\"><h5><sup><i class=\"ion-pound u-fontOpacity--2\"></i></sup> <span bo-text=\"continuation | dashedNumber\"></span></h5></td><td class=\"layerTable__cell--value\">&nbsp;</td><td class=\"layerTable__cell--value\">&nbsp;</td><td class=\"layerTable__cell--value\">&nbsp;</td><td class=\"layerTable__cell--value\">&nbsp;</td><td class=\"layerTable__cell--value\" colspan=\"2\">&nbsp;</td></tr><tr ng-repeat-end=\"\"><td colspan=\"8\" ng-if=\"activeStream === stream\" class=\"layerTable__cell--drawer\"><stream-breakdown channel=\"channel\" start=\"stream.pulled_at\" end=\"stream.ended_at\" stream-id=\"{{ stream.id }}\"></stream-breakdown></td></tr></tbody>");
$templateCache.put("app/components/channel-report/channel-report.html","<div><div class=\"streamList layer u-paddingBottom--20\"><h2 class=\"layerCap layerCap--range layerCap--noInner\"><div class=\"layerCap__aside layerCap__aside--export\" ng-click=\"exportPeeks()\" ng-class=\"{ \'is-disabled\': rawPeeks.length < 1 }\"><i class=\"icon--export ion-android-download\"></i> Export</div><ns-section-dot ns-section-dot-icon=\"ion-android-calendar\" ns-section-dot-loading=\"loading\"></ns-section-dot><ns-range ns-range-start=\"start\" ns-range-end=\"end\" ns-range-presets=\"timeline\" ns-range-preset=\"2\" ns-range-callback=\"applyRange\" ns-range-changed=\"changed\" ns-range-loading=\"loading || nav[tab].loading || tabLoading\" ns-range-selected=\"selectedRange\" ns-set-params=\"true\"></ns-range></h2><div sticky=\"\" offset=\"75\" sticky-class=\"reportFilter--sticky\"><div class=\"reportFilter\" ng-if=\"gameFilter\"><i class=\"ion-funnel funnel\"></i> Showing only <i class=\"ion-ios-game-controller-a u-marginLeft--5 u-fontOpacity--3\"></i> <a class=\"u-invisibleLink u-fwb\" ui-sref=\"app.game.report({ slug: gameInfo.slug })\" ng-bind=\"gameInfo.title\"></a> <a class=\"clear\" ng-click=\"clearGame()\"><i class=\"ion-close\"></i> Clear Filter</a></div></div><ns-stats class=\"u-separatorBorder--bottom\" ng-class=\"{ \'u-separatorBorder--top\': gameFilter }\"><ns-stats-item ng-class=\"{ \'is-link\': !isDay }\" ng-click=\"isDay || chart.changeMetric(chart.metrics[0])\" ng-click-enable=\"!isDay\" ns-stats-item-value=\"(stats.minutes_watched || 0) | bigNumber\" ns-stats-item-loading=\"loading\" ns-stats-item-title=\"Minutes Watched\" tooltip-enable=\"stats.minutes_watched\" uib-tooltip-html=\"(stats.minutes_watched | number) + \' min <br>\' + (stats.hours_watched | number) + \' hr\'\"></ns-stats-item><ns-stats-item ng-class=\"{ \'is-link\': !isDay }\" ng-click=\"isDay || chart.changeMetric(chart.metrics[3])\" ns-stats-item-value=\"(stats.peak_viewers || 0) | number\" ns-stats-item-loading=\"loading\" ns-stats-item-title=\"Peak Viewers\"></ns-stats-item><ns-stats-item ng-class=\"{ \'is-link\': !isDay }\" ng-click=\"isDay || chart.changeMetric(chart.metrics[1])\" ns-stats-item-value=\"(stats.minutes_streamed || 0 ) | durationToTimestamp: \'m\'\" ns-stats-item-loading=\"loading\" ns-stats-item-title=\"Stream Time\"></ns-stats-item><ns-stats-item ng-class=\"{ \'is-link\': !isDay }\" ng-click=\"isDay || chart.changeMetric(chart.metrics[2])\" ns-stats-item-value=\"(stats.average_viewers || 0) | number: 0\" ns-stats-item-title=\"Average Viewership\" ns-stats-item-loading=\"loading\"></ns-stats-item></ns-stats><div class=\"layer__hPadding\"><ns-chart ng-if=\"peeks !== false\" ns-chart-config=\"(isDay) ? chartDay : chart\" ns-chart-data=\"peeks\" ns-chart-loading=\"loading\" ns-chart-empty=\"No Activity in this Range\"></ns-chart><div class=\"chart__none\" ng-if=\"peeks === false\">No Activity in this Range</div><h2 class=\"layerCap u-separatorBorder--top\"><div class=\"layerCap__aside layerCap__aside--export u-paddingRight--35\" ng-click=\"exportList()\" ng-class=\"{ \'is-disabled\': nav[tab].loading || nav[tab].total === 0 }\"><i class=\"icon--export ion-android-download\"></i> Export</div><ul class=\"layerCap__tabs\"><li ng-class=\"{ \'is-active\': tab === \'streams\' }\" ng-click=\"changeTab(\'streams\')\"><ns-section-dot ns-section-dot-icon=\"ion-mic-c\" ns-section-dot-loading=\"nav.streams.loading\"></ns-section-dot>Broadcasts</li><li ng-class=\"{ \'is-active\': tab === \'games\' }\" ng-click=\"changeTab(\'games\')\"><ns-section-dot ns-section-dot-icon=\"ion-ios-game-controller-a\" ns-section-dot-loading=\"nav.games.loading\"></ns-section-dot>Games</li><li ng-class=\"{ \'is-active\': tab === \'days\' }\" ng-click=\"changeTab(\'days\')\"><ns-section-dot ns-section-dot-icon=\"ion-android-calendar\" ns-section-dot-loading=\"nav.days.loading\"></ns-section-dot>Days</li></ul></h2><div class=\"u-animate--loadingOpacity u-paddingBottom--20 streamList__data\" ng-class=\"{ \'u-opacity--5\': isLoading }\"><table class=\"layerTable\" ng-if=\"tab === \'streams\'\" ng-include=\"\'app/components/channel-report/_streams.html\'\"></table><table class=\"layerTable\" ng-if=\"tab === \'games\'\" ng-include=\"\'app/components/channel-report/_games.html\'\"></table><table class=\"layerTable\" ng-if=\"tab === \'days\'\" ng-include=\"\'app/components/channel-report/_days.html\'\"></table></div><ns-pagination ng-hide=\"nav[tab].total <= 8\" ns-pagination-loading=\"nav[tab].loading\" ns-pagination-page=\"currentPage\" ns-pagination-total=\"nav[tab].total\" ns-pagination-limit=\"perPage\" ns-pagination-change-page=\"nav[tab].changePage\" ns-pagination-change-limit=\"setLimit\"></ns-pagination></div></div></div>");
$templateCache.put("app/components/date/date.html","<span ng-class=\"{ \'is-display\': display, \'d-date\': !dateText, \'d-date--text\': dateText, \'is-open\': isOpen }\" uib-datepicker-popup=\"\" datepicker-options=\"{ showWeeks: false, initDate: moment, maxDate: max ? max : null, minDate: min }\" ng-model=\"moment\" init-date=\"moment\" ng-click=\"(display) ? false : isOpen = (isOpen) ? false : true;\" is-open=\"isOpen\" show-button-bar=\"false\"><span ng-if=\"!dateText\"><div ng-if=\"moment\"><p class=\"title\">{{ moment | dateUtcToLocal | dateToFormat: (dateHorizontal) ? \'MMMM\' : \'MMM\' }}</p><p class=\"subtitle\">{{ moment | dateUtcToLocal | dateToFormat: (dateHorizontal) ? \'Do\' : \'DD\' }}</p><p class=\"aside\">{{ moment | dateUtcToLocal | dateToFormat: \'YYYY\' }}</p></div><div ng-if=\"!moment\" class=\"is-none\"><p class=\"title\">MMM</p><p class=\"subtitle\">DD</p><p class=\"aside\">YYYY</p></div></span> <span ng-if=\"dateText\">{{ moment | dateToFormat: \'ddd l\' }}</span></span>");
$templateCache.put("app/components/date-old/date.html","<span ng-class=\"{ \'is-display\': display, \'d-date\': !dateText, \'d-date--text\': dateText, \'is-open\': isOpen }\" uib-datepicker-popup=\"\" datepicker-options=\"{ showWeeks: false, initDate: moment, maxDate: max, minDate: min }\" ng-model=\"moment\" ng-click=\"(display) ? false : isOpen = (isOpen) ? false : true;\" datepicker-append-to-body=\"\" is-open=\"isOpen\" show-button-bar=\"false\"><span ng-if=\"!dateText\"><div ng-if=\"moment\"><p class=\"title\">{{ moment | dateUtcToLocal | dateToFormat: (dateHorizontal) ? \'MMMM\' : \'MMM\' }}</p><p class=\"subtitle\">{{ moment | dateUtcToLocal | dateToFormat: (dateHorizontal) ? \'Do\' : \'DD\' }}</p><p class=\"aside\">{{ moment | dateUtcToLocal | dateToFormat: \'YYYY\' }}</p></div><div ng-if=\"!moment\" class=\"is-none\"><p class=\"title\">MMM</p><p class=\"subtitle\">DD</p><p class=\"aside\">YYYY</p></div></span> <span ng-if=\"dateText\">{{ moment | dateDayStart | dateToFormat: \'MMMM Do YYYY\' }}</span></span>");
$templateCache.put("app/components/follow-button/follow-button.html","<div class=\"d-followButton\" ng-click=\"cFollowButton.toggleFollow()\" ng-class=\"{ \'is-active\': cFollowButton.active }\" uib-tooltip=\"{{ (cFollowButton.active) ? \'Unf\' : \'F\' }}{{ (cFollowButton.type === \'game\') ? \'ollow this Game\' : \'ollow this Channel\' }}\" tooltip-placement=\"right\"><i class=\"icon ion-android-star\" ng-if=\"!cFollowButton.loading\"></i><div class=\"spinner--small\" ng-if=\"cFollowButton.loading\"></div></div>");
$templateCache.put("app/components/game-card/game-card.html","<div class=\"d-gameCard\"><bg-img class=\"d-gameCard__banner base__banner\" height=\"200\" ng-if=\"game.banner\" image=\"{{ game.banner | urlIgdbImage }}\"></bg-img><div class=\"d-gameCard__banner is-noBanner\" ng-if=\"!game.banner\"></div><div class=\"d-gameCard__name\"><div class=\"u-fl\"><bg-img class=\"logo\" height=\"130\" width=\"100\" image=\"{{ gameData.cover[gameData.imageProperty] | urlIgdbImage }}\" ng-if=\"gameData.coverold\"></bg-img><bg-img class=\"logo\" height=\"130\" width=\"100\" image=\"{{ game.title | urlBoxart }}\"></bg-img></div><h2 class=\"title\">{{ game.title }} <span ng-if=\"gameData.release_date\" class=\"timestamp\">Released {{ gameData.release_date | dateToSince }}</span></h2></div><ul class=\"d-gameCard__companies\" ng-if=\"gameData.companies\"><li ng-repeat=\"company in gameData.companies | orderBy: \'-publisher\'\" ng-class=\"{ \'is-full\': game.igdb_data.game.companies.length === 1 }\"><i ng-if=\"company.publisher\" class=\"icon ion-disc\"></i> <i ng-if=\"company.developer\" class=\"icon ion-code\"></i> {{ company.name }}</li></ul><p class=\"d-gameCard__description\" ng-if=\"gameData.summary || gameData.genres\">{{ gameData.summary | limitTo: limit }}<span ng-if=\"gameData.summary.length > limit && limit\"><i class=\"icon ion-ios-more-outline\"></i><br><a class=\"d-gameCard__readMore\" ng-click=\"readMore()\">Show More &nbsp; <i class=\"icon ion-android-arrow-dropdown\"></i></a></span> <span class=\"d-gameCard__genres\" ng-if=\"gameData.genres\"><b>Genre:</b>&nbsp; <span ng-repeat=\"genre in gameData.genres\">{{ genre.name }}<span ng-hide=\"$index+1 === gameData.genres.length\">,&nbsp;</span></span></span></p><div class=\"d-gameCard__moreInfo\" ng-if=\"game.steamapp_id || gameData.slug\"><span class=\"title\">View on:</span> <a target=\"_blank\" class=\"is-steam\" ng-if=\"game.steamapp_id\" ng-href=\"http://store.steampowered.com/app/{{ game.steamapp_id }}/\"><i class=\"icon ion-steam\"></i> Steam</a> <a target=\"_blank\" class=\"is-igdb\" ng-if=\"gameData.slug\" ng-href=\"https://www.igdb.com/games/{{ gameData.slug }}\"><i class=\"icon ion-ios-game-controller-a\"></i> IGDB</a></div><div class=\"d-gameCard__gameList\" ng-if=\"game.twitch_games.length > 1\"><a ng-click=\"gameListOpen = (gameListOpen) ? false : true;\"><i ng-hide=\"gameListOpen\" class=\"icon ion-android-add\"></i> <i ng-show=\"gameListOpen\" class=\"icon ion-android-remove\"></i> This game has been streamed under {{ game.twitch_games.length }} different titles</a><ul ng-show=\"gameListOpen\"><li ng-repeat=\"game in game.twitch_games\"><i class=\"icon ion-social-twitch-outline\"></i> {{ game.title }}</li></ul></div><div class=\"d-gameCard__suggestGrouping\" ng-class=\"{ \'no-border\': game.twitch_games.length == 1, \'is-thanks\': reviewRequested }\"><div ng-hide=\"game.review_requested_by || reviewRequestLoading || reviewRequested\">Something wrong? <a ng-click=\"requestReview()\"><i class=\"ion-search\"></i> Request a Review</a></div><div ng-show=\"reviewRequestLoading\"><div class=\"wait wait--small wait--dark\"></div></div><div ng-show=\"reviewRequested\"><i class=\"ion-android-checkmark-circle\"></i> <b>Thanks!</b> We\'ll have a look</div><div ng-show=\"game.review_requested_by\" class=\"under-review\"><i class=\"ion-search\"></i> &nbsp; A review has been requested for this game</div></div><div class=\"statBar\"><div class=\"statBar__value\" style=\"width: 66.666%\" ng-if=\"!game.average_viewers\"><h4 class=\"value\">INACTIVE<h3 class=\"title\">for last 40 hours</h3></h4></div><div class=\"statBar__value\" uib-tooltip=\"{{ game.average_viewers | number:0 }} Viewers\" ng-if=\"game.average_viewers\"><h4 class=\"value\">{{ game.average_viewers | bigNumber }}</h4><h3 class=\"title\">Avg Viewership</h3></div><div class=\"statBar__value\" uib-tooltip=\"{{ game.average_streams | number:0 }} Channels\" ng-if=\"game.average_viewers\"><h4 class=\"value\">{{ game.average_streams | bigNumber }}</h4><h3 class=\"title\">Avg Playing</h3></div><div class=\"statBar__value is-last\" uib-tooltip=\"{{ game.total_minutes | number:0 }} Minutes\"><h4 class=\"value\">{{ game.total_minutes | bigNumber }}</h4><h3 class=\"title\">Minutes Watched</h3></div></div></div>");
$templateCache.put("app/components/game-lists/_channels.html","<div class=\"d-gameLists__filters\"><ul class=\"buttons\"><li ng-if=\"channels.filters.channel\" class=\"is-active\" ng-click=\"channels.filters.channel = null; clearChannel()\"><i class=\"icon ion-checkmark-circled\"></i> {{ channels.filters.channel.display_name }}</li></ul></div><table class=\"d-gameLists__table\" ng-class=\"{ \'is-loading\': loading }\"><thead><tr><th width=\"30\"></th><th class=\"is-search\"><div class=\"icon\"><div ng-if=\"channelsLoading\" class=\"spinner--small icon--loading\"></div><i uib-tooltip=\"No Results\" class=\"icon--none ion-close\" ng-show=\"channelNone\"></i> <i class=\"icon--search ion-search\" ng-hide=\"channelsLoading || channelNone\"></i></div><input type=\"text\" ng-model=\"channel\" placeholder=\"Filter by Channel...\" typeahead-focus-first=\"true\" typeahead-min-length=\"3\" typeahead-loading=\"channelsLoading\" typeahead-wait-ms=\"120\" typeahead-on-select=\"setChannel($item); channel=\'\'\" uib-typeahead=\"hit.display_name for hit in (searchChannels($viewValue))\" typeahead-append-to-body=\"\" typeahead-no-results=\"channelNone\" ng-blur=\"channel = \'\'; channelNone = false;\"></th><th ng-click=\"changeSort(\'-total_viewers\')\" table-sort=\"channels.sort\" table-sort-column=\"total_viewers\" width=\"120\">Min Watched</th><th ng-click=\"changeSort(\'-average_viewers\')\" table-sort=\"channels.sort\" table-sort-column=\"average_viewers\" width=\"130\">Avg Viewers</th><th ng-click=\"changeSort(\'-peak_viewers\')\" table-sort=\"channels.sort\" table-sort-column=\"peak_viewers\" width=\"100\">Peak Viewers</th><th ng-click=\"changeSort(\'-peek_count\')\" table-sort=\"channels.sort\" table-sort-column=\"peek_count\" width=\"100\">Stream Time</th><th ng-click=\"changeSort(\'-stream_count\')\" table-sort=\"channels.sort\" table-sort-column=\"stream_count\" width=\"80\">Streams</th></tr></thead><tbody ng-if=\"channels.data.length === 0 && !loading\"><tr><td class=\"is-none\" colspan=\"7\"><img src=\"/assets/images/chest.png\" alt=\"\"> It\'s empty...</td></tr></tbody><tbody><tr ng-repeat=\"channel in channels.data\" ng-class-odd=\"\'is-odd\'\"><td class=\"is-type\"><i class=\"icon ion-person\"></i></td><td class=\"is-channel\"><div class=\"liveDot\" ng-show=\"channel.channel.is_live\"><i class=\"icon ion-ios-pulse-strong\"></i> <span>Live</span></div><a class=\"is-image\" ui-sref=\"app.channel({ channel: channel.channel.name, platform: \'twitch\' })\"><bg-img class=\"logo\" height=\"48\" width=\"48\" image=\"{{ channel.channel.logo || \'/assets/images/blank-user.png\' }}\"></bg-img></a><div class=\"inner\"><h3 class=\"title\"><a class=\"m-inheritLink\" ui-sref=\"app.channel({ channel: channel.channel.name, platform: \'twitch\' })\">{{ channel.channel.display_name }}</a></h3><p class=\"subtitle\"><i class=\"icon ion-heart\"></i> {{ channel.channel.followers | number }} Followers</p></div></td><td class=\"is-number\">{{ channel.total_viewers*pullInterval | bigNumber }} <i class=\"icon--estimated ion-alert-circled\" uib-tooltip=\"Estimated, export for exact values\" ng-if=\"channel.estimated\"></i><p class=\"percent\" ng-if=\"!isDay\">{{ (channel.total_viewers*pullInterval / (chart.minutesWatched)) * 100 | number: 1 }}%</p><p class=\"percent\" ng-if=\"isDay\">{{ (channel.total_viewers*pullInterval / (chart.minutesWatched)) * 100 | number: 1 }}%</p></td><td class=\"is-number\">{{ channel.average_viewers | number: 0 }}<report-card value=\"{{ channel.average_viewers | percentageOf: channel.channel.average_viewers_shorterm }}\" comparison=\"{{ channel.channel.average_viewers_shorterm }}\"></report-card><i class=\"icon--estimated ion-alert-circled\" uib-tooltip=\"Estimated, export for exact values\" ng-if=\"channel.estimated\"></i></td><td class=\"is-number\">{{ channel.peak_viewers | number: 0 }} <i class=\"icon--estimated ion-alert-circled\" uib-tooltip=\"Estimated, export for exact values\" ng-if=\"channel.estimated\"></i></td><td class=\"is-duration\"><duration peeks=\"channel.peek_count\"></duration></td><td class=\"is-number\"><a class=\"m-inheritLink u-cp\" ng-click=\"showChannelStreams(channel.channel)\">{{ channel.stream_count }}</a></td></tr></tbody></table>");
$templateCache.put("app/components/game-lists/_streams.html","<div class=\"d-gameLists__filters\"><ul class=\"buttons\"><li ng-if=\"streams.filters.channel\" class=\"is-active\" ng-click=\"streams.filters.channel = null; clearChannel()\"><i class=\"icon ion-checkmark-circled\"></i> {{ streams.filters.channel.display_name }}</li><li ng-class=\"{ \'is-active\': streams.filters.live }\" ng-click=\"setFilter(\'live\')\"><i class=\"icon ion-checkmark-circled\"></i> Playing Now</li><li ng-class=\"{ \'is-active\': streams.filters.hour }\" ng-click=\"setFilter(\'hour\')\"><i class=\"icon ion-checkmark-circled\"></i> 1 Hour or Longer</li></ul></div><table class=\"d-gameLists__table\" ng-class=\"{ \'is-loading\': loading }\"><thead><tr><th width=\"30\"></th><th class=\"is-search\"><div class=\"icon\"><div ng-if=\"channelsLoading\" class=\"spinner--small icon--loading\"></div><i uib-tooltip=\"No Results\" class=\"icon--none ion-close\" ng-show=\"channelNone\"></i> <i class=\"icon--search ion-search\" ng-hide=\"channelsLoading || channelNone\"></i></div><input type=\"text\" ng-model=\"channel\" placeholder=\"Filter by Channel...\" typeahead-focus-first=\"true\" typeahead-min-length=\"3\" typeahead-loading=\"channelsLoading\" typeahead-wait-ms=\"120\" typeahead-on-select=\"setChannel($item); channel=\'\'\" uib-typeahead=\"hit.display_name for hit in (searchChannels($viewValue))\" typeahead-append-to-body=\"\" typeahead-no-results=\"channelNone\" ng-blur=\"channel = \'\'; channelNone = false;\"></th><th ng-click=\"changeSort(\'-average_viewers\')\" table-sort=\"streams.sort\" table-sort-column=\"average_viewers\" width=\"120\">Avg Viewers</th><th ng-click=\"changeSort(\'-peek_viewers\')\" table-sort=\"streams.sort\" table-sort-column=\"peek_viewers\" width=\"96\">Peak Viewers</th><th ng-click=\"changeSort(\'-peek_count\')\" table-sort=\"streams.sort\" table-sort-column=\"peek_count\" width=\"90\">Duration</th><th ng-click=\"changeSort(\'pulled_at\')\" table-sort=\"streams.sort\" table-sort-column=\"pulled_at\" width=\"80\">Date</th><th ng-click=\"changeSort(\'pulled_at\')\" table-sort=\"streams.sort\" table-sort-column=\"pulled_at\" width=\"100\">Start Time</th><th width=\"64\">More</th></tr></thead><tbody ng-if=\"streams.data.length === 0 && !loading\"><tr><td class=\"is-none\" colspan=\"8\"><img src=\"/assets/images/chest.png\" alt=\"\"> It\'s empty...</td></tr></tbody><tbody><tr ng-repeat-start=\"stream in streams.data\" ng-class-odd=\"\'is-odd\'\"><td class=\"is-type\"><i class=\"icon ion-mic-c\"></i></td><td class=\"is-stream\"><div class=\"liveDot\" ng-show=\"stream.channel.is_live\"><i class=\"icon ion-ios-pulse-strong\"></i> <span>Live</span></div><a class=\"is-image\" ui-sref=\"app.channel({ channel: stream.channel.name, platform: \'twitch\' })\"><bg-img class=\"logo\" height=\"48\" width=\"48\" image=\"{{ stream.channel.logo || \'/assets/images/blank-user.png\' }}\"></bg-img></a><div class=\"inner\"><h3 class=\"title\"><a class=\"m-inheritLink\" ui-sref=\"app.channel({ channel: stream.channel.name, platform: \'twitch\' })\">{{ stream.channel.display_name }}</a></h3><p class=\"subtitle\"><i class=\"icon ion-pound\"></i> {{ stream.twitch_stream_id | dashedNumber }}</p></div></td><td class=\"is-number\">{{ stream.average_viewers | number: 0 }}<report-card value=\"{{ stream.average_viewers | percentageOf: stream.channel.average_viewers_shorterm }}\" comparison=\"{{ stream.channel.average_viewers_shorterm }}\"></report-card></td><td class=\"is-number\">{{ stream.peak_viewers | number: 0 }}</td><td class=\"is-duration\"><duration peeks=\"stream.peek_count\"></duration></td><td class=\"is-date\"><date display=\"true\" moment=\"stream.pulled_at\"></date></td><td class=\"is-duration\"><span class=\"m-duration\"><i class=\"icon--fade icon--margin ion-android-time\"></i> {{ stream.pulled_at | dateUtcToLocal | dateToFormat: \'LT\' }}</span></td><td class=\"is-more\" ng-class=\"{ \'is-active\': activeStream === stream }\" ng-click=\"showBreakdown(stream, $index)\"><i ng-if=\"activeStream !== stream\" class=\"icon ion-stats-bars\"></i> <i ng-if=\"activeStream === stream\" class=\"icon icon--close ion-close\"></i></td></tr><tr ng-repeat-end=\"\" ng-if=\"activeStream === stream\"><td colspan=\"8\" class=\"layerTable__cell--drawer\"><stream-breakdown channel=\"stream.channel\" stream-id=\"{{ stream.twitch_stream_id }}\"></stream-breakdown></td></tr></tbody></table>");
$templateCache.put("app/components/game-lists/game-lists.html","<div class=\"d-gameLists\"><div class=\"inner\"><div class=\"d-gameLists__timeframe\"><div class=\"export u-fr\" ng-click=\"export()\"><i class=\"icon ion-android-download\"></i> Export</div><h2 class=\"section-title title\"><ns-section-dot ns-section-dot-icon=\"ion-android-calendar\" ns-section-dot-loading=\"chart.loading\"></ns-section-dot><date-old moment=\"start\" min=\"minimumDate\" max=\"end\" date-text=\"true\" display=\"chart.loading\"></date-old><span class=\"subtitle\">through</span><date-old moment=\"end\" min=\"start\" max=\"today\" date-text=\"true\" display=\"chart.loading\"></date-old><ns-dropdown class=\"list\" ns-dropdown-display=\"title\" ns-dropdown-options=\"ranges\" ns-dropdown-select=\"changeRange\"><span class=\"title\"><span ng-if=\"isDay && ranges[0].start !== start && ranges[1].start !== start\">Day <i class=\"icon ion-android-arrow-dropdown\"></i></span> <span ng-repeat=\"range in ranges\" ng-if=\"range.start == start && range.end == end\">{{ range.title }} <i class=\"icon ion-android-arrow-dropdown\"></i></span> <span>Custom <i class=\"icon ion-android-arrow-dropdown\"></i></span></span></ns-dropdown></h2></div><ns-stats class=\"d-gameLists__stats\"><ns-stats-item ns-stats-item-value=\"chart.minutesWatched | bigNumber\" ns-stats-item-loading=\"chart.loading\" ns-stats-item-title=\"Minutes Watched\" style=\"width: 25%\"></ns-stats-item><ns-stats-item ns-stats-item-value=\"(chart.peeks | maxProperty: (isDay) ?\'total_viewers\' : \'peak_viewers\' | number)\" ns-stats-item-loading=\"chart.loading\" ns-stats-item-title=\"Peak Viewers\" style=\"width: 25%\"></ns-stats-item><ns-stats-item ns-stats-item-value=\"!isDay ? (chart.peeks | sumProperty: \'minutes_streamed\' | durationToTimestamp: \'m\') : ((chart.peeks | sumProperty: \'stream_count\') * pullInterval | durationToTimestamp: \'m\')\" ns-stats-item-loading=\"chart.loading\" ns-stats-item-title=\"Stream Time\" style=\"width: 25%\"></ns-stats-item><ns-stats-item ns-stats-item-value=\"(!isDay ? (chart.peeks | sumProperty: \'average_total_viewers\')/chart.peeks.length : (chart.peeks | sumProperty: \'total_viewers\')/chart.peeks.length) | number: 0\" ns-stats-item-loading=\"chart.loading\" ns-stats-item-title=\"Average Viewership\" style=\"width: 25%\"></ns-stats-item></ns-stats><div class=\"u-tar\"><div class=\"chartDropdown\"><ns-dropdown ns-dropdown-model=\"metric\" ns-dropdown-display=\"title\" ns-dropdown-options=\"(isDay) ? dayMetrics : metrics\" ns-dropdown-select=\"changeMetric\">{{ metric.title }} <i class=\"icon ion-android-arrow-dropdown\"></i></ns-dropdown></div></div><div class=\"d-gameLists__chart\"><highchart ng-hide=\"metric.column === \'channels\'\" config=\"chart\"></highchart><highchart ng-show=\"metric.column === \'channels\'\" config=\"channelsChart\"></highchart></div></div><div class=\"inner\"><h2 class=\"section-title\"><ul class=\"toggle\"><li ng-class=\"{ \'is-active\': tab === \'streams\' }\" ng-click=\"toggleStreams()\"><div ng-if=\"loading && tab === \'streams\'\" class=\"spinner--sectionTitle\"></div><i ng-hide=\"loading && tab === \'streams\'\" class=\"icon ion-mic-c\"></i> Broadcasts</li><li ng-class=\"{ \'is-active\': tab === \'channels\' }\" ng-click=\"toggleChannels()\"><div ng-if=\"loading && tab === \'channels\'\" class=\"spinner--sectionTitle\"></div><i ng-hide=\"loading && tab === \'channels\'\" class=\"icon ion-person\"></i> Channels</li></ul></h2><div ng-show=\"tab === \'streams\'\" class=\"d-gameLists__container\" ng-include=\"\'app/components/game-lists/_streams.html\'\"></div><div ng-show=\"tab === \'channels\'\" class=\"d-gameLists__container\" ng-include=\"\'app/components/game-lists/_channels.html\'\"></div><div class=\"d-gameLists__perPage\">Per Page<ul><li ng-class=\"{ \'is-active\': perPage == limit }\" ng-click=\"changePerPage(limit)\" ng-repeat=\"limit in [ 8, 15, 25 ]\">{{ limit }}</li></ul></div><uib-pagination total-items=\"total\" items-per-page=\"perPage\" ng-model=\"currentPage\" ng-change=\"pageChanged()\" max-size=\"8\" rotate=\"false\" ng-disabled=\"loading || chart.loading\"></uib-pagination><div class=\"pagination__map\">{{ from | number }} <span class=\"icon--fade\">-</span> {{ to | number }} <span class=\"icon--fade\">of</span> {{ total | number }}</div><div ng-if=\"loading\" class=\"pagination__loading\"><div class=\"spinner\"></div></div></div></div>");
$templateCache.put("app/components/game-live/game-live.html","<div class=\"base base--margin\" bindonce=\"game.liveStats\"><div class=\"base-live\" ng-class=\"{ \'base-live--notLive\': !game.liveStats.total_viewers }\"><div class=\"base-live__section base-live__section--cap\" uib-tooltip=\"Pulled {{ game.liveStats.pulled_at | dateUtcToLocal | dateToTimeAgo }}\" tooltip-placement=\"left\" tooltip-enable=\"game.liveStats.pulled_at\"><div><i class=\"base-live__capIcon ion-ios-pulse-strong\"></i><h3 class=\"base-live__label\">Right Now</h3></div></div><div class=\"base-live__message\"><b>Not Live</b> Currently no live broadcasts with 10 or more viewers</div><div class=\"base-live__section base-live__section--half\"><div><h4 class=\"base-live__value\" bo-bind=\"game.liveStats.rank | number: 0\"></h4><h3 class=\"base-live__label\">Rank</h3></div></div><div class=\"base-live__section\"><div><h4 class=\"base-live__value\"><big-number number=\"game.liveStats.total_viewers\"></big-number><ns-report-card ns-report-card-value=\"{{ game.liveStats.total_viewers | percentageOf: game.average_viewers }}\" ns-report-card-comparison=\"{{ game.average_viewers }}\"></ns-report-card></h4><h3 class=\"base-live__label\">Viewers</h3></div></div><a class=\"base-live__section\" ui-sref=\"app.live.channels({ game: game.id })\"><div><h4 class=\"base-live__value\">{{ game.liveStats.stream_count }}<ns-report-card ns-report-card-value=\"{{ game.liveStats.stream_count | percentageOf: game.average_streams }}\" ns-report-card-comparison=\"{{ game.average_streams }}\"></ns-report-card></h4><h3 class=\"base-live__label\">Streams</h3></div></a> <a ui-sref=\"app.channel({ platform: \'twitch\', channel: game.liveStats.top_channel.name })\" class=\"base-live__section base-live__section--double base-live__section--left\"><ns-image width=\"40\" height=\"40\" ns-image-src=\"{{ game.liveStats.top_channel.logo | avatar }}\" uib-tooltip=\"{{ game.liveStats.top_channel.display_name }}\" tooltip-placement=\"left\"></ns-image><div><h4 class=\"base-live__value\"><big-number number=\"game.liveStats.most_viewers\"></big-number><ns-report-card ns-report-card-value=\"{{ game.liveStats.most_viewers | percentageOf: game.liveStats.top_channel.average_viewers_shorterm }}\" ns-report-card-comparison=\"{{ game.liveStats.top_channel.average_viewers_shorterm }}\"></ns-report-card></h4><h3 class=\"base-live__label\">Top Stream</h3></div></a></div></div>");
$templateCache.put("app/components/game-report/_channels.html","<thead><tr><th class=\"layerTable__header\" width=\"30\">&nbsp;</th><th class=\"layerTable__header\" table-sort=\"$ctrl.report.sort\" table-sort-column=\"name\" ng-click=\"$ctrl.setSort(\'name\')\" colspan=\"2\">Channel</th><th width=\"100\" class=\"layerTable__header u-tac\" table-sort=\"$ctrl.report.sort\" table-sort-column=\"minutes_watched\" ng-click=\"$ctrl.setSort(\'-minutes_watched\')\">Min Watched</th><th width=\"130\" class=\"layerTable__header u-tac\" table-sort=\"$ctrl.report.sort\" table-sort-column=\"average_viewers\" ng-click=\"$ctrl.setSort(\'-average_viewers\')\">Avg Viewers</th><th width=\"100\" class=\"layerTable__header u-tac\" table-sort=\"$ctrl.report.sort\" table-sort-column=\"peak_viewers\" ng-click=\"$ctrl.setSort(\'-peak_viewers\')\">Peak Viewers</th><th width=\"110\" class=\"layerTable__header u-tac\" table-sort=\"$ctrl.report.sort\" table-sort-column=\"peek_count\" ng-click=\"$ctrl.setSort(\'-peek_count\')\">Stream Time</th><th width=\"80\" class=\"layerTable__header u-tac\" table-sort=\"$ctrl.report.sort\" table-sort-column=\"stream_count\" ng-click=\"$ctrl.setSort(\'-stream_count\')\">Streams</th><th width=\"29\" class=\"layerTable__header layerTable__header--icon u-tac u-dn\"><i class=\"ion-funnel\"></i></th></tr></thead><tbody class=\"u-animate--loadingOpacity\"><tr ng-repeat=\"channel in $ctrl.report.data\" bindonce=\"channel\" bo-class=\"{ \'is-odd\': $index%2 == 0 }\"><td class=\"layerTable__cell--type\" uib-tooltip=\"{{ channel.estimated ? \'Estimated Values, Click for Exact\' : \'Updated!\' }}\" tooltip-enable=\"channel.estimated\" tooltip-placement=\"left\" ng-click=\"$ctrl.parent.getExact(channel)\" ng-class=\"{ \'u-cp\': channel.estimated }\"><i ng-show=\"!channel.estimated && !channel.loading\" class=\"ion-person\"></i> <i ng-show=\"channel.estimated && !channel.loading\" class=\"ion-android-alert u-fontOpacity--7\"></i><div class=\"wait wait--small wait--dark\" ng-if=\"channel.loading\"></div></td><td class=\"layerTable__cell--boxArt\" width=\"60\"><ns-image height=\"54\" width=\"54\" class=\"u-fl u-ofh\" ui-sref=\"app.channel({ channel: channel.name, platform: \'twitch\' })\" ns-image-src=\"{{ channel.logo || \'/assets/images/blank-user.png\' }}\"></ns-image></td><td class=\"layerTable__cell--title\"><h5 class=\"u-ellipsis\" style=\"max-width: 190px;\"><ns-live-dot ng-if=\"channel.is_live\" ns-live-dot-peek=\"channel.is_live\" ns-live-dot-text=\"true\" ns-live-dot-game=\"{{ $ctrl.parent.game.title }}\"></ns-live-dot><a class=\"u-invisibleLink\" ui-sref=\"app.channel({ channel: channel.name, platform: \'twitch\' })\" bo-bind=\"channel.display_name\"></a></h5><p bo-show=\"channel.broadcaster_language\"><i class=\"ion-mic-a\"></i> <span bo-text=\"channel.broadcaster_language\"></span></p><p><i class=\"ion-heart\"></i> <span bo-text=\"channel.followers | bigNumber\"></span></p><p><i class=\"icon ion-person-stalker\"></i> <span bo-text=\"channel.average_viewers_shorterm | bigNumber\"></span></p></td><td class=\"layerTable__cell--value\" uib-tooltip=\"{{ channel.minutes_watched | number: 0 }}\"><span ng-bind=\"(channel.minutes_watched > 0 ? channel.minutes_watched : 0) | bigNumber\" tooltips=\"\"></span><p ng-show=\"$ctrl.parent.stats.minutes_watched\">{{ (channel.minutes_watched > 0 ? channel.minutes_watched : 0)/$ctrl.parent.stats.minutes_watched * 100 | round: 1 }}%</p><p ng-show=\"!$ctrl.parent.stats.minutes_watched\">-</p></td><td class=\"layerTable__cell--value\"><span ng-bind=\"(channel.average_viewers > 0 ? channel.average_viewers : 0) | number:0\"></span><report-card value=\"{{ (channel.average_viewers > 0 ? channel.average_viewers : 0) | percentageOf: channel.average_viewers_shorterm }}\" comparison=\"{{ channel.average_viewers_shorterm }}\"></report-card></td><td class=\"layerTable__cell--value\" ng-bind=\"channel.peak_viewers | number\"></td><td class=\"u-tac\"><duration peeks=\"(channel.peek_count > 1 ? channel.peek_count : 1)\"></duration></td><td class=\"layerTable__cell--value\">{{ $ctrl.game }} <a class=\"u-invisibleLink\" bo-text=\"channel.stream_count | number\" ui-sref=\"app.channel({ platform: \'twitch\', start: $ctrl.parent.start.format(), end: $ctrl.parent.end.format(), channel: channel.name, game: $ctrl.parent.game.id })\"></a></td><td class=\"layerTable__cell--menu u-dn\" ng-click=\"$ctrl.parent.addFilter({ type: \'channel\', value: channel.name, display: channel.display_name })\" uib-tooltip=\"Add Filter\" tooltip-placement=\"left\"><i class=\"ion-android-add-circle\"></i></td></tr></tbody>");
$templateCache.put("app/components/game-report/_days.html","<thead><tr><th colspan=\"2\" class=\"layerTable__header\" table-sort=\"$ctrl.report.sort\" table-sort-column=\"dow\" ng-click=\"$ctrl.setSort(\'dow\', true)\">Day of the Week</th><th width=\"125\" class=\"layerTable__header u-tac\" table-sort=\"$ctrl.report.sort\" table-sort-column=\"minutes_watched\" ng-click=\"$ctrl.setSort(\'-minutes_watched\', true)\">Min Watched</th><th width=\"140\" class=\"layerTable__header u-tac\" table-sort=\"$ctrl.report.sort\" table-sort-column=\"average_viewers\" ng-click=\"$ctrl.setSort(\'-average_viewers\', true)\">Avg Viewers</th><th width=\"125\" class=\"layerTable__header u-tac\" table-sort=\"$ctrl.report.sort\" table-sort-column=\"peak_viewers\" ng-click=\"$ctrl.setSort(\'-peak_viewers\', true)\">Peak Viewers</th><th width=\"125\" class=\"layerTable__header u-tac\" table-sort=\"$ctrl.report.sort\" table-sort-column=\"peek_count\" ng-click=\"$ctrl.setSort(\'-peek_count\', true)\">Stream Time</th></tr></thead><tbody><tr ng-repeat=\"day in $ctrl.report.data | orderBy: $ctrl.report.sort\" bindonce=\"day\" ng-class=\"{ \'is-odd\': $index%2 == 0 }\"><td class=\"layerTable__cell--type\"><i class=\"ion-android-calendar\"></i></td><td class=\"layerTable__cell--title\"><h5 bo-text=\"day.dow | indexToDay\"></h5></td><td class=\"layerTable__cell--value\" tooltip-enable=\"day.minutes_watched\" uib-tooltip=\"{{ day.minutes_watched | number: 0 }}\"><span bo-text=\"day.minutes_watched | bigNumber\"></span><p ng-show=\"$ctrl.parent.stats.minutes_watched\">{{ day.minutes_watched/$ctrl.parent.stats.minutes_watched * 100 | round: 1 }}%</p><p ng-show=\"!$ctrl.parent.stats.minutes_watched\">-</p></td><td class=\"layerTable__cell--value\"><span bo-text=\"day.average_viewers | number:0\"></span><report-card value=\"{{ day.average_viewers | percentageOf: channel.average_viewers_shorterm }}\" comparison=\"{{ channel.average_viewers_shorterm }}\"></report-card></td><td class=\"layerTable__cell--value\" bo-text=\"day.peak_viewers | number\"></td><td class=\"u-tac\"><duration peeks=\"day.peek_count\"></duration></td></tr></tbody>");
$templateCache.put("app/components/game-report/_languages.html","<thead><tr><th class=\"layerTable__header\" table-sort=\"$ctrl.report.sort\" table-sort-column=\"name\" ng-click=\"$ctrl.setSort(\'name\')\" colspan=\"2\">Broadcaster Language</th><th width=\"115\" class=\"layerTable__header u-tac\" table-sort=\"$ctrl.report.sort\" table-sort-column=\"channel_count\" ng-click=\"$ctrl.setSort(\'-channel_count\')\"># of Channels</th><th width=\"125\" class=\"layerTable__header u-tac\" table-sort=\"$ctrl.report.sort\" table-sort-column=\"minutes_watched\" ng-click=\"$ctrl.setSort(\'-minutes_watched\')\">Min Watched</th><th width=\"140\" class=\"layerTable__header u-tac\" table-sort=\"$ctrl.report.sort\" table-sort-column=\"average_viewers\" ng-click=\"$ctrl.setSort(\'-average_viewers\')\">Avg Viewers</th><th width=\"125\" class=\"layerTable__header u-tac\" table-sort=\"$ctrl.report.sort\" table-sort-column=\"peak_viewers\" ng-click=\"$ctrl.setSort(\'-peak_viewers\')\">Peak Viewers</th><th width=\"125\" class=\"layerTable__header u-tac\" table-sort=\"$ctrl.report.sort\" table-sort-column=\"peek_count\" ng-click=\"$ctrl.setSort(\'-peek_count\')\">Stream Time</th><th width=\"29\" class=\"layerTable__header layerTable__header--icon u-tac u-dn\"><i class=\"ion-funnel\"></i></th></tr></thead><tbody><tr ng-repeat=\"language in $ctrl.report.data\" bindonce=\"language\" bo-class=\"{ \'is-odd\': $index%2 == 0 }\"><td class=\"layerTable__cell--type\"><i class=\"ion-mic-a\"></i></td><td class=\"layerTable__cell--title\"><h5>{{ language.name | uppercase }}</h5><p>{{ $ctrl.parent.languageFactory[language.name] ? $ctrl.parent.languageFactory[language.name] : language.name }}</p></td><td class=\"layerTable__cell--value\"><span ng-bind=\"language.channel_count | number\"></span></td><td class=\"layerTable__cell--value\" uib-tooltip=\"{{ language.minutes_watched | number: 0 }}\"><span ng-bind=\"language.minutes_watched | bigNumber\"></span><p ng-show=\"$ctrl.parent.stats.minutes_watched\">{{ language.minutes_watched/$ctrl.parent.stats.minutes_watched * 100 | round: 1 }}%</p><p ng-show=\"!$ctrl.parent.stats.minutes_watched\">-</p></td><td class=\"layerTable__cell--value\"><span ng-bind=\"language.average_viewers | number:0\"></span></td><td class=\"layerTable__cell--value\" ng-bind=\"language.peak_viewers | number\"></td><td class=\"u-tac\"><duration peeks=\"language.peek_count\"></duration></td><td class=\"layerTable__cell--menu u-dn\" ng-click=\"$ctrl.parent.addFilter({ type: \'language\', value: language.name })\" uib-tooltip=\"Add Filter\" tooltip-placement=\"left\"><i class=\"ion-android-add-circle\"></i></td></tr></tbody>");
$templateCache.put("app/components/game-report/_primary_games.html","<thead><tr><th class=\"layerTable__header\" table-sort=\"$ctrl.report.sort\" table-sort-column=\"name\" ng-click=\"$ctrl.setSort(\'name\')\" colspan=\"3\">Channel\'s&nbsp;<u>Current</u>&nbsp;Primary Game</th><th width=\"125\" class=\"layerTable__header u-tac\" table-sort=\"$ctrl.report.sort\" table-sort-column=\"minutes_watched\" ng-click=\"$ctrl.setSort(\'-minutes_watched\')\">Min Watched</th><th width=\"140\" class=\"layerTable__header u-tac\" table-sort=\"$ctrl.report.sort\" table-sort-column=\"average_viewers\" ng-click=\"$ctrl.setSort(\'-average_viewers\')\">Avg Viewers</th><th width=\"125\" class=\"layerTable__header u-tac\" table-sort=\"$ctrl.report.sort\" table-sort-column=\"channel_count\" ng-click=\"$ctrl.setSort(\'-channel_count\')\"># of Channels</th><th width=\"125\" class=\"layerTable__header u-tac\" table-sort=\"$ctrl.report.sort\" table-sort-column=\"peek_count\" ng-click=\"$ctrl.setSort(\'-peek_count\')\">Stream Time</th></tr></thead><tbody class=\"u-animate--loadingOpacity\"><tr ng-repeat=\"game in $ctrl.report.data\" bindonce=\"game\" bo-class=\"{ \'is-odd\': $index%2 == 0 }\"><td class=\"layerTable__cell--type\"><i class=\"ion-ios-game-controller-b\"></i></td><td class=\"layerTable__cell--boxArt\" width=\"60\"><ns-image height=\"54\" width=\"44\" class=\"u-fl u-ofh\" ui-sref=\"app.game.report({ slug: game.title })\" ns-image-src=\"{{ game.title | urlBoxart:190:138 }}\"></ns-image></td><td class=\"layerTable__cell--title\"><h5><a ui-sref=\"app.game.report({ slug: game.title })\">{{ game.title }}</a></h5></td><td class=\"layerTable__cell--value\" uib-tooltip=\"{{ game.minutes_watched | number: 0 }}\"><span ng-bind=\"game.minutes_watched | bigNumber\"></span><p ng-show=\"$ctrl.parent.stats.minutes_watched\">{{ game.minutes_watched/$ctrl.parent.stats.minutes_watched * 100 | round: 1 }}%</p><p ng-show=\"!$ctrl.parent.stats.minutes_watched\">-</p></td><td class=\"layerTable__cell--value\"><span ng-bind=\"game.average_viewers | number:0\"></span><report-card value=\"{{ game.average_viewers | percentageOf: game.average_viewers_shorterm }}\" comparison=\"{{ game.average_viewers_shorterm }}\"></report-card></td><td class=\"layerTable__cell--value\" ng-bind=\"game.channel_count | number\"></td><td class=\"u-tac\"><duration peeks=\"game.peek_count\"></duration></td></tr></tbody>");
$templateCache.put("app/components/game-report/_streams.html","<thead><tr><th class=\"layerTable__header\"></th><th width=\"200\" class=\"layerTable__header\" table-sort=\"$ctrl.report.sort\" table-sort-column=\"pulled_at\" ng-click=\"$ctrl.setSort(\'-pulled_at\')\">Start Time</th><th class=\"layerTable__header\" colspan=\"2\">Channel</th><th width=\"95\" class=\"layerTable__header u-tac\" table-sort=\"$ctrl.report.sort\" table-sort-column=\"peak_viewers\" ng-click=\"$ctrl.setSort(\'-peak_viewers\')\">Peak Viewers</th><th width=\"115\" class=\"layerTable__header u-tac\" table-sort=\"$ctrl.report.sort\" table-sort-column=\"average_viewers\" ng-click=\"$ctrl.setSort(\'-average_viewers\')\">Avg Viewers</th><th width=\"86\" class=\"layerTable__header u-tac\" table-sort=\"$ctrl.report.sort\" table-sort-column=\"peek_count\" ng-click=\"$ctrl.setSort(\'-peek_count\')\">Duration</th><th width=\"60\" class=\"layerTable__header u-tac\">More</th></tr></thead><tbody><tr ng-repeat-start=\"stream in $ctrl.report.data\" bindonce=\"stream\" bo-class=\"{ \'is-odd\': $index%2 == 0, \'is-live\': (stream.channel.is_live && $index === 0), \'is-open\': activeStream === stream }\"><td class=\"layerTable__cell--type\" width=\"30\"><i class=\"ion-ios-recording\"></i></td><td class=\"layerTable__cell--title\"><h5 uib-tooltip=\"{{ stream.pulled_at | dateUtcToLocal | dateToTimeAgo }}\" tooltip-placement=\"left\" bo-text=\"stream.pulled_at | dateUtcToLocal | dateToFormat: \'l LT\'\"></h5><p bo-if=\"stream.stream.broadcast_platform === \'watch_party\'\" uib-tooltip=\"Vodcast (Not Live)\"><i class=\"ion-refresh\"></i></p><p bo-text=\"stream.stream.pulled_at | dateUtcToLocal | dateToFormat: \'ddd\'\"></p><p><ion class=\"ion-pound\"></ion><span bo-text=\"stream.twitch_stream_id | dashedNumber\"></span></p></td><td class=\"layerTable__cell--logo\" width=\"50\"><ns-image height=\"50\" width=\"50\" ui-sref=\"app.channel({ channel: stream.channel.name, platform: \'twitch\' })\" ns-image-src=\"{{ stream.channel.logo || \'/assets/images/blank-user.png\' }}\"></ns-image></td><td class=\"layerTable__cell--title\"><h5 class=\"u-ellipsis\" style=\"max-width: 170px;\"><ns-live-dot bo-if=\"stream.channel.is_live\" ns-live-dot-peek=\"stream.channel.is_live\" ns-live-dot-game=\"{{ game.title }}\"></ns-live-dot><a class=\"u-invisibleLink\" ui-sref=\"app.channel({ channel: stream.channel.name, platform: \'twitch\' })\" bo-text=\"stream.channel.display_name\"></a></h5><p><i class=\"ion-heart\"></i> <span bo-text=\"stream.channel.followers | bigNumber\"></span></p></td><td class=\"layerTable__cell--value\" bo-text=\"stream.peak_viewers | bigNumber\"></td><td class=\"layerTable__cell--value\"><span bo-text=\"stream.average_viewers | bigNumber:0\"></span><report-card value=\"{{ stream.average_viewers | percentageOf: stream.channel.average_viewers_shorterm }}\" comparison=\"{{ stream.channel.average_viewers_shorterm }}\"></report-card></td><td class=\"u-tac\"><duration start=\"stream.pulled_at\" end=\"stream.ended_at\"></duration></td><td class=\"layerTable__cell--more\" ng-click=\"$ctrl.showStreamBreakdown(stream)\" ng-class=\"{ \'is-active\': $ctrl.activeStreamBreakdown === stream, \'is-disabled\': stream.peek_count < 2 }\"><i class=\"ion-stats-bars\"></i> <i class=\"ion-android-close\"></i></td></tr><tr ng-repeat-end=\"\"><td colspan=\"8\" ng-if=\"$ctrl.activeStreamBreakdown === stream\" class=\"layerTable__cell--drawer\"><stream-breakdown channel=\"stream.channel\" stream-id=\"{{ stream.twitch_stream_id }}\"></stream-breakdown></td></tr></tbody>");
$templateCache.put("app/components/game-report/game-report-table.html","<div class=\"u-animate--loadingOpacity\" ng-class=\"{ \'u-opacity--5\': $ctrl.parent.reportLoading, \'u-noClick\': $ctrl.parent.reportLoading }\" ng-show=\"$ctrl.parent.selectedReport.name === $ctrl.report.name\" ng-cloak=\"\"><table class=\"layerTable\" ng-include=\"\'app/components/game-report/_\' + $ctrl.report.template + \'.html\'\"></table></div>");
$templateCache.put("app/components/game-report/game-report.html","<div class=\"base base--margin\" ng-if=\"1===2\"><div class=\"base-cap base-cap--date base-cap--padded\"><ns-section-dot ns-section-dot-icon=\"ion-android-calendar\" ns-section-dot-loading=\"$ctrl.loading || $ctrl.reportLoading || $ctrl.peeksLoading\"></ns-section-dot><ns-date-range ns-date-range-loading=\"$ctrl.loading || $ctrl.reportLoading || $ctrl.peeksLoading\" ns-date-range-dates=\"$ctrl.dates\"></ns-date-range></div>{{ $ctrl.dates.start }}<br>{{ $ctrl.dates.end }}</div><div class=\"gameReport layer u-paddingBottom--20\"><h2 class=\"layerCap layerCap--range layerCap--noInner\"><div class=\"layerCap__aside layerCap__aside--export\" ng-click=\"$ctrl.exportPeeks()\" ng-class=\"{ \'is-disabled\': $ctrl.rawPeeks.length < 1 || $ctrl.peeksLoading }\"><i class=\"icon--export ion-android-download\"></i> Export</div><ns-section-dot ns-section-dot-icon=\"ion-android-calendar\" ns-section-dot-loading=\"$ctrl.loading || $ctrl.reportLoading || $ctrl.peeksLoading\"></ns-section-dot><ns-range ns-range-start=\"$ctrl.start\" ns-range-end=\"$ctrl.end\" ns-range-preset=\"0\" ns-range-callback=\"$ctrl.applyRange\" ns-range-changed=\"$ctrl.changed\" ns-range-loading=\"$ctrl.loading || $ctrl.reportLoading || $ctrl.peeksLoading\" ns-range-selected=\"$ctrl.selectedRange\"></ns-range></h2><div sticky=\"\" offset=\"77\" sticky-class=\"reportFilter--sticky\" ng-if=\"$ctrl.filter\"><div class=\"reportFilter\" ng-if=\"$ctrl.filter.type === \'channel\'\"><i class=\"ion-funnel funnel\"></i> <b>Showing Only</b> <i class=\"ion-person u-marginLeft--5 u-marginRight--5 u-fontOpacity--3\"></i> {{ $ctrl.filter.display }}\'s Broadcasts <a class=\"clear\" ng-click=\"$ctrl.clearFilter()\"><i class=\"ion-close\"></i> Clear</a></div><div class=\"reportFilter\" ng-if=\"$ctrl.filter.type === \'language\'\"><i class=\"ion-funnel funnel\"></i> <b>Showing Only</b> <i class=\"ion-mic-a u-marginLeft--5 u-marginRight--5 u-fontOpacity--3\"></i> {{ $ctrl.languageFactory[$ctrl.filter.value] ? $ctrl.languageFactory[$ctrl.filter.value] : $ctrl.filter.value }} <span ng-if=\"$ctrl.languageFactory[$ctrl.filter.value]\">({{ $ctrl.filter.value | uppercase }}) Broadcasts</span> <a class=\"clear\" ng-click=\"$ctrl.clearFilter()\"><i class=\"ion-close\"></i> Clear</a></div></div><ns-stats class=\"u-separatorBorder--bottom\" ng-class=\"{ \'u-separatorBorder--top\': $ctrl.filter }\"><ns-stats-item ng-class=\"{ \'is-link\': !$ctrl.isDay }\" ng-click=\"$ctrl.isDay || $ctrl.chart.changeMetric($ctrl.chart.metrics[0])\" ns-stats-item-value=\"($ctrl.stats.minutes_watched || 0) | bigNumber\" ns-stats-item-loading=\"$ctrl.peeksLoading\" ns-stats-item-title=\"Minutes Watched\" tooltip-enable=\"$ctrl.stats.minutes_watched\" uib-tooltip-html=\"($ctrl.stats.minutes_watched | number) + \' min <br>\' + ($ctrl.stats.hours_watched | number) + \' hr\'\"></ns-stats-item><ns-stats-item ng-class=\"{ \'is-link\': !$ctrl.isDay }\" ng-click=\"$ctrl.isDay || $ctrl.chart.changeMetric($ctrl.chart.metrics[5])\" ns-stats-item-value=\"($ctrl.stats.peak_viewers || 0) | number\" ns-stats-item-loading=\"$ctrl.peeksLoading\" ns-stats-item-title=\"Peak Viewers\"></ns-stats-item><ns-stats-item ng-class=\"{ \'is-link\': !$ctrl.isDay }\" ng-click=\"$ctrl.isDay || $ctrl.chart.changeMetric($ctrl.chart.metrics[1])\" ns-stats-item-value=\"($ctrl.stats.minutes_streamed || 0 ) | durationToTimestamp: \'m\'\" ns-stats-item-loading=\"$ctrl.peeksLoading\" ns-stats-item-title=\"Stream Time\"></ns-stats-item><ns-stats-item ng-class=\"{ \'is-link\': !$ctrl.isDay }\" ng-click=\"$ctrl.isDay || $ctrl.chart.changeMetric($ctrl.chart.metrics[3])\" ns-stats-item-value=\"($ctrl.stats.average_viewers || 0) | number: 0\" ns-stats-item-title=\"Average Viewership\" ns-stats-item-loading=\"$ctrl.peeksLoading\"></ns-stats-item></ns-stats><div class=\"layer__hPadding\"><ns-chart ng-hide=\"$ctrl.showTopTen\" ns-chart-config=\"($ctrl.isDay) ? $ctrl.chartDay : $ctrl.chart\" ns-chart-data=\"$ctrl.peeks\" ns-chart-loading=\"$ctrl.peeksLoading\" ns-chart-empty=\"No Activity in this Range\"></ns-chart><h2 class=\"layerCap u-separatorBorder--top\"><div class=\"layerCap__aside layerCap__aside--export u-paddingRight--35\" ng-click=\"$ctrl.selectedReport.doExport()\" ng-class=\"{ \'is-disabled\': !$ctrl.selectedReport || $ctrl.reportLoading || $ctrl.selectedReport.data.length === 0 || $ctrl.selectedReport.total > 100000 }\"><i ng-show=\"$ctrl.selectedReport.total > 100000\" class=\"icon--export ion-close\"></i> <span ng-show=\"$ctrl.selectedReport.total > 100000\">Too Large</span> <i ng-hide=\"$ctrl.selectedReport.total > 100000\" class=\"icon--export ion-android-download\"></i> <span ng-hide=\"$ctrl.selectedReport.total > 100000\">Export</span></div><ul class=\"layerCap__tabs\"><li ng-repeat=\"report in $ctrl.reports\" ng-class=\"{ \'is-active\': report.active, \'is-disabled\': $ctrl.reportLoading }\" ng-click=\"$ctrl.changeTab(report)\"><ns-section-dot ns-section-dot-icon=\"{{ report.icon }}\" ns-section-dot-loading=\"report.loading\"></ns-section-dot>{{ report.display }}</li></ul></h2><p class=\"u-paddingTop--30 u-hPadding--20 u-paddingBottom--10\" ng-if=\"!$ctrl.selectedReport && !$ctrl.reportLoading\" style=\"font-size: 15px; color: #777\">Select a Dimension Above</p><div ng-if=\"$ctrl.selectedReport.data && $ctrl.selectedReport.data[0] && $ctrl.selectedReport.data[0].is_bucket\" class=\"bucketedMessage\">Showing full, 24 hour days in ({{ ($ctrl.selectedReport.data[0].bucket_offset === \'-8\') ? \'PST\' : ($ctrl.selectedReport.data[0].bucket_offset === \'8\') ? \'CST\' : \'GMT\' }}) <i class=\"ion-help\" uib-tooltip=\"When selecting a date range longer than 2 days, we default to looking at full days at predefined timezones to decrease load times.\"></i></div><game-report-table ng-repeat=\"report in $ctrl.reports\" report=\"report\" template=\"_{{ report.template }}\"></game-report-table><div class=\"u-tac u-paddingTop--40 u-paddingBottom--25\" ng-class=\"{ \'u-separatorBorder--top\': $ctrl.selectedReport }\" ng-show=\"$ctrl.reportLoading && (!$ctrl.selectedReport.data || $ctrl.selectedReport.data.length === 0)\"><span class=\"wait wait--dark\"></span></div><p class=\"u-tac u-paddingTop--30 u-paddingBottom--15 u-separatorBorder--top\" ng-if=\"!$ctrl.reportLoading && $ctrl.selectedReport.data && $ctrl.selectedReport.data.length == 0\" style=\"font-size: 14px; color: #777\">No Activity in this Range</p><div class=\"u-paddingTop--20\" ng-hide=\"!$ctrl.selectedReport || $ctrl.selectedReport.total <= 8\"><ns-pagination ns-pagination-loading=\"$ctrl.selectedReport.loading\" ns-pagination-page=\"$ctrl.selectedReport.page\" ns-pagination-total=\"$ctrl.selectedReport.total\" ns-pagination-limit=\"$ctrl.selectedReport.limit\" ns-pagination-change-page=\"$ctrl.changePage\" ns-pagination-change-limit=\"$ctrl.setLimit\"></ns-pagination></div></div></div>");
$templateCache.put("app/components/growth-report/growth-report.html","<div class=\"layer\"><h2 class=\"layerCap layerCap--range layerCap--noInner\"><div class=\"layerCap__aside layerCap__aside--export\" ng-click=\"doExport()\"><i class=\"icon--export ion-android-download\"></i> Export</div><ns-section-dot ns-section-dot-icon=\"ion-android-calendar\" ns-section-dot-loading=\"loading\"></ns-section-dot><ns-range ns-range-start=\"start\" ns-range-end=\"end\" ns-range-presets=\"timeline\" ns-range-preset=\"4\" ns-range-callback=\"applyRange\" ns-range-changed=\"changed\" ns-range-loading=\"loading\" ns-range-selected=\"selectedRange\" ns-no-time=\"true\"></ns-range></h2><p ng-if=\"inactive\" class=\"u-tac u-vPadding--10 u-separatorBorder--bottom globalMessage--warning u-font--small\">This channel has been inactive for more than 7 days, we\'re no longer tracking growth</p><ns-stats class=\"u-separatorBorder--bottom\"><ns-stats-item class=\"is-link\" ng-click=\"chart.changeMetric(chart.metrics[0])\" ns-stats-item-value=\"stats.average_viewers_shorterm | number: 0\" ns-stats-item-loading=\"loading\" ns-stats-item-title=\"Average Viewers\" ns-stats-item-change=\"(stats.average_viewers_shorterm > 0) ? 1 : (stats.average_viewers_shorterm < 0) ? -1 : 0\"></ns-stats-item><ns-stats-item class=\"is-link\" ng-click=\"chart.changeMetric(chart.metrics[2])\" ns-stats-item-value=\"stats.followers | bigNumber\" ns-stats-item-loading=\"loading\" ns-stats-item-title=\"Followers Gained\" ns-stats-item-change=\"(stats.followers > 0) ? 1 : (stats.followers < 0) ? -1 : 0\"></ns-stats-item><ns-stats-item class=\"is-link\" ng-click=\"chart.changeMetric(chart.metrics[3])\" ns-stats-item-value=\"stats.views | bigNumber\" ns-stats-item-loading=\"loading\" ns-stats-item-title=\"Views Gained\" ns-stats-item-change=\"(stats.views > 0) ? 1 : (stats.views < 0) ? -1 : 0\"></ns-stats-item></ns-stats><div class=\"layer__hPadding\"><ns-chart ns-chart-config=\"chart\" ns-chart-data=\"points\" ns-chart-loading=\"loading\" ns-chart-empty=\"No Activity in this Range\"></ns-chart></div></div>");
$templateCache.put("app/components/loaded-info/loaded-info.html","<div class=\"loaded-info\"><div class=\"loaded-info__content\"><h4 class=\"title\"><i class=\"ion-close\" ng-click=\"close()\"></i><div class=\"icon\"><img src=\"/assets/images/noscope-logo-black.svg\"></div>Upgrades</h4><div ng-if=\"!formOpen\"><p>We\'re doing a lot behind the scenes to make NOSCOPE a better platform. As a result you may notice a few things:</p><p><b>Some things will be faster, some things temporarily slower</b><br>You\'ll notice a lot of things loading faster, and some things slower than they used to. As we continue down our roadmap, speed across the board will be vastly improved.</p><p><b>More consistent and up-to-date data</b><br>No more random blips or dips that could show up on charts that didn\'t make sense and data much more up-to-the-minute than in previous iterations.</p><p><b>A better user experience</b><br>We\'re taking steps to improve the user experience on the platform across the board, so look out for quality-of-life changes to the UI that make using NOSCOPE easier than ever.</p><p><b>New features and data</b><br>With these changes, we\'ll also start to see new features and more ways of looking at the data. More customization, better insights, more in-depth data, etc.</p><div class=\"u-tar\"><a ng-click=\"open()\" class=\"button\">Email Us</a> <a ng-click=\"close()\" class=\"button button--ghost\">Close</a></div></div><div ng-if=\"formOpen\" style=\"padding-top: 5px;\"><div ng-if=\"done\"><div class=\"done\"><i class=\"ion-checkmark\"></i> &nbsp;We\'ll be reaching out right away!</div><div style=\"padding-top: 5px; text-align: right\"><a ng-click=\"close()\" class=\"button button--ghost\">Close</a></div></div><form ng-submit=\"contact()\" ng-if=\"!done\"><div class=\"u-paddingBottom--15\"><label><strong>Where can we reach you?</strong> <span class=\"required\">*</span></label> <input ng-class=\"{ \'is-invalid\': !validateEmail(form.email) }\" select-on-click=\"\" maxlength=\"200\" placeholder=\"you@yourcompany.com\" class=\"input\" type=\"text\" name=\"email\" ng-model=\"form.email\"><p class=\"invalid\" ng-if=\"invalid\">Please enter a valid email address</p></div><div><label><strong>Anything else we should know?</strong> (optional)</label> <textarea maxlength=\"200\" ng-model=\"form.notes\"></textarea><p class=\"remaining\">{{ 200 - form.notes.length }} characters remaining</p></div><div style=\"padding-top: 27px; text-align: right\"><div class=\"button submit\" style=\"margin: 0\" ng-click=\"letsTalk()\" ng-if=\"!done\" ng-class=\"{ \'is-loading\' : loading }\"><span ng-if=\"!loading\">Submit Request</span><div ng-if=\"loading\" class=\"wait wait--dark wait--small u-vam\"></div></div><a ng-click=\"close()\" class=\"button button--ghost\">Close</a></div></form></div></div></div>");
$templateCache.put("app/components/search/result.html","<div class=\"search__result\"><div class=\"boxart\" ng-if=\"match.model.title\" ng-style=\"{ \'background-image\': \'url(\' + (match.model.title | urlBoxart:190:138) + \')\' }\"></div><img class=\"avatar\" ng-if=\"match.model.name\" ng-src=\"{{ match.model.logo ? match.model.logo : \'/assets/images/blank-user.png\' }}\"><div class=\"inner\" ng-if=\"match.model.display_name\"><h4><span ng-bind-html=\"match.model.display_name\"></span></h4><ul class=\"sub-title\"><li ng-if=\"match.model.broadcaster_language\"><i class=\"ion-mic-a\"></i> {{ match.model.broadcaster_language }}</li><li><i class=\"ion-heart\"></i> {{ match.model.followers | bigNumber }}</li><li><i class=\"ion-person-stalker\"></i> {{ match.model.average_viewers_shorterm | bigNumber }}</li></ul></div><div class=\"inner inner--game\" ng-if=\"match.model.title\"><h4><span ng-bind-html=\"match.model.title\"></span></h4></div></div>");
$templateCache.put("app/components/search/search.html","<div class=\"search\"><div class=\"search__icon\"><i ng-hide=\"isLoading || noResults\" class=\"icon ion-search\"></i> <i ng-show=\"!isLoading && noResults\" class=\"icon--noResults ion-close\"></i><div ng-show=\"isLoading\" class=\"spinner--small\"></div></div><input class=\"search__input\" type=\"text\" ng-blur=\"blur($event)\" placeholder=\"Find a {{ types[currentSearch] }}...\" ng-model=\"resultSelected\" typeahead-focus-first=\"true\" typeahead-loading=\"isLoading\" typeahead-min-length=\"2\" typeahead-wait-ms=\"300\" typeahead-on-select=\"goTo($item)\" typeahead-template-url=\"app/components/search/result.html\" uib-typeahead=\"match for match in (doSearch($viewValue))\" typeahead-no-results=\"noResults\" set-focus=\"focus\"><ns-dropdown class=\"search__category\" ns-dropdown-display=\"title\" ns-dropdown-options=\"searchCategories\" ns-dropdown-select=\"setType\" ns-dropdown-addclass=\"search__category\">{{ types[currentSearch] }} <i class=\"icon ion-android-arrow-dropdown\"></i></ns-dropdown></div>");
$templateCache.put("app/components/search-filter/game.html","<div class=\"gameListLoading\" ng-if=\"listSearchLoading\"><div class=\"spinner--small\"></div></div><div><input class=\"d-searchFilter__input\" type=\"text\" ng-hide=\"selected.length > 0\" set-focus=\"isOpen && selected.length === 0\" ng-model=\"searchModel\" placeholder=\"Enter game title...\" typeahead-focus-first=\"true\" typeahead-min-length=\"3\" typeahead-loading=\"listSearchLoading\" typeahead-wait-ms=\"250\" typeahead-on-select=\"addToList($item, selected); searchModel = \'\';\" uib-typeahead=\"hit.title for hit in (searchGames($viewValue))\" typeahead-append-to-body=\"\"><ul class=\"d-searchFilter__games\"><li ng-repeat=\"game in selected track by $index\" class=\"single\"><bg-img image=\"{{ game.title | urlBoxart:190:138 }}\" height=\"45\" width=\"38\"></bg-img><div class=\"inner\">{{ game.title }}</div><div class=\"remove\" uib-tooltip=\"Remove\" ng-class=\"{ \'is-disabled\' : loading }\" ng-click=\"removeFromList($index, selected, game)\"><i class=\"icon ion-android-cancel\"></i></div></li></ul></div>");
$templateCache.put("app/components/search-filter/games.html","<div class=\"gameListLoading\" ng-if=\"listSearchLoading\"><div class=\"spinner--small\"></div></div><div><input class=\"d-searchFilter__input\" type=\"text\" set-focus=\"isOpen\" ng-model=\"searchModel\" placeholder=\"Enter game title...\" typeahead-focus-first=\"true\" typeahead-min-length=\"3\" typeahead-loading=\"listSearchLoading\" typeahead-wait-ms=\"250\" typeahead-on-select=\"addToList($item, selected); searchModel = \'\';\" uib-typeahead=\"hit.title for hit in (searchGames($viewValue))\" typeahead-append-to-body=\"\"><ul class=\"d-searchFilter__games\"><li ng-repeat=\"game in selected track by $index\"><bg-img image=\"{{ game.title | urlBoxart:190:138 }}\" height=\"45\" width=\"38\"></bg-img><div class=\"inner\">{{ game.title }}</div><div class=\"remove\" uib-tooltip=\"Remove\" ng-class=\"{ \'is-disabled\' : loading }\" ng-click=\"removeFromList($index, selected, game)\"><i class=\"icon ion-android-cancel\"></i></div></li></ul></div>");
$templateCache.put("app/components/search-filter/option.html","<div class=\"filter--{{ type }}\"><ul class=\"d-searchFilter__options\"><li ng-repeat=\"option in options\" ng-class=\"{ \'is-selected\': option.selected }\" ng-click=\"setOption(option)\"><i class=\"ion-android-radio-button-on check is-checked\" ng-show=\"option.selected\"></i> <i class=\"ion-android-radio-button-off check\" ng-show=\"!option.selected\"></i> {{ (option.name) ? option.name : option.title }} <span ng-if=\"option.count\" class=\"u-font--tiny u-fontOpacity--5 u-fwb\">[{{ option.count }}]</span></li></ul><p ng-if=\"options.length < 1\" class=\"u-paddingTop--10 u-font--none\">It\'s Empty...</p></div>");
$templateCache.put("app/components/search-filter/range.html","<div class=\"filter--{{ type }}\"><form ng-submit=\"setRange(selected.min, selected.max)\"><input class=\"d-searchFilter__input\" type=\"number\" maxlength=\"10\" set-focus=\"isOpen\" placeholder=\"Minimum\" ng-model=\"selected.min\" min=\"0\"> <i class=\"icon ion-android-remove d-searchFilter__rangeBetween\"></i> <input class=\"d-searchFilter__input\" type=\"number\" maxlength=\"10\" placeholder=\"Maximum\" ng-model=\"selected.max\" min=\"0\"><div><button type=\"submit\" class=\"button-a--full\" ng-class=\"{ \'u-cw is-loading\' : loading }\"><div class=\"spinner--small--dark\"></div>Apply</button> <button class=\"button-b--full remove\" ng-click=\"setRange(); selected.min = \'\'; selected.max = \'\';\" uib-tooltip=\"Clear\">Clear</button></div></form></div>");
$templateCache.put("app/components/search-filter/search-filter.html","<div class=\"d-searchFilter\"><h4 class=\"title\" ng-click=\"isOpen = (isOpen) ? false : true;\"><i class=\"icon ion-checkmark-circled checked\" ng-class=\"{ \'is-checked\': selected.length > 0 || selected.min || selected.max || selectedOption }\"></i> <i class=\"icon ion-android-add\" ng-hide=\"isOpen\"></i> <i class=\"icon ion-android-remove\" ng-show=\"isOpen\"></i> {{ title }} <span ng-show=\"selected.length >= 1\" class=\"subtitle\">[ {{ selected.length }} ]</span> <span ng-show=\"type === \'range\' && (selected.min || selected.max)\" class=\"subtitle\">[ <span ng-show=\"selected.min\">{{ selected.min | bigNumber }}</span> <span ng-show=\"!selected.min\">0</span> - <span ng-show=\"selected.max\">{{ selected.max | bigNumber }}</span><span ng-show=\"!selected.max\"><i class=\"ion-ios-infinite\"></i></span> ]</span></h4><div ng-show=\"isOpen\" class=\"d-searchFilter__filter\" ng-include=\"\'app/components/search-filter/\' + type + \'.html\'\"></div></div>");
$templateCache.put("app/components/search-filter/tag.html","<div class=\"gameListLoading\" ng-if=\"listSearchLoading\"><div class=\"spinner--small\"></div></div><div><input type=\"text\" maxlength=\"20\" ng-model=\"searchModel\" placeholder=\"Enter Tag\" typeahead-focus-first=\"true\" typeahead-min-length=\"1\" typeahead-loading=\"searchLoading\" typeahead-wait-ms=\"0\" typeahead-on-select=\"addTag($item); searchModel = \'\';\" uib-typeahead=\"hit.name for hit in (searchTags($viewValue))\"><ul><li ng-repeat=\"tag in selectedTags track by $index\">{{ tag.name }}</li></ul></div>");
$templateCache.put("app/components/stream-breakdown/stream-breakdown.html","<div class=\"layer streamBreakdown\"><div class=\"layer__hPadding u-paddingBottom--15\"><h2 class=\"layerCap\"><div class=\"layerCap__aside layerCap__aside--button\" ng-if=\"hasVod\" ng-click=\"openVod()\"><i class=\"icon ion-play\"></i> Play Vod</div><span class=\"layerCap__aside u-fontOpacity--4\" ng-show=\"hasVod === false\">VOD Not Found</span> <span class=\"layerCap__aside\" ng-show=\"hasVod !== false && !hasVod\"><div class=\"wait wait--small wait--dark u-vam u-marginRight--10 u-paddingLeft--10\"></div>Searching for VODs</span><ns-section-dot ns-section-dot-icon=\"ion-mic-c\" ns-section-dot-loading=\"chartConfig.loading\"></ns-section-dot><span ng-if=\"type === \'segment\'\">{{ segementStart | dateToFormat: \'ddd l : LT\' }} <span class=\"layerCap__betweenDates\">through</span> {{ segementEnd | dateToFormat: \'ddd l : LT\' }}</span> <span ng-if=\"type === \'broadcast\'\"><i class=\"ion-pound u-fontOpacity--4\"></i> {{ stream.id | dashedNumber }} <span class=\"layerCap__also\">{{ segmentStart | dateUtcToLocal | dateToFormat: \'l : LT\' }}\'s Broadcast</span></span> <span ng-if=\"type === \'broadcast_segment\'\"><span uib-tooltip=\"This broadcast is being cut-off by your selected date range.\"><i class=\"ion-pound u-fontOpacity--4\"></i> {{ stream.id | dashedNumber }} <i class=\"ion-scissors u-fontOpacity--4\"></i> Cut-Off</span> <span class=\"layerCap__also\">{{ segmentStart | dateUtcToLocal | dateToFormat: \'l : LT\' }} <span class=\"layerCap__betweenDates\">-</span> {{ segmentEnd | dateUtcToLocal | dateToFormat: \'l : LT\' }}</span></span><div class=\"layerCap__others\"><i class=\"ion-plus\"></i> <span ng-if=\"type === \'segment\'\">This Segment is made up of {{ streamCount }} Stream<span ng-hide=\"streamCount === 1\">s</span></span> <span ng-if=\"type === \'broadcast\'\">This Full Broadcast is made up of {{ streamCount }} Stream<span ng-hide=\"streamCount === 1\">s</span> <a class=\"u-fr u-invisibleLink u-cp\" ng-if=\"fromSegment\" ng-click=\"segment()\"><i class=\"ion-arrow-left-a\"></i> Back to Segment</a></span> <span ng-if=\"type === \'broadcast_segment\'\">This Broadcast Segment is made up of {{ streamCount }} Stream<span ng-hide=\"streamCount === 1\">s</span> - {{ missing | durationToTimestamp: \'s\' }} missing <a class=\"u-fr u-invisibleLink u-cp\" ng-click=\"fullBroadcast()\">View Full Broadcast</a></span></div></h2><highchart config=\"chartConfig\"></highchart><h2 class=\"layerCap layerCap--borderTop\"><div class=\"layerCap__aside layerCap__aside--export\" ng-click=\"exportGames()\" ng-class=\"{ \'is-disabled\': games.length < 1 }\"><i class=\"icon--export ion-android-download\"></i> Export</div><ns-section-dot ns-section-dot-icon=\"ion-ios-game-controller-a\" ns-section-dot-loading=\"chartConfig.loading\"></ns-section-dot>{{ games.length }} Game<span ng-hide=\"games.length == 1\">s</span> Played</h2><table class=\"layerTable layerTable--small\"><thead><tr><th class=\"layerTable__header\" ng-click=\"changeSort(\'title\')\" table-sort=\"sort\" table-sort-column=\"title\" colspan=\"2\">Title</th><th width=\"120\" class=\"layerTable__header u-tac\" ng-click=\"changeSort(\'minutes_watched\')\" table-sort=\"sort\" table-sort-column=\"minutes_watched\">Min Watched</th><th width=\"100\" class=\"layerTable__header u-tac\" ng-click=\"changeSort(\'peek_count\')\" table-sort=\"sort\" table-sort-column=\"peek_count\">Time Played</th><th width=\"140\" class=\"layerTable__header u-tac\" ng-click=\"changeSort(\'average_viewers\')\" table-sort=\"sort\" table-sort-column=\"average_viewers\">Average Viewers</th><th width=\"100\" class=\"layerTable__header u-tac\" ng-click=\"changeSort(\'peak_viewers\')\" table-sort=\"sort\" table-sort-column=\"peak_viewers\">Peak Viewers</th></tr></thead><tbody><tr ng-if=\"!peeks\"><td colspan=\"7\" class=\"u-tac\"><div class=\"wait\"></div></td></tr><tr ng-class=\"{ \'is-odd\': $index%2 === 0 }\" ng-repeat=\"game in games | orderBy: sort\"><td class=\"layerTable__void streamBreakdown__boxArt\" width=\"50\" ng-style=\"{ backgroundColor: colorMap[game.id].color }\" valign=\"top\"><ns-image height=\"58\" width=\"50\" ui-sref=\"app.game.report({ slug: game.title })\" ns-image-src=\"{{ game.title | urlBoxart:190:138 }}\">{{ (game.peek_count/peeks.length) * 100 | round }}%</ns-image></td><td class=\"layerTable__cell--title streamBreakdown__gameTitle\"><h5>{{ game.title }}</h5></td><td class=\"u-tac layerTable__cell--value\" uib-tooltip=\"{{ game.minutes_watched | round: 0 | number }}\">{{ game.minutes_watched | round: 0 | bigNumber }}</td><td class=\"u-tac\"><duration peeks=\"game.peek_count\"></duration></td><td class=\"layerTable__cell--value\">{{ game.average_viewers | number:0 }}<report-card ng-if=\"channel.average_viewers_shorterm\" value=\"{{ game.average_viewers | percentageOf: channel.average_viewers_shorterm }}\" comparison=\"{{ channel.average_viewers_shorterm }}\"></report-card></td><td class=\"layerTable__cell--value\">{{ game.peak_viewers | number:0 }}</td></tr></tbody></table></div></div>");
$templateCache.put("app/components/stream-breakdown/vod.html","<div class=\"vod\"><div class=\"vod__close button button--small\" ng-click=\"cVod.close()\"><i class=\"ion-close\"></i> Close</div><div id=\"vod\" class=\"d-streamBreakdown__vodContainer\" ng-style=\"{ height: cVod.height - 68 + \'px\' }\" ng-class=\"{ \'is-loading\': cVod.loading }\"></div><div class=\"d-streamBreakdown__vodInfo js-vodInfo\" ng-style=\"{ marginLeft: cVod.infoMargin + \'px\', marginTop: -(cVod.info.height + 12) + \'px\', borderColor: cVod.map[cVod.infoPeek.twitch_game_id].color }\" ng-class=\"{ \'is-noArrow\': cVod.info.noArrow }\" ng-show=\"cVod.infoPeek\"><bg-img class=\"u-fl\" height=\"60\" width=\"46\" image=\"{{ cVod.infoPeek.twitch_game.title | urlBoxart:190:138 }}\"></bg-img><h4 class=\"title\">{{ cVod.infoPeek.twitch_game.title }}</h4><p class=\"subtitle\">{{ cVod.infoPeek.viewers | number }} Viewers</p><p class=\"timestamp\">{{ cVod.infoPeek.pulled_at | dateUtcToLocal | dateToCalendar }}</p></div><div class=\"vod__behind\" ng-if=\"!cVod.loading && cVod.seekOffset() <= -2\"><i class=\"ion-arrow-left-a\"></i></div><div class=\"vod__ahead\" ng-if=\"!cVod.loading && cVod.seekOffset() > cVod.width\"><i class=\"ion-arrow-right-a\"></i></div><div class=\"d-streamBreakdown__vodMapContainer\" ng-hide=\"cVod.loading\"><svg class=\"vod__map\" height=\"40\" width=\"100%\"><rect ng-repeat=\"peek in cVod.peeks\" ng-attr-x=\"{{ peek.distance }}\" y=\"0\" ng-style=\"{ width: 1, height: 70 }\" ng-if=\"peek.distance >= cVod.activeVod.offset && peek.distance <= cVod.activeVod.offset+cVod.activeVod.size\" style=\"fill:rgba(255,255,255,.075); height: 66px;\"></rect><rect style=\"height: 66px;\" class=\"d-streamBreakdown__vodMap__section\" ng-repeat=\"peek in cVod.peeks\" ng-attr-x=\"{{ peek.distance }}\" y=\"0\" ng-style=\"{ width: peek.width }\" ng-click=\"cVod.seekTo(peek)\" ng-mouseover=\"cVod.showInfo(peek)\" ng-mouseleave=\"cVod.showInfo(false)\" ng-if=\"peek.distance >= cVod.activeVod.offset && peek.distance <= cVod.activeVod.offset+cVod.activeVod.size\"></rect><rect ng-attr-x=\"{{ cVod.vod.postOffset }}\" y=\"0\" ng-style=\"{ width: cVod.vod.postLength, height: 68 }\" ng-if=\"1==2\" style=\"fill: rgba(34,34,34,0.85); stroke: #444;\"></rect><rect class=\"vod__continuation\" ng-if=\"cVod.activeVod._id !== cVod.vod._id\" ng-attr-x=\"{{ cVod.vod.offset }}\" ng-click=\"cVod.changeVod(cVod.vod)\" y=\"3\" rx=\"3\" ry=\"3\" ng-style=\"{ width: cVod.vod.size-2 }\" style=\"height: 55px;\"></rect><rect class=\"vod__continuation\" ng-repeat=\"stream in cVod.streams\" ng-attr-x=\"{{ cVod.streamMap[stream].vod.offset }}\" ng-click=\"cVod.changeVod(cVod.streamMap[stream].vod)\" ng-if=\"cVod.streamMap[stream] && cVod.streamMap[stream].vod._id !== cVod.activeVod._id\" y=\"3\" rx=\"3\" ry=\"3\" ng-style=\"{ width: cVod.streamMap[stream].vod.size-2 }\" style=\"height: 55px;\"></rect><text class=\"vod__continuationTitle\" ng-repeat=\"stream in cVod.streams\" ng-attr-x=\"{{ cVod.streamMap[stream].vod.offset + 5 }}\" ng-if=\"cVod.streamMap[stream] && cVod.streamMap[stream].vod._id !== cVod.activeVod._id\" y=\"16\" font-size=\"10\" style=\"fill: rgba(255,255,255,0.7);\">#{{$index+1}}</text><rect class=\"vod__seekIndicator\" ng-if=\"!cVod.loading\" ng-attr-x=\"{{ cVod.seekOffset() }}\" y=\"0\" ng-style=\"{ width: 2, height: 100 }\" style=\"fill: #eee;\"></rect><rect ng-repeat=\"peek in cVod.peeks\" ng-attr-x=\"{{ peek.distance }}\" ng-style=\"{ width: peek.width, height: 6 }\" y=\"63\" style=\"fill:{{ cVod.map[peek.twitch_game_id].color }};\"></rect><path ng-attr-d=\"{{ cVod.lineString }}\" class=\"vod__line\" stroke=\"#B18DEC\" stroke-width=\"3\" fill=\"none\"></path></svg></div><div class=\"vod__loadingPeeks\" ng-if=\"cVod.loading\"><uib-progressbar ng-if=\"cVod.streams.length > 1\" max=\"cVod.streams.length\" value=\"cVod.vodsPulled.length\"><span>{{ (cVod.vodsPulled.length/cVod.streams.length)*100 | round: \'0\' }}%</span></uib-progressbar><div ng-if=\"cVod.streams.length < 2 || !cVod.streams\" class=\"wait wait--black\"></div></div></div>");
$templateCache.put("app/components/tagger/tagger.html","<div class=\"layer u-marginBottom--50\"><div class=\"layer__inner u-paddingBottom--20\"><h3 class=\"layerCap\"><ns-section-dot ns-section-dot-icon=\"ion-pricetag\" ns-section-dot-loading=\"loading\"></ns-section-dot>{{ tags.length }} Tag<span ng-hide=\"tags.length === 1\">s</span></h3><ul bindonce=\"tags\" class=\"tags\"><li class=\"tags__tag\" ng-repeat=\"tag in tags\" ng-class=\"{ \'is-hidden\': tag.hidden }\"><a ui-sref=\"app.channels({ sort: \'name\', page: 1, query: \'(has_tag$\' + tag.name + \')\' })\" bo-text=\"tag.name\" class=\"u-invisibleLink\"></a> <i class=\"ion-close\" ng-show=\"tag.id\" ng-click=\"delete(tag)\"></i><div class=\"tags__loading\" ng-if=\"!tag.id\"><span class=\"wait wait--small\"></span></div></li></ul><form ng-submit=\"addTag(tagModel)\"><input type=\"text\" class=\"input\" ns-hiding-label=\"\" no-special-chars=\"\" maxlength=\"20\" ng-model=\"tagModel\" placeholder=\"Add a Tag\" typeahead-focus-first=\"false\" typeahead-min-length=\"1\" typeahead-loading=\"searchLoading\" typeahead-wait-ms=\"0\" typeahead-on-select=\"addTag(tagModel)\" uib-typeahead=\"tag.name for tag in tagList | filter:$viewValue | limitTo:8\" typeahead-append-to-body=\"\"></form></div></div>");
$templateCache.put("app/components/terms/terms.html","<div class=\"terms\"><a class=\"button-a--small u-fr\" ng-click=\"close()\"><i class=\"ion-close\"></i> Close</a><h3>Terms of Service</h3><div class=\"terms__container\"><p ng-bind-html=\"terms.copy | unsafe\"></p></div></div>");
$templateCache.put("app/components/work-with/work-with.html","<div class=\"work-with layer\"><div class=\"button\" ng-click=\"toggle()\" ng-if=\"!isOpen\"><span ng-if=\"!loading\">Let\'s Talk</span><div ng-if=\"loading\" class=\"wait wait--dark wait--small u-vam\"></div></div><i class=\"ion-close work-with__close\" ng-if=\"isOpen && !done\" ng-click=\"toggle()\"></i> <img class=\"loaded\" src=\"/assets/images/loaded/emblem-noscope.svg\"> <span class=\"max\">Wanna\' work with {{ channel.display_name }}?</span><div ng-if=\"isOpen\" class=\"work-with__container u-separatorBorder--top\"><div class=\"success\" ng-if=\"done\"><span>We\'ll be reaching out right away!</span></div><form ng-submit=\"contact()\" ng-if=\"!done\"><div class=\"u-paddingBottom--15\"><label><strong>Where can we reach you?</strong> <span class=\"required\">*</span></label> <input ng-class=\"{ \'is-invalid\': !validateEmail(form.email) }\" select-on-click=\"\" maxlength=\"200\" placeholder=\"you@yourcompany.com\" class=\"input\" type=\"text\" name=\"email\" ng-model=\"form.email\"><p class=\"invalid\" ng-if=\"invalid\">Please enter a valid email address</p></div><div><label><strong>Anything else we should know?</strong> (optional)</label> <textarea maxlength=\"200\" ng-model=\"form.notes\"></textarea><p class=\"work-with__remaining\">{{ 200 - form.notes.length }} characters remaining</p></div><div><div class=\"button submit\" ng-click=\"contact()\" ng-if=\"!done\" ng-class=\"{ \'is-loading\' : loading }\"><span ng-if=\"!loading\">Submit Request</span><div ng-if=\"loading\" class=\"wait wait--dark wait--small u-vam\"></div></div></div></form></div></div>");
$templateCache.put("app/pages/changelog/changelog.html","<div class=\"p-changelog\"><div class=\"layer\"><div class=\"layer__inner\"><h2 class=\"layerCap\"><ns-section-dot ns-section-dot-icon=\"icon ion-clipboard\"></ns-section-dot>Changelogs</h2><div class=\"changelog\" ng-repeat=\"changelog in cChangelog.changelogs\"><h3><span class=\"date\">{{ changelog.created_at | dateUtcToLocal | dateToSince }}</span> <span ng-if=\"changelog.id > cChangelog.newAfter\" class=\"newTag\">New</span> {{ changelog.title }}</h3><p ng-bind-html=\"changelog.copy | unsafe\"></p></div></div></div></div>");
$templateCache.put("app/pages/channel/channel.html","<div class=\"u-columns\"><div class=\"u-columns__column--4\"><channel-card channel=\"cChannel.channel\" stream=\"cChannel.stream\"></channel-card><channel-game-profile channel=\"cChannel.channel\" limit=\"7\"></channel-game-profile><tagger model=\"cChannel.channel\"></tagger></div><div class=\"u-columns__column--8\"><channel-live channel=\"cChannel.channel\"></channel-live><ul class=\"tabNav\" ng-init=\"cChannel.tab = \'performance\'\"><li ng-class=\"{ \'is-active\': cChannel.tab ==\'performance\' }\" ng-click=\"cChannel.tab = \'performance\';\"><i class=\"ion-speedometer\"></i> Performance</li><li ng-class=\"{ \'is-active\': cChannel.tab ==\'growth\' }\" ng-click=\"cChannel.tab = \'growth\'\"><i class=\"ion-arrow-graph-up-right\"></i> Growth</li></ul><growth-report ng-show=\"cChannel.tab === \'growth\'\" class=\"layer--hasTabNav\" channel=\"cChannel.channel\"></growth-report><channel-report ng-show=\"cChannel.tab === \'performance\'\" class=\"layer--hasTabNav\" channel=\"cChannel.channel\"></channel-report></div></div>");
$templateCache.put("app/pages/game/_report.html","<game-report game=\"cGame.game\"></game-report>");
$templateCache.put("app/pages/game/game.html","<admin-bar-game game=\"cGame.game\"></admin-bar-game><div class=\"u-columns\"><div class=\"u-columns__column--4\"><game-card game=\"cGame.game\"></game-card></div><div class=\"u-columns__column--8\"><game-live game=\"cGame.game\"></game-live><div ui-view=\"\" autoscroll=\"false\"></div></div></div>");
$templateCache.put("app/pages/reset-password/gate.html","<div class=\"l-login\"><form class=\"loginForm layer\" ng-submit=\"cForgotPasswordGate.next()\"><div class=\"loginForm__inner layer__inner\"><h2 class=\"layerCap\"><img class=\"loginForm__logo\" alt=\"Loaded\" src=\"/assets/images/loaded/logo.svg\"></h2><div class=\"loginForm__field\" ng-if=\"!cForgotPasswordGate.expired\"><input name=\"email\" ns-hiding-label=\"\" type=\"text\" placeholder=\"Enter your email address\" ng-model=\"cForgotPasswordGate.email\" autofocus=\"\"></div><div ng-if=\"cForgotPasswordGate.expired\" class=\"u-tac u-paddingTop--15\">Your request has expired.</div></div><div ng-if=\"cForgotPasswordGate.invalid\" class=\"loginForm__message is-shown\">Invalid Email Address</div><div ng-if=\"!cForgotPasswordGate.expired\"><button class=\"button button--colorA button--fullWidth button--noRadius loginForm__submit\" ng-class=\"{ \'is-loading\': cForgotPasswordGate.loading }\"><div class=\"spinner--dark\"></div>Continue</button></div></form></div>");
$templateCache.put("app/pages/reset-password/index.html","<div class=\"outofapp\"><div class=\"base\"><h2 class=\"base-cap u-tac\"><a class=\"base-form__cancel\" ng-if=\"cResetPassword.expired\" ui-sref=\"logout\"><i ui-sref=\"logout\" class=\"ion-close\"></i></a> <img class=\"outofapp__logo\" alt=\"Loaded\" src=\"/assets/images/loaded/logo.svg\"></h2><div ng-if=\"cResetPassword.isReset\" class=\"base-form__success\">Your password has been changed! <a ui-sref=\"logout\">Login Now</a></div><form name=\"resetpassword\" class=\"base-form\" novalidate=\"\" ng-submit=\"cResetPassword.attempt(resetpassword)\" ng-if=\"!cResetPassword.isReset\"><div ng-if=\"cResetPassword.user\" class=\"base-form__who\"><img ng-src=\"{{ cResetPassword.user.avatar | avatar }}\"> {{ cResetPassword.user.first_name }}</div><h3 class=\"base-form__alert u-marginBottom--5\" ng-show=\"cResetPassword.expired\">Welcome to Loaded Analytics,<br>Create your new password to continue.</h3><h3 class=\"base-form__alert u-marginBottom--5\" ng-hide=\"cResetPassword.expired\">Enter Your New Password</h3><div class=\"base-form__fieldset\"><input class=\"base-form__input\" name=\"new_password\" type=\"password\" placeholder=\"New password\" ng-model=\"cResetPassword.newPassword\" ns-hiding-label=\"\" autofocus=\"\"></div><div class=\"base-form__fieldset\"><input class=\"base-form__input\" name=\"repeat_password\" type=\"password\" placeholder=\"Repeat password\" ng-model=\"cResetPassword.repeatPassword\" ns-hiding-label=\"\"></div><ul class=\"base-form__validationMessage\"><li ng-repeat=\"message in cResetPassword.validationErrors\"><i class=\"ion-alert-circled\"></i> {{ message }}</li></ul><button class=\"base-form__submit\" type=\"submit\" ng-class=\"{ \'is-loading\': cResetPassword.loading }\"><div class=\"wait wait--dark\"></div>Reset Password</button></form></div></div>");
$templateCache.put("app/pages/right-now/_channels.html","<table class=\"base-table\"><tbody bindonce=\"cRightNow.topChannels\"><tr ng-repeat=\"item in cRightNow.topChannels | limitTo: 13\" ng-class-odd=\"\'base-table__row--odd\'\" class=\"base-table__row\"><td class=\"base-table-cell\" width=\"55\"><ns-rank ns-rank-index=\"$index+1\" ns-rank-under=\"{{ (item.viewers/cRightNow.totals.viewers)*100 | number: 1 }}%\"></ns-rank></td><td class=\"base-table-cell base-table-cell--avatar\" width=\"60\"><ns-image height=\"48\" width=\"48\" ui-sref=\"app.channel({ channel: item.channel.name, platform: \'twitch\' })\" ns-image-src=\"{{ item.channel.logo | avatar }}\"></ns-image></td><td class=\"base-table-cell base-table-cell--entity\"><h4 class=\"base-table-cell__name u-ellipsis u-mw--170\"><a ui-sref=\"app.channel({ channel: item.channel.name, platform: \'twitch\' })\" bo-bind=\"item.channel.display_name\"></a><ns-report-card ns-report-card-value=\"{{ item.viewers | percentageOf: item.channel.average_viewers_shorterm }}\" ns-report-card-comparison=\"{{ item.channel.average_viewers_shorterm }}\"></ns-report-card></h4><ul class=\"base-table-cell__underName\"><li class=\"u-ellipsis u-mw--170\"><i class=\"icon ion-ios-game-controller-b\"></i> <a ui-sref=\"app.game.report({ slug: item.twitch_game.title })\" bo-bind=\"item.twitch_game.title\"></a></li></ul></td><td class=\"base-table-cell base-table-cell--labeledValue\" width=\"70\"><span bo-bind=\"item.viewers | number\"></span><h5 class=\"base-table-cell__label\">Viewers</h5></td></tr></tbody></table><div class=\"base__total\"><a ui-sref=\"app.live.channels()\">{{ cRightNow.totals.stream_count - 13 | number }} More</a></div>");
$templateCache.put("app/pages/right-now/_games--streams.html","<table class=\"base-table\"><tbody bindonce=\"cRightNow.popularGames\"><tr ng-repeat=\"item in cRightNow.popularGames | limitTo: 5\" ng-class-odd=\"\'base-table__row--odd\'\" class=\"base-table__row\"><td class=\"base-table-cell\" width=\"55\"><ns-rank ns-rank-index=\"$index+1\" ns-rank-under=\"{{ (item.stream_count/cRightNow.totals.stream_count)*100 | number: 1 }}%\"></ns-rank></td><td class=\"base-table-cell base-table-cell--avatar\" width=\"52\"><ns-image height=\"48\" width=\"40\" ui-sref=\"app.game.report({ slug: item.twitch_game.title })\" ns-image-src=\"{{ item.twitch_game.title | urlBoxart:190:138 }}\"></ns-image></td><td class=\"base-table-cell base-table-cell--entity\"><h4 class=\"base-table-cell__name\"><a ui-sref=\"app.game.report({ slug: item.twitch_game.title })\" bo-bind=\"item.twitch_game.title\"></a><ns-report-card ns-report-card-value=\"{{ item.stream_count | percentageOf: item.twitch_game.grouping.game.average_streams }}\" ns-report-card-comparison=\"{{ item.twitch_game.grouping.game.average_streams }}\"></ns-report-card></h4></td><td class=\"base-table-cell base-table-cell--labeledValue\" width=\"70\"><span bo-bind=\"item.stream_count | number\"></span><h5 class=\"base-table-cell__label\">Streams</h5></td></tr></tbody></table><div class=\"base__total\"><a ui-sref=\"app.live.games()\">{{ cRightNow.totals.game_count - 5 | number }} More</a></div>");
$templateCache.put("app/pages/right-now/_games--viewers.html","<table class=\"base-table\"><tbody bindonce=\"cRightNow.topGames\"><tr ng-repeat=\"item in cRightNow.topGames | limitTo: 5\" ng-class-odd=\"\'base-table__row--odd\'\" class=\"base-table__row\"><td class=\"base-table-cell\" width=\"55\"><ns-rank ns-rank-index=\"$index+1\" ns-rank-under=\"{{ (item.total_viewers/cRightNow.totals.viewers)*100 | number: 1 }}%\"></ns-rank></td><td class=\"base-table-cell base-table-cell--avatar\" width=\"52\"><ns-image height=\"48\" width=\"40\" ui-sref=\"app.game.report({ slug: item.twitch_game.title })\" ns-image-src=\"{{ item.twitch_game.title | urlBoxart:190:138 }}\"></ns-image></td><td class=\"base-table-cell base-table-cell--entity\"><h4 class=\"base-table-cell__name\"><a ui-sref=\"app.game.report({ slug: item.twitch_game.title })\" bo-bind=\"item.twitch_game.title\"></a><ns-report-card ns-report-card-value=\"{{ item.total_viewers | percentageOf: item.twitch_game.grouping.game.average_viewers }}\" ns-report-card-comparison=\"{{ item.twitch_game.grouping.game.average_viewers }}\"></ns-report-card></h4></td><td class=\"base-table-cell base-table-cell--labeledValue\" width=\"70\"><span bo-bind=\"item.total_viewers | number\"></span><h5 class=\"base-table-cell__label\">Viewers</h5></td></tr></tbody></table><div class=\"base__total\"><a ui-sref=\"app.live.games()\">{{ cRightNow.totals.game_count - 5 | number }} More</a></div>");
$templateCache.put("app/pages/right-now/_livebar.html","<div class=\"base base--margin\" bindonce=\"cRightNow.topChannels\"><div class=\"base-live\"><div class=\"base-live__section base-live__section--cap\" uib-tooltip=\"{{ \'Pulled \' + (cRightNow.topChannels[0].pulled_at | dateUtcToLocal | dateToTimeAgo) }}\" tooltip-placement=\"left\"><div><i class=\"base-live__capIcon ion-ios-pulse-strong\"></i><h3 class=\"base-live__label\">Right Now</h3></div></div><div class=\"base-live__section\"><div><h4 class=\"base-live__value\" bo-bind=\"(cRightNow.totals.viewers | number: 0)\"></h4><h3 class=\"base-live__label\">Viewers Watching</h3></div></div><a class=\"base-live__section\" ui-sref=\"app.live.channels()\"><div><h4 class=\"base-live__value\" bo-bind=\"cRightNow.totals.stream_count | number: 0\"></h4><h3 class=\"base-live__label\">Live Streams</h3></div></a> <a class=\"base-live__section\" ui-sref=\"app.live.games()\"><div><h4 class=\"base-live__value\" bo-bind=\"cRightNow.totals.game_count | number: 0\"></h4><h3 class=\"base-live__label\">Games being streamed</h3></div></a><div class=\"base-live__section\"><div><h4 class=\"base-live__value\" bo-bind=\"cRightNow.totals.average_viewers_stream | number: 0\"></h4><h3 class=\"base-live__label\">Avg Viewers/Stream</h3></div></div></div></div>");
$templateCache.put("app/pages/right-now/right-now.html","<div class=\"u-columns\"><div class=\"u-column--4\"><div class=\"base base--margin base--padded\"><h3 class=\"base-cap\"><ns-section-dot ns-section-dot-icon=\"icon ion-mic-c\"></ns-section-dot>Top Live Broadcasts</h3><div ng-include=\"\'app/pages/right-now/_channels.html\'\"></div></div></div><div class=\"u-column--8\"><div ng-include=\"\'app/pages/right-now/_livebar.html\'\"></div><div class=\"base base--margin base--padded\"><h3 class=\"base-cap\"><ns-section-dot ns-section-dot-icon=\"icon ion-android-calendar\" ns-section-dot-loading=\"cRightNow.chart.config.loading\"></ns-section-dot>Today</h3><div class=\"u-tar u-separatorBorder--bottom\"><ns-dropdown class=\"chart__dropdown\" ns-dropdown-display=\"title\" ns-dropdown-options=\"cRightNow.chart.metrics\" ns-dropdown-select=\"cRightNow.chart.changeMetric\" ns-dropdown-direction=\"right\">{{ cRightNow.chart.selectedMetric.title }} <i class=\"icon ion-android-arrow-dropdown\"></i></ns-dropdown></div><div class=\"u-marginLeft--minus5 u-marginRight--minus5\"><highchart config=\"cRightNow.chart.config\"></highchart></div></div><div class=\"u-columns\"><div class=\"u-column--6\"><div class=\"base base--margin base--padded\"><h3 class=\"base-cap\"><ns-section-dot ns-section-dot-icon=\"icon ion-ios-game-controller-b\"></ns-section-dot>Top Live Games</h3><div ng-include=\"\'app/pages/right-now/_games--viewers.html\'\"></div></div></div><div class=\"u-column--6\"><div class=\"base base--margin base--padded\"><h3 class=\"base-cap\"><ns-section-dot ns-section-dot-icon=\"icon ion-ios-pulse-strong\"></ns-section-dot>Popular Live Games</h3><div ng-include=\"\'app/pages/right-now/_games--streams.html\'\"></div></div></div></div></div></div>");
$templateCache.put("app/pages/right-now-full/_channels.html","<div class=\"base base--padded\"><h2 class=\"base-cap\"><ns-section-dot ns-section-dot-icon=\"ion-mic-c\" ns-section-dot-loading=\"cLive.loading\"></ns-section-dot><span ng-show=\"!cLive.pull\">Right Now</span> <span ng-if=\"cLive.pull\">{{ cLive.pull | amUtc | amLocal | amCalendar }} - (<span am-time-ago=\"cLive.pull | amUtc | amLocal\"></span>)</span> <i class=\"ion-android-arrow-dropright u-hMargin--5\"></i> Live Broadcasts</h2><div class=\"base-filter base-filter--game u-separatorBorder--bottom u-separatorBorder--right\" ng-if=\"cLive.game\"><i class=\"base-filter__cap ion-funnel\"></i><div class=\"base-filter__type\"><i class=\"ion-ios-game-controller-a\"></i></div><ns-image ui-sref=\"app.game.report({ slug: cLive.results.data[0].twitch_game.title })\" ns-image-src=\"{{ cLive.results.data[0].twitch_game.title | urlBoxart:190:138 }}\"></ns-image><a class=\"u-invisibleLink\" ui-sref=\"app.game.report({ slug: cLive.results.data[0].twitch_game.title })\"><b>{{ cLive.results.data[0].twitch_game.title }}</b></a> <a class=\"base-filter__clear\" ng-click=\"cLive.clearGame()\"><i class=\"ion-close\"></i></a></div><div class=\"u-separatorBorder--bottom u-vPadding--15\"><ns-pagination ns-pagination-loading=\"cLive.loading\" ns-pagination-page=\"cLive.page\" ns-pagination-total=\"cLive.results.total\" ns-pagination-limit=\"cLive.results.per_page\" ns-pagination-change-page=\"cLive.changePage\" ns-pagination-hide-limit=\"true\"></ns-pagination></div><div style=\"margin-left: 3.5%; margin-top: 20px; margin-bottom: 20px;\" class=\"u-animate--loadingOpacity\" ng-class=\"{ \'u-opacity--6\': cLive.loading }\"><div style=\"width: 30%; margin: .5% .9%;\" ng-repeat=\"stream in cLive.results.data\" class=\"placard u-dib\"><table class=\"base-table\"><tr class=\"base-table__row\"><td class=\"base-table-cell\" width=\"48\"><ns-rank ns-rank-index=\"$index + 1 + ((cLive.page - 1) * cLive.results.per_page)\" ns-rank-under=\"{{ (stream.viewers/cLive.results.total_viewers)*100 | number: 1 }}%\"></ns-rank></td><td class=\"base-table-cell base-table-cell--avatar\" width=\"58\"><ns-image height=\"48\" width=\"48\" ui-sref=\"app.channel({ channel: stream.channel.name, platform: \'twitch\' })\" ns-image-src=\"{{ stream.channel.logo | avatar }}\"></ns-image></td><td class=\"base-table-cell base-table-cell base-table-cell--entity\"><h4 class=\"base-table-cell__name u-ellipsis u-mw--170\"><a ui-sref=\"app.channel({ channel: stream.channel.name, platform: \'twitch\' })\" ng-bind=\"stream.channel.display_name\"></a><ns-report-card ns-report-card-value=\"{{ stream.viewers | percentageOf: stream.channel.average_viewers_shorterm }}\" ns-report-card-comparison=\"{{ stream.channel.average_viewers_shorterm }}\"></ns-report-card></h4><ul class=\"base-table-cell__underName\"><li class=\"u-ellipsis u-mw--170\"><i class=\"icon ion-ios-game-controller-b\"></i> <a ui-sref=\"app.game.report({ slug: stream.twitch_game.title })\">{{ stream.twitch_game.title }}</a></li></ul></td><td class=\"base-table-cell base-table-cell--labeledValue\" width=\"70\"><span ng-bind=\"stream.viewers | number\"></span><h5 class=\"base-table-cell__label\">Viewers</h5></td></tr></table></div></div><div class=\"u-separatorBorder--top u-vPadding--15\"><ns-pagination ns-pagination-loading=\"cLive.loading\" ns-pagination-page=\"cLive.page\" ns-pagination-total=\"cLive.results.total\" ns-pagination-limit=\"cLive.results.per_page\" ns-pagination-change-page=\"cLive.changePage\" ns-pagination-hide-limit=\"true\"></ns-pagination></div></div>");
$templateCache.put("app/pages/right-now-full/_games.html","<div class=\"base base--padded\"><h2 class=\"base-cap\"><ns-section-dot ns-section-dot-icon=\"ion-mic-c\" ns-section-dot-loading=\"cLive.loading\"></ns-section-dot>Right Now <i class=\"ion-android-arrow-dropright u-hMargin--5\"></i> Live Game<span ng-hide=\"cLive.results.total === 1\">s</span></h2><div class=\"u-separatorBorder--bottom u-vPadding--15\"><ns-pagination ns-pagination-loading=\"cLive.loading\" ns-pagination-page=\"cLive.page\" ns-pagination-total=\"cLive.results.total\" ns-pagination-limit=\"cLive.results.per_page\" ns-pagination-change-page=\"cLive.changePage\" ns-pagination-hide-limit=\"true\"></ns-pagination></div><div style=\"margin-left: 3.5%; margin-top: 20px; margin-bottom: 20px;\" class=\"u-animate--loadingOpacity\" ng-class=\"{ \'u-opacity--6\': cLive.loading }\"><div style=\"width: 30%; margin: .5% .9%;\" ng-repeat=\"gamePeek in cLive.results.data\" class=\"placard u-dib\"><table class=\"base-table\"><tr class=\"base-table__row\"><td class=\"base-table-cell\" width=\"48\"><ns-rank ns-rank-index=\"$index + 1 + ((cLive.page - 1) * cLive.results.per_page)\" ns-rank-under=\"{{ (gamePeek.total_viewers/cLive.results.total_viewers)*100 | number: 0 }}%\"></ns-rank></td><td class=\"base-table-cell base-table-cell--avatar\" width=\"50\"><ns-image height=\"48\" width=\"40\" ui-sref=\"app.game.report({ slug: gamePeek.twitch_game.title })\" ns-image-src=\"{{ gamePeek.twitch_game.title | urlBoxart:190:138 }}\"></ns-image></td><td class=\"base-table-cell base-table-cell base-table-cell--entity\"><h4 class=\"base-table-cell__name\"><a ui-sref=\"app.game.report({ slug: gamePeek.twitch_game.title })\" ng-bind=\"gamePeek.twitch_game.title\"></a><ns-report-card ns-report-card-value=\"{{ gamePeek.total_viewers | percentageOf: gamePeek.game_grouping.game.average_viewers }}\" ns-report-card-comparison=\"{{ gamePeek.game_grouping.game.average_viewers }}\"></ns-report-card></h4></td><td class=\"base-table-cell base-table-cell--labeledValue\" width=\"70\"><span ng-bind=\"gamePeek.total_viewers | number: 0\"></span><h5 class=\"base-table-cell__label\">Viewers</h5></td></tr></table></div></div><div class=\"u-separatorBorder--top u-vPadding--15\"><ns-pagination ns-pagination-loading=\"cLive.loading\" ns-pagination-page=\"cLive.page\" ns-pagination-total=\"cLive.results.total\" ns-pagination-limit=\"cLive.results.per_page\" ns-pagination-change-page=\"cLive.changePage\" ns-pagination-hide-limit=\"true\"></ns-pagination></div></div>");
$templateCache.put("app/pages/right-now-full/right-now-full.html","<div ui-view=\"\"></div>");
$templateCache.put("app/ui-bootstrap/timepicker/timepicker.html","<span class=\"uibs-timepicker\"><i class=\"icon ion-android-time\"></i><div class=\"uibs-timepicker__set\"><div><a class=\"uibs-timepicker__arrow uibs-timepicker__arrow--top\" ng-click=\"incrementHours()\" ng-class=\"{disabled: noIncrementHours()}\" ng-disabled=\"noIncrementHours()\" tabindex=\"{{::tabindex}}\"><i class=\"ion-android-arrow-dropup icon--arrow\"></i></a> <a class=\"uibs-timepicker__arrow uibs-timepicker__arrow--bottom\" ng-click=\"decrementHours()\" ng-class=\"{disabled: noIncrementHours()}\" ng-disabled=\"noIncrementHours()\" tabindex=\"{{::tabindex}}\"><i class=\"ion-android-arrow-dropdown icon--arrow\"></i></a> {{ hours }} <input class=\"uibs-timepicker__input\" type=\"hidden\" placeholder=\"HH\" ng-model=\"hours\" ng-change=\"updateHours()\" ng-readonly=\"::readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\" ng-disabled=\"noIncrementHours()\" ng-blur=\"blur()\"></div></div><span class=\"uibs-timepicker__colon\">:</span><div class=\"uibs-timepicker__set\"><a class=\"uibs-timepicker__arrow uibs-timepicker__arrow--top\" ng-click=\"incrementMinutes()\" ng-class=\"{disabled: noIncrementMinutes()}\" ng-disabled=\"noIncrementMinutes()\" tabindex=\"{{::tabindex}}\"><i class=\"ion-android-arrow-dropup icon--arrow\"></i></a> <a class=\"uibs-timepicker__arrow uibs-timepicker__arrow--bottom\" ng-click=\"decrementMinutes()\" ng-class=\"{disabled: noDecrementMinutes()}\" ng-disabled=\"noDecrementMinutes()\" tabindex=\"{{::tabindex}}\"><i class=\"ion-android-arrow-dropdown icon--arrow\"></i></a> {{ minutes }} <input class=\"uibs-timepicker__input\" type=\"hidden\" placeholder=\"MM\" ng-model=\"minutes\" ng-change=\"updateMinutes()\" ng-readonly=\"::readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\" ng-disabled=\"noIncrementMinutes()\" ng-blur=\"blur()\"></div><span class=\"uibs-timepicker__meridian\" ng-class=\"{disabled: noToggleMeridian()}\" ng-click=\"toggleMeridian()\" ng-disabled=\"noToggleMeridian()\" tabindex=\"{{::tabindex}}\">{{meridian}}</span></span>");
$templateCache.put("app/ui-components/chart/chart.html","<div class=\"u-paddingBottom--10 ns-chart\"><div class=\"u-tar u-separatorBorder--bottom\" ng-if=\"config.metrics\"><ns-dropdown class=\"chartDropdown\" ns-dropdown-display=\"title\" ns-dropdown-options=\"config.metrics\" ns-dropdown-select=\"changeMetric\" ns-dropdown-direction=\"right\">{{ config.selectedMetric.title }} <i class=\"icon ion-android-arrow-dropdown\"></i></ns-dropdown></div><div class=\"ns-chart__empty\" ng-if=\"!config.series[0].data.length && !loading\" ng-style=\"{ height: config.size.height + \'px\', width: config.size.width + \'px\', lineHeight: (config.size.height - 25) + \'px\' }\">{{ empty || \'No Data\'}}</div><highchart config=\"config\"></highchart></div>");
$templateCache.put("app/ui-components/date-picker/date-picker.html","<span class=\"ns-date-picker\" ng-class=\"{ \'is-open\': $ctrl.isOpen }\"><div class=\"ns-date-picker__toggle\" ng-click=\"$ctrl.togglePicker()\"><ng-transclude></ng-transclude></div><span class=\"ns-date-picker__dropdown\" ng-change=\"$ctrl.update()\" uib-datepicker-popup=\"\" ng-model=\"$ctrl.date\" show-button-bar=\"false\" is-open=\"$ctrl.isOpen\" datepicker-options=\"{ minDate: $ctrl.min.toDate(), maxDate: $ctrl.max.toDate(), showWeeks: false, initDate: $ctrl.date }\"></span></span>");
$templateCache.put("app/ui-components/date-range/date-range.html","<div class=\"ns-date-range\" ng-class=\"{ \'is-loading\': $ctrl.loading }\"><a class=\"ns-date-range__arrow ion-arrow-left-a\"></a> <span class=\"ns-date-range__component\" ns-date-picker=\"\" ns-date-picker-model=\"$ctrl.dates.start\" ns-date-picker-min=\"$ctrl.minimumDate\" ns-date-picker-max=\"$ctrl.dates.end\">{{ $ctrl.dates.start | dateToFormat: \'ddd l\' }}</span> <i class=\"ion-android-time ns-date-range__clock\"></i> <a class=\"ns-date-range__component\">12:00 AM</a> <span class=\"ns-date-range__through\">through</span> <span class=\"ns-date-range__component\" ns-date-picker=\"\" ns-date-picker-model=\"$ctrl.dates.end\" ns-date-picker-min=\"$ctrl.dates.start\" ns-date-picker-max=\"$ctrl.maxDate\">{{ $ctrl.dates.end | dateToFormat: \'ddd l\' }}</span> <i class=\"ion-android-time ns-date-range__clock\"></i> <a class=\"ns-date-range__component\">12:00 AM</a> <a class=\"ns-date-range__arrow ion-arrow-right-a\"></a></div>");
$templateCache.put("app/ui-components/dropdown/dropdown.html","<span class=\"ns-dropdown\" ng-class=\"{ \'ns-dropdown--right\': direction === \'right\' }\" uib-dropdown=\"\" uib-keyboard-nav=\"\" on-toggle=\"toggle(open)\"><span uib-dropdown-toggle=\"\" class=\"ns-dropdown__toggle\"><ng-transclude></ng-transclude></span><ul class=\"uib-dropdown-menu ns-dropdown__menu\"><li class=\"ns-dropdown__option\" ng-repeat=\"option in nsDropdownOptions track by $index\"><a class=\"ns-dropdown__link\" ng-click=\"select(option)\">{{ (nsDropdownDisplay) ? option[nsDropdownDisplay] : option }}</a></li></ul></span>");
$templateCache.put("app/ui-components/image/image.html","<a class=\"ns-image\" bindonce=\"src\" bo-style=\"{ backgroundImage: \'url(\' + src + \')\', height: height + \'px\', width: width + \'px\', lineHeight: height + \'px\' }\"><ng-transclude class=\"ns-image__content\"></ng-transclude></a>");
$templateCache.put("app/ui-components/live-dot/live-dot.html","<i class=\"liveDot ion-ios-pulse-strong\" uib-tooltip-html=\"tooltip\" bindonce=\"peek\" ng-class=\"{ \'liveDot--game\': isGame }\"></i>");
$templateCache.put("app/ui-components/pagination/pagination.html","<div class=\"ns-pagination\"><div class=\"ns-pagination__perPage\" ng-hide=\"$ctrl.hideLimit || !$ctrl.limitCallback\"><span ng-hide=\"$ctrl.page >= 100\">Per Page</span><ul><li ng-click=\"$ctrl.limitSet(8)\" ng-class=\"{ \'is-active\': $ctrl.limit === 8 }\">8</li><li ng-click=\"$ctrl.limitSet(25)\" ng-class=\"{ \'is-active\': $ctrl.limit === 25 }\">25</li><li ng-click=\"$ctrl.limitSet(50)\" ng-class=\"{ \'is-active\': $ctrl.limit === 50 }\">50</li></ul></div><ul uib-pagination=\"\" total-items=\"$ctrl.total\" items-per-page=\"$ctrl.limit\" ng-model=\"$ctrl.page\" ng-change=\"$ctrl.pageSet()\" max-size=\"8\" rotate=\"false\" ng-disabled=\"$ctrl.loading\"></ul><div class=\"ns-pagination__map\" ng-show=\"$ctrl.total > $ctrl.limit\">{{ (($ctrl.page - 1) * $ctrl.limit) + 1 | number }}<span ng-hide=\"$ctrl.page >= 1000\"><i>-</i>{{ $ctrl.page * $ctrl.limit | number }}</span> <i>of</i> {{ $ctrl.total | number }}</div><div ng-if=\"$ctrl.loading\" class=\"wait\"></div></div>");
$templateCache.put("app/ui-components/range/range.html","<div class=\"ns-range\" ng-class=\"{ \'is-loading\': loading }\"><i class=\"ion-arrow-left-a ns-range__arrow ns-range__arrow--prev\" ng-if=\"!noApply\" ng-click=\"prevRange()\"></i><date class=\"layerCap__date\" moment=\"startDate\" min=\"minimumDate\" max=\"endDate\" date-text=\"true\" display=\"chart.config.loading\"></date>&nbsp;<ns-time-picker ng-hide=\"noTime\" ns-time-picker-moment=\"startDate\" ns-time-picker-max=\"endDate\"></ns-time-picker>&nbsp; <span class=\"layerCap__betweenDates\">through</span><date class=\"layerCap__date\" moment=\"endDate\" min=\"startDate\" max=\"now\" date-text=\"true\" display=\"chart.config.loading\"></date>&nbsp;<ns-time-picker ng-hide=\"noTime\" ns-time-picker-moment=\"endDate\" ns-time-picker-min=\"startDate\"></ns-time-picker>&nbsp; <i class=\"ion-arrow-right-a ns-range__arrow ns-range__arrow--next\" ng-if=\"!noApply\" ng-click=\"nextRange()\"></i><ns-dropdown class=\"layerCap__range\" ng-if=\"!noApply\" ns-dropdown-display=\"title\" ns-dropdown-options=\"rangePresets\" ns-dropdown-select=\"selectRangePreset\"><span class=\"title\" ng-if=\"selectedRangePreset\">{{ selectedRangePreset.title }} <i class=\"icon ion-android-arrow-dropdown\"></i></span> <span class=\"title\">Custom<i class=\"icon ion-android-arrow-dropdown\"></i></span></ns-dropdown><a class=\"layerCap__apply\" ng-if=\"callback\" ng-click=\"customRange()\" ng-class=\"{ \'is-disabled\': !rangeChanged || loading }\">Apply</a></div>");
$templateCache.put("app/ui-components/rank/rank.html","<div class=\"ns-rank\"><h5 class=\"ns-rank__value\" ng-if=\"nsRankIndex > 1\" ng-class=\"{ \'is-small\': nsRankIndex > 99 }\"><i class=\"ns-rank__hash ion-pound\" ng-hide=\"nsRankIndex > 99\"></i>{{ nsRankIndex | number }}</h5><h5 class=\"ns-rank__value\" ng-if=\"nsRankIndex === 1\"><i class=\"ns-rank__trophy ion-trophy\"></i></h5><p class=\"ns-rank__under\">{{ nsRankUnder || \'RANK\' }}</p></div>");
$templateCache.put("app/ui-components/section-dot/section-dot.html","<span class=\"ns-sectionDot\"><i class=\"ns-sectionDot__icon {{ nsSectionDotIcon }}\" ng-if=\"!nsSectionDotLoading\"></i><div ng-if=\"nsSectionDotLoading\" class=\"spinner--sectionTitle ns-sectionDot__loading\"></div></span>");
$templateCache.put("app/ui-components/stats/item.html","<div class=\"base-stats__section\"><div><h4 class=\"base-live__value\" ng-class=\"{ \'is-plus\': nsStatsItemChange && nsStatsItemChange > 0, \'is-minus\': nsStatsItemChange && nsStatsItemChange < 0, }\"><div class=\"wait wait--small wait--dark\" ng-if=\"nsStatsItemLoading\"></div><span ng-hide=\"nsStatsItemLoading\"><span ng-if=\"nsStatsItemChange\"><span class=\"base-stats__change base-stats__change--plus\" ng-if=\"nsStatsItemChange > 0\"><i class=\"ion-arrow-up-a\"></i></span> <span class=\"base-stats__change base-stats__change--minus\" ng-if=\"nsStatsItemChange < 0\"><i class=\"ion-arrow-down-a\"></i></span></span> {{ nsStatsItemValue }}</span></h4><h3 class=\"base-stats__label\">{{ nsStatsItemTitle }}</h3></div></div>");
$templateCache.put("app/ui-components/stats/stats.html","<div class=\"base-stats\" ng-transclude=\"\"></div>");
$templateCache.put("app/ui-components/time-picker/_picker.html","<div class=\"timepicker\" ng-show=\"::showSpinners\"><div class=\"timepicker__column\"><div class=\"timepicker__up\" ng-click=\"incrementHours()\"><i class=\"ion-chevron-up\"></i></div><div class=\"timepicker__value\">{{ hours }}</div><div class=\"timepicker__down\" ng-click=\"decrementHours()\"><i class=\"ion-chevron-down\"></i></div></div><div class=\"timepicker__column timepicker__dots\"><div class=\"timepicker__placeholder\">u</div><div class=\"timepicker__value\">:</div><div class=\"timepicker__placeholder\">d</div></div><div class=\"timepicker__column\"><div class=\"timepicker__up\" ng-click=\"incrementMinutes()\"><i class=\"ion-chevron-up\"></i></div><div class=\"timepicker__value\">{{ minutes }}</div><div class=\"timepicker__down\" ng-click=\"decrementMinutes()\"><i class=\"ion-chevron-down\"></i></div></div><div class=\"timepicker__column timepicker__meridian\"><div class=\"timepicker__placeholder\">u</div><div class=\"timepicker__value\" ng-click=\"toggleMeridian()\">{{ meridian }}</div><div class=\"timepicker__placeholder\">d</div></div></div>");
$templateCache.put("app/ui-components/time-picker/time-picker.html","<div class=\"ns-timePicker\"><i class=\"ns-timePicker__icon ion-clock\"></i><div class=\"ns-timePicker__picker\"><span uib-timepicker=\"\" ng-model=\"date\" mousewheel=\"false\" arrowkeys=\"false\" hour-step=\"1\" minute-step=\"10\" template-url=\"app/ui-components/time-picker/_picker.html\" min=\"min\" max=\"max\"></span></div></div>");
$templateCache.put("app/ui-components/toggle/toggle.html","<span class=\"ns-toggle\" ng-class=\"{ \'is-active\': nsToggleModel }\" ng-click=\"toggle()\"><i class=\"icon ion-checkmark-circled\"></i> <span ng-if=\"nsToggleLabel\">{{ nsToggleLabel }}</span> <span ng-if=\"nsToggleModel\">{{ nsToggleActiveLabel }}</span> <span ng-if=\"!nsToggleModel\">{{ nsToggleInactiveLabel }}</span></span>");
$templateCache.put("app/pages/campaigns/create/campaign--create.html","<form class=\"l-newCampaign\"><div class=\"l-newCampaign__leftColumn\"><div class=\"m-layer l-newCampaign__section\"><div class=\"inner\"><h3 class=\"section-title\"><i class=\"icon ion-trophy\"></i> Game Campaign Details</h3><div class=\"l-newCampaign__field\"><h4>What do we call this campaign?</h4><input type=\"text\" ng-model=\"cCampaignsCreate.title\" name=\"title\" placeholder=\"Campaign title...\"></div><div class=\"l-newCampaign__field\"><h2 class=\"section-title\"><i class=\"icon ion-ios-game-controller-b\"></i> <span ng-show=\"cCampaignsCreate.games.selected.length > 0\">{{ cCampaignsCreate.games.selected.length }}</span> Game<span ng-hide=\"cCampaignsCreate.games.selected.length === 1\">s</span></h2><h4>What game(s) are we looking at?</h4><i ng-hide=\"cCampaignsCreate.games.loading\" class=\"is-add icon ion-android-add-circle\"></i><div ng-if=\"cCampaignsCreate.games.loading\" class=\"loading spinner--small\"></div><input type=\"text\" class=\"is-add\" ng-model=\"cCampaignsCreate.games.searchString\" placeholder=\"Enter game title...\" typeahead-focus-first=\"true\" typeahead-min-length=\"3\" typeahead-loading=\"cCampaignsCreate.games.loading\" typeahead-wait-ms=\"250\" typeahead-on-select=\"cCampaignsCreate.games.select($item)\" uib-typeahead=\"hit.title for hit in (cCampaignsCreate.games.doSearch($viewValue))\" typeahead-append-to-body=\"\" ng-blur=\"cCampaignsCreate.games.searchString = \'\'\"><ul class=\"l-newCampaign__list\" ng-show=\"cCampaignsCreate.games.selected.length\"><li ng-repeat=\"game in cCampaignsCreate.games.selected\"><a ui-sref=\"app.game.report({ slug: game.title })\" target=\"_blank\"><bg-img class=\"avatar\" height=\"60\" width=\"50\" image=\"{{ game.title | urlBoxart:190:138 }}\"></bg-img></a><div class=\"inner\">{{ game.title }}</div><a class=\"remove\" ng-click=\"cCampaignsCreate.games.remove(game)\"><i class=\"icon ion-close-circled\"></i></a></li></ul></div><div class=\"l-newCampaign__field\"><h2 class=\"section-title\"><i class=\"icon ion-android-calendar\"></i> <span ng-show=\"!cCampaignsCreate.timeframes.selected[0].start || !cCampaignsCreate.timeframes.selected[0].end\">Date Range</span> <span ng-show=\"cCampaignsCreate.timeframes.selected[0].start && cCampaignsCreate.timeframes.selected[0].end\">{{ ((cCampaignsCreate.timeframes.selected[0].start | durationBetweenDates: cCampaignsCreate.timeframes.selected[0].end)/86400)+1 | round: 0 }} Days Selected</span></h2><h4>What date range are we looking at?</h4><div ng-repeat=\"timeframe in cCampaignsCreate.timeframes.selected\" class=\"l-newCampaign__date\"><div class=\"column\"><h5>Start On</h5><date-old moment=\"timeframe.start\" max=\"timeframe.end\"></date-old></div><div class=\"seperator\"><i class=\"icons is-between ion-minus-round\"></i></div><div class=\"column\"><h5>End After</h5><date-old moment=\"timeframe.end\" min=\"timeframe.start\"></date-old></div></div></div><ul class=\"l-newCampaign__description\" ng-show=\"cCampaignsCreate.submitAttempted\"><li ng-if=\"!cCampaignsCreate.title || cCampaignsCreate.title === \'\'\">We don\'t know what we should call this report.</li><li ng-if=\"!cCampaignsCreate.timeframes.selected[0].start || !cCampaignsCreate.timeframes.selected[0].end\">We don\'t know what date range are we should look at.</li><li ng-if=\"cCampaignsCreate.games.selected.length === 0\">You must select at least one game to look at.</li><li ng-if=\"cCampaignsCreate.channels.selected.length === 0\">You must select at least one broadcaster to look at.</li></ul><div class=\"l-newCampaign__save\"><button ng-class=\"{ \'is-loading\': cCampaignsCreate.submitLoading }\" ng-disabled=\"cCampaignsCreate.submitLoading\" class=\"button-a--full\" type=\"submit\" ng-click=\"cCampaignsCreate.submitForm()\"><div class=\"spinner--dark\"></div>Save Report</button></div><div ng-if=\"cCampaignsCreate.isEdit\" class=\"l-newCampaign__delete\"><a ng-hide=\"cCampaignsCreate.deleteConfirm\" ng-click=\"cCampaignsCreate.deleteConfirm = true;\"><i class=\"icon ion-android-delete\"></i> Delete this report</a> <span ng-if=\"cCampaignsCreate.deleteConfirm\">Delete this report? <a ng-click=\"cCampaignsCreate.deleteCampaign()\">Yes</a> / <a ng-click=\"cCampaignsCreate.deleteConfirm = false;\">No</a></span></div></div></div></div><div class=\"l-newCampaign__centerColumn\"><div class=\"m-layer l-newCampaign__section\"><div class=\"inner\"><h2 class=\"section-title\"><i class=\"icon ion-mic-c\"></i> <span ng-show=\"cCampaignsCreate.channels.selected.length > 0\">{{ cCampaignsCreate.channels.selected.length }}</span> Broadcaster<span ng-hide=\"cCampaignsCreate.channels.selected.length === 1\">s</span></h2><div class=\"l-newCampaign__field\"><div><h4>What broadcasters are we looking at?</h4><i ng-hide=\"cCampaignsCreate.channels.loading\" class=\"is-add icon ion-android-add-circle\"></i><div ng-if=\"cCampaignsCreate.channels.loading\" class=\"loading spinner--small\"></div><input type=\"text\" class=\"is-add is-bulk\" ng-model=\"cCampaignsCreate.channels.searchString\" placeholder=\"Enter channel name...\" typeahead-focus-first=\"true\" typeahead-min-length=\"3\" typeahead-loading=\"cCampaignsCreate.channels.loading\" typeahead-wait-ms=\"250\" typeahead-on-select=\"cCampaignsCreate.channels.select($item)\" uib-typeahead=\"hit.display_name for hit in (cCampaignsCreate.channels.doSearch($viewValue))\" typeahead-append-to-body=\"\" ng-blur=\"cCampaignsCreate.channels.searchString = \'\'\"><div class=\"l-newCampaign__bulkAddButton\" ng-class=\"{ \'is-open\': cCampaignsCreate.showBulkImport }\" ng-click=\"cCampaignsCreate.showBulkImport = (cCampaignsCreate.showBulkImport) ? false : true\"><i class=\"icon ion-android-add\" ng-hide=\"cCampaignsCreate.showBulkImport\"></i> <i class=\"icon ion-android-remove\" ng-show=\"cCampaignsCreate.showBulkImport\"></i> <span class=\"inner\">Bulk<br>Add</span></div></div><div ng-show=\"cCampaignsCreate.showBulkImport\" class=\"l-newCampaign__bulkAdd\" ng-cloak=\"\"><textarea ng-model=\"cCampaignsCreate.bulkImportModel\" placeholder=\"Enter up to 250 channel names or Twitch URLs separated by commas, semicolons or line breaks...\" rows=\"8\"></textarea> <button class=\"button-a--full\" ng-disabled=\"cCampaignsCreate.importLoading\" ng-hide=\"cCampaignsCreate.importLoading || cCampaignsCreate.importResult\" ng-click=\"cCampaignsCreate.bulkImport()\">Add Channels</button><div ng-if=\"cCampaignsCreate.importLoading\" class=\"loading--import\"><div class=\"spinner\"></div>Hold tight, this may take a bit...</div><div ng-if=\"cCampaignsCreate.importResult\" class=\"message--import\"><i class=\"icon ion-checkmark-circled\"></i> {{ cCampaignsCreate.importResult.result }} of {{ cCampaignsCreate.importResult.entered }} channels added.</div></div><div><ul class=\"l-newCampaign__list\" ng-hide=\"cCampaignsCreate.channels.selected.length === 0\"><li ng-repeat=\"channel in cCampaignsCreate.channels.selected\" class=\"is-channel\"><a ui-sref=\"app.channel({ channel: channel.name })\" target=\"_blank\"><bg-img class=\"avatar\" height=\"60\" width=\"60\" image=\"{{ channel.logo || \'/assets/images/blank-user.png\' }}\"></bg-img></a><div class=\"inner\">{{ channel.display_name }}<p class=\"stats\"><i class=\"icon ion-heart\"></i> {{ channel.followers | bigNumber }} &nbsp; &nbsp; <i class=\"icon ion-person-stalker\"></i> {{ channel.average_viewers_shorterm | bigNumber }}</p></div><div class=\"remove\" ng-click=\"cCampaignsCreate.channels.remove(channel)\"><i class=\"icon ion-close-circled\"></i></div></li></ul></div></div></div><br></div></div></form>");
$templateCache.put("app/pages/campaigns/index/campaigns--index.html","<div class=\"l-campaigns\"><div class=\"m-layer l-campaigns__controls\"><div class=\"inner\"><h2 class=\"section-title\"><ns-dropdown class=\"options\" ns-dropdown-display=\"title\" ns-dropdown-options=\"cCampaignsIndex.sorts\" ns-dropdown-select=\"cCampaignsIndex.setSort\" ns-dropdown-direction=\"left\">{{ cCampaignsIndex.selectedSort.title }} <i class=\"icon ion-android-arrow-dropdown\"></i></ns-dropdown><i class=\"icon ion-stats-bars\"></i> {{ cCampaignsIndex.campaigns.length }} Campaign<span ng-hide=\"cCampaignsIndex.campaigns.length == 1\">s</span><div class=\"search\"><i class=\"icon ion-search\"></i> <input type=\"text\" ng-model=\"cCampaignsIndex.campaignFilter\" placeholder=\"Enter campaign name...\"></div></h2></div></div><div class=\"l-campaigns__container\"><a ui-sref=\"app.newCampaign()\" class=\"campaignCard is-new\"><span class=\"inner\"><i class=\"icon ion-android-add-circle\"></i><p>Create New Campaign</p></span></a><div class=\"campaignCard\" ng-repeat=\"campaign in cCampaignsIndex.campaigns | orderBy: cCampaignsIndex.selectedSort.column\" ng-show=\"!cCampaignsIndex.campaignFilter || campaign.title.toLowerCase().indexOf(cCampaignsIndex.campaignFilter.toLowerCase()) > -1\"><a class=\"campaignCard__header\" ui-sref=\"app.campaign({ campaignId: campaign.id })\"><ul class=\"list\" ng-class=\"{ \'is-full\': campaign.listeners[0].header.length > 12 }\"><li ng-repeat=\"item in campaign.listeners[0].header track by $index\"><bg-img ng-if=\"item.logo\" class=\"avatar\" height=\"60\" width=\"60\" image=\"{{ item.logo }}\" uib-tooltip=\"{{ item.display_name }}\"></bg-img><bg-img ng-if=\"item.title\" class=\"avatar\" height=\"60\" width=\"60\" image=\"{{ item.title | urlBoxart:190:138 }}\" uib-tooltip=\"{{ item.title }}\"></bg-img><div class=\"blank is-{{ item }}\" ng-if=\"!item.title && !item.logo\"><i class=\"icon ion-ios-game-controller-b\" ng-if=\"item % 2 !== 0\"></i> <i class=\"icon ion-mic-c\" ng-if=\"item % 2 === 0\"></i></div></li></ul></a><div class=\"inner\"><h2 class=\"section-title\"><i class=\"icon ion-stats-bars\"></i> {{ campaign.title }}</h2><div class=\"campaignCard__dates\">{{ campaign.listeners[0].start | dateToFormat:\'MMMM D , YYYY\' }} - {{ campaign.listeners[0].end | dateToFormat:\'MMMM D, YYYY\' }}</div></div><ul class=\"m-statBar campaignCard__buttons\"><li class=\"m-statBar__value\" style=\"width: 33.333%\"><h2 class=\"value\">{{ campaign.listeners[0].channel_count === 0 ? \'All\' : campaign.listeners[0].channel_count }}</h2><h3 class=\"title\">Broadcaster<span ng-hide=\"campaign.listeners[0].channel_count == 1\">s</span></h3></li><li class=\"m-statBar__value\" style=\"width: 33.333%\"><h2 class=\"value\">{{ campaign.listeners[0].game_count === 0 ? \'All\' : campaign.listeners[0].game_count }}</h2><h3 class=\"title\">Game<span ng-hide=\"campaign.listeners[0].game_count == 1\">s</span></h3></li><a class=\"m-statBar__value\" ui-sref=\"app.editCampaign({ campaign: campaign.id })\" style=\"width: 33.333%\"><h2 class=\"value\"><i class=\"icon ion-edit\"></i></h2><h3 class=\"title\">Edit</h3></a></ul></div></div></div>");
$templateCache.put("app/pages/campaigns/show/_channelPerformance.html","<campaign-channel channel=\"channel\" campaign=\"cCampaignsShow.campaign\"></campaign-channel>");
$templateCache.put("app/pages/campaigns/show/_info.html","<div class=\"p-campaign--report__info\"><div class=\"inner\"><h2 class=\"section-title\"><ns-section-dot ns-section-dot-icon=\"ion-stats-bars\"></ns-section-dot>{{ cCampaignsShow.campaign.title }}</h2><ul class=\"p-campaign--report__gameList\"><li ng-repeat=\"game in cCampaignsShow.campaign.games\"><bg-img image=\"{{ game.title | urlBoxart:190:138 }}\" height=\"50\" width=\"38\"></bg-img><div class=\"inner\"><h4 class=\"title\">{{ game.title }}</h4><h4 class=\"subtitle\">{{ game.total_minutes | bigNumber }} Minutes Watched</h4></div></li></ul><a href=\"\" class=\"button button-a--full u-marginTop--5\" ui-sref=\"app.editCampaign({ campaign: cCampaignsShow.campaign.id })\">Edit Campaign</a><div class=\"u-tac u-separatorBorder--top u-vPadding--10 u-font--small u-fwb\" style=\"color: #666\"><i class=\"ion-ios-copy u-marginRight--5\"></i> <a ui-sref=\"app.newCampaign({ template: cCampaignsShow.campaign.id })\" class=\"u-invisibleLink\">Duplicate campaign</a></div></div></div>");
$templateCache.put("app/pages/campaigns/show/_participation.html","<div class=\"p-campaign--report__participants\"><h3 class=\"section-title has-expand\" ng-class=\"{ \'is-closed\': !cCampaignsShow.participantsOpen }\" ng-click=\"cCampaignsShow.toggleParticipants()\"><span class=\"expand\"><i ng-hide=\"cCampaignsShow.participantsOpen\" class=\"icon ion-android-add\"></i> <i ng-show=\"cCampaignsShow.participantsOpen\" class=\"icon ion-android-remove\"></i></span><ns-section-dot ns-section-dot-icon=\"ion-android-star\" ns-section-dot-loading=\"cCampaignsShow.chart.config.loading\"></ns-section-dot>Participation</h3><ul ng-show=\"cCampaignsShow.participantsOpen\"><li class=\"participant\" ng-repeat=\"channel in cCampaignsShow.channelMap | toArray | orderBy: \'name\'\" ng-class=\"{ \'is-played\': channel.played }\"><a ng-click=\"cCampaignsShow.goToChannel(channel)\" target=\"_blank\" class=\"is-image u-cp\"><bg-img height=\"50\" width=\"69\" uib-tooltip=\"{{ channel.display_name }}\" image=\"{{ channel.logo || \'/assets/images/blank-user.png\' }}\"><div class=\"subtitle\">{{ channel.stats.peek_count*cCampaignsShow.pullInterval | durationToTimestamp: \'m\' }}</div><div class=\"inner\">{{ channel.display_name }}</div></bg-img></a></li></ul></div>");
$templateCache.put("app/pages/campaigns/show/_performance.html","<div class=\"p-campaign--report__performance\"><h3 class=\"section-title\"><ns-toggle class=\"u-fr\" ns-toggle-model=\"cCampaignsShow.onlyPlayed\" ns-toggle-label=\"Participants Only\"></ns-toggle><ns-section-dot ns-section-dot-icon=\"ion-mic-c\" ns-section-dot-loading=\"cCampaignsShow.chart.config.loading\"></ns-section-dot>Channel Performance</h3><table><tr><th table-sort=\"cCampaignsShow.tableSort\" table-sort-column=\"played\" width=\"60\" ng-click=\"cCampaignsShow.changeSort(\'-played\')\">Played</th><th table-sort=\"cCampaignsShow.tableSort\" table-sort-column=\"name\" colspan=\"2\" class=\"is-left\" ng-click=\"cCampaignsShow.changeSort(\'name\')\">Channel</th><th table-sort=\"cCampaignsShow.tableSort\" table-sort-column=\"stats.total_minutes\" width=\"120\" ng-click=\"cCampaignsShow.changeSort(\'-stats.total_minutes\')\">Min Watched</th><th table-sort=\"cCampaignsShow.tableSort\" table-sort-column=\"stats.total_minutes\" width=\"120\" ng-click=\"cCampaignsShow.changeSort(\'-stats.total_minutes\')\">Contribution</th><th table-sort=\"cCampaignsShow.tableSort\" table-sort-column=\"stats.peek_count\" width=\"100\" ng-click=\"cCampaignsShow.changeSort(\'-stats.peek_count\')\">Stream Time</th><th table-sort=\"cCampaignsShow.tableSort\" table-sort-column=\"stats.average_viewers\" width=\"120\" ng-click=\"cCampaignsShow.changeSort(\'-stats.average_viewers\')\">Average Viewers</th><th table-sort=\"cCampaignsShow.tableSort\" table-sort-column=\"stats.peak_viewers\" width=\"110\" ng-click=\"cCampaignsShow.changeSort(\'-stats.peak_viewers\')\">Peak Viewers</th><th width=\"70\">More</th></tr><tr ng-class-odd=\"\'is-odd\'\" ng-class=\"{ \'is-highlight\': channel.highlight }\" id=\"{{ channel.name }}\" ng-repeat-start=\"channel in cCampaignsShow.channelMap | toArray | orderBy: cCampaignsShow.tableSort | filter:(cCampaignsShow.onlyPlayed) ? { played: true } : {} as filteredChannels\"><td class=\"is-boolean\" ng-class=\"{ \'is-active\': channel.played }\"><i class=\"icon ion-checkmark-circled\"></i></td><td class=\"is-logo\" width=\"58\"><a class=\"is-image\" ui-sref=\"app.channel({ channel: channel.name, platform: \'twitch\' })\" target=\"_blank\"><bg-img class=\"logo\" height=\"45\" width=\"45\" image=\"{{ channel.logo || \'/assets/images/blank-user.png\' }}\"></bg-img></a></td><td class=\"is-channel is-noLogo\"><div class=\"inner\"><h3 class=\"title\"><a ui-sref=\"app.channel({ channel: channel.name, platform: \'twitch\' })\" target=\"_blank\">{{ channel.display_name }}</a></h3><p class=\"subtitle\"><i class=\"icon ion-person-stalker\"></i> {{ channel.followers | number }} Followers</p></div></td><td class=\"is-number\">{{ channel.stats.total_minutes | number }}</td><td class=\"is-number\"><span ng-show=\"channel.played\">{{ (channel.stats.total_minutes/cCampaignsShow.totals.total_minutes) * 100 | number: 1 }}%</span></td><td class=\"is-duration\"><duration ng-show=\"channel.played\" peeks=\"channel.stats.peek_count\"></duration></td><td class=\"is-number\">{{ channel.stats.average_viewers | number:0 }}<report-card value=\"{{ channel.stats.average_viewers | percentageOf: channel.average_viewers_shorterm }}\" comparison=\"{{ channel.average_viewers_shorterm }}\"></report-card></td><td class=\"is-number\">{{ channel.stats.peak_viewers | number }}</td><td class=\"is-more\" ng-if=\"channel.played\" ng-class=\"{ \'is-active\': channel.open }\" ng-click=\"cCampaignsShow.openChannel(channel)\"><i ng-if=\"!channel.open\" class=\"icon ion-stats-bars\"></i> <i ng-if=\"channel.open\" class=\"icon icon--close ion-close\"></i></td><td class=\"is-more is-disabled\" ng-if=\"!channel.played\"></td></tr><tr ng-repeat-end=\"\" ng-if=\"channel.open\"><td colspan=\"10\" class=\"is-breakdown--big\"><div class=\"inner\" ng-include=\"\'app/pages/campaigns/show/_channelPerformance.html\'\"></div></td></tr><tr ng-if=\"filteredChannels.length === 0\"><td class=\"is-none\" colspan=\"10\"><img src=\"/assets/images/chest.png\" alt=\"It\'s empty...\"> It\'s empty...</td></tr></table></div>");
$templateCache.put("app/pages/campaigns/show/_potential.html","<div class=\"p-campaign--report__info\"><div class=\"inner\"><h2 class=\"section-title is-noBorder\"><ns-section-dot ns-section-dot-icon=\"ion-ribbon-b\" ns-section-dot-loading=\"!cCampaignsShow.channelMap\"></ns-section-dot>Potential Reach</h2><div style=\"margin-left: -20px; margin-right: -20px;\"><ns-stats><ns-stats-item ns-stats-item-value=\"cCampaignsShow.channelMap | sumProperty: \'average_viewers_shorterm\' | number\" ns-stats-item-loading=\"!cCampaignsShow.channelMap\" ns-stats-item-title=\"Average Viewers\" style=\"width: 50%\"></ns-stats-item><ns-stats-item ns-stats-item-value=\"(cCampaignsShow.channelMap | sumProperty: \'average_viewers_shorterm\') / cCampaignsShow.channelCount | number: 0\" ns-stats-item-loading=\"!cCampaignsShow.channelMap\" ns-stats-item-title=\"Avg Viewers/Channel\" style=\"width: 50%\"></ns-stats-item></ns-stats><ns-stats><ns-stats-item ns-stats-item-value=\"cCampaignsShow.channelMap | sumProperty: \'followers\' | number\" ns-stats-item-loading=\"!cCampaignsShow.channelMap\" ns-stats-item-title=\"Total Followers\" style=\"width: 50%\"></ns-stats-item><ns-stats-item ns-stats-item-value=\"(cCampaignsShow.channelMap | sumProperty: \'followers\')/cCampaignsShow.channelCount | number: 0\" ns-stats-item-loading=\"!cCampaignsShow.channelMap\" ns-stats-item-title=\"Followers/Channel\" style=\"width: 50%\"></ns-stats-item></ns-stats></div></div></div>");
$templateCache.put("app/pages/campaigns/show/_stats.html","<ns-stats class=\"d-gameLists__stats\"><ns-stats-item ns-stats-item-value=\"cCampaignsShow.totals.total_minutes | number\" ns-stats-item-loading=\"cCampaignsShow.loading\" ns-stats-item-title=\"Minutes Watched\" style=\"width: 20%\"></ns-stats-item><ns-stats-item ns-stats-item-value=\"cCampaignsShow.totals.peak_viewers | number\" ns-stats-item-loading=\"cCampaignsShow.chart.config.loading\" ns-stats-item-title=\"Peak Viewers\" style=\"width: 20%\"></ns-stats-item><ns-stats-item ns-stats-item-value=\"cCampaignsShow.totals.stream_time | durationToTimestamp: \'m\'\" ns-stats-item-loading=\"cCampaignsShow.chart.config.loading\" ns-stats-item-title=\"Stream Time\" style=\"width: 20%\"></ns-stats-item><ns-stats-item ns-stats-item-value=\"cCampaignsShow.totals.participants + \'/\' + cCampaignsShow.channelCount\" ns-stats-item-loading=\"cCampaignsShow.chart.config.loading\" ns-stats-item-title=\"Channel Participation\" style=\"width: 20%\"></ns-stats-item><ns-stats-item ns-stats-item-value=\"cCampaignsShow.daysLeft\" ns-stats-item-title=\"Days Left\" style=\"width: 20%\"></ns-stats-item></ns-stats>");
$templateCache.put("app/pages/campaigns/show/campaign--show.html","<div class=\"p-campaign--report__loading\" ng-if=\"!cCampaignsShow.channelMap\"><div class=\"inner\"><div class=\"spinner spinner--colorB\"></div>Reticulating Splines...</div></div><div class=\"u-columns p-campaign--report\" ng-class=\"{ \'is-loading\': !cCampaignsShow.channelMap }\"><div class=\"u-column--3\"><div ng-include=\"\'app/pages/campaigns/show/_info.html\'\"></div><div ng-include=\"\'app/pages/campaigns/show/_potential.html\'\"></div></div><div class=\"u-column--9\"><div class=\"p-campaign--report__chart\"><div class=\"inner\"><div class=\"export u-fr is-disabled\"><div class=\"soonTag\">Coming Soon</div><i class=\"icon ion-android-download\"></i> Export</div><h2 class=\"section-title title\"><ns-section-dot ns-section-dot-icon=\"ion-android-calendar\" ns-section-dot-loading=\"cCampaignsShow.chart.config.loading\"></ns-section-dot><span ng-if=\"!cCampaignsShow.isDay\" style=\"display: none;\"><date ng-if=\"cCampaignsShow.range.start\" moment=\"cCampaignsShow.range.start\" display=\"true\" date-text=\"true\"></date><span class=\"subtitle\">through</span><date ng-if=\"cCampaignsShow.range.end\" moment=\"cCampaignsShow.range.end\" display=\"true\" date-text=\"true\"></date></span> <span ng-if=\"!cCampaignsShow.isDay\">Full Campaign</span> <span ng-if=\"cCampaignsShow.isDay\">{{ cCampaignsShow.range.start | dateToFormat: \'MMMM Do YYYY\' }}</span><div class=\"list\" ng-if=\"cCampaignsShow.isDay\"><span class=\"title\" ng-if=\"cCampaignsShow.isDay\">Single Day</span> <span class=\"title\" ng-if=\"!cCampaignsShow.isDay\">Full Campaign</span></div><a class=\"button-a--small p-campaign--report__reset\" ng-if=\"cCampaignsShow.isDay\" ng-click=\"cCampaignsShow.reset()\">View Full</a></h2><div ng-include=\"\'app/pages/campaigns/show/_stats.html\'\"></div><div class=\"u-tar p-campaign--report__chartDropdown\"><div class=\"chartDropdown\"><ns-dropdown ng-if=\"!cCampaignsShow.isDay\" ns-dropdown-model=\"cCampaignsShow.metric\" ns-dropdown-display=\"title\" ns-dropdown-options=\"cCampaignsShow.chart.metrics\" ns-dropdown-select=\"cCampaignsShow.chart.changeMetric\">{{ cCampaignsShow.chart.metric.title }} <i class=\"icon ion-android-arrow-dropdown\"></i></ns-dropdown><ns-dropdown ng-if=\"cCampaignsShow.isDay\" ns-dropdown-model=\"cCampaignsShow.dayMetric\" ns-dropdown-display=\"title\" ns-dropdown-options=\"cCampaignsShow.chart.dayMetrics\" ns-dropdown-select=\"cCampaignsShow.chart.changeDayMetric\">{{ cCampaignsShow.chart.dayMetric.title }} <i class=\"icon ion-android-arrow-dropdown\"></i></ns-dropdown></div></div><highchart config=\"cCampaignsShow.chart.config\"></highchart><div ng-include=\"\'app/pages/campaigns/show/_participation.html\'\"></div><div ng-include=\"\'app/pages/campaigns/show/_performance.html\'\"></div></div></div></div></div>");}]);